/* eslint-disable */
import { DocumentTypeDecoration } from "@graphql-typed-document-node/core"
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  AWSDate: { input: any; output: any }
  AWSDateTime: { input: any; output: any }
  AWSEmail: { input: any; output: any }
  AWSIPAddress: { input: any; output: any }
  AWSJSON: { input: any; output: any }
  AWSPhone: { input: any; output: any }
  AWSTime: { input: any; output: any }
  AWSTimestamp: { input: any; output: any }
  AWSURL: { input: any; output: any }
}

export type ActiveTemplateResult = {
  __typename?: "ActiveTemplateResult"
  templateId?: Maybe<Scalars["String"]["output"]>
  templateVersionId?: Maybe<Scalars["String"]["output"]>
}

export enum AddressTypeCode {
  BusinessAddress = "BUSINESS_ADDRESS",
  DeliveryToAddress = "DELIVERY_TO_ADDRESS",
  FiscalAddress = "FISCAL_ADDRESS",
  MailToAddress = "MAIL_TO_ADDRESS",
  PhysicalAddress = "PHYSICAL_ADDRESS",
  PostalAddress = "POSTAL_ADDRESS",
  PostboxAddress = "POSTBOX_ADDRESS",
  ResidentialAddress = "RESIDENTIAL_ADDRESS",
}

export type Agency = {
  __typename?: "Agency"
  id: Scalars["ID"]["output"]
  name: Scalars["String"]["output"]
  type?: Maybe<AgencyType>
}

export type AgencyInput = {
  id: Scalars["ID"]["input"]
  name: Scalars["String"]["input"]
  type?: InputMaybe<AgencyType>
}

export enum AgencyType {
  Certifying = "CERTIFYING",
  Halal = "HALAL",
  Iva = "IVA",
  Oca = "OCA",
  Other = "OTHER",
  Ra = "RA",
  Verifying = "VERIFYING",
}

export type AggregatedProcessHistory = {
  __typename?: "AggregatedProcessHistory"
  concatenated: Scalars["Boolean"]["output"]
  countryCode: Scalars["String"]["output"]
  countryName?: Maybe<Scalars["String"]["output"]>
  createdAt: Scalars["AWSDateTime"]["output"]
  currentEndDate?: Maybe<Scalars["AWSDate"]["output"]>
  currentStartDate?: Maybe<Scalars["AWSDate"]["output"]>
  dateOverride?: Maybe<Scalars["Boolean"]["output"]>
  earliestStartDate?: Maybe<Scalars["AWSDate"]["output"]>
  id: Scalars["ID"]["output"]
  lastProcessEndDate?: Maybe<Scalars["AWSDate"]["output"]>
  lastProcessStartDate?: Maybe<Scalars["AWSDate"]["output"]>
  latestEndDate?: Maybe<Scalars["AWSDate"]["output"]>
  latestSubmissionDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  nameOverride?: Maybe<Scalars["Boolean"]["output"]>
  overriddenEndDate?: Maybe<Scalars["AWSDate"]["output"]>
  overriddenStartDate?: Maybe<Scalars["AWSDate"]["output"]>
  owned: Scalars["Boolean"]["output"]
  premisesIdentifier: Scalars["String"]["output"]
  premisesName?: Maybe<Scalars["String"]["output"]>
  premisesRegistrationId?: Maybe<Scalars["String"]["output"]>
  processCategory: Scalars["String"]["output"]
  processCode: Scalars["String"]["output"]
  processName?: Maybe<Scalars["String"]["output"]>
  processSequenceNumber?: Maybe<Scalars["Int"]["output"]>
  processUnCode?: Maybe<Scalars["String"]["output"]>
  productItemId: Scalars["ID"]["output"]
  registrationTypeCode?: Maybe<Scalars["String"]["output"]>
}

export type Announcement = {
  __typename?: "Announcement"
  createdAt: Scalars["AWSDateTime"]["output"]
  createdBy: Scalars["String"]["output"]
  endDate: Scalars["AWSDateTime"]["output"]
  id: Scalars["ID"]["output"]
  message: Scalars["String"]["output"]
  publishDate: Scalars["AWSDateTime"]["output"]
  status: AnnouncementStatus
  title: Scalars["String"]["output"]
}

export type AnnouncementList = {
  __typename?: "AnnouncementList"
  items: Array<Announcement>
  totalCount: Scalars["Int"]["output"]
}

export type AnnouncementListInput = {
  page?: InputMaybe<Scalars["Int"]["input"]>
  pageSize?: InputMaybe<Scalars["Int"]["input"]>
}

export enum AnnouncementStatus {
  Active = "ACTIVE",
  Deleted = "DELETED",
  Ended = "ENDED",
  Scheduled = "SCHEDULED",
}

export type ApprovalToReplaceExportCertificateRequestInput = {
  id: Scalars["ID"]["input"]
  reason?: InputMaybe<Scalars["String"]["input"]>
}

export type ApproveCertificateRequestInput = {
  certifier: SpsAuthenticationInput
  reason_for_status_change?: InputMaybe<Scalars["String"]["input"]>
  requestor?: InputMaybe<Scalars["String"]["input"]>
  requestor_id: Scalars["String"]["input"]
  status: ExportCertificateStatus
}

export type ApprovedProductRequest = {
  __typename?: "ApprovedProductRequest"
  products: Array<TransferProductDetails>
}

export type ApprovedProductRequestInput = {
  productIds: Array<Scalars["String"]["input"]>
}

export enum AuthenticationType {
  AzureAd = "AZURE_AD",
  AzureB2C = "AZURE_B2C",
  Legacy = "LEGACY",
}

export type AvailableTemplateFields = {
  __typename?: "AvailableTemplateFields"
  code: Scalars["String"]["output"]
  commodity?: Maybe<Scalars["String"]["output"]>
  destinationMarket: DestinationMarket
  displayedDescription?: Maybe<Scalars["String"]["output"]>
  exportCertificateType?: Maybe<CertificateType>
  id: Scalars["ID"]["output"]
  majorVersion: Scalars["Int"]["output"]
  minorVersion: Scalars["Int"]["output"]
  title: Scalars["String"]["output"]
}

export type AwsS3Fields = {
  __typename?: "AwsS3Fields"
  key: Scalars["String"]["output"]
  value: Scalars["String"]["output"]
}

export type B2GAddress = {
  __typename?: "B2GAddress"
  city?: Maybe<Scalars["String"]["output"]>
  cityId?: Maybe<Scalars["ID"]["output"]>
  countryId?: Maybe<Scalars["ID"]["output"]>
  countryName?: Maybe<Scalars["String"]["output"]>
  countrySubdivisionId?: Maybe<Scalars["ID"]["output"]>
  countrySubdivisionName?: Maybe<Scalars["String"]["output"]>
  postcode?: Maybe<Scalars["String"]["output"]>
  postcodeCode?: Maybe<Scalars["String"]["output"]>
  street?: Maybe<Scalars["String"]["output"]>
  typeCode?: Maybe<AddressTypeCode>
}

export type B2GAddressInput = {
  city?: InputMaybe<Scalars["String"]["input"]>
  cityId?: InputMaybe<Scalars["ID"]["input"]>
  countryId?: InputMaybe<Scalars["ID"]["input"]>
  countryName?: InputMaybe<Scalars["String"]["input"]>
  countrySubdivisionId?: InputMaybe<Scalars["ID"]["input"]>
  countrySubdivisionName?: InputMaybe<Scalars["String"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  postcodeCode?: InputMaybe<Scalars["String"]["input"]>
  street?: InputMaybe<Scalars["String"]["input"]>
  typeCode?: InputMaybe<AddressTypeCode>
}

export type B2GAuthentication = {
  __typename?: "B2GAuthentication"
  actual?: Maybe<Scalars["AWSDateTime"]["output"]>
  includedClauses: Array<B2GClause>
  issueLocation?: Maybe<B2GLocation>
  locationProviderParty?: Maybe<B2GParty>
  providerParty?: Maybe<B2GParty>
  typeCode?: Maybe<NamedCode>
}

export type B2GAuthenticationInput = {
  actual?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  includedClauses?: InputMaybe<Array<B2GClauseInput>>
  issueLocation?: InputMaybe<B2GLocationInput>
  locationProviderParty?: InputMaybe<B2GPartyInput>
  providerParty?: InputMaybe<B2GPartyInput>
  typeCode?: InputMaybe<NamedCodeInput>
}

export type B2GBanWineBatchInput = {
  effectiveDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  market: DestinationMarket
  productId: Scalars["ID"]["input"]
  reason?: InputMaybe<Scalars["String"]["input"]>
}

export type B2GCertificateDelivery = {
  __typename?: "B2GCertificateDelivery"
  certificateDeliveryMethod?: Maybe<B2GCertificateDeliveryMethod>
  certificateSigningOffice?: Maybe<Scalars["ID"]["output"]>
  collectionMethod?: Maybe<B2GCollectionMethod>
  copies?: Maybe<Scalars["Int"]["output"]>
  digitalScanRequired?: Maybe<Scalars["Boolean"]["output"]>
  dueDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  recipientAddress?: Maybe<B2GAddress>
  recipientContactName?: Maybe<Scalars["String"]["output"]>
  recipientEmail?: Maybe<Scalars["String"]["output"]>
}

export type B2GCertificateDeliveryInput = {
  certificateDeliveryMethod?: InputMaybe<B2GCertificateDeliveryMethod>
  certificateSigningOffice?: InputMaybe<Scalars["ID"]["input"]>
  collectionMethod?: InputMaybe<B2GCollectionMethod>
  copies?: InputMaybe<Scalars["Int"]["input"]>
  digitalScanRequired?: InputMaybe<Scalars["Boolean"]["input"]>
  dueDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  recipientAddress?: InputMaybe<B2GAddressInput>
  recipientContactName?: InputMaybe<Scalars["String"]["input"]>
  recipientEmail?: InputMaybe<Scalars["String"]["input"]>
}

export enum B2GCertificateDeliveryMethod {
  OvernightCourierAuckland = "OVERNIGHT_COURIER_AUCKLAND",
  OvernightCourierChristchurch = "OVERNIGHT_COURIER_CHRISTCHURCH",
  UrgentCourier = "URGENT_COURIER",
}

export type B2GClassification = {
  __typename?: "B2GClassification"
  classCode?: Maybe<Scalars["String"]["output"]>
  className: Scalars["String"]["output"]
  systemId?: Maybe<Scalars["String"]["output"]>
  systemName: Scalars["String"]["output"]
}

export type B2GClassificationInput = {
  classCode?: InputMaybe<Scalars["String"]["input"]>
  className: Scalars["String"]["input"]
  systemId?: InputMaybe<Scalars["String"]["input"]>
  systemName: Scalars["String"]["input"]
}

export type B2GClause = {
  __typename?: "B2GClause"
  content?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
}

export type B2GClauseInput = {
  content?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
}

export enum B2GCollectionMethod {
  Delivery = "Delivery",
  Pickup = "Pickup",
}

export type B2GConsignment = {
  __typename?: "B2GConsignment"
  EORINumber?: Maybe<Scalars["String"]["output"]>
  carrier?: Maybe<B2GParty>
  consignee?: Maybe<B2GParty>
  consignor?: Maybe<B2GParty>
  consignorReference?: Maybe<Scalars["ID"]["output"]>
  containers: Array<B2GContainer>
  delivery?: Maybe<B2GParty>
  expectedArrivalDateTime?: Maybe<Scalars["AWSDateTime"]["output"]>
  exportExitDateTime?: Maybe<Scalars["AWSDateTime"]["output"]>
  grossWeight?: Maybe<Scalars["String"]["output"]>
  id: Scalars["ID"]["output"]
  items: Array<B2GTradeLineItem>
  loadingBasePort?: Maybe<B2GLocation>
  mainCarriageTransportMovements: Array<B2GTransportMovement>
  unloadingBasePort?: Maybe<B2GLocation>
  verifier?: Maybe<B2GParty>
  wineConsignment?: Maybe<B2GWineConsignment>
  /** @deprecated Use wineConsignment.shippingFormat */
  wineShippingFormat?: Maybe<WinePackaging>
}

export type B2GConsignmentInput = {
  EORINumber?: InputMaybe<Scalars["String"]["input"]>
  carrier?: InputMaybe<B2GPartyInput>
  consignee?: InputMaybe<B2GPartyInput>
  consignor?: InputMaybe<B2GPartyInput>
  consignorReference?: InputMaybe<Scalars["ID"]["input"]>
  containers?: InputMaybe<Array<B2GContainerInput>>
  delivery?: InputMaybe<B2GPartyInput>
  expectedArrivalDateTime?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  exportExitDateTime?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  grossWeight?: InputMaybe<Scalars["String"]["input"]>
  items?: InputMaybe<Array<B2GTradeLineItemInput>>
  loadingBasePort?: InputMaybe<B2GLocationInput>
  mainCarriageTransportMovements?: InputMaybe<Array<B2GTransportMovementInput>>
  unloadingBasePort?: InputMaybe<B2GLocationInput>
  verifier?: InputMaybe<B2GPartyInput>
  wineConsignment?: InputMaybe<B2GWineConsignmentInput>
  /** @deprecated Use wineConsignment.shippingFormat */
  wineShippingFormat?: InputMaybe<WinePackaging>
}

export type B2GContact = {
  __typename?: "B2GContact"
  email?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  personName?: Maybe<Scalars["String"]["output"]>
  phone?: Maybe<Scalars["String"]["output"]>
}

export type B2GContactInput = {
  email?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
  personName?: InputMaybe<Scalars["String"]["input"]>
  phone?: InputMaybe<Scalars["String"]["input"]>
}

export type B2GContainer = {
  __typename?: "B2GContainer"
  affixedSeals: Array<B2GSeal>
  containerId: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  temperatureSettings: Array<B2GTemperature>
}

export type B2GContainerInput = {
  affixedSeals?: InputMaybe<Array<B2GSealInput>>
  containerId: Scalars["String"]["input"]
  temperatureSettings?: InputMaybe<Array<B2GTemperatureInput>>
}

export type B2GCountry = {
  __typename?: "B2GCountry"
  id: Scalars["ID"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  subdivision?: Maybe<B2GCountrySubDivision>
}

export type B2GCountryInput = {
  id: Scalars["ID"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  subdivision?: InputMaybe<B2GCountrySubDivisionInput>
}

export type B2GCountrySubDivision = {
  __typename?: "B2GCountrySubDivision"
  id?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

export type B2GCountrySubDivisionInput = {
  id?: InputMaybe<Scalars["String"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
}

export type B2GDeclaration = {
  __typename?: "B2GDeclaration"
  eligibilityCriteria: Scalars["ID"]["output"]
  market?: Maybe<DestinationMarket>
  text?: Maybe<Scalars["String"]["output"]>
}

export type B2GDeclarationInput = {
  eligibilityCriteria: Scalars["ID"]["input"]
  market?: InputMaybe<DestinationMarket>
  text: Scalars["String"]["input"]
}

export type B2GEligibilityCriteriaMet = {
  __typename?: "B2GEligibilityCriteriaMet"
  effectiveDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  eligibilityCriteria: Scalars["ID"]["output"]
  expiryDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  processId: Scalars["ID"]["output"]
}

export type B2GEligibilityCriteriaMetInput = {
  effectiveDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  eligibilityCriteria: Scalars["ID"]["input"]
  expiryDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  processId: Scalars["ID"]["input"]
}

export type B2GEligibilityStatus = {
  __typename?: "B2GEligibilityStatus"
  expiryDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  market: DestinationMarket
  status: B2GEligibilityStatusType
}

export enum B2GEligibilityStatusType {
  Eligible = "ELIGIBLE",
  Expired = "EXPIRED",
  Incomplete = "INCOMPLETE",
  NotEligible = "NOT_ELIGIBLE",
  NotRequested = "NOT_REQUESTED",
  Requested = "REQUESTED",
}

export enum B2GError {
  InvalidValue = "INVALID_VALUE",
  Required = "REQUIRED",
}

export type B2GExportCertificateRequest = {
  __typename?: "B2GExportCertificateRequest"
  certificateDelivery?: Maybe<B2GCertificateDelivery>
  certificateNumber?: Maybe<Scalars["String"]["output"]>
  certificateType?: Maybe<CertificateType>
  commodity?: Maybe<Scalars["String"]["output"]>
  consignment?: Maybe<B2GConsignment>
  customsPermitNumber?: Maybe<Scalars["String"]["output"]>
  destination?: Maybe<B2GCountry>
  exporterDeclaration?: Maybe<B2GExporterDeclaration>
  id: Scalars["ID"]["output"]
  lastStatusChange?: Maybe<Scalars["AWSDateTime"]["output"]>
  market: DestinationMarket
  referencedDocuments: Array<B2GReferencedDocument>
  replacedBy?: Maybe<B2GExportCertificateRequest>
  replacing?: Maybe<B2GExportCertificateRequest>
  requestName?: Maybe<Scalars["String"]["output"]>
  requestedOnBehalfOfConsignor?: Maybe<Scalars["Boolean"]["output"]>
  status: ExportCertificateStatus
  statusLabel: Scalars["String"]["output"]
  statusNotes?: Maybe<Scalars["String"]["output"]>
}

export type B2GExportCertificateRequestInput = {
  certificateDelivery?: InputMaybe<B2GCertificateDeliveryInput>
  certificateType?: InputMaybe<CertificateType>
  commodity?: InputMaybe<Scalars["String"]["input"]>
  consignment?: InputMaybe<B2GConsignmentInput>
  copyFromId?: InputMaybe<Scalars["String"]["input"]>
  destination?: InputMaybe<B2GCountryInput>
  exporterDeclaration?: InputMaybe<B2GExporterDeclarationInput>
  id?: InputMaybe<Scalars["ID"]["input"]>
  /** @deprecated Use consigment.consignor.id */
  partyId?: InputMaybe<Scalars["ID"]["input"]>
  referencedDocuments?: InputMaybe<Array<B2GReferencedDocumentInput>>
  requestName?: InputMaybe<Scalars["String"]["input"]>
  requestedOnBehalfOfConsignor?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type B2GExportCertificatesDownloadUrl = {
  __typename?: "B2GExportCertificatesDownloadUrl"
  filename: Scalars["String"]["output"]
  url: Scalars["String"]["output"]
}

export type B2GExporterDeclaration = {
  __typename?: "B2GExporterDeclaration"
  date: Scalars["AWSDateTime"]["output"]
  name: Scalars["String"]["output"]
}

export type B2GExporterDeclarationInput = {
  date: Scalars["AWSDateTime"]["input"]
  name: Scalars["String"]["input"]
}

export type B2GLocation = {
  __typename?: "B2GLocation"
  country?: Maybe<Scalars["String"]["output"]>
  countryId?: Maybe<Scalars["ID"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

export type B2GLocationInput = {
  country?: InputMaybe<Scalars["String"]["input"]>
  countryId?: InputMaybe<Scalars["ID"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
}

export type B2GNote = {
  __typename?: "B2GNote"
  content: Scalars["String"]["output"]
  contentCode?: Maybe<Scalars["String"]["output"]>
  subject?: Maybe<Scalars["String"]["output"]>
  subjectCode?: Maybe<Scalars["String"]["output"]>
}

export type B2GNoteInput = {
  content: Scalars["String"]["input"]
  contentCode?: InputMaybe<Scalars["String"]["input"]>
  subject?: InputMaybe<Scalars["String"]["input"]>
  subjectCode?: InputMaybe<Scalars["String"]["input"]>
}

export type B2GPackage = {
  __typename?: "B2GPackage"
  levelCode?: Maybe<Scalars["String"]["output"]>
  nominalGrossVolume?: Maybe<Scalars["String"]["output"]>
  nominalGrossWeight?: Maybe<Scalars["String"]["output"]>
  packaging?: Maybe<B2GPackage>
  physicalShippingMarks: Array<Scalars["String"]["output"]>
  quantity?: Maybe<Scalars["String"]["output"]>
  typeCode?: Maybe<NamedCode>
}

export type B2GPackageInput = {
  levelCode?: InputMaybe<Scalars["String"]["input"]>
  nominalGrossVolume?: InputMaybe<Scalars["String"]["input"]>
  nominalGrossWeight?: InputMaybe<Scalars["String"]["input"]>
  packaging?: InputMaybe<B2GPackageInput>
  physicalShippingMarks?: InputMaybe<Array<Scalars["String"]["input"]>>
  quantity?: InputMaybe<Scalars["String"]["input"]>
  typeCode?: InputMaybe<NamedCodeInput>
}

export type B2GParty = {
  __typename?: "B2GParty"
  definedContacts: Array<B2GContact>
  id?: Maybe<Scalars["ID"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  /** @deprecated Use registration.number */
  partyId?: Maybe<Scalars["String"]["output"]>
  registration?: Maybe<B2GRegistrationDetails>
  specifiedAddress?: Maybe<B2GAddress>
  specifiedPerson?: Maybe<B2GPerson>
}

export type B2GPartyInput = {
  definedContacts?: InputMaybe<Array<B2GContactInput>>
  id?: InputMaybe<Scalars["ID"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  /** @deprecated Use registrationNumber */
  partyId?: InputMaybe<Scalars["String"]["input"]>
  registration?: InputMaybe<B2GRegistrationDetailsInput>
  specifiedAddress?: InputMaybe<B2GAddressInput>
  specifiedPerson?: InputMaybe<B2GPersonInput>
}

export type B2GPeriod = {
  __typename?: "B2GPeriod"
  duration?: Maybe<Scalars["String"]["output"]>
  end?: Maybe<Scalars["AWSDateTime"]["output"]>
  start?: Maybe<Scalars["AWSDateTime"]["output"]>
}

export type B2GPeriodInput = {
  duration?: InputMaybe<Scalars["String"]["input"]>
  end?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  start?: InputMaybe<Scalars["AWSDateTime"]["input"]>
}

export type B2GPerson = {
  __typename?: "B2GPerson"
  attainedQualifications: Array<B2GQualification>
  name?: Maybe<Scalars["String"]["output"]>
}

export type B2GPersonInput = {
  attainedQualifications?: InputMaybe<Array<B2GQualificationInput>>
  name?: InputMaybe<Scalars["String"]["input"]>
}

export type B2GPremise = {
  __typename?: "B2GPremise"
  id: Scalars["ID"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
}

export type B2GPremiseInput = {
  id: Scalars["ID"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
}

export type B2GProcess = {
  __typename?: "B2GProcess"
  applicableProcessCharacteristics: Array<B2GProcessCharacteristic>
  completionPeriod?: Maybe<B2GPeriod>
  operationCountry?: Maybe<B2GCountry>
  operatorParty?: Maybe<B2GParty>
  typeCode?: Maybe<NamedCode>
}

export type B2GProcessCharacteristic = {
  __typename?: "B2GProcessCharacteristic"
  description?: Maybe<Scalars["String"]["output"]>
  maximum?: Maybe<Scalars["String"]["output"]>
  minimum?: Maybe<Scalars["String"]["output"]>
  typeCode?: Maybe<NamedCode>
  value?: Maybe<Scalars["String"]["output"]>
}

export type B2GProcessCharacteristicInput = {
  description?: InputMaybe<Scalars["String"]["input"]>
  maximum?: InputMaybe<Scalars["String"]["input"]>
  minimum?: InputMaybe<Scalars["String"]["input"]>
  typeCode?: InputMaybe<NamedCodeInput>
  value?: InputMaybe<Scalars["String"]["input"]>
}

export type B2GProcessInput = {
  applicableProcessCharacteristics?: InputMaybe<
    Array<B2GProcessCharacteristicInput>
  >
  completionPeriod?: InputMaybe<B2GPeriodInput>
  operationCountry?: InputMaybe<B2GCountryInput>
  operatorParty?: InputMaybe<B2GPartyInput>
  typeCode?: InputMaybe<NamedCodeInput>
}

export type B2GProduct = {
  __typename?: "B2GProduct"
  additionalInformation: Array<B2GNote>
  appliedProcesses: Array<B2GProcess>
  assertedAuthentications: Array<B2GAuthentication>
  classifications: Array<B2GClassification>
  cnCode?: Maybe<Scalars["String"]["output"]>
  commodity: Scalars["String"]["output"]
  commonName?: Maybe<Scalars["String"]["output"]>
  created: Scalars["AWSDateTime"]["output"]
  createdBy?: Maybe<Scalars["String"]["output"]>
  declarations?: Maybe<Array<B2GDeclaration>>
  description: Scalars["String"]["output"]
  eligibilityCriteriaFailed?: Maybe<Array<B2GEligibilityCriteriaMet>>
  eligibilityCriteriaMet?: Maybe<Array<B2GEligibilityCriteriaMet>>
  eligibilityStatus?: Maybe<Array<B2GEligibilityStatus>>
  events: Array<B2GProductEvent>
  expiry?: Maybe<Scalars["AWSDateTime"]["output"]>
  exporterReference?: Maybe<Scalars["ID"]["output"]>
  finalProcessor?: Maybe<B2GParty>
  grossVolume?: Maybe<Scalars["String"]["output"]>
  grossWeight?: Maybe<Scalars["String"]["output"]>
  hsCode?: Maybe<Scalars["String"]["output"]>
  id: Scalars["ID"]["output"]
  intendedUse: Array<Scalars["String"]["output"]>
  migrationId?: Maybe<Scalars["ID"]["output"]>
  modifiable: Scalars["Boolean"]["output"]
  netVolume?: Maybe<Scalars["String"]["output"]>
  netWeight?: Maybe<Scalars["String"]["output"]>
  parentId?: Maybe<Scalars["ID"]["output"]>
  physicalPackage?: Maybe<B2GPackage>
  premise: B2GPremise
  productNumber?: Maybe<Scalars["String"]["output"]>
  productionBatchIds: Array<Scalars["String"]["output"]>
  referencedDocuments: Array<B2GReferencedDocument>
  scientificName?: Maybe<Scalars["String"]["output"]>
  verifier?: Maybe<B2GParty>
  wine?: Maybe<B2GWineFields>
}

export type B2GProductEligibility = {
  __typename?: "B2GProductEligibility"
  createdAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  criteriaId: Scalars["ID"]["output"]
  effectiveDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  executionArn?: Maybe<Scalars["String"]["output"]>
  expiryDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  id: Scalars["ID"]["output"]
  market: DestinationMarket
  status: B2GEligibilityStatusType
}

export type B2GProductEligibilityCriteriaV2 = {
  __typename?: "B2GProductEligibilityCriteriaV2"
  active?: Maybe<Scalars["Boolean"]["output"]>
  criteria: Scalars["String"]["output"]
  effectiveDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  expiryDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  failed: Scalars["Boolean"]["output"]
  id: Scalars["ID"]["output"]
  market?: Maybe<DestinationMarket>
  met: Scalars["Boolean"]["output"]
  processId?: Maybe<Scalars["String"]["output"]>
  updatedAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  wsmpId?: Maybe<Scalars["String"]["output"]>
}

export type B2GProductEligibilityInput = {
  createdAt?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  criteriaId: Scalars["ID"]["input"]
  effectiveDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  executionArn?: InputMaybe<Scalars["String"]["input"]>
  expiryDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  id: Scalars["ID"]["input"]
  market: DestinationMarket
  status: B2GEligibilityStatusType
}

export type B2GProductEvent = {
  __typename?: "B2GProductEvent"
  from: B2GProduct
  id: Scalars["ID"]["output"]
  other?: Maybe<Scalars["String"]["output"]>
  to: B2GProduct
  what: B2GProductEventType
  when: Scalars["AWSDateTime"]["output"]
  where: B2GPremise
}

export enum B2GProductEventType {
  AddedToExportCertificateRequest = "ADDED_TO_EXPORT_CERTIFICATE_REQUEST",
  Amended = "AMENDED",
  Other = "OTHER",
  Processsed = "PROCESSSED",
  Saved = "SAVED",
  Transferred = "TRANSFERRED",
}

export type B2GProductInput = {
  additionalInformation?: InputMaybe<Array<B2GNoteInput>>
  appliedProcesses?: InputMaybe<Array<B2GProcessInput>>
  assertedAuthentications?: InputMaybe<Array<B2GAuthenticationInput>>
  classifications?: InputMaybe<Array<B2GClassificationInput>>
  cnCode?: InputMaybe<Scalars["String"]["input"]>
  commodity: Scalars["String"]["input"]
  commonName?: InputMaybe<Scalars["String"]["input"]>
  created?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  declarations?: InputMaybe<Array<B2GDeclarationInput>>
  description: Scalars["String"]["input"]
  eligibilityCriteriaFailed?: InputMaybe<Array<B2GEligibilityCriteriaMetInput>>
  eligibilityCriteriaMet?: InputMaybe<Array<B2GEligibilityCriteriaMetInput>>
  expiry?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  exporterReference?: InputMaybe<Scalars["ID"]["input"]>
  finalProcessor?: InputMaybe<B2GPartyInput>
  grossVolume?: InputMaybe<Scalars["String"]["input"]>
  grossWeight?: InputMaybe<Scalars["String"]["input"]>
  hsCode?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
  intendedUse?: InputMaybe<Array<Scalars["String"]["input"]>>
  netVolume?: InputMaybe<Scalars["String"]["input"]>
  netWeight?: InputMaybe<Scalars["String"]["input"]>
  parentId?: InputMaybe<Scalars["ID"]["input"]>
  physicalPackage?: InputMaybe<B2GPackageInput>
  premise: B2GPremiseInput
  productionBatchIds?: InputMaybe<Array<Scalars["String"]["input"]>>
  referencedDocuments?: InputMaybe<Array<B2GReferencedDocumentInput>>
  scientificName?: InputMaybe<Scalars["String"]["input"]>
  verifier?: InputMaybe<B2GPartyInput>
  wine?: InputMaybe<B2GWineFieldsInput>
}

export type B2GProductsDownloadUrl = {
  __typename?: "B2GProductsDownloadUrl"
  filename: Scalars["String"]["output"]
  url: Scalars["String"]["output"]
}

export type B2GQualification = {
  __typename?: "B2GQualification"
  abbreviatedName?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

export type B2GQualificationInput = {
  abbreviatedName?: InputMaybe<Scalars["String"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
}

export type B2GReferencedDocument = {
  __typename?: "B2GReferencedDocument"
  attachment?: Maybe<ReferencedDocument>
  documentType?: Maybe<Scalars["String"]["output"]>
  information?: Maybe<Scalars["String"]["output"]>
  issued?: Maybe<Scalars["AWSDateTime"]["output"]>
  relationshipTypeCode: Scalars["String"]["output"]
  requestorId?: Maybe<Scalars["ID"]["output"]>
  typeCode?: Maybe<Scalars["String"]["output"]>
}

export type B2GReferencedDocumentInput = {
  attachment: Scalars["ID"]["input"]
  documentType?: InputMaybe<Scalars["String"]["input"]>
  information?: InputMaybe<Scalars["String"]["input"]>
  issued?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  relationshipTypeCode: Scalars["String"]["input"]
  requestorId?: InputMaybe<Scalars["ID"]["input"]>
  typeCode?: InputMaybe<Scalars["String"]["input"]>
}

export type B2GRegistrationDetails = {
  __typename?: "B2GRegistrationDetails"
  identifier?: Maybe<Scalars["String"]["output"]>
  number?: Maybe<Scalars["String"]["output"]>
}

export type B2GRegistrationDetailsInput = {
  identifier?: InputMaybe<Scalars["String"]["input"]>
  number?: InputMaybe<Scalars["String"]["input"]>
}

export type B2GSeal = {
  __typename?: "B2GSeal"
  issuingParty?: Maybe<B2GParty>
  sealId: Scalars["String"]["output"]
}

export type B2GSealInput = {
  issuingParty?: InputMaybe<B2GPartyInput>
  sealId: Scalars["String"]["input"]
}

export type B2GTemperature = {
  __typename?: "B2GTemperature"
  maximum?: Maybe<Scalars["String"]["output"]>
  minimum?: Maybe<Scalars["String"]["output"]>
  value?: Maybe<Scalars["String"]["output"]>
}

export type B2GTemperatureInput = {
  maximum?: InputMaybe<Scalars["String"]["input"]>
  minimum?: InputMaybe<Scalars["String"]["input"]>
  value?: InputMaybe<Scalars["String"]["input"]>
}

export type B2GTradeLineItem = {
  __typename?: "B2GTradeLineItem"
  associatedTransportEquipment: Array<B2GContainer>
  id: Scalars["String"]["output"]
  physicalPackage?: Maybe<B2GPackage>
  product?: Maybe<B2GProduct>
  verified: Scalars["Boolean"]["output"]
}

export type B2GTradeLineItemContainer = {
  __typename?: "B2GTradeLineItemContainer"
  containerId: Scalars["String"]["output"]
  grossVolume?: Maybe<Scalars["String"]["output"]>
  grossWeight?: Maybe<Scalars["String"]["output"]>
  netVolume?: Maybe<Scalars["String"]["output"]>
  netWeight?: Maybe<Scalars["String"]["output"]>
}

export type B2GTradeLineItemContainerInput = {
  containerId: Scalars["String"]["input"]
  grossVolume?: InputMaybe<Scalars["String"]["input"]>
  grossWeight?: InputMaybe<Scalars["String"]["input"]>
  netVolume?: InputMaybe<Scalars["String"]["input"]>
  netWeight?: InputMaybe<Scalars["String"]["input"]>
}

export type B2GTradeLineItemInput = {
  associatedTransportEquipment?: InputMaybe<Array<B2GContainerInput>>
  physicalPackage?: InputMaybe<B2GPackageInput>
  product?: InputMaybe<B2GProductInput>
}

export type B2GTransportMovement = {
  __typename?: "B2GTransportMovement"
  /** @deprecated Use reference */
  ITDNNumber?: Maybe<Scalars["String"]["output"]>
  mode: TransportModeCode
  reference?: Maybe<Scalars["String"]["output"]>
  registeredCountry?: Maybe<B2GCountry>
  usedTransportMeans?: Maybe<Scalars["String"]["output"]>
}

export type B2GTransportMovementInput = {
  /** @deprecated Use reference */
  ITDNNumber?: InputMaybe<Scalars["String"]["input"]>
  mode: TransportModeCode
  reference?: InputMaybe<Scalars["String"]["input"]>
  registeredCountry?: InputMaybe<B2GCountryInput>
  usedTransportMeans?: InputMaybe<Scalars["String"]["input"]>
}

export type B2GValidationErrors = {
  __typename?: "B2GValidationErrors"
  error?: Maybe<Scalars["String"]["output"]>
  path?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<B2GError>
}

export type B2GWineChemistry = {
  __typename?: "B2GWineChemistry"
  actual_alcohol_content?: Maybe<Scalars["String"]["output"]>
  citric_acidity?: Maybe<Scalars["String"]["output"]>
  laboratory?: Maybe<B2GParty>
  laboratoryReference?: Maybe<Scalars["String"]["output"]>
  methyl_alcohol?: Maybe<Scalars["String"]["output"]>
  reduced_dry_extract?: Maybe<Scalars["String"]["output"]>
  sugar_content?: Maybe<Scalars["String"]["output"]>
  sugar_content_qualifier?: Maybe<Scalars["String"]["output"]>
  total_acidity_7_0?: Maybe<Scalars["String"]["output"]>
  total_acidity_8_2_meql?: Maybe<Scalars["String"]["output"]>
  total_alcoholic_strength?: Maybe<Scalars["String"]["output"]>
  total_dry_extract?: Maybe<Scalars["String"]["output"]>
  total_sulphates?: Maybe<Scalars["String"]["output"]>
  total_sulphur_dioxide?: Maybe<Scalars["String"]["output"]>
  volatile_acidity?: Maybe<Scalars["String"]["output"]>
  volatile_acidity_meql?: Maybe<Scalars["String"]["output"]>
}

export type B2GWineConsignment = {
  __typename?: "B2GWineConsignment"
  packaging?: Maybe<B2GPackage>
  shippingFormat?: Maybe<WinePackaging>
}

export type B2GWineConsignmentInput = {
  packaging?: InputMaybe<B2GPackageInput>
  shippingFormat?: InputMaybe<WinePackaging>
}

export type B2GWineFields = {
  __typename?: "B2GWineFields"
  BRClassification?: Maybe<BrClassification>
  EUCategory?: Maybe<Scalars["String"]["output"]>
  EUIngredients?: Maybe<Array<EuIngredient>>
  alternateWineNames?: Maybe<Array<Scalars["String"]["output"]>>
  availableLitres?: Maybe<Scalars["Float"]["output"]>
  batchNumber?: Maybe<Scalars["String"]["output"]>
  bottlerReference?: Maybe<Scalars["String"]["output"]>
  chemistry?: Maybe<B2GWineChemistry>
  colour?: Maybe<Scalars["String"]["output"]>
  exportedLitres?: Maybe<Scalars["Float"]["output"]>
  geographicIndication?: Maybe<Scalars["ID"]["output"]>
  grapeVariety?: Maybe<Scalars["String"]["output"]>
  isEUEligible?: Maybe<Scalars["Boolean"]["output"]>
  mainNamePrefix?: Maybe<Scalars["String"]["output"]>
  mainNameSuffix?: Maybe<Scalars["String"]["output"]>
  package?: Maybe<B2GWinePackage>
  shippingFormat?: Maybe<WinePackaging>
  specialProcess?: Maybe<Scalars["String"]["output"]>
  style?: Maybe<Scalars["String"]["output"]>
  totalPackagedLitres?: Maybe<Scalars["Float"]["output"]>
  vintage?: Maybe<Scalars["String"]["output"]>
  volumeAdjustment?: Maybe<Array<ManualVolumeAdjustment>>
}

export type B2GWineFieldsInput = {
  BRClassification?: InputMaybe<BrClassificationInput>
  EUCategory?: InputMaybe<Scalars["String"]["input"]>
  EUIngredients?: InputMaybe<Array<EuIngredientInput>>
  alternateWineNames?: InputMaybe<Array<Scalars["String"]["input"]>>
  colour?: InputMaybe<Scalars["String"]["input"]>
  geographicIndication?: InputMaybe<Scalars["ID"]["input"]>
  grapeVariety?: InputMaybe<Scalars["String"]["input"]>
  mainNamePrefix?: InputMaybe<Scalars["String"]["input"]>
  mainNameSuffix?: InputMaybe<Scalars["String"]["input"]>
  package?: InputMaybe<B2GWinePackageInput>
  shippingFormat?: InputMaybe<WinePackaging>
  specialProcess?: InputMaybe<Scalars["String"]["input"]>
  style?: InputMaybe<Scalars["String"]["input"]>
  vintage?: InputMaybe<Scalars["String"]["input"]>
}

export type B2GWinePackage = {
  __typename?: "B2GWinePackage"
  bottleSize?: Maybe<Scalars["String"]["output"]>
  bottlesPerCase?: Maybe<Scalars["Int"]["output"]>
  cases?: Maybe<Scalars["Int"]["output"]>
  extraBottles?: Maybe<Scalars["Int"]["output"]>
  nameForDocuments?: Maybe<Scalars["String"]["output"]>
  totalBottles?: Maybe<Scalars["Int"]["output"]>
}

export type B2GWinePackageInput = {
  bottleSize?: InputMaybe<Scalars["String"]["input"]>
  bottlesPerCase?: InputMaybe<Scalars["Int"]["input"]>
  cases?: InputMaybe<Scalars["Int"]["input"]>
  extraBottles?: InputMaybe<Scalars["Int"]["input"]>
  nameForDocuments?: InputMaybe<Scalars["String"]["input"]>
}

export type BrClassification = {
  __typename?: "BRClassification"
  className?: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  sugarContent?: Maybe<Scalars["String"]["output"]>
}

export type BrClassificationInput = {
  className?: InputMaybe<Scalars["String"]["input"]>
  name: Scalars["String"]["input"]
  sugarContent?: InputMaybe<Scalars["String"]["input"]>
}

export type BrClassificationTemplate = {
  __typename?: "BRClassificationTemplate"
  class_name?: Maybe<Scalars["String"]["output"]>
  sugar_content?: Maybe<Scalars["String"]["output"]>
}

export type Block = {
  __typename?: "Block"
  description?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["String"]["output"]>
  rows?: Maybe<Array<Row>>
  title?: Maybe<Scalars["String"]["output"]>
}

export type BottlingRunData = {
  __typename?: "BottlingRunData"
  bottleVolume: Scalars["ID"]["output"]
  bottlesPerCase: Scalars["Int"]["output"]
  cases: Scalars["Int"]["output"]
  date: Scalars["AWSDateTime"]["output"]
  extraBottles?: Maybe<Scalars["Int"]["output"]>
  id: Scalars["ID"]["output"]
  litres: Scalars["Float"]["output"]
  reference: Scalars["String"]["output"]
}

export type BottlingRunDataInput = {
  bottleVolume: Scalars["ID"]["input"]
  bottlesPerCase: Scalars["Int"]["input"]
  cases: Scalars["Int"]["input"]
  date: Scalars["AWSDateTime"]["input"]
  extraBottles?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
  reference: Scalars["String"]["input"]
}

export type BottlingRunInput = {
  processId: Scalars["ID"]["input"]
  runs: Array<BottlingRunDataInput>
}

export type BottlingRunResponse = {
  __typename?: "BottlingRunResponse"
  processId: Scalars["ID"]["output"]
  runs: Array<BottlingRunData>
}

export enum BusinessArea {
  Dairy = "DAIRY",
  Honey = "HONEY",
  LiveAnimals = "LIVE_ANIMALS",
  Meat = "MEAT",
  Organics = "ORGANICS",
  Other = "OTHER",
  Plants = "PLANTS",
  Seafood = "SEAFOOD",
  Seed = "SEED",
  Wine = "WINE",
}

export type BusinessRule = {
  __typename?: "BusinessRule"
  path?: Maybe<Scalars["String"]["output"]>
}

export type BusinessRuleConfigInput = {
  businessRules?: InputMaybe<Array<InputMaybe<BusinessRuleInput>>>
  fields?: InputMaybe<Array<InputMaybe<BusinessRuleFieldInput>>>
  templateId?: InputMaybe<Scalars["ID"]["input"]>
}

export type BusinessRuleField = IConfigField & {
  __typename?: "BusinessRuleField"
  BusinessRules?: Maybe<Array<Maybe<BusinessRule>>>
  fuid?: Maybe<Scalars["ID"]["output"]>
}

export type BusinessRuleFieldInput = {
  businessRules?: InputMaybe<Array<InputMaybe<BusinessRuleInput>>>
  fuid?: InputMaybe<Scalars["String"]["input"]>
}

export type BusinessRuleInput = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

export type BusinessRulesConfig = IConfig &
  IConfigBase & {
    __typename?: "BusinessRulesConfig"
    businessRules?: Maybe<Array<Maybe<BusinessRule>>>
    fields?: Maybe<Array<Maybe<BusinessRuleField>>>
    templateId?: Maybe<Scalars["ID"]["output"]>
    templateRevisionId?: Maybe<Scalars["ID"]["output"]>
  }

export type CtAssayTestDataInput = {
  analyticalTechnique?: InputMaybe<Scalars["String"]["input"]>
  assayTestName?: InputMaybe<Scalars["String"]["input"]>
  assayTestNumber?: InputMaybe<Scalars["String"]["input"]>
  isQualitative?: InputMaybe<Scalars["Boolean"]["input"]>
  repetitions?: InputMaybe<Array<InputMaybe<CtRepetitionDataInput>>>
  reportingUnit?: InputMaybe<Scalars["String"]["input"]>
}

export type CtCancellationDataInput = {
  sampleId: Scalars["String"]["input"]
}

export type CtCancelledDataInput = {
  sampleId: Scalars["String"]["input"]
}

export type CtCompoundDataInput = {
  compoundName?: InputMaybe<Scalars["String"]["input"]>
  detectionLimit?: InputMaybe<Scalars["String"]["input"]>
  quantitativeResult?: InputMaybe<Scalars["String"]["input"]>
  resultQualifier?: InputMaybe<Scalars["String"]["input"]>
  resultState?: InputMaybe<Scalars["String"]["input"]>
}

export type CtErrorDataInput = {
  processId: Scalars["String"]["input"]
}

export type CtFailStatusDataInput = {
  destinationMarkets?: InputMaybe<Array<InputMaybe<DestinationMarket>>>
  sampleId: Scalars["String"]["input"]
  testResults?: InputMaybe<Array<InputMaybe<CtAssayTestDataInput>>>
}

export type CtFirstReportedDateDataInput = {
  firstReportedDate: Scalars["AWSDateTime"]["input"]
  sampleId: Scalars["String"]["input"]
}

export type CtInProgressStatusDataInput = {
  comments?: InputMaybe<Scalars["String"]["input"]>
  dateTimeReceived?: InputMaybe<Scalars["String"]["input"]>
  isReceipted?: InputMaybe<Scalars["Boolean"]["input"]>
  laboratoryReference?: InputMaybe<Scalars["String"]["input"]>
  officiallySealed?: InputMaybe<Scalars["Boolean"]["input"]>
  reasonUnsuitable?: InputMaybe<Scalars["String"]["input"]>
  receiptChangedOn?: InputMaybe<Scalars["String"]["input"]>
  sampleId: Scalars["String"]["input"]
  sampleTemperature?: InputMaybe<Scalars["String"]["input"]>
  suitable?: InputMaybe<Scalars["Boolean"]["input"]>
  timeStamp?: InputMaybe<Scalars["AWSDateTime"]["input"]>
}

export type CtnCancellationErrorDataInput = {
  sampleId: Scalars["String"]["input"]
}

export type CtNoOrgErrorDataInput = {
  processId: Scalars["String"]["input"]
}

export type CtPassStatusDataInput = {
  destinationMarkets?: InputMaybe<Array<InputMaybe<DestinationMarket>>>
  sampleId: Scalars["String"]["input"]
  testResults?: InputMaybe<Array<InputMaybe<CtAssayTestDataInput>>>
}

export type CtRepetitionDataInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>
  compounds?: InputMaybe<Array<InputMaybe<CtCompoundDataInput>>>
  repetitionId?: InputMaybe<Scalars["Int"]["input"]>
  reportedDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  resultsEntered?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type CtRequestedStatusDataInput = {
  processId: Scalars["String"]["input"]
  sampleId: Scalars["String"]["input"]
  sampleNumber?: InputMaybe<Scalars["String"]["input"]>
}

export enum CtStatusEventType {
  CancellationError = "CANCELLATION_ERROR",
  CancellationRequested = "CANCELLATION_REQUESTED",
  Cancelled = "CANCELLED",
  Error = "ERROR",
  Fail = "FAIL",
  FirstResultReported = "FIRST_RESULT_REPORTED",
  InProgress = "IN_PROGRESS",
  NoOrgFoundError = "NO_ORG_FOUND_ERROR",
  Pass = "PASS",
  Request = "REQUEST",
  Requested = "REQUESTED",
  Unsuitable = "UNSUITABLE",
}

export type CtUnsuitableStatusDataInput = {
  laboratoryReference?: InputMaybe<Scalars["String"]["input"]>
  reason?: InputMaybe<Scalars["String"]["input"]>
  receiptDate?: InputMaybe<Scalars["String"]["input"]>
  sampleId: Scalars["String"]["input"]
  suitable?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type CancelExportCertificateRequestInput = {
  id: Scalars["ID"]["input"]
  reason?: InputMaybe<Scalars["String"]["input"]>
}

export type CancelSupportingDocumentInput = {
  id: Scalars["ID"]["input"]
  reason?: InputMaybe<Scalars["String"]["input"]>
}

export type CancelledProcessInput = {
  cancelledReason?: InputMaybe<Scalars["String"]["input"]>
  processId: Scalars["ID"]["input"]
}

export type CancelledProcessResponse = {
  __typename?: "CancelledProcessResponse"
  cancelledReason?: Maybe<Scalars["String"]["output"]>
  firstResultReportedDate?: Maybe<Scalars["String"]["output"]>
  receipt: ChemistryTestReceipt
  request: ChemistryTestRequest
  status?: Maybe<Scalars["String"]["output"]>
}

export enum CargoTypeClassificationCode {
  CtBallastOnly = "CT_BALLAST_ONLY",
  CtBreakbulk = "CT_BREAKBULK",
  CtContainerized = "CT_CONTAINERIZED",
  CtDeepFrozenCargo = "CT_DEEP_FROZEN_CARGO",
  CtDiplomatic = "CT_DIPLOMATIC",
  CtDocuments = "CT_DOCUMENTS",
  CtEnvironmentalPollutantCargo = "CT_ENVIRONMENTAL_POLLUTANT_CARGO",
  CtFrozenCargo = "CT_FROZEN_CARGO",
  CtGeneralCargo = "CT_GENERAL_CARGO",
  CtHazardousCargo = "CT_HAZARDOUS_CARGO",
  CtHighValueConsignments = "CT_HIGH_VALUE_CONSIGNMENTS",
  CtHouseholdGoodsAndPersonalEffects = "CT_HOUSEHOLD_GOODS_AND_PERSONAL_EFFECTS",
  CtIncompatibleCargo = "CT_INCOMPATIBLE_CARGO",
  CtLiquidCargo = "CT_LIQUID_CARGO",
  CtLowValueDutiableConsignments = "CT_LOW_VALUE_DUTIABLE_CONSIGNMENTS",
  CtLowValueNonDutiableConsignments = "CT_LOW_VALUE_NON_DUTIABLE_CONSIGNMENTS",
  CtMilitary = "CT_MILITARY",
  CtNotHazardousCargo = "CT_NOT_HAZARDOUS_CARGO",
  CtObnoxious = "CT_OBNOXIOUS",
  CtOtherNonContainerized = "CT_OTHER_NON_CONTAINERIZED",
  CtOutOfGauge = "CT_OUT_OF_GAUGE",
  CtPalletized = "CT_PALLETIZED",
  CtRollOnRollOff = "CT_ROLL_ON_ROLL_OFF",
  CtTemperatureControlledCargo = "CT_TEMPERATURE_CONTROLLED_CARGO",
  CtVehicles = "CT_VEHICLES",
}

export enum CertificateCollectionAction {
  CertificateCollected = "CERTIFICATE_COLLECTED",
  PreValidationCheck = "PRE_VALIDATION_CHECK",
}

export type CertificateCollectionInput = {
  action: CertificateCollectionAction
  certificateId: Scalars["String"]["input"]
  reasonInformation?: InputMaybe<Scalars["String"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
  systemUserName?: InputMaybe<Scalars["String"]["input"]>
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
}

export type CertificateCollectionOutput = {
  __typename?: "CertificateCollectionOutput"
  certificateNumber?: Maybe<Scalars["String"]["output"]>
  message: Scalars["String"]["output"]
  success: Scalars["Boolean"]["output"]
}

export enum CertificateType {
  Catch = "CATCH",
  ExportEligibilityStatement = "EXPORT_ELIGIBILITY_STATEMENT",
  FreeSale = "FREE_SALE",
  FreeSaleStatement = "FREE_SALE_STATEMENT",
  Halal = "HALAL",
  LiveAnimals = "LIVE_ANIMALS",
  Nonconsignment = "NONCONSIGNMENT",
  OecdSeedVarietal = "OECD_SEED_VARIETAL",
  Organics = "ORGANICS",
  OtherDocument = "OTHER_DOCUMENT",
  Phytosanitary = "PHYTOSANITARY",
  ProductEstablishmentRegistrationDocument = "PRODUCT_ESTABLISHMENT_REGISTRATION_DOCUMENT",
  ReexportPhytosanitary = "REEXPORT_PHYTOSANITARY",
  Sanitary = "SANITARY",
  Supplementary = "SUPPLEMENTARY",
}

export enum ChangeExportRequestAction {
  Amend = "AMEND",
  CertificateCollected = "CERTIFICATE_COLLECTED",
  ExhaustionUpdated = "EXHAUSTION_UPDATED",
  FullyExhausted = "FULLY_EXHAUSTED",
  FullyUnExhausted = "FULLY_UN_EXHAUSTED",
  PreValidationCheck = "PRE_VALIDATION_CHECK",
  Raise = "RAISE",
  Replaced = "REPLACED",
  ResponseReceived = "RESPONSE_RECEIVED",
  StatusChange = "STATUS_CHANGE",
  Transferred = "TRANSFERRED",
}

export enum ChangeExportRequestStatus {
  Accepted = "ACCEPTED",
  Acknowledged = "ACKNOWLEDGED",
  Amended = "AMENDED",
  Approved = "APPROVED",
  Cancelled = "CANCELLED",
  PendingReplacement = "PENDING_REPLACEMENT",
  Raised = "RAISED",
  Replaced = "REPLACED",
  ReplacementAuthorised = "REPLACEMENT_AUTHORISED",
  RequestReplacement = "REQUEST_REPLACEMENT",
  Resubmit = "RESUBMIT",
  Revoked = "REVOKED",
}

export type ChangeExportRequestStatusInput = {
  action?: InputMaybe<ChangeExportRequestAction>
  b2gProfileName?: InputMaybe<Scalars["String"]["input"]>
  b2gSystemName?: InputMaybe<Scalars["String"]["input"]>
  exportRequestId: Scalars["ID"]["input"]
  overseasAuthorityInvolved?: InputMaybe<Scalars["Boolean"]["input"]>
  reasonCategories?: InputMaybe<Array<EditReasonCategory>>
  reasonForStatusChange?: InputMaybe<Scalars["String"]["input"]>
  requestOrigin?: InputMaybe<RequestOrigin>
  status: ChangeExportRequestStatus
  submissionLayout?: InputMaybe<SubmissionLayoutType>
  version?: InputMaybe<Scalars["Int"]["input"]>
}

export type ChangeExportRequestStatusResponse = {
  __typename?: "ChangeExportRequestStatusResponse"
  exportRequestId: Scalars["ID"]["output"]
  status: Scalars["String"]["output"]
  version?: Maybe<Scalars["Int"]["output"]>
}

export type ChangeTransferRequestAmendmentStatusInput = {
  b2gProfileName: Scalars["String"]["input"]
  b2gSystemName: Scalars["String"]["input"]
  certificateId: Scalars["ID"]["input"]
  reasonForStatusChange?: InputMaybe<Scalars["String"]["input"]>
  status: ChangeTransferRequestStatus
}

export type ChangeTransferRequestAmendmentStatusResponse = {
  __typename?: "ChangeTransferRequestAmendmentStatusResponse"
  certificateId?: Maybe<Scalars["ID"]["output"]>
  message?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  success: Scalars["Boolean"]["output"]
}

export enum ChangeTransferRequestStatus {
  Amended = "AMENDED",
  Approved = "APPROVED",
  Cancelled = "CANCELLED",
  Raised = "RAISED",
  RequestAmendment = "REQUEST_AMENDMENT",
  Resubmit = "RESUBMIT",
  Revoked = "REVOKED",
  ToBeAmended = "TO_BE_AMENDED",
}

export type ChangeTransferRequestStatusInput = {
  b2gProfileName?: InputMaybe<Scalars["String"]["input"]>
  b2gSystemName?: InputMaybe<Scalars["String"]["input"]>
  reasonForStatusChange?: InputMaybe<Scalars["String"]["input"]>
  requestOrigin?: InputMaybe<RequestOrigin>
  status: ChangeTransferRequestStatus
  transferRequestId: Scalars["ID"]["input"]
  version?: InputMaybe<Scalars["Int"]["input"]>
}

export type ChangeTransferRequestStatusResponse = {
  __typename?: "ChangeTransferRequestStatusResponse"
  status: Scalars["String"]["output"]
  transferRequestId: Scalars["ID"]["output"]
  version?: Maybe<Scalars["Int"]["output"]>
}

export type CheckUserAccessInput = {
  registrationId: Scalars["String"]["input"]
  role: Scalars["String"]["input"]
  userId: Scalars["String"]["input"]
}

export type CheckUserAccessResponse = {
  __typename?: "CheckUserAccessResponse"
  allowed: Scalars["Boolean"]["output"]
  message?: Maybe<Scalars["String"]["output"]>
}

export type ChemistryTest = {
  chemistryTest: Scalars["String"]["input"]
  result: Scalars["Float"]["input"]
}

export type ChemistryTestEventDataInput = {
  cancellationData?: InputMaybe<CtCancellationDataInput>
  cancellationErrorData?: InputMaybe<CtnCancellationErrorDataInput>
  cancelledData?: InputMaybe<CtCancelledDataInput>
  errorData?: InputMaybe<CtErrorDataInput>
  event: CtStatusEventType
  failData?: InputMaybe<CtFailStatusDataInput>
  firstReportedDateData?: InputMaybe<CtFirstReportedDateDataInput>
  inProgressData?: InputMaybe<CtInProgressStatusDataInput>
  noOrgErrorData?: InputMaybe<CtNoOrgErrorDataInput>
  passData?: InputMaybe<CtPassStatusDataInput>
  requestData?: InputMaybe<ChemistryTestInput>
  requestedData?: InputMaybe<CtRequestedStatusDataInput>
  unsuitableData?: InputMaybe<CtUnsuitableStatusDataInput>
}

export type ChemistryTestInput = {
  attributes: ChemistryTestRequestInput
  productId: Scalars["ID"]["input"]
}

export type ChemistryTestReceipt = {
  __typename?: "ChemistryTestReceipt"
  laboratoryReference?: Maybe<Scalars["String"]["output"]>
  receiptDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  sampleSuitable?: Maybe<Scalars["Boolean"]["output"]>
  unsuitableReason?: Maybe<Scalars["String"]["output"]>
}

export type ChemistryTestRequest = {
  __typename?: "ChemistryTestRequest"
  expectedAlcoholContent?: Maybe<Scalars["Float"]["output"]>
  laboratory: Scalars["ID"]["output"]
  packagingDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  packagingReference?: Maybe<Scalars["String"]["output"]>
  sampleCollectionDate: Scalars["AWSDateTime"]["output"]
  sampleReference: Scalars["String"]["output"]
  testRequired: Scalars["ID"]["output"]
  wineTestReference: Scalars["String"]["output"]
}

export type ChemistryTestRequestInput = {
  expectedAlcoholContent?: InputMaybe<Scalars["Float"]["input"]>
  laboratory: Scalars["String"]["input"]
  packagingDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  packagingReference?: InputMaybe<Scalars["String"]["input"]>
  sampleCollectionDate: Scalars["AWSDateTime"]["input"]
  testRequired: Scalars["ID"]["input"]
}

export type ChemistryTestResponse = {
  __typename?: "ChemistryTestResponse"
  cancelledReason?: Maybe<Scalars["String"]["output"]>
  firstResultReportedDate?: Maybe<Scalars["String"]["output"]>
  passedDestinationMarkets?: Maybe<Array<DestinationMarket>>
  receipt: ChemistryTestReceipt
  request: ChemistryTestRequest
  requestedDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  results?: Maybe<Array<ChemistryTestResult>>
  status?: Maybe<Scalars["String"]["output"]>
}

export type ChemistryTestResult = {
  __typename?: "ChemistryTestResult"
  assayTestName?: Maybe<Scalars["String"]["output"]>
  assayTestNumber: Scalars["String"]["output"]
  entered?: Maybe<Scalars["Boolean"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  qualifier?: Maybe<Scalars["String"]["output"]>
  reportedDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  resultState?: Maybe<Scalars["String"]["output"]>
  unit: Scalars["String"]["output"]
  value: Scalars["String"]["output"]
}

export enum ChemistryTestStatus {
  CancellationRequested = "CANCELLATION_REQUESTED",
  Cancelled = "CANCELLED",
  Error = "ERROR",
  Fail = "FAIL",
  InProgress = "IN_PROGRESS",
  Pass = "PASS",
  Requested = "REQUESTED",
  Unsuitable = "UNSUITABLE",
}

export enum ColumnsToDisplay {
  Code = "CODE",
  CodeAndText = "CODE_AND_TEXT",
  Text = "TEXT",
}

export type CombinedPartyTemplate = {
  __typename?: "CombinedPartyTemplate"
  authenticator?: Maybe<SpsPartyTemplate>
  processor?: Maybe<SpsPartyTemplate>
}

export enum CompetentAuthorityType {
  Custom = "CUSTOM",
  MinistryForPrimaryIndustries = "MINISTRY_FOR_PRIMARY_INDUSTRIES",
  NewZealandFoodSafetyAuthority = "NEW_ZEALAND_FOOD_SAFETY_AUTHORITY",
  None = "NONE",
}

export type ConfirmPackagingInput = {
  confirmed: Scalars["Boolean"]["input"]
  disputeReason?: InputMaybe<Scalars["String"]["input"]>
  disputeResolution?: InputMaybe<Scalars["String"]["input"]>
  processId: Scalars["ID"]["input"]
  taskId: Scalars["ID"]["input"]
}

export type ConfirmPackagingResponse = {
  __typename?: "ConfirmPackagingResponse"
  confirmed: Scalars["Boolean"]["output"]
  disputeReason?: Maybe<Scalars["String"]["output"]>
  disputeResolution?: Maybe<Scalars["String"]["output"]>
  processId: Scalars["ID"]["output"]
}

export type ConfirmWinemakingInput = {
  confirmations: Array<WinemakingConfirmationInput>
  processId: Scalars["ID"]["input"]
  taskId: Scalars["ID"]["input"]
}

export enum ConnectionType {
  Direct = "Direct",
  Hub = "Hub",
}

export type ConsignorDetails = {
  __typename?: "ConsignorDetails"
  identifiers: Array<ConsignorIdentifier>
  name: Scalars["String"]["output"]
  physicalAddress?: Maybe<Scalars["String"]["output"]>
}

export type ConsignorIdentifier = {
  __typename?: "ConsignorIdentifier"
  id: Scalars["String"]["output"]
  status: Scalars["String"]["output"]
  type: Scalars["String"]["output"]
}

export type CoreAddress = {
  __typename?: "CoreAddress"
  city?: Maybe<Scalars["String"]["output"]>
  country?: Maybe<Scalars["String"]["output"]>
  countryCode?: Maybe<Scalars["String"]["output"]>
  lines?: Maybe<Scalars["String"]["output"]>
  postCode?: Maybe<Scalars["String"]["output"]>
  state?: Maybe<Scalars["String"]["output"]>
}

export type CoreB2GFile = {
  __typename?: "CoreB2GFile"
  attachment?: Maybe<Scalars["String"]["output"]>
  extensionType?: Maybe<PhytoSupportingDocumentType>
  fileContentType?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

export type CoreB2GFileInput = {
  attachment?: InputMaybe<Scalars["String"]["input"]>
  extensionType?: InputMaybe<PhytoSupportingDocumentType>
  fileContentType?: InputMaybe<Scalars["String"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
}

export type CoreCommodity = {
  __typename?: "CoreCommodity"
  id: Scalars["ID"]["output"]
  name: Scalars["String"]["output"]
}

export type CoreContainer = {
  __typename?: "CoreContainer"
  id: Scalars["ID"]["output"]
  number?: Maybe<Scalars["String"]["output"]>
  seals?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
}

export type CoreContainerInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>
  number?: InputMaybe<Scalars["String"]["input"]>
  seals?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
}

export type CoreCountry = {
  __typename?: "CoreCountry"
  id: Scalars["ID"]["output"]
  name: Scalars["String"]["output"]
}

export type CoreDateRange = {
  __typename?: "CoreDateRange"
  from?: Maybe<Scalars["AWSDate"]["output"]>
  to?: Maybe<Scalars["AWSDate"]["output"]>
}

export type CoreDateRangeInput = {
  from?: InputMaybe<Scalars["AWSDate"]["input"]>
  to?: InputMaybe<Scalars["AWSDate"]["input"]>
}

export type CoreDeclarationInputValueOutput = {
  __typename?: "CoreDeclarationInputValueOutput"
  id?: Maybe<Scalars["ID"]["output"]>
  inputValue?: Maybe<Scalars["String"]["output"]>
  sequenceNumber?: Maybe<Scalars["Int"]["output"]>
}

export type CoreDeclarationOutput = {
  __typename?: "CoreDeclarationOutput"
  id?: Maybe<Scalars["ID"]["output"]>
  inputs?: Maybe<Array<CoreDeclarationInputValueOutput>>
  selected?: Maybe<Scalars["Boolean"]["output"]>
  statementCode?: Maybe<Scalars["Int"]["output"]>
  substitutedText?: Maybe<Scalars["String"]["output"]>
  substitutedTranslatedText?: Maybe<Array<Maybe<CoreDeclarationTranslatedText>>>
}

export type CoreDeclarationTranslatedText = {
  __typename?: "CoreDeclarationTranslatedText"
  languageCode?: Maybe<Scalars["ID"]["output"]>
  text?: Maybe<Scalars["String"]["output"]>
}

export enum CoreExportCertificateType {
  Catch = "CATCH",
  ExportEligibilityStatement = "EXPORT_ELIGIBILITY_STATEMENT",
  FreeSale = "FREE_SALE",
  FreeSaleStatement = "FREE_SALE_STATEMENT",
  Halal = "HALAL",
  LiveAnimals = "LIVE_ANIMALS",
  Nonconsignment = "NONCONSIGNMENT",
  OecdSeedVarietal = "OECD_SEED_VARIETAL",
  Organics = "ORGANICS",
  OtherDocument = "OTHER_DOCUMENT",
  Phytosanitary = "PHYTOSANITARY",
  ProductEstablishmentRegistrationDocument = "PRODUCT_ESTABLISHMENT_REGISTRATION_DOCUMENT",
  ReexportPhytosanitary = "REEXPORT_PHYTOSANITARY",
  Sanitary = "SANITARY",
  Supplementary = "SUPPLEMENTARY",
}

export type CoreExportContainer = {
  __typename?: "CoreExportContainer"
  createdAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  createdBy?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  number?: Maybe<Scalars["String"]["output"]>
  productGroupId?: Maybe<Scalars["ID"]["output"]>
  productItemId?: Maybe<Scalars["ID"]["output"]>
  seals?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  updatedAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  updatedBy?: Maybe<Scalars["String"]["output"]>
}

export type CoreExportDetails = {
  __typename?: "CoreExportDetails"
  action?: Maybe<CoreHistoryExportActions>
  additionalDeclaration?: Maybe<Scalars["String"]["output"]>
  additionalDeclarationCaption?: Maybe<Scalars["String"]["output"]>
  approvedAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  approvedBy?: Maybe<Scalars["String"]["output"]>
  approvedCertificateEmailAddresses?: Maybe<
    Array<Maybe<Scalars["String"]["output"]>>
  >
  approverQualification?: Maybe<Scalars["String"]["output"]>
  attributes?: Maybe<CoreExportRequestAttributes>
  calculatedTotalGrossWeight?: Maybe<Measurment>
  certificateNumber: Scalars["String"]["output"]
  certificateNumberReplacedById?: Maybe<Scalars["String"]["output"]>
  certificateNumberReplacesId?: Maybe<Scalars["String"]["output"]>
  certificate_type?: Maybe<CoreExportCertificateType>
  certifyingAgencyId?: Maybe<CoreLookup>
  commodity: CoreCommodity
  consignee?: Maybe<CoreRegistration>
  consigneeRegId?: Maybe<Scalars["String"]["output"]>
  consignor?: Maybe<CoreRegistration>
  consignorRegId?: Maybe<Scalars["String"]["output"]>
  copiedFromId?: Maybe<Scalars["String"]["output"]>
  createdAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  createdBy?: Maybe<Scalars["String"]["output"]>
  customsTransitAgent?: Maybe<CoreExportRequestPartyType>
  declarations?: Maybe<Array<Maybe<CoreDeclarationOutput>>>
  deliveryDetails?: Maybe<CoreLookup>
  deliveryDispatchDetails?: Maybe<CoreLookup>
  destinationCountry: CoreCountry
  destinationParty?: Maybe<CoreExportRequestPartyType>
  externalConsignor?: Maybe<CoreExportRequestPartyType>
  id: Scalars["ID"]["output"]
  importer?: Maybe<CoreExportRequestImporterType>
  officialStatement?: Maybe<Scalars["String"]["output"]>
  officialStatementCaption?: Maybe<Scalars["String"]["output"]>
  outputTranslationLanguages?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  overseasAuthorityInvolved?: Maybe<Scalars["Boolean"]["output"]>
  printDetails?: Maybe<CorePrintDetails>
  productGroupId?: Maybe<Scalars["ID"]["output"]>
  productItemGroupDetails?: Maybe<CoreProductItemGroup>
  reasonCategories?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  reasonForStatusChange?: Maybe<Scalars["String"]["output"]>
  replacedById?: Maybe<Scalars["String"]["output"]>
  replacesApprovedAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  replacesId?: Maybe<Scalars["String"]["output"]>
  requestName?: Maybe<Scalars["String"]["output"]>
  requiresAttention?: Maybe<Scalars["Boolean"]["output"]>
  signingOffice?: Maybe<CoreLookup>
  sourceTransfer?: Maybe<Array<SourceTransfer>>
  status?: Maybe<ExportStatus>
  submittedAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  submittedBy?: Maybe<Scalars["String"]["output"]>
  substatus?: Maybe<Scalars["String"]["output"]>
  supportingDocuments?: Maybe<Array<Maybe<CoreSupportingDocument>>>
  template?: Maybe<CoreTemplate>
  templateCode?: Maybe<Scalars["String"]["output"]>
  templateId?: Maybe<Scalars["ID"]["output"]>
  templateVersion?: Maybe<Scalars["Int"]["output"]>
  thirdParty?: Maybe<Array<Maybe<CoreLookup>>>
  thirdPartyConsignor?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  transitCountries?: Maybe<Array<Maybe<CoreLookup>>>
  transport?: Maybe<CoreExportTransport>
  uniqueConsignmentReference?: Maybe<Scalars["String"]["output"]>
  unofficialInformation?: Maybe<Scalars["String"]["output"]>
  updatedAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  updatedBy?: Maybe<Scalars["String"]["output"]>
  updatedByFullName?: Maybe<Scalars["String"]["output"]>
  urgency?: Maybe<CoreLookup>
  verifyingAgencyId?: Maybe<Scalars["String"]["output"]>
  verifyingAgencyIdentifier?: Maybe<Scalars["String"]["output"]>
  version?: Maybe<Scalars["Int"]["output"]>
}

export type CoreExportRequest = CoreRequest & {
  __typename?: "CoreExportRequest"
  certificateNumber: Scalars["String"]["output"]
  commodity: CoreCommodity
  consignee?: Maybe<CoreRegistration>
  consignor?: Maybe<CoreRegistration>
  containers?: Maybe<Array<Maybe<CoreContainer>>>
  declarations?: Maybe<Array<Maybe<DeclarationOutput>>>
  destinationCountry: CoreCountry
  externalConsignor?: Maybe<CoreExportRequestPartyType>
  id: Scalars["ID"]["output"]
  importer?: Maybe<CoreExportRequestImporterType>
  products?: Maybe<Array<Maybe<SavedProductOutput>>>
  sequenceNumber?: Maybe<Scalars["String"]["output"]>
  status: CoreRequestStatus
  substatus?: Maybe<CoreRequestSubstatus>
  supportingDocuments?: Maybe<Array<Maybe<CoreSupportingDocument>>>
  template?: Maybe<CoreTemplate>
  transport?: Maybe<CoreTransport>
  version?: Maybe<Scalars["Int"]["output"]>
}

export type CoreExportRequestAddress = {
  city?: InputMaybe<Scalars["String"]["input"]>
  countryCode?: InputMaybe<CoreLookupInput>
  lines?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  postCode?: InputMaybe<Scalars["String"]["input"]>
  state?: InputMaybe<Scalars["String"]["input"]>
}

export type CoreExportRequestAddressType = {
  __typename?: "CoreExportRequestAddressType"
  city?: Maybe<Scalars["String"]["output"]>
  country?: Maybe<CoreLookup>
  countryCode?: Maybe<CoreLookup>
  lines?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  postCode?: Maybe<Scalars["String"]["output"]>
  state?: Maybe<Scalars["String"]["output"]>
}

export type CoreExportRequestAttributes = {
  __typename?: "CoreExportRequestAttributes"
  address?: Maybe<CoreLookup>
  administrativeTerritorialUnit?: Maybe<CoreLookup>
  brandName?: Maybe<CoreLookup>
  categoryOfGoods?: Maybe<CoreLookup>
  cnInspection?: Maybe<CoreLookup>
  contractNo?: Maybe<CoreLookup>
  edReference?: Maybe<CoreLookup>
  euCommodityCode?: Maybe<CoreLookup>
  euTransit?: Maybe<CoreLookup>
  expRef?: Maybe<CoreLookup>
  exporterRef?: Maybe<CoreLookup>
  exporterSignature?: Maybe<CoreLookup>
  exportingCountryId?: Maybe<CoreLookup>
  forImportorAdmission?: Maybe<CoreLookup>
  halalAuditor?: Maybe<CoreLookup>
  halalCertificateNumber?: Maybe<CoreLookup>
  importPermitNumbers?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  importPermitNumbersCaption?: Maybe<Scalars["String"]["output"]>
  inspectionDate?: Maybe<Scalars["AWSDate"]["output"]>
  inspectionDateCaption?: Maybe<Scalars["String"]["output"]>
  issuingAuthority?: Maybe<CoreLookup>
  issuingAuthority1?: Maybe<CoreLookup>
  letterOfCreditRefCode?: Maybe<CoreLookup>
  lot?: Maybe<CoreLookup>
  manifacturingpremisesname?: Maybe<CoreLookup>
  manufacturerRegistration?: Maybe<CoreLookup>
  markingofsealontransportcontai?: Maybe<CoreLookup>
  nameRegistrationandAddressofse?: Maybe<CoreLookup>
  netWeightInWords?: Maybe<CoreLookup>
  numberOfDoses?: Maybe<CoreLookup>
  numberOfEmbryos?: Maybe<CoreLookup>
  numberOfPackagesContainers?: Maybe<CoreLookup>
  orgCertRefCode?: Maybe<Scalars["String"]["output"]>
  phytoCertSubType?: Maybe<CoreLookup>
  phytoCertificateNumber?: Maybe<Scalars["String"]["output"]>
  phytoLotRefNumber?: Maybe<Scalars["String"]["output"]>
  phytoPackhouse?: Maybe<Scalars["String"]["output"]>
  phytoSchemeControl?: Maybe<CoreLookup>
  phytoStatementOfRelabelling?: Maybe<Scalars["String"]["output"]>
  placeandDateofQuarantine?: Maybe<Scalars["String"]["output"]>
  productDescription?: Maybe<CoreLookup>
  purposeBR?: Maybe<CoreLookup>
  sanitoryCertificateNumber?: Maybe<CoreLookup>
  scope?: Maybe<CoreLookup>
  shipStores?: Maybe<Scalars["Boolean"]["output"]>
  summaryofRecordsfor?: Maybe<CoreLookup>
  totalGrossWeight?: Maybe<CoreLookup>
  totalQuantity?: Maybe<CoreLookup>
  transport?: Maybe<CoreLookup>
}

export type CoreExportRequestAttributesInput = {
  address?: InputMaybe<CoreLookupInput>
  administrativeTerritorialUnit?: InputMaybe<CoreLookupInput>
  brandName?: InputMaybe<CoreLookupInput>
  categoryOfGoods?: InputMaybe<CoreLookupInput>
  cnInspection?: InputMaybe<CoreLookupInput>
  contractNo?: InputMaybe<CoreLookupInput>
  edReference?: InputMaybe<CoreLookupInput>
  euCommodityCode?: InputMaybe<CoreLookupInput>
  euTransit?: InputMaybe<CoreLookupInput>
  expRef?: InputMaybe<CoreLookupInput>
  exporterRef?: InputMaybe<CoreLookupInput>
  exporterSignature?: InputMaybe<CoreLookupInput>
  exportingCountryId?: InputMaybe<CoreLookupInput>
  forImportorAdmission?: InputMaybe<CoreLookupInput>
  halalAuditor?: InputMaybe<CoreLookupInput>
  halalCertificateNumber?: InputMaybe<CoreLookupInput>
  importPermitNumbers?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >
  inspectionDate?: InputMaybe<Scalars["AWSDate"]["input"]>
  issuingAuthority?: InputMaybe<CoreLookupInput>
  issuingAuthority1?: InputMaybe<CoreLookupInput>
  letterOfCreditRefCode?: InputMaybe<CoreLookupInput>
  lot?: InputMaybe<CoreLookupInput>
  manifacturingpremisesname?: InputMaybe<CoreLookupInput>
  manufacturerRegistration?: InputMaybe<CoreLookupInput>
  markingofsealontransportcontai?: InputMaybe<CoreLookupInput>
  nameRegistrationandAddressofse?: InputMaybe<CoreLookupInput>
  netWeightInWords?: InputMaybe<CoreLookupInput>
  numberOfDoses?: InputMaybe<CoreLookupInput>
  numberOfEmbryos?: InputMaybe<CoreLookupInput>
  numberOfPackagesContainers?: InputMaybe<CoreLookupInput>
  orgCertRefCode?: InputMaybe<Scalars["String"]["input"]>
  phytoCertSubType?: InputMaybe<CoreLookupInput>
  phytoCertificateNumber?: InputMaybe<Scalars["String"]["input"]>
  phytoLotRefNumber?: InputMaybe<Scalars["String"]["input"]>
  phytoPackhouse?: InputMaybe<Scalars["String"]["input"]>
  phytoSchemeControl?: InputMaybe<CoreLookupInput>
  phytoStatementOfRelabelling?: InputMaybe<Scalars["String"]["input"]>
  placeandDateofQuarantine?: InputMaybe<Scalars["String"]["input"]>
  productDescription?: InputMaybe<CoreLookupInput>
  purposeBR?: InputMaybe<CoreLookupInput>
  sanitoryCertificateNumber?: InputMaybe<CoreLookupInput>
  scope?: InputMaybe<CoreLookupInput>
  shipStores?: InputMaybe<Scalars["Boolean"]["input"]>
  summaryofRecordsfor?: InputMaybe<CoreLookupInput>
  totalGrossWeight?: InputMaybe<CoreLookupInput>
  totalQuantity?: InputMaybe<CoreLookupInput>
  transport?: InputMaybe<CoreLookupInput>
}

export type CoreExportRequestImporter = {
  address?: InputMaybe<CoreExportRequestAddress>
  id?: InputMaybe<Scalars["ID"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  representative?: InputMaybe<Scalars["String"]["input"]>
}

export type CoreExportRequestImporterType = {
  __typename?: "CoreExportRequestImporterType"
  address?: Maybe<CoreExportRequestAddressType>
  id?: Maybe<Scalars["ID"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  representative?: Maybe<Scalars["String"]["output"]>
}

export type CoreExportRequestInput = {
  additionalDeclaration?: InputMaybe<Scalars["String"]["input"]>
  approvedCertificateEmailAddresses?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >
  attributes?: InputMaybe<CoreExportRequestAttributesInput>
  b2gProfileName?: InputMaybe<Scalars["String"]["input"]>
  b2gSystemName?: InputMaybe<Scalars["String"]["input"]>
  certificateType?: InputMaybe<Scalars["String"]["input"]>
  certifyingAgencyId?: InputMaybe<Scalars["String"]["input"]>
  commodity?: InputMaybe<Scalars["ID"]["input"]>
  consignee?: InputMaybe<CoreLookupInput>
  consignor?: InputMaybe<CoreLookupInput>
  containers?: InputMaybe<CoreContainerInput>
  copiedFromId?: InputMaybe<Scalars["ID"]["input"]>
  customsTransitAgent?: InputMaybe<CoreExportRequestParty>
  declarations?: InputMaybe<Array<InputMaybe<DeclarationInput>>>
  deliveryDetails?: InputMaybe<CoreLookupInput>
  deliveryDispatchDetails?: InputMaybe<CoreLookupInput>
  destinationCountry?: InputMaybe<CoreLookupInput>
  destinationParty?: InputMaybe<CoreExportRequestParty>
  externalConsignor?: InputMaybe<CoreExportRequestParty>
  id?: InputMaybe<Scalars["ID"]["input"]>
  importer?: InputMaybe<CoreExportRequestImporter>
  isExportInput: Scalars["Boolean"]["input"]
  isProductInput: Scalars["Boolean"]["input"]
  isReplacementRequest?: InputMaybe<Scalars["Boolean"]["input"]>
  isSupportingDocumentInput?: InputMaybe<Scalars["Boolean"]["input"]>
  lastModifiedAt?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  officialStatement?: InputMaybe<Scalars["String"]["input"]>
  products?: InputMaybe<Array<CoreProductItemInput>>
  reasonForStatusChange?: InputMaybe<Scalars["String"]["input"]>
  removeContainers?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  removeProcesses?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  removeProducts?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  removeSources?: InputMaybe<Array<InputMaybe<RemoveSources>>>
  removeSupportingDocuments?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >
  replacesId?: InputMaybe<Scalars["ID"]["input"]>
  requestName?: InputMaybe<Scalars["String"]["input"]>
  requestOrigin?: InputMaybe<RequestOrigin>
  sequenceNumber?: InputMaybe<Scalars["String"]["input"]>
  signingOffice?: InputMaybe<CoreLookupInput>
  sources?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>
  status?: InputMaybe<Scalars["String"]["input"]>
  submissionLayout?: InputMaybe<SubmissionLayoutType>
  substatus?: InputMaybe<Scalars["String"]["input"]>
  supportingDocuments?: InputMaybe<
    Array<InputMaybe<CoreSupportingDocumentInput>>
  >
  template?: InputMaybe<Scalars["ID"]["input"]>
  templateCode?: InputMaybe<Scalars["String"]["input"]>
  templateVersion?: InputMaybe<Scalars["Int"]["input"]>
  thirdParty?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>
  thirdPartyConsignor?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >
  transitCountries?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>
  transport?: InputMaybe<CoreTransportInput>
  uniqueConsignmentReference?: InputMaybe<Scalars["String"]["input"]>
  unofficialInformation?: InputMaybe<Scalars["String"]["input"]>
  urgency?: InputMaybe<CoreLookupInput>
  userId?: InputMaybe<Scalars["String"]["input"]>
  verifyingAgencyId?: InputMaybe<Scalars["String"]["input"]>
  version?: InputMaybe<Scalars["Int"]["input"]>
}

export type CoreExportRequestParty = {
  address?: InputMaybe<CoreExportRequestAddress>
  id?: InputMaybe<Scalars["ID"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
}

export type CoreExportRequestPartyType = {
  __typename?: "CoreExportRequestPartyType"
  address?: Maybe<CoreExportRequestAddressType>
  id?: Maybe<Scalars["ID"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

export type CoreExportSupportingDocuments = {
  __typename?: "CoreExportSupportingDocuments"
  description?: Maybe<Scalars["String"]["output"]>
  documentType: PhytoSupportingDocumentType
  filename?: Maybe<Scalars["String"]["output"]>
  id: Scalars["ID"]["output"]
}

export type CoreExportSupportingDocumentsInput = {
  description?: InputMaybe<Scalars["String"]["input"]>
  documentType: PhytoSupportingDocumentType
  filename?: InputMaybe<Scalars["String"]["input"]>
  id: Scalars["ID"]["input"]
}

export type CoreExportTransport = {
  __typename?: "CoreExportTransport"
  _transportMode?: Maybe<CoreLookup>
  carrierName?: Maybe<Scalars["String"]["output"]>
  conveyanceReference?: Maybe<Scalars["String"]["output"]>
  departureDate?: Maybe<Scalars["AWSDate"]["output"]>
  dischargePort?: Maybe<CoreLookup>
  expectedArrivalDate?: Maybe<Scalars["AWSDate"]["output"]>
  finalDestination?: Maybe<CoreLookup>
  inspectionPort?: Maybe<CoreLookup>
  loadingPort?: Maybe<CoreLookup>
  localCarrier?: Maybe<Scalars["String"]["output"]>
  localCarrierReference?: Maybe<Scalars["String"]["output"]>
  transportMode?: Maybe<CoreLookup>
}

export type CoreGroup = {
  __typename?: "CoreGroup"
  addressFormat?: Maybe<Scalars["String"]["output"]>
  caption?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
}

export enum CoreHistoryExportActions {
  Amend = "AMEND",
  PreValidationCheck = "PRE_VALIDATION_CHECK",
  Raise = "RAISE",
  Replaced = "REPLACED",
  Restore = "RESTORE",
  StatusChange = "STATUS_CHANGE",
}

export enum CoreHistoryTransferActions {
  Amend = "AMEND",
  ExhaustionUpdated = "EXHAUSTION_UPDATED",
  FullyExhausted = "FULLY_EXHAUSTED",
  FullyUnexhausted = "FULLY_UNEXHAUSTED",
  Raise = "RAISE",
  Restore = "RESTORE",
  StatusChange = "STATUS_CHANGE",
  TransportDetailsUpdated = "TRANSPORT_DETAILS_UPDATED",
}

export type CoreLocation = {
  __typename?: "CoreLocation"
  country?: Maybe<Scalars["String"]["output"]>
  countryId: Scalars["ID"]["output"]
  id: Scalars["ID"]["output"]
  name: Scalars["String"]["output"]
}

export type CoreLookup = {
  __typename?: "CoreLookup"
  id?: Maybe<Scalars["ID"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  registrationId?: Maybe<Scalars["String"]["output"]>
}

export type CoreLookupInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  registrationId?: InputMaybe<Scalars["String"]["input"]>
}

export type CorePackaging = {
  __typename?: "CorePackaging"
  itemMarksOuter?: Maybe<Scalars["String"]["output"]>
  itemMarksOuterCaption?: Maybe<Scalars["String"]["output"]>
  level?: Maybe<Scalars["Int"]["output"]>
  nominalGrossVolume?: Maybe<Measurment>
  nominalGrossWeight?: Maybe<Measurment>
  outermostNumberOfPacakges?: Maybe<Scalars["Int"]["output"]>
  packageType?: Maybe<CoreLookup>
  quantity?: Maybe<Scalars["Int"]["output"]>
}

export type CorePrintDetails = {
  __typename?: "CorePrintDetails"
  officialPrinted: Scalars["Boolean"]["output"]
  reasonForReprinting?: Maybe<Scalars["String"]["output"]>
}

export type CoreProcessAttributes = {
  __typename?: "CoreProcessAttributes"
  additionalTreatment?: Maybe<Scalars["String"]["output"]>
  chemicalDetail?: Maybe<Scalars["String"]["output"]>
  concentration?: Maybe<Scalars["String"]["output"]>
  duration?: Maybe<Measurment>
  temperature?: Maybe<Measurment>
}

export type CoreProcessAttributesInput = {
  additionalTreatment?: InputMaybe<Scalars["String"]["input"]>
  chemicalDetail?: InputMaybe<Scalars["String"]["input"]>
  concentration?: InputMaybe<Scalars["String"]["input"]>
  duration?: InputMaybe<MeasurmentInput>
  temperature?: InputMaybe<MeasurmentInput>
}

export type CoreProcessHistory = {
  __typename?: "CoreProcessHistory"
  country?: Maybe<CoreCountry>
  earliestStartDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  endDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  endDatePDF?: Maybe<Scalars["AWSDateTime"]["output"]>
  group?: Maybe<CoreGroup>
  id?: Maybe<Scalars["ID"]["output"]>
  latestEndDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  premise?: Maybe<CoreRegistration>
  startDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  startDatePDF?: Maybe<Scalars["AWSDateTime"]["output"]>
  unTypeCode?: Maybe<Scalars["String"]["output"]>
}

export type CoreProcessTypeLookup = {
  __typename?: "CoreProcessTypeLookup"
  code?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  unCode?: Maybe<Scalars["String"]["output"]>
}

export type CoreProduct = {
  __typename?: "CoreProduct"
  id: Scalars["ID"]["output"]
}

export type CoreProductAttributes = {
  __typename?: "CoreProductAttributes"
  NZHSCode?: Maybe<CoreLookup>
  commonName?: Maybe<CoreLookup>
  expiryDateFrom?: Maybe<Scalars["AWSDate"]["output"]>
  expiryDateTo?: Maybe<Scalars["AWSDate"]["output"]>
  grossVolume?: Maybe<Measurment>
  grossWeight?: Maybe<Measurment>
  inspectionType?: Maybe<CoreLookup>
  intendedUse?: Maybe<Array<Maybe<CoreLookup>>>
  netUnits?: Maybe<Measurment>
  netVolume?: Maybe<Measurment>
  netWeight?: Maybe<Measurment>
  origin?: Maybe<CoreLookup>
  originCountries?: Maybe<Array<Maybe<CoreLookup>>>
  otherQuantity?: Maybe<Measurment>
  overseasCertIDs?: Maybe<Array<Scalars["String"]["output"]>>
  phytoApprovedSeedCategory?: Maybe<CoreLookup>
  phytoBotanicalName?: Maybe<CoreLookup>
  phytoClass?: Maybe<CoreLookup>
  phytoClassCaption?: Maybe<Scalars["String"]["output"]>
  phytoCommonName?: Maybe<CoreLookup>
  phytoEndPointInspectionRef?: Maybe<Scalars["String"]["output"]>
  phytoGrowers?: Maybe<Scalars["String"]["output"]>
  phytoInspectionLocation?: Maybe<Scalars["String"]["output"]>
  phytoIsInspectionOnOriginal?: Maybe<Scalars["String"]["output"]>
  phytoIsOriginalCert?: Maybe<Scalars["String"]["output"]>
  phytoIsOriginalContainer?: Maybe<Scalars["String"]["output"]>
  phytoIsRepacked?: Maybe<Scalars["String"]["output"]>
  phytoLableDescription?: Maybe<CoreLookup>
  phytoMixtureName?: Maybe<Scalars["String"]["output"]>
  phytoObservation?: Maybe<Scalars["String"]["output"]>
  phytoPackhouse?: Maybe<Scalars["String"]["output"]>
  phytoPercentageByWeight?: Maybe<Scalars["Float"]["output"]>
  phytoQuantityMeasure?: Maybe<Measurment>
  phytoQuantityType?: Maybe<CoreLookup>
  phytoSeedLotApproval?: Maybe<Scalars["String"]["output"]>
  phytoSeedLotReference?: Maybe<Scalars["String"]["output"]>
  phytoSubClass?: Maybe<CoreLookup>
  phytoSubClassCaption?: Maybe<Scalars["String"]["output"]>
  phytoSupplier?: Maybe<Scalars["String"]["output"]>
  phytoVariety?: Maybe<Scalars["String"]["output"]>
  productBatchIds?: Maybe<Array<Scalars["String"]["output"]>>
  productReference?: Maybe<Scalars["String"]["output"]>
  productStatement?: Maybe<Scalars["String"]["output"]>
  productionBatchIds?: Maybe<Array<Scalars["String"]["output"]>>
  scientificName?: Maybe<Array<Maybe<CoreLookup>>>
  speciesCommonName?: Maybe<Array<Maybe<CoreLookup>>>
  temperature?: Maybe<CoreLookup>
}

export type CoreProductAttributesInput = {
  NZHSCode?: InputMaybe<CoreLookupInput>
  commonName?: InputMaybe<CoreLookupInput>
  expiryDateFrom?: InputMaybe<Scalars["AWSDate"]["input"]>
  expiryDateTo?: InputMaybe<Scalars["AWSDate"]["input"]>
  grossVolume?: InputMaybe<MeasurmentInput>
  grossWeight?: InputMaybe<MeasurmentInput>
  inspectionType?: InputMaybe<CoreLookupInput>
  intendedUse?: InputMaybe<Array<CoreLookupInput>>
  netUnits?: InputMaybe<MeasurmentInput>
  netVolume?: InputMaybe<MeasurmentInput>
  netWeight?: InputMaybe<MeasurmentInput>
  origin?: InputMaybe<CoreLookupInput>
  originCountries?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>
  otherQuantity?: InputMaybe<MeasurmentInput>
  overseasCertIDs?: InputMaybe<Array<Scalars["String"]["input"]>>
  phytoApprovedSeedCategory?: InputMaybe<CoreLookupInput>
  phytoBotanicalName?: InputMaybe<CoreLookupInput>
  phytoClass?: InputMaybe<CoreLookupInput>
  phytoCommonName?: InputMaybe<CoreLookupInput>
  phytoEndPointInspectionRef?: InputMaybe<Scalars["String"]["input"]>
  phytoGrowers?: InputMaybe<Scalars["String"]["input"]>
  phytoInspectionLocation?: InputMaybe<Scalars["String"]["input"]>
  phytoIsInspectionOnOriginal?: InputMaybe<Scalars["String"]["input"]>
  phytoIsOriginalCert?: InputMaybe<Scalars["String"]["input"]>
  phytoIsOriginalContainer?: InputMaybe<Scalars["String"]["input"]>
  phytoIsRepacked?: InputMaybe<Scalars["String"]["input"]>
  phytoLableDescription?: InputMaybe<CoreLookupInput>
  phytoMixtureName?: InputMaybe<Scalars["String"]["input"]>
  phytoObservation?: InputMaybe<Scalars["String"]["input"]>
  phytoPackhouse?: InputMaybe<Scalars["String"]["input"]>
  phytoPercentageByWeight?: InputMaybe<Scalars["Float"]["input"]>
  phytoQuantityMeasure?: InputMaybe<MeasurmentInput>
  phytoQuantityType?: InputMaybe<CoreLookupInput>
  phytoSeedLotApproval?: InputMaybe<Scalars["String"]["input"]>
  phytoSeedLotReference?: InputMaybe<Scalars["String"]["input"]>
  phytoSubClass?: InputMaybe<CoreLookupInput>
  phytoSupplier?: InputMaybe<Scalars["String"]["input"]>
  phytoVariety?: InputMaybe<Scalars["String"]["input"]>
  productBatchIds?: InputMaybe<Array<Scalars["String"]["input"]>>
  productReference?: InputMaybe<Scalars["String"]["input"]>
  productStatement?: InputMaybe<Scalars["String"]["input"]>
  productionBatchIds?: InputMaybe<Array<Scalars["String"]["input"]>>
  scientificName?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>
  speciesCommonName?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>
  temperature?: InputMaybe<CoreLookupInput>
}

export type CoreProductClassificationInput = {
  classificationCode?: InputMaybe<Scalars["String"]["input"]>
  fieldUniqueId?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
  itemCode?: InputMaybe<Scalars["String"]["input"]>
  value?: InputMaybe<Scalars["String"]["input"]>
}

export type CoreProductClassificationResponse = {
  __typename?: "CoreProductClassificationResponse"
  classificationCode?: Maybe<Scalars["String"]["output"]>
  classificationName?: Maybe<Scalars["String"]["output"]>
  createdAt?: Maybe<Scalars["String"]["output"]>
  fieldUniqueId?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  itemCode?: Maybe<Scalars["String"]["output"]>
  updatedAt?: Maybe<Scalars["String"]["output"]>
  value?: Maybe<Scalars["String"]["output"]>
}

export type CoreProductItemGroup = {
  __typename?: "CoreProductItemGroup"
  createdAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  createdBy?: Maybe<Scalars["String"]["output"]>
  groupType?: Maybe<CoreRequestType>
  id?: Maybe<Scalars["ID"]["output"]>
  products?: Maybe<Array<Maybe<TransferProductDetails>>>
}

export type CoreProductItemInput = {
  attributes?: InputMaybe<CoreProductAttributesInput>
  classification?: InputMaybe<Array<CoreProductClassificationInput>>
  container?: InputMaybe<Array<InputMaybe<CoreContainerInput>>>
  eligibilityCountries?: InputMaybe<Array<CoreLookupInput>>
  exhausted?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
  itemDescription?: InputMaybe<CoreLookupInput>
  packaging?: InputMaybe<Array<InputMaybe<PackagingInput>>>
  process?: InputMaybe<Array<CoreProductProcessInput>>
  productDeclaration?: InputMaybe<Scalars["String"]["input"]>
  productReference?: InputMaybe<Scalars["String"]["input"]>
  productStatement?: InputMaybe<Scalars["String"]["input"]>
  sequenceNumber?: InputMaybe<Scalars["Int"]["input"]>
  sourceId?: InputMaybe<Scalars["ID"]["input"]>
  sourceProducts?: InputMaybe<Array<InputMaybe<CoreProductRefrence>>>
  supportingDocuments?: InputMaybe<Array<CoreProductSupportingDocumentInput>>
  tradeLineGroupNumber?: InputMaybe<Scalars["Int"]["input"]>
  tradeLineGroupSequenceNumber?: InputMaybe<Scalars["Int"]["input"]>
}

export type CoreProductItemRelation = {
  __typename?: "CoreProductItemRelation"
  createdAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  fromId?: Maybe<Scalars["ID"]["output"]>
  toId?: Maybe<Scalars["ID"]["output"]>
}

export type CoreProductProcess = {
  __typename?: "CoreProductProcess"
  _processType?: Maybe<CoreLookup>
  attributes?: Maybe<CoreProcessAttributes>
  createdAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  createdBy?: Maybe<Scalars["String"]["output"]>
  endDate?: Maybe<Scalars["AWSDate"]["output"]>
  foreignPremises?: Maybe<Scalars["String"]["output"]>
  foreignPremisesCountryID?: Maybe<CoreLookup>
  foreignPremisesIdentifier?: Maybe<Scalars["String"]["output"]>
  id: Scalars["ID"]["output"]
  isSourceProcess?: Maybe<Scalars["Boolean"]["output"]>
  nameOverride?: Maybe<Scalars["Boolean"]["output"]>
  overrideProcessDate?: Maybe<Scalars["Boolean"]["output"]>
  premises?: Maybe<CoreRegistration>
  processGroup?: Maybe<Scalars["String"]["output"]>
  processType?: Maybe<CoreProcessTypeLookup>
  productItemId?: Maybe<Scalars["ID"]["output"]>
  sequenceNumber?: Maybe<Scalars["String"]["output"]>
  startDate?: Maybe<Scalars["AWSDate"]["output"]>
  updatedAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  updatedBy?: Maybe<Scalars["String"]["output"]>
}

export type CoreProductProcessInput = {
  attributes?: InputMaybe<CoreProcessAttributesInput>
  endDate?: InputMaybe<Scalars["AWSDate"]["input"]>
  foreignPremises?: InputMaybe<Scalars["String"]["input"]>
  foreignPremisesCountryID?: InputMaybe<CoreLookupInput>
  foreignPremisesID?: InputMaybe<Scalars["String"]["input"]>
  foreignPremisesNameOverride?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
  isSourceProcess?: InputMaybe<Scalars["Boolean"]["input"]>
  overrideProcessDate?: InputMaybe<Scalars["Boolean"]["input"]>
  premises?: InputMaybe<CoreLookupInput>
  processType?: InputMaybe<CoreLookupInput>
  sequenceNumber?: InputMaybe<Scalars["String"]["input"]>
  startDate?: InputMaybe<Scalars["AWSDate"]["input"]>
}

export type CoreProductRefrence = {
  requestNumber?: InputMaybe<Scalars["String"]["input"]>
  sequenceNumber?: InputMaybe<Scalars["Int"]["input"]>
}

export type CoreProductSupportingDocumentInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>
  isInherited?: InputMaybe<Scalars["Boolean"]["input"]>
  supportingDocumentId?: InputMaybe<Scalars["ID"]["input"]>
  supportingDocumentNumber?: InputMaybe<Scalars["String"]["input"]>
}

export type CoreReferencedDocument = {
  __typename?: "CoreReferencedDocument"
  filename: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  uploadInProgress: Scalars["Boolean"]["output"]
}

export type CoreReferencedDocumentUrl = {
  __typename?: "CoreReferencedDocumentUrl"
  documentName: Scalars["String"]["output"]
  url: Scalars["String"]["output"]
}

export type CoreRegistration = {
  __typename?: "CoreRegistration"
  addresses?: Maybe<CoreAddress>
  id?: Maybe<Scalars["ID"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  registrationId?: Maybe<Scalars["String"]["output"]>
  registrationTypeCode?: Maybe<Scalars["String"]["output"]>
}

export type CoreRequest = {
  certificateNumber: Scalars["String"]["output"]
  commodity: CoreCommodity
  destinationCountry: CoreCountry
  id: Scalars["ID"]["output"]
  status: CoreRequestStatus
  substatus?: Maybe<CoreRequestSubstatus>
  template?: Maybe<CoreTemplate>
}

export type CoreRequestStatus = {
  __typename?: "CoreRequestStatus"
  code?: Maybe<CoreStatus>
  label: Scalars["String"]["output"]
}

export type CoreRequestSubstatus = {
  __typename?: "CoreRequestSubstatus"
  code?: Maybe<CoreSubstatus>
  label: Scalars["String"]["output"]
}

export enum CoreRequestType {
  Export = "EXPORT",
  Transfer = "TRANSFER",
}

export enum CoreStatus {
  Accepted = "ACCEPTED",
  Acknowledged = "ACKNOWLEDGED",
  Amended = "AMENDED",
  Approved = "APPROVED",
  Cancelled = "CANCELLED",
  Detained = "DETAINED",
  Draft = "DRAFT",
  Partial = "PARTIAL",
  PendingReplacement = "PENDING_REPLACEMENT",
  Raised = "RAISED",
  Rejected = "REJECTED",
  Replaced = "REPLACED",
  RequestAmendment = "REQUEST_AMENDMENT",
  RequestReplacement = "REQUEST_REPLACEMENT",
  Resubmit = "RESUBMIT",
  Revoked = "REVOKED",
  ToBeAmended = "TO_BE_AMENDED",
}

export enum CoreSubstatus {
  PendingCertification = "PENDING_CERTIFICATION",
  PendingSfCall = "PENDING_SF_CALL",
  PendingVerification = "PENDING_VERIFICATION",
}

export type CoreSupportingDocument = {
  __typename?: "CoreSupportingDocument"
  b2gFile?: Maybe<CoreB2GFile>
  comment?: Maybe<Scalars["String"]["output"]>
  createdAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  createdBy?: Maybe<Scalars["String"]["output"]>
  documentNumber?: Maybe<Scalars["String"]["output"]>
  documentReference?: Maybe<Scalars["String"]["output"]>
  documentReferenceNumber?: Maybe<Scalars["String"]["output"]>
  documentSequence?: Maybe<Scalars["Int"]["output"]>
  documentType?: Maybe<Scalars["String"]["output"]>
  fileContentType?: Maybe<Scalars["String"]["output"]>
  fileId?: Maybe<Scalars["String"]["output"]>
  filename?: Maybe<Scalars["String"]["output"]>
  foreignManufacturePremises?: Maybe<Scalars["String"]["output"]>
  foreignPremisesId?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  identificationMarks?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  intendedOperators?: Maybe<Array<Maybe<CoreLookup>>>
  isLinked?: Maybe<Scalars["Boolean"]["output"]>
  lastAction?: Maybe<Scalars["String"]["output"]>
  nzManufacturePremises?: Maybe<Scalars["String"]["output"]>
  originCountry?: Maybe<CoreLookup>
  primaryOperator?: Maybe<CoreLookup>
  productDescription?: Maybe<Scalars["String"]["output"]>
  productionDates?: Maybe<Array<Maybe<CoreDateRange>>>
  reason?: Maybe<Scalars["String"]["output"]>
  replacedByDocumentNumber?: Maybe<Scalars["String"]["output"]>
  replacedById?: Maybe<Scalars["String"]["output"]>
  replacesDocumentNumber?: Maybe<Scalars["String"]["output"]>
  replacesId?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  updatedAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  updatedBy?: Maybe<Scalars["String"]["output"]>
}

export type CoreSupportingDocumentInput = {
  b2gFile?: InputMaybe<CoreB2GFileInput>
  b2gProfileName?: InputMaybe<Scalars["String"]["input"]>
  b2gSystemName?: InputMaybe<Scalars["String"]["input"]>
  comment?: InputMaybe<Scalars["String"]["input"]>
  documentNumber?: InputMaybe<Scalars["String"]["input"]>
  documentReferenceNumber?: InputMaybe<Scalars["String"]["input"]>
  documentType?: InputMaybe<Scalars["String"]["input"]>
  fileId?: InputMaybe<Scalars["String"]["input"]>
  foreignManufacturePremises?: InputMaybe<Scalars["String"]["input"]>
  foreignPremisesId?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
  identificationMarks?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >
  intendedOperators?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>
  nzManufacturePremises?: InputMaybe<Scalars["String"]["input"]>
  originCountry?: InputMaybe<CoreLookupInput>
  primaryOperator?: InputMaybe<CoreLookupInput>
  productDescription?: InputMaybe<Scalars["String"]["input"]>
  productionDates?: InputMaybe<Array<InputMaybe<CoreDateRangeInput>>>
  reason?: InputMaybe<Scalars["String"]["input"]>
  replacesId?: InputMaybe<Scalars["ID"]["input"]>
  requestOrigin?: InputMaybe<RequestOrigin>
}

export type CoreTemplate = {
  __typename?: "CoreTemplate"
  code?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  majorVersion?: Maybe<Scalars["Int"]["output"]>
  minorVersion?: Maybe<Scalars["Int"]["output"]>
  requestType?: Maybe<CoreRequestType>
  templateVersionId?: Maybe<Scalars["String"]["output"]>
}

export type CoreTransferProductSupportingDocument = {
  __typename?: "CoreTransferProductSupportingDocument"
  b2gFile?: Maybe<CoreB2GFile>
  comment?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  documentNumber?: Maybe<Scalars["String"]["output"]>
  documentReferenceNumber?: Maybe<Scalars["String"]["output"]>
  fileId?: Maybe<Scalars["String"]["output"]>
  foreignManufacturePremises?: Maybe<Scalars["String"]["output"]>
  foreignPremisesId?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  identificationMarks?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  intendedOperators?: Maybe<Array<Maybe<CoreLookup>>>
  isInherited?: Maybe<Scalars["Boolean"]["output"]>
  isLinked?: Maybe<Scalars["Boolean"]["output"]>
  nzManufacturePremises?: Maybe<CoreLookup>
  originCountry?: Maybe<CoreLookup>
  primaryOperator?: Maybe<CoreLookup>
  productDescription?: Maybe<Scalars["String"]["output"]>
  productionDates?: Maybe<Array<Maybe<CoreDateRange>>>
  status?: Maybe<Scalars["String"]["output"]>
}

export type CoreTransferRequest = CoreRequest & {
  __typename?: "CoreTransferRequest"
  certificateNumber: Scalars["String"]["output"]
  commodity: CoreCommodity
  consignee?: Maybe<CoreRegistration>
  consignor?: Maybe<CoreRegistration>
  containers?: Maybe<Array<Maybe<CoreContainer>>>
  destinationCountry: CoreCountry
  id: Scalars["ID"]["output"]
  products?: Maybe<Array<Maybe<SavedProductOutput>>>
  reasonForStatusChange?: Maybe<Scalars["String"]["output"]>
  status: CoreRequestStatus
  substatus?: Maybe<CoreRequestSubstatus>
  template?: Maybe<CoreTemplate>
  transport?: Maybe<CoreTransport>
  version?: Maybe<Scalars["Int"]["output"]>
}

export type CoreTransferRequestInput = {
  attributes?: InputMaybe<CoreExportRequestAttributesInput>
  b2gProfileName?: InputMaybe<Scalars["String"]["input"]>
  b2gSystemName?: InputMaybe<Scalars["String"]["input"]>
  commodity?: InputMaybe<Scalars["ID"]["input"]>
  consignee?: InputMaybe<CoreLookupInput>
  consignor?: InputMaybe<CoreLookupInput>
  containers?: InputMaybe<CoreContainerInput>
  copiedFromTransferId?: InputMaybe<Scalars["ID"]["input"]>
  destinationCountry?: InputMaybe<CoreLookupInput>
  eligibility_declaration?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
  isProductInput: Scalars["Boolean"]["input"]
  isTransferInput: Scalars["Boolean"]["input"]
  lastModifiedAt?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  products?: InputMaybe<Array<CoreProductItemInput>>
  reasonForStateChangeCategories?: InputMaybe<
    Array<InputMaybe<CoreLookupInput>>
  >
  removeProcesses?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  removeProducts?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  removeSources?: InputMaybe<Array<InputMaybe<RemoveSources>>>
  removeSupportingDocuments?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >
  requestOrigin?: InputMaybe<RequestOrigin>
  sequenceNumber?: InputMaybe<Scalars["String"]["input"]>
  sources?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>
  status?: InputMaybe<Scalars["String"]["input"]>
  template?: InputMaybe<Scalars["ID"]["input"]>
  templateCode?: InputMaybe<Scalars["String"]["input"]>
  templateVersion?: InputMaybe<Scalars["Int"]["input"]>
  thirdPartyConsignor?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>
  transport?: InputMaybe<CoreTransportInput>
  uniqueConsignmentReference?: InputMaybe<Scalars["String"]["input"]>
  unofficialInformation?: InputMaybe<Scalars["String"]["input"]>
  urgency?: InputMaybe<CoreLookupInput>
  userId?: InputMaybe<Scalars["String"]["input"]>
  version?: InputMaybe<Scalars["Int"]["input"]>
}

export type CoreTransport = {
  __typename?: "CoreTransport"
  carrierName?: Maybe<Scalars["String"]["output"]>
  conveyanceReference?: Maybe<Scalars["String"]["output"]>
  departureDate?: Maybe<Scalars["AWSDate"]["output"]>
  dischargePort?: Maybe<CoreLocation>
  expectedArrivalDate?: Maybe<Scalars["AWSDate"]["output"]>
  finalDestination?: Maybe<CoreLookup>
  inspectionPort?: Maybe<CoreLocation>
  loadingPort?: Maybe<CoreLocation>
  localCarrier?: Maybe<Scalars["String"]["output"]>
  localCarrierReference?: Maybe<Scalars["String"]["output"]>
  transportMode?: Maybe<CoreLookup>
}

export type CoreTransportInput = {
  carrierName?: InputMaybe<Scalars["String"]["input"]>
  conveyanceReference?: InputMaybe<Scalars["String"]["input"]>
  departureDate?: InputMaybe<Scalars["AWSDate"]["input"]>
  dischargePort?: InputMaybe<CoreLookupInput>
  expectedArrivalDate?: InputMaybe<Scalars["AWSDate"]["input"]>
  finalDestination?: InputMaybe<CoreLookupInput>
  inspectionPort?: InputMaybe<CoreLookupInput>
  loadingPort?: InputMaybe<CoreLookupInput>
  localCarrier?: InputMaybe<Scalars["String"]["input"]>
  localCarrierReference?: InputMaybe<Scalars["String"]["input"]>
  transportMode?: InputMaybe<CoreLookupInput>
}

export enum Country {
  At = "AT",
  Au = "AU",
  Be = "BE",
  Bg = "BG",
  Br = "BR",
  Ca = "CA",
  Cn = "CN",
  Cy = "CY",
  Cz = "CZ",
  De = "DE",
  Dk = "DK",
  Ee = "EE",
  El = "EL",
  Es = "ES",
  Eu = "EU",
  Fi = "FI",
  Fr = "FR",
  Gb = "GB",
  Gr = "GR",
  Hr = "HR",
  Hu = "HU",
  Ie = "IE",
  It = "IT",
  Jp = "JP",
  Lt = "LT",
  Lu = "LU",
  Lv = "LV",
  Mt = "MT",
  Nl = "NL",
  NotApplicable = "NOT_APPLICABLE",
  Nz = "NZ",
  Pl = "PL",
  Pt = "PT",
  Re = "RE",
  Ro = "RO",
  Se = "SE",
  Sg = "SG",
  Si = "SI",
  Sk = "SK",
  Tw = "TW",
  Ua = "UA",
  Us = "US",
}

export type CreateAnnouncementInput = {
  endDate: Scalars["AWSDateTime"]["input"]
  message: Scalars["String"]["input"]
  publishDate: Scalars["AWSDateTime"]["input"]
  title: Scalars["String"]["input"]
}

export type CreateDfeConfigRequest = {
  __typename?: "CreateDfeConfigRequest"
  templateVersionId: Scalars["ID"]["output"]
}

export type CreateDfeConfigResponse = {
  __typename?: "CreateDfeConfigResponse"
  errorMessage?: Maybe<Scalars["String"]["output"]>
  s3location?: Maybe<Scalars["String"]["output"]>
}

export type CreateTemplateGeneralInput = {
  agencies?: InputMaybe<Array<InputMaybe<AgencyInput>>>
  allowForeignPremises?: InputMaybe<Scalars["Boolean"]["input"]>
  allowPackageLevels?: InputMaybe<Scalars["Boolean"]["input"]>
  assignedTo?: InputMaybe<Scalars["String"]["input"]>
  businessArea?: InputMaybe<BusinessArea>
  code: Scalars["String"]["input"]
  commodities?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  commodity: Scalars["String"]["input"]
  description?: InputMaybe<Scalars["String"]["input"]>
  destinationCountries?: InputMaybe<Array<Scalars["String"]["input"]>>
  displayedDescription: Scalars["String"]["input"]
  effective?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  expire?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  exportCertificateType?: InputMaybe<CertificateType>
  exportingCountry?: InputMaybe<Scalars["String"]["input"]>
  importCertificateType?: InputMaybe<ImportCertificateType>
  industryAccess?: InputMaybe<Scalars["Boolean"]["input"]>
  majorVersion: Scalars["Int"]["input"]
  minorVersion: Scalars["Int"]["input"]
  ocaAccess?: InputMaybe<Scalars["Boolean"]["input"]>
  officialVersion?: InputMaybe<Scalars["Int"]["input"]>
  outputSubtitle?: InputMaybe<Scalars["String"]["input"]>
  outputSubtitleTranslations?: InputMaybe<Array<InputMaybe<TranslationInput>>>
  outputTitle?: InputMaybe<Scalars["String"]["input"]>
  outputTitleTranslations?: InputMaybe<Array<InputMaybe<TranslationInput>>>
  reasonForUpdate?: InputMaybe<Scalars["String"]["input"]>
  release?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  signatory?: InputMaybe<Scalars["String"]["input"]>
  sourceTemplateVersionId?: InputMaybe<Scalars["ID"]["input"]>
  status: TemplateVersionStatus
  submissionLayout: SubmissionLayoutType
  templateType?: InputMaybe<TemplateType>
  title: Scalars["String"]["input"]
  transferCertificateType?: InputMaybe<TransferCertificateType>
}

export type CreateTemplateInput = {
  assignedTo?: InputMaybe<Scalars["String"]["input"]>
  businessArea?: InputMaybe<BusinessArea>
  code: Scalars["String"]["input"]
  commodities?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  commodity?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  destinationMarket: DestinationMarket
  displayedDescription?: InputMaybe<Scalars["String"]["input"]>
  effective?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  expire?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  exportCertificateType?: InputMaybe<CertificateType>
  importCertificateType?: InputMaybe<ImportCertificateType>
  majorVersion: Scalars["Int"]["input"]
  minorVersion: Scalars["Int"]["input"]
  newFileUpload?: InputMaybe<Scalars["Boolean"]["input"]>
  reasonForUpdate?: InputMaybe<Scalars["String"]["input"]>
  status: TemplateVersionStatus
  templateType?: InputMaybe<TemplateType>
  title: Scalars["String"]["input"]
  transferCertificateType?: InputMaybe<TransferCertificateType>
}

export type CreateTestRegistrationInput = {
  accountName?: InputMaybe<Scalars["String"]["input"]>
  businessName?: InputMaybe<Scalars["String"]["input"]>
  identifier: Scalars["String"]["input"]
  nzbn?: InputMaybe<Scalars["String"]["input"]>
  operatorDisplayName?: InputMaybe<Scalars["String"]["input"]>
  registrationTypeId: Scalars["Int"]["input"]
  source?: InputMaybe<RegistrationSource>
}

export type CreateTestUserInput = {
  authenticationType?: InputMaybe<AuthenticationType>
  email: Scalars["String"]["input"]
  g2gUser?: InputMaybe<Scalars["Boolean"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  permissions: Array<UserPermissionInput>
  profileName?: InputMaybe<Scalars["String"]["input"]>
  sfUserId?: InputMaybe<Scalars["String"]["input"]>
  subId?: InputMaybe<Scalars["String"]["input"]>
  systemUser?: InputMaybe<Scalars["Boolean"]["input"]>
  systemUsername?: InputMaybe<Scalars["String"]["input"]>
}

export type CreateUserInput = {
  authenticationType?: InputMaybe<AuthenticationType>
  email?: InputMaybe<Scalars["String"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  systemUser?: InputMaybe<Scalars["Boolean"]["input"]>
}

export enum CustomLookupType {
  EuOperatorSearch = "EU_OPERATOR_SEARCH",
  None = "NONE",
}

export type CustomsPermitNumberUsage = {
  __typename?: "CustomsPermitNumberUsage"
  allocatedInPastThirtyDays: Scalars["Int"]["output"]
  unallocated: Scalars["Int"]["output"]
}

export type DfeForm = {
  __typename?: "DFEForm"
  config?: Maybe<Scalars["AWSJSON"]["output"]>
}

export type DfePermission = {
  __typename?: "DFEPermission"
  permissions: Array<Scalars["String"]["output"]>
  role: Scalars["String"]["output"]
}

export enum DateFormat {
  DMY = "D_M_Y",
  MY = "M_Y",
}

export enum DateRange {
  All = "ALL",
  LastInEachProduct = "LAST_IN_EACH_PRODUCT",
}

export type DateTemplate = {
  __typename?: "DateTemplate"
  day: IntTemplate
  month: MonthTemplate
  year: IntTemplate
}

export type DateTimeTemplate = {
  __typename?: "DateTimeTemplate"
  date: DateTemplate
  time: TimeTemplate
}

export type DecimalTemplate = {
  __typename?: "DecimalTemplate"
  in_English: Scalars["String"]["output"]
  value: Scalars["String"]["output"]
}

export type DecisionTable = {
  __typename?: "DecisionTable"
  approvedRevision?: Maybe<DecisionTableRevision>
  id: Scalars["ID"]["output"]
  inputColumns: Array<DecisionTableColumn>
  lastRevision?: Maybe<DecisionTableRevision>
  responseColumns: Array<DecisionTableColumn>
  revisions: Array<DecisionTableRevision>
}

export type DecisionTableBaseInput = {
  validFrom?: Maybe<Scalars["AWSDateTime"]["output"]>
  validUntil?: Maybe<Scalars["AWSDateTime"]["output"]>
}

export type DecisionTableColumn = {
  __typename?: "DecisionTableColumn"
  collection?: Maybe<Scalars["String"]["output"]>
  dataType: DecisionTableDataType
  enumeration?: Maybe<Array<Scalars["String"]["output"]>>
  enumerationInfo?: Maybe<Array<EnumerationInfo>>
  header: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  mandatory?: Maybe<Scalars["Boolean"]["output"]>
}

export enum DecisionTableDataType {
  Boolean = "BOOLEAN",
  Enumeration = "ENUMERATION",
  Number = "NUMBER",
  Search = "SEARCH",
  String = "STRING",
  Text = "TEXT",
}

export type DecisionTableExpectation = {
  __typename?: "DecisionTableExpectation"
  description: Scalars["String"]["output"]
  input: RulesInput
  response: RulesResponse
}

export type DecisionTableField = {
  __typename?: "DecisionTableField"
  description: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  label: Scalars["String"]["output"]
  mandatory: Scalars["Boolean"]["output"]
}

export type DecisionTableFilter = {
  q?: InputMaybe<Scalars["String"]["input"]>
}

export type DecisionTableRevision = {
  __typename?: "DecisionTableRevision"
  comment?: Maybe<Scalars["String"]["output"]>
  createdAt: Scalars["AWSDateTime"]["output"]
  description: Scalars["String"]["output"]
  expectations: Array<DecisionTableExpectation>
  id: Scalars["ID"]["output"]
  revisionNumber: Scalars["Int"]["output"]
  rows: Array<DecisionTableRow>
  status: DecisionTableRevisionStatus
  title: Scalars["String"]["output"]
  updatedAt: Scalars["AWSDateTime"]["output"]
  updatedBy: Scalars["String"]["output"]
}

export type DecisionTableRevisionInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>
  decisionTableId: Scalars["ID"]["input"]
  description: Scalars["String"]["input"]
  expectations: Array<DecisionTableRowInput>
  rows: Array<DecisionTableRowInput>
  title: Scalars["String"]["input"]
}

export enum DecisionTableRevisionStatus {
  Approved = "APPROVED",
  Cancelled = "CANCELLED",
  Draft = "DRAFT",
}

export type DecisionTableRow = {
  __typename?: "DecisionTableRow"
  description: Scalars["String"]["output"]
  input: RulesInput
  response: RulesResponse
}

export type DecisionTableRowInput = {
  declarationsInput?: InputMaybe<DeclarationsInput>
  declarationsResponse?: InputMaybe<DeclarationsResponseInput>
  description: Scalars["String"]["input"]
  eligibilityInput?: InputMaybe<EligibilityInput>
  eligibilityResponse?: InputMaybe<EligibilityResponseInput>
  exportCertificateWorkflowInput?: InputMaybe<ExportCertificateWorkflowInput>
  exportCertificateWorkflowResponse?: InputMaybe<ExportCertificateWorkflowResponseInput>
  importConnectionsInput?: InputMaybe<ImportConnectionsInput>
  importConnectionsResponse?: InputMaybe<ImportConnectionsResponseInput>
  phytoOcaEmailNotificationsInput?: InputMaybe<PhytoOcaEmailNotificationsInput>
  phytoOcaEmailNotificationsResponse?: InputMaybe<PhytoOcaEmailNotificationsResponseInput>
  productFieldInput?: InputMaybe<ProductFieldInput>
  productFieldResponse?: InputMaybe<ProductFieldResponseInput>
  validFrom?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  validUntil?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  wineAnalytesTolerancesInput?: InputMaybe<WineAnalytesTolerancesInput>
  wineAnalytesTolerancesResponse?: InputMaybe<WineAnalytesTolerancesResponseRowInput>
  wineProductFieldInput?: InputMaybe<WineProductFieldInput>
}

export type DecisionTableTestResult = {
  __typename?: "DecisionTableTestResult"
  error_message: Scalars["String"]["output"]
  succes: Scalars["Boolean"]["output"]
}

export type DeclarationFormletFields = {
  __typename?: "DeclarationFormletFields"
  eligibilityCriteria: FormletField
  market: FormletField
  text: FormletField
}

export type DeclarationFormletSection = {
  __typename?: "DeclarationFormletSection"
  fields: DeclarationFormletFields
  id: Scalars["String"]["output"]
  type: FormletFieldType
}

export enum DeclarationGroupNumbering {
  Bullet = "BULLET",
  Custom = "CUSTOM",
  LowerAlpha = "LOWER_ALPHA",
  LowerRoman = "LOWER_ROMAN",
  None = "NONE",
  Number = "NUMBER",
  UpperAlpha = "UPPER_ALPHA",
  UpperRoman = "UPPER_ROMAN",
}

export enum DeclarationGroupType {
  Footnote = "FOOTNOTE",
  Mandatory = "MANDATORY",
  MandatoryExactlyOne = "MANDATORY_EXACTLY_ONE",
  MandatoryOneOrMore = "MANDATORY_ONE_OR_MORE",
  OptionalZeroOrMore = "OPTIONAL_ZERO_OR_MORE",
  OptionalZeroOrOne = "OPTIONAL_ZERO_OR_ONE",
  Phrase = "PHRASE",
}

export enum DeclarationHeadingType {
  Custom = "CUSTOM",
  HealthAttestation = "HEALTH_ATTESTATION",
  None = "NONE",
}

export type DeclarationInput = {
  declarationStatementCode?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
  inputs?: InputMaybe<Array<DeclarationInputValueInput>>
  selected?: InputMaybe<Scalars["Boolean"]["input"]>
  statementCode?: InputMaybe<Scalars["Int"]["input"]>
}

export type DeclarationInputValueInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>
  inputValue?: InputMaybe<Scalars["String"]["input"]>
  sequenceNumber?: InputMaybe<Scalars["Int"]["input"]>
}

export type DeclarationInputValueOutput = {
  __typename?: "DeclarationInputValueOutput"
  id?: Maybe<Scalars["ID"]["output"]>
}

export type DeclarationOutput = {
  __typename?: "DeclarationOutput"
  id?: Maybe<Scalars["ID"]["output"]>
  inputs?: Maybe<Array<DeclarationInputValueOutput>>
  statementCode?: Maybe<Scalars["Int"]["output"]>
}

export type DeclarationStatement = {
  __typename?: "DeclarationStatement"
  code: Scalars["Int"]["output"]
  customNumber?: Maybe<Scalars["String"]["output"]>
  id: Scalars["ID"]["output"]
  inputs?: Maybe<Array<DeclarationStatementInput>>
  sequenceNumber: Scalars["Int"]["output"]
  statementDisplayCode?: Maybe<Scalars["String"]["output"]>
  text: Scalars["String"]["output"]
  traces?: Maybe<Array<DeclarationStatementTrace>>
  translations?: Maybe<Scalars["AWSJSON"]["output"]>
}

export type DeclarationStatementInput = {
  __typename?: "DeclarationStatementInput"
  id: Scalars["ID"]["output"]
  inputSequenceNumber: Scalars["Int"]["output"]
  inputType: DeclarationStatementInputType
  maxLength?: Maybe<Scalars["Int"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  tracesId?: Maybe<Scalars["String"]["output"]>
}

export enum DeclarationStatementInputType {
  CompanyAddress = "companyAddress",
  CompanyName = "companyName",
  DefaultTracesStatement = "defaultTracesStatement",
  ManufacturerName = "manufacturerName",
  OverseasMarket = "overseasMarket",
  SourceEd = "sourceED",
  SourceEddoi = "sourceEDDOI",
  User = "user",
}

export type DeclarationStatementTrace = {
  __typename?: "DeclarationStatementTrace"
  id: Scalars["ID"]["output"]
  tracesContent?: Maybe<Scalars["String"]["output"]>
  tracesId?: Maybe<Scalars["String"]["output"]>
}

export type DeclarationsInput = {
  commodity?: InputMaybe<Scalars["String"]["input"]>
  destinationMarket?: InputMaybe<DestinationMarket>
  processType?: InputMaybe<Scalars["String"]["input"]>
}

export type DeclarationsResponse = {
  __typename?: "DeclarationsResponse"
  commodity?: Maybe<Scalars["String"]["output"]>
  declaration?: Maybe<Scalars["String"]["output"]>
  destinationMarket?: Maybe<DestinationMarket>
  eligibilityCriteria?: Maybe<Scalars["String"]["output"]>
}

export type DeclarationsResponseInput = {
  declaration?: InputMaybe<Scalars["String"]["input"]>
  eligibilityCriteria?: InputMaybe<Scalars["String"]["input"]>
}

export type DeclarationsType = DecisionTableBaseInput & {
  __typename?: "DeclarationsType"
  commodity?: Maybe<Scalars["String"]["output"]>
  destinationMarket?: Maybe<DestinationMarket>
  processType?: Maybe<Scalars["String"]["output"]>
  validFrom?: Maybe<Scalars["AWSDateTime"]["output"]>
  validUntil?: Maybe<Scalars["AWSDateTime"]["output"]>
}

export enum DefaultAction {
  Blank = "BLANK",
  EntryRequired = "ENTRY_REQUIRED",
  NotApplicable = "NOT_APPLICABLE",
  NotShown = "NOT_SHOWN",
  Xxxxxx = "XXXXXX",
}

export type DeleteReplacementExportRequestInput = {
  id: Scalars["ID"]["input"]
}

export type DeleteReplacementExportRequestResponse = {
  __typename?: "DeleteReplacementExportRequestResponse"
  parentId?: Maybe<Scalars["ID"]["output"]>
}

export enum DestinationMarket {
  Australia = "AUSTRALIA",
  Brazil = "BRAZIL",
  China = "CHINA",
  Eu = "EU",
  GreatBritain = "GREAT_BRITAIN",
  Japan = "JAPAN",
  NotApplicable = "NOT_APPLICABLE",
  Singapore = "SINGAPORE",
  Taiwan = "TAIWAN",
  Ukraine = "UKRAINE",
}

export type DestinationProductTracking = {
  __typename?: "DestinationProductTracking"
  id: Scalars["ID"]["output"]
  isExhausted: Scalars["Boolean"]["output"]
  packagingType?: Maybe<Scalars["String"]["output"]>
  productDescription?: Maybe<Scalars["String"]["output"]>
  productItem: Scalars["Int"]["output"]
  quantity?: Maybe<Scalars["String"]["output"]>
  requestId: Scalars["ID"]["output"]
  requestNumber: Scalars["String"]["output"]
  requestType: Scalars["String"]["output"]
  sourceNumber: Scalars["String"]["output"]
  sourceStatus: Scalars["String"]["output"]
  status: Scalars["String"]["output"]
  templateVersion?: Maybe<Scalars["String"]["output"]>
}

export enum DestinationSystem {
  EuTracesCatch = "EU_TRACES_CATCH",
  EuTracesImport = "EU_TRACES_IMPORT",
  EuTracesProcessingStatement = "EU_TRACES_PROCESSING_STATEMENT",
  None = "NONE",
}

export type DfeCondition = {
  __typename?: "DfeCondition"
  fieldRef?: Maybe<Scalars["String"]["output"]>
  operator?: Maybe<DfeOperatorType>
  value?: Maybe<Scalars["String"]["output"]>
}

export type DfeConditionInput = {
  fieldRef?: InputMaybe<Scalars["String"]["input"]>
  operator?: InputMaybe<DfeOperatorType>
  value?: InputMaybe<Scalars["String"]["input"]>
}

export type DfeConfig = IConfig &
  IConfigBase & {
    __typename?: "DfeConfig"
    declarationGroups: Array<DfeDeclarationGroup>
    fields: Array<DfeField>
    meta: DfeMeta
    products: Layout
    requests: Layout
    templateId: Scalars["ID"]["output"]
    templateRevisionId: Scalars["ID"]["output"]
  }

export type DfeConfigInput = {
  fields?: InputMaybe<Array<InputMaybe<DfeFieldInput>>>
  templateId?: InputMaybe<Scalars["ID"]["input"]>
}

export type DfeCrossExclusion = {
  __typename?: "DfeCrossExclusion"
  fieldA: Scalars["String"]["output"]
  fieldB: Scalars["String"]["output"]
  message: Scalars["String"]["output"]
}

export type DfeCrossFieldValidation = {
  __typename?: "DfeCrossFieldValidation"
  crossExclusions?: Maybe<Array<DfeCrossExclusion>>
  exclusiveGroups?: Maybe<Array<DfeExclusiveGroup>>
  fieldDisableGroups?: Maybe<Array<DfeFieldDisableGroup>>
  valueUnitPairs?: Maybe<Array<DfeValueUnitPair>>
}

export type DfeCustomRule = {
  __typename?: "DfeCustomRule"
  if?: Maybe<DfeCondition>
  then?: Maybe<DfeCondition>
}

export type DfeCustomRuleInput = {
  allOf?: InputMaybe<Array<InputMaybe<DfeCustomRuleInput>>>
  anyOf?: InputMaybe<Array<InputMaybe<DfeCustomRuleInput>>>
  if?: InputMaybe<DfeConditionInput>
  then?: InputMaybe<DfeConditionInput>
}

export enum DfeDeclarationBlockType {
  Declaration = "declaration",
  DefaultDeclaration = "defaultDeclaration",
}

export type DfeDeclarationGroup = {
  __typename?: "DfeDeclarationGroup"
  blockType: DfeDeclarationBlockType
  declarationGroupType: DeclarationGroupType
  statements: Array<DfeDeclarationStatement>
}

export type DfeDeclarationStatement = {
  __typename?: "DfeDeclarationStatement"
  inputs?: Maybe<Array<DfeDeclarationStatementInput>>
  statementCode: Scalars["Int"]["output"]
  statementDisplayCode: Scalars["String"]["output"]
  statementNumber: Scalars["String"]["output"]
  statementText: Scalars["String"]["output"]
}

export type DfeDeclarationStatementInput = {
  __typename?: "DfeDeclarationStatementInput"
  dataType: DeclarationStatementInputType
  fieldRef: Scalars["String"]["output"]
  inputSequenceNumber: Scalars["Int"]["output"]
  inputType: DfeDeclarationStatementInputType
  name?: Maybe<Scalars["String"]["output"]>
  size?: Maybe<Scalars["Int"]["output"]>
}

export enum DfeDeclarationStatementInputType {
  Text = "text",
}

export type DfeExclusiveGroup = {
  __typename?: "DfeExclusiveGroup"
  fieldAUnit: Scalars["String"]["output"]
  fieldAValue: Scalars["String"]["output"]
  fieldBUnit: Scalars["String"]["output"]
  fieldBValue: Scalars["String"]["output"]
  message: Scalars["String"]["output"]
}

export type DfeField = IConfigField & {
  __typename?: "DfeField"
  dataType: DfeFieldType
  defaultValue?: Maybe<Scalars["String"]["output"]>
  fuid: Scalars["ID"]["output"]
  label?: Maybe<Scalars["String"]["output"]>
  parent?: Maybe<Scalars["String"]["output"]>
  validation: DfeValidation
}

export type DfeFieldDisableGroup = {
  __typename?: "DfeFieldDisableGroup"
  disable: Array<Scalars["String"]["output"]>
  message?: Maybe<Scalars["String"]["output"]>
  whenActive: Array<Scalars["String"]["output"]>
}

export type DfeFieldInput = {
  defaultValue?: InputMaybe<Scalars["String"]["input"]>
  fuid?: InputMaybe<Scalars["ID"]["input"]>
  parent?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<DfeFieldType>
  validation?: InputMaybe<DfeValidationInput>
}

export enum DfeFieldType {
  Boolean = "boolean",
  Date = "date",
  DateTime = "dateTime",
  EntityArray = "entityArray",
  Number = "number",
  String = "string",
  Text = "text",
  TextArray = "textArray",
}

export type DfeMeta = {
  __typename?: "DfeMeta"
  catalogue?: Maybe<Array<Maybe<DfeMetaCatalogueType>>>
  code?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  effective?: Maybe<Scalars["AWSDateTime"]["output"]>
  expire?: Maybe<Scalars["AWSDateTime"]["output"]>
  majorVersion?: Maybe<Scalars["Int"]["output"]>
  minorVersion?: Maybe<Scalars["Int"]["output"]>
  title?: Maybe<Scalars["String"]["output"]>
}

export enum DfeMetaCatalogueType {
  DeclarationGroups = "declarationGroups",
  Fields = "fields",
  Products = "products",
  Requests = "requests",
  Review = "review",
}

export enum DfeOperatorType {
  Contains = "contains",
  EndsWith = "endsWith",
  Equals = "equals",
  GreaterThan = "greaterThan",
  GreaterThanOrEqual = "greaterThanOrEqual",
  IsEmpty = "isEmpty",
  IsNotEmpty = "isNotEmpty",
  LessThan = "lessThan",
  LessThanOrEqual = "lessThanOrEqual",
  Matches = "matches",
  NotContains = "notContains",
  NotEquals = "notEquals",
  NotMatches = "notMatches",
  StartsWith = "startsWith",
}

export type DfeRequestInput = {
  requestId?: InputMaybe<Scalars["ID"]["input"]>
  templateId?: InputMaybe<Scalars["ID"]["input"]>
}

export type DfeTemplateInfo = IConfigBase & {
  __typename?: "DfeTemplateInfo"
  templateId?: Maybe<Scalars["ID"]["output"]>
  templateRevisionId?: Maybe<Scalars["ID"]["output"]>
}

export type DfeValidation = {
  __typename?: "DfeValidation"
  messages?: Maybe<DfeValidationMessages>
  rules?: Maybe<DfeValidationRules>
}

export type DfeValidationInput = {
  messages?: InputMaybe<DfeValidationMessagesInput>
  rules?: InputMaybe<DfeValidationRulesInput>
}

export type DfeValidationMessages = {
  __typename?: "DfeValidationMessages"
  custom?: Maybe<Scalars["String"]["output"]>
  greaterThan?: Maybe<Scalars["String"]["output"]>
  lessThan?: Maybe<Scalars["String"]["output"]>
  maxLength?: Maybe<Scalars["String"]["output"]>
  minLength?: Maybe<Scalars["String"]["output"]>
  pattern?: Maybe<Scalars["String"]["output"]>
  required?: Maybe<Scalars["String"]["output"]>
}

export type DfeValidationMessagesInput = {
  custom?: InputMaybe<Scalars["String"]["input"]>
  greaterThan?: InputMaybe<Scalars["String"]["input"]>
  lessThan?: InputMaybe<Scalars["String"]["input"]>
  maxLength?: InputMaybe<Scalars["String"]["input"]>
  minLength?: InputMaybe<Scalars["String"]["input"]>
  pattern?: InputMaybe<Scalars["String"]["input"]>
  required?: InputMaybe<Scalars["String"]["input"]>
}

export type DfeValidationRules = {
  __typename?: "DfeValidationRules"
  crossFieldValidation?: Maybe<DfeCrossFieldValidation>
  custom?: Maybe<DfeCustomRule>
  greaterThan?: Maybe<Scalars["Float"]["output"]>
  length?: Maybe<Scalars["Int"]["output"]>
  lessThan?: Maybe<Scalars["Float"]["output"]>
  maxLength?: Maybe<Scalars["Int"]["output"]>
  minLength?: Maybe<Scalars["Int"]["output"]>
  pattern?: Maybe<Scalars["String"]["output"]>
  required?: Maybe<Scalars["Boolean"]["output"]>
}

export type DfeValidationRulesInput = {
  custom?: InputMaybe<DfeCustomRuleInput>
  greaterThan?: InputMaybe<Scalars["Float"]["input"]>
  lessThan?: InputMaybe<Scalars["Float"]["input"]>
  maxLength?: InputMaybe<Scalars["Int"]["input"]>
  minLength?: InputMaybe<Scalars["Int"]["input"]>
  pattern?: InputMaybe<Scalars["String"]["input"]>
  required?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type DfeValueUnitPair = {
  __typename?: "DfeValueUnitPair"
  unit: Scalars["String"]["output"]
  value: Scalars["String"]["output"]
}

export enum DisplayType {
  FreeText = "FREE_TEXT",
  RestrictedList = "RESTRICTED_LIST",
  UnrestrictedList = "UNRESTRICTED_LIST",
}

export type DisplayTypeSettings = {
  __typename?: "DisplayTypeSettings"
  columnsToDisplay?: Maybe<ColumnsToDisplay>
  maxFieldLength?: Maybe<Scalars["Int"]["output"]>
  referenceDataList?: Maybe<ReferenceDataList>
  sortOrder?: Maybe<SortOrder>
}

export type DisplayTypeSettingsInput = {
  columnsToDisplay?: InputMaybe<ColumnsToDisplay>
  maxFieldLength?: InputMaybe<Scalars["Int"]["input"]>
  referenceDataList?: InputMaybe<Scalars["ID"]["input"]>
  sortOrder?: InputMaybe<SortOrder>
}

export enum DisplayedBoxWidth {
  Full = "FULL",
  Half = "HALF",
  Quarter = "QUARTER",
  Third = "THIRD",
}

export type DownloadExportRequestsCsvInput = {
  exportRequestType: ExportRequestType
  filter?: InputMaybe<Scalars["String"]["input"]>
  highlightFullFields?: InputMaybe<Scalars["String"]["input"]>
  infix?: InputMaybe<Scalars["String"]["input"]>
  query?: InputMaybe<Scalars["String"]["input"]>
  queryBy?: InputMaybe<Scalars["String"]["input"]>
  queryByWeights?: InputMaybe<Scalars["String"]["input"]>
}

export type DownloadStatusReportInput = {
  consignorIds?: InputMaybe<Array<Scalars["String"]["input"]>>
  dateRangeEnd: Scalars["AWSDateTime"]["input"]
  dateRangeStart: Scalars["AWSDateTime"]["input"]
  reportType: StatusReportType
}

export type DownloadSupportingDocumentsCsvInput = {
  filter?: InputMaybe<Scalars["String"]["input"]>
  infix?: InputMaybe<Scalars["String"]["input"]>
  query?: InputMaybe<Scalars["String"]["input"]>
  queryBy?: InputMaybe<Scalars["String"]["input"]>
}

export type DownloadTransferProcessHistoryXmlInput = {
  certificateId: Scalars["ID"]["input"]
  requestOrigin?: InputMaybe<RequestOrigin>
  systemAccountName?: InputMaybe<Scalars["String"]["input"]>
  userId?: InputMaybe<Scalars["String"]["input"]>
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
}

export type DownloadTransferRequestsCsvInput = {
  filter?: InputMaybe<Scalars["String"]["input"]>
  infix?: InputMaybe<Scalars["String"]["input"]>
  query?: InputMaybe<Scalars["String"]["input"]>
  queryBy?: InputMaybe<Scalars["String"]["input"]>
}

export enum DraftCertificateExecutionStatus {
  Aborted = "ABORTED",
  Failed = "FAILED",
  Running = "RUNNING",
  Succeeded = "SUCCEEDED",
  TimedOut = "TIMED_OUT",
}

export type DraftCertificateGenerationStatusResponse = {
  __typename?: "DraftCertificateGenerationStatusResponse"
  error?: Maybe<Scalars["String"]["output"]>
  exportRequestOutputId?: Maybe<Scalars["String"]["output"]>
  isCompleted: Scalars["Boolean"]["output"]
  pdfCertificateUrl?: Maybe<Scalars["String"]["output"]>
  status: DraftCertificateExecutionStatus
}

export type DraftExportCertificate = {
  __typename?: "DraftExportCertificate"
  executionArn: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
}

export type EStarOrganisation = {
  __typename?: "EStarOrganisation"
  id: Scalars["ID"]["output"]
  name: Scalars["String"]["output"]
}

export type EStarOrganisationFilter = {
  q?: InputMaybe<Scalars["String"]["input"]>
}

export type EuIngredient = {
  __typename?: "EUIngredient"
  allergen: Scalars["Boolean"]["output"]
  eNumber?: Maybe<Scalars["String"]["output"]>
  functionalCategory?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  ingredient: Scalars["String"]["output"]
  useENumber?: Maybe<Scalars["Boolean"]["output"]>
}

export type EuIngredientInput = {
  allergen: Scalars["Boolean"]["input"]
  eNumber?: InputMaybe<Scalars["String"]["input"]>
  functionalCategory?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
  ingredient: Scalars["String"]["input"]
  useENumber?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type EuIngredientsTemplate = {
  __typename?: "EUIngredientsTemplate"
  as_formatted_paragraph?: Maybe<Scalars["String"]["output"]>
}

export enum EditReasonCategory {
  ChangeOfContainerSeal = "CHANGE_OF_CONTAINER_SEAL",
  ChangeOfFlight = "CHANGE_OF_FLIGHT",
  ConsigneeDetails = "CONSIGNEE_DETAILS",
  ConsignmentDoesNotMeetImportingMarketRequirements = "CONSIGNMENT_DOES_NOT_MEET_IMPORTING_MARKET_REQUIREMENTS",
  ContainerSeal = "CONTAINER_SEAL",
  DateOfInspection = "DATE_OF_INSPECTION",
  Declarations = "DECLARATIONS",
  DestinationDetails = "DESTINATION_DETAILS",
  ExporterDetails = "EXPORTER_DETAILS",
  ImportPermitNumber = "IMPORT_PERMIT_NUMBER",
  LoadingPort = "LOADING_PORT",
  NoLongerRequired = "NO_LONGER_REQUIRED",
  OfficialInformationStatement = "OFFICIAL_INFORMATION_STATEMENT",
  Other = "OTHER",
  PackagingDetails = "PACKAGING_DETAILS",
  PaperCertificateLost = "PAPER_CERTIFICATE_LOST",
  ProcessingDates = "PROCESSING_DATES",
  ProcessingTreatmentDetails = "PROCESSING_TREATMENT_DETAILS",
  ProductDescription = "PRODUCT_DESCRIPTION",
  Quantity = "QUANTITY",
  UnofficialUnverifiedCommercialInformation = "UNOFFICIAL_UNVERIFIED_COMMERCIAL_INFORMATION",
  VesselVoyage = "VESSEL_VOYAGE",
}

export type EgRequestInput = {
  businessRuleConfig?: InputMaybe<BusinessRuleConfigInput>
  data?: InputMaybe<Scalars["AWSJSON"]["input"]>
  dfeConfig?: InputMaybe<DfeConfigInput>
}

export type EligibilityInput = {
  commodity?: InputMaybe<Scalars["String"]["input"]>
  destinationMarket?: InputMaybe<DestinationMarket>
}

export type EligibilityResponse = {
  __typename?: "EligibilityResponse"
  destinationMarket?: Maybe<DestinationMarket>
  eligibilityCriteria: Scalars["String"]["output"]
}

export type EligibilityResponseInput = {
  eligibilityCriteria: Scalars["String"]["input"]
}

export type EligibilityType = DecisionTableBaseInput & {
  __typename?: "EligibilityType"
  commodity?: Maybe<Scalars["String"]["output"]>
  destinationMarket?: Maybe<DestinationMarket>
  validFrom?: Maybe<Scalars["AWSDateTime"]["output"]>
  validUntil?: Maybe<Scalars["AWSDateTime"]["output"]>
}

export type EnumerationInfo = {
  __typename?: "EnumerationInfo"
  label: Scalars["String"]["output"]
  value: Scalars["String"]["output"]
}

export type EstarCancelRequest = {
  __typename?: "EstarCancelRequest"
  executionArn: Scalars["ID"]["output"]
}

export type ExhaustTransferProductItem = {
  productIds: Array<Scalars["ID"]["input"]>
  transferRequestId: Scalars["ID"]["input"]
}

export type ExhaustTransferProductResult = {
  __typename?: "ExhaustTransferProductResult"
  isFullyExhausted: Scalars["Boolean"]["output"]
  products: Array<TransferProductDetails>
  transferRequestId: Scalars["ID"]["output"]
}

export type ExhaustTransferProductsInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>
  transferProducts: Array<ExhaustTransferProductItem>
}

export type ExhaustTransferProductsResponse = {
  __typename?: "ExhaustTransferProductsResponse"
  results: Array<ExhaustTransferProductResult>
}

export type ExhaustTransferRequestInput = {
  certificateNumber: Scalars["String"]["input"]
  comment?: InputMaybe<Scalars["String"]["input"]>
  requestOrigin?: InputMaybe<RequestOrigin>
  systemAccountName?: InputMaybe<Scalars["String"]["input"]>
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
}

export type ExhaustTransferRequestResponse = {
  __typename?: "ExhaustTransferRequestResponse"
  certificateNumber: Scalars["String"]["output"]
  isFullyExhausted: Scalars["Boolean"]["output"]
  transferRequestId: Scalars["ID"]["output"]
}

export type ExhaustionResponse = {
  __typename?: "ExhaustionResponse"
  exhaust?: Maybe<Scalars["Boolean"]["output"]>
  products?: Maybe<Array<Maybe<ProductExhaustionResponse>>>
  transferId?: Maybe<Scalars["String"]["output"]>
}

export type ExportCertificateCollectionInput = {
  action: CertificateCollectionAction
  certificateId: Scalars["String"]["input"]
  reasonInformation?: InputMaybe<Scalars["String"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
  systemUserName?: InputMaybe<Scalars["String"]["input"]>
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
}

export type ExportCertificateCollectionResponse = {
  __typename?: "ExportCertificateCollectionResponse"
  certificateNumber?: Maybe<Scalars["String"]["output"]>
  message: Scalars["String"]["output"]
  success: Scalars["Boolean"]["output"]
}

export type ExportCertificateRequest = {
  __typename?: "ExportCertificateRequest"
  certificate_id?: Maybe<Scalars["String"]["output"]>
  certificate_type: CertificateType
  certifier?: Maybe<SpsAuthentication>
  commodity?: Maybe<Scalars["String"]["output"]>
  consignment: SpsConsignment
  destination_market: DestinationMarket
  id: Scalars["ID"]["output"]
  reason_for_status_change?: Maybe<Scalars["String"]["output"]>
  requestor?: Maybe<Scalars["String"]["output"]>
  requestor_id?: Maybe<Scalars["String"]["output"]>
  state_machine_execution_arn?: Maybe<Scalars["String"]["output"]>
  status: ExportCertificateStatus
  verifiers: Array<SpsAuthentication>
}

export type ExportCertificateRequestInput = {
  certificate_id?: InputMaybe<Scalars["String"]["input"]>
  certificate_type: CertificateType
  certifier?: InputMaybe<SpsAuthenticationInput>
  commodity?: InputMaybe<Scalars["String"]["input"]>
  consignment: SpsConsignmentInput
  destination_market: DestinationMarket
  reason_for_status_change?: InputMaybe<Scalars["String"]["input"]>
  requestor?: InputMaybe<Scalars["String"]["input"]>
  requestor_id?: InputMaybe<Scalars["String"]["input"]>
  status: ExportCertificateStatus
  verifiers?: InputMaybe<Array<SpsAuthenticationInput>>
}

export enum ExportCertificateStatus {
  Accepted = "ACCEPTED",
  Acknowledged = "ACKNOWLEDGED",
  Amended = "AMENDED",
  Approved = "APPROVED",
  Cancelled = "CANCELLED",
  Draft = "DRAFT",
  PendingReplacement = "PENDING_REPLACEMENT",
  ProvisionallyApproved = "PROVISIONALLY_APPROVED",
  Raised = "RAISED",
  Replaced = "REPLACED",
  ReplacementAuthorised = "REPLACEMENT_AUTHORISED",
  RequestedToReplace = "REQUESTED_TO_REPLACE",
  RequestedToResubmit = "REQUESTED_TO_RESUBMIT",
  RequestedToRevoke = "REQUESTED_TO_REVOKE",
  Revoked = "REVOKED",
  Verified = "VERIFIED",
}

export type ExportCertificateSupportingDocumentsInput = {
  requestor?: InputMaybe<Scalars["String"]["input"]>
  requestor_id: Scalars["ID"]["input"]
}

export type ExportCertificateWorkflowInput = {
  certificateType?: InputMaybe<CertificateType>
}

export type ExportCertificateWorkflowResponse = {
  __typename?: "ExportCertificateWorkflowResponse"
  validatonNeeded: Scalars["Boolean"]["output"]
}

export type ExportCertificateWorkflowResponseInput = {
  validatonNeeded: Scalars["Boolean"]["input"]
}

export type ExportCertificateWorkflowType = DecisionTableBaseInput & {
  __typename?: "ExportCertificateWorkflowType"
  certificateType?: Maybe<CertificateType>
  validFrom?: Maybe<Scalars["AWSDateTime"]["output"]>
  validUntil?: Maybe<Scalars["AWSDateTime"]["output"]>
}

export type ExportCsvResponse = {
  __typename?: "ExportCsvResponse"
  filename: Scalars["String"]["output"]
  presignedUrl: Scalars["String"]["output"]
}

export type ExportDetailsInput = {
  id: Scalars["ID"]["input"]
}

export enum ExportReasonCategory {
  Compliance = "COMPLIANCE",
}

export type ExportRequestHistoryInput = {
  exportRequestId: Scalars["ID"]["input"]
}

export type ExportRequestHistoryRecord = {
  __typename?: "ExportRequestHistoryRecord"
  action?: Maybe<Scalars["String"]["output"]>
  exportRequestId: Scalars["ID"]["output"]
  id: Scalars["ID"]["output"]
  nzxmlURI?: Maybe<Scalars["String"]["output"]>
  overseasAuthorityInvolved?: Maybe<Scalars["Boolean"]["output"]>
  reasonCategories?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  reasonForReprinting?: Maybe<Scalars["String"]["output"]>
  reasonForStatusChange?: Maybe<Scalars["String"]["output"]>
  replacesId?: Maybe<Scalars["ID"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  substatus?: Maybe<Scalars["String"]["output"]>
  templateVersionId?: Maybe<Scalars["ID"]["output"]>
  updatedAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  updatedBy?: Maybe<Scalars["String"]["output"]>
  updatedByFullName?: Maybe<Scalars["String"]["output"]>
  updatedByProfileFullName?: Maybe<Scalars["String"]["output"]>
  updatedByProfileName?: Maybe<Scalars["String"]["output"]>
  updatedBySystem?: Maybe<Scalars["String"]["output"]>
}

export enum ExportRequestOutputAssuranceType {
  Copy = "COPY",
  Draft = "DRAFT",
  Extract = "EXTRACT",
  Official = "OFFICIAL",
}

export enum ExportRequestOutputFileType {
  Pdf = "PDF",
  Xml = "XML",
}

export enum ExportRequestOutputStatus {
  Failed = "FAILED",
  Success = "SUCCESS",
}

export enum ExportRequestType {
  AnimalProducts = "ANIMAL_PRODUCTS",
  OcaBorder = "OCA_BORDER",
  PlantsProducts = "PLANTS_PRODUCTS",
  Wine = "WINE",
}

export type ExportSpsAcknowledgementInput = {
  certificateNumber: Scalars["String"]["input"]
  reasonInformation?: InputMaybe<Scalars["String"]["input"]>
  source: Scalars["String"]["input"]
  status: CoreStatus
  systemUserName?: InputMaybe<Scalars["String"]["input"]>
}

export type ExportSpsAcknowledgementResponse = {
  __typename?: "ExportSPSAcknowledgementResponse"
  message: Scalars["String"]["output"]
  success: Scalars["Boolean"]["output"]
  updatedStatus?: Maybe<Scalars["String"]["output"]>
}

export enum ExportStatus {
  Accepted = "ACCEPTED",
  Acknowledged = "ACKNOWLEDGED",
  Amended = "AMENDED",
  Approved = "APPROVED",
  Cancelled = "CANCELLED",
  Detained = "DETAINED",
  Draft = "DRAFT",
  Partial = "PARTIAL",
  PendingReplacement = "PENDING_REPLACEMENT",
  Raised = "RAISED",
  Rejected = "REJECTED",
  Replaced = "REPLACED",
  ReplacementAuthorised = "REPLACEMENT_AUTHORISED",
  RequestReplacement = "REQUEST_REPLACEMENT",
  Resubmit = "RESUBMIT",
  Revoked = "REVOKED",
}

export type ExtendIntendedOperatorInput = {
  extendIntendedOperator: Array<InputMaybe<CoreLookupInput>>
  id: Scalars["ID"]["input"]
  reason?: InputMaybe<Scalars["String"]["input"]>
}

export type Field = {
  __typename?: "Field"
  name?: Maybe<Scalars["String"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  valid?: Maybe<Scalars["Boolean"]["output"]>
}

export type FieldBySubmissionLayout = {
  __typename?: "FieldBySubmissionLayout"
  active: Scalars["Boolean"]["output"]
  captionList: Array<ReferenceCaption>
  defaultDisplayType?: Maybe<Scalars["String"]["output"]>
  fieldCategory?: Maybe<Scalars["String"]["output"]>
  fieldName: Scalars["String"]["output"]
  fieldUniqueId: Scalars["String"]["output"]
  referenceDataList: Array<ReferenceDataList>
  sectionName?: Maybe<Scalars["String"]["output"]>
}

export type FieldConfiguration = {
  __typename?: "FieldConfiguration"
  displayType: Scalars["String"]["output"]
  isActive: Scalars["Boolean"]["output"]
}

export type FieldFilterInput = {
  classificationCode: Scalars["String"]["input"]
}

export type FieldInfo = {
  __typename?: "FieldInfo"
  fieldUniqueId: Scalars["String"]["output"]
}

export type FieldInput = {
  __typename?: "FieldInput"
  defaultValue?: Maybe<Scalars["String"]["output"]>
  fieldRef: Scalars["String"]["output"]
  inputType: Scalars["String"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  placeholder?: Maybe<Scalars["String"]["output"]>
  readOnly?: Maybe<Scalars["Boolean"]["output"]>
}

export type FieldV2 = {
  __typename?: "FieldV2"
  category?: Maybe<Scalars["String"]["output"]>
  grouping?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  productHierarchy?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  reference?: Maybe<Scalars["String"]["output"]>
  valid?: Maybe<Scalars["Boolean"]["output"]>
}

export type FlexiFillingRunData = {
  __typename?: "FlexiFillingRunData"
  date: Scalars["AWSDateTime"]["output"]
  id: Scalars["ID"]["output"]
  litres: Scalars["Float"]["output"]
  reference: Scalars["String"]["output"]
}

export type FlexiFillingRunDataInput = {
  date: Scalars["AWSDateTime"]["input"]
  id?: InputMaybe<Scalars["ID"]["input"]>
  litres: Scalars["Float"]["input"]
  reference: Scalars["String"]["input"]
}

export type FlexiFillingRunInput = {
  processId: Scalars["ID"]["input"]
  runs: Array<FlexiFillingRunDataInput>
}

export type FlexiFillingRunResponse = {
  __typename?: "FlexiFillingRunResponse"
  processId: Scalars["ID"]["output"]
  runs: Array<FlexiFillingRunData>
}

export type Form = {
  __typename?: "Form"
  declarations: Array<DeclarationFormletSection>
  productDetails: Array<FormletField>
}

export type FormletCollectionFilter = {
  __typename?: "FormletCollectionFilter"
  attribute: Scalars["String"]["output"]
  value: Scalars["String"]["output"]
}

export type FormletField = {
  __typename?: "FormletField"
  charLength?: Maybe<Scalars["Int"]["output"]>
  collection?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  filter?: Maybe<FormletCollectionFilter>
  id: Scalars["String"]["output"]
  label?: Maybe<Scalars["String"]["output"]>
  nested?: Maybe<Array<Maybe<FormletNestedFields>>>
  numberConstrain?: Maybe<NumberConstrain>
  numberOfLines?: Maybe<Scalars["Int"]["output"]>
  options?: Maybe<Array<Maybe<FormletOption>>>
  readonly?: Maybe<Scalars["Boolean"]["output"]>
  required?: Maybe<Scalars["Boolean"]["output"]>
  sectionFields?: Maybe<Array<Maybe<FormletField>>>
  type?: Maybe<FormletFieldType>
  value?: Maybe<Scalars["String"]["output"]>
}

export enum FormletFieldType {
  Checkbox = "CHECKBOX",
  Date = "DATE",
  LongText = "LONG_TEXT",
  MultilineText = "MULTILINE_TEXT",
  MultisearchTable = "MULTISEARCH_TABLE",
  Nested = "NESTED",
  Number = "NUMBER",
  Parallel = "PARALLEL",
  Party = "PARTY",
  Radio = "RADIO",
  Search = "SEARCH",
  Select = "SELECT",
  ShortText = "SHORT_TEXT",
  ShortTextArray = "SHORT_TEXT_ARRAY",
}

export type FormletNestedFields = {
  __typename?: "FormletNestedFields"
  collection?: Maybe<Scalars["String"]["output"]>
  description: Scalars["String"]["output"]
  id: Scalars["String"]["output"]
  type: FormletFieldType
}

export type FormletOption = {
  __typename?: "FormletOption"
  label: Scalars["String"]["output"]
  value: Scalars["String"]["output"]
}

export type ForwardProductTrackingResponse = {
  __typename?: "ForwardProductTrackingResponse"
  sourceProducts: Array<SourceProductTracking>
}

export type G2GAccount = {
  __typename?: "G2GAccount"
  accountType: G2GAccountType
  comment?: Maybe<Scalars["String"]["output"]>
  contactNumber: Scalars["String"]["output"]
  createdAt: Scalars["String"]["output"]
  createdBy?: Maybe<Scalars["String"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  fullName: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  jobTitle?: Maybe<Scalars["String"]["output"]>
  permissions: G2GPermissions
  profileName?: Maybe<Scalars["String"]["output"]>
  reason?: Maybe<SuspensionReason>
  status: G2GAccountStatus
  subId?: Maybe<Scalars["String"]["output"]>
  systemUsername?: Maybe<Scalars["String"]["output"]>
  updatedAt: Scalars["String"]["output"]
  updatedBy?: Maybe<Scalars["String"]["output"]>
}

export type G2GAccountSearchResult = {
  __typename?: "G2GAccountSearchResult"
  results: Array<G2GAccountSummary>
  totalCount: Scalars["Int"]["output"]
}

export enum G2GAccountStatus {
  Active = "ACTIVE",
  Deleted = "DELETED",
  Suspended = "SUSPENDED",
}

export type G2GAccountSummary = {
  __typename?: "G2GAccountSummary"
  accountType: G2GAccountType
  agencyName?: Maybe<Scalars["String"]["output"]>
  certificateTypes?: Maybe<Array<CoreExportCertificateType>>
  countries?: Maybe<Array<Scalars["String"]["output"]>>
  email?: Maybe<Scalars["String"]["output"]>
  fullName: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  inspectionPorts?: Maybe<Array<Scalars["String"]["output"]>>
  status: G2GAccountStatus
  subId?: Maybe<Scalars["String"]["output"]>
  systemUsername?: Maybe<Scalars["String"]["output"]>
  updatedAt: Scalars["String"]["output"]
}

export enum G2GAccountType {
  G2GReadOnly = "G2G_READ_ONLY",
  G2GSystem = "G2G_SYSTEM",
  OcaBorderInspector = "OCA_BORDER_INSPECTOR",
}

export type G2GPermissions = {
  __typename?: "G2GPermissions"
  agencyId?: Maybe<Scalars["String"]["output"]>
  agencyName?: Maybe<Scalars["String"]["output"]>
  certificateTypes: Array<CoreExportCertificateType>
  countries?: Maybe<Array<Scalars["String"]["output"]>>
  inspectionPorts?: Maybe<Array<Scalars["String"]["output"]>>
}

export type G2GPermissionsInput = {
  agencyId?: InputMaybe<Scalars["String"]["input"]>
  certificateTypes: Array<CoreExportCertificateType>
  countries?: InputMaybe<Array<Scalars["String"]["input"]>>
  inspectionPorts?: InputMaybe<Array<Scalars["String"]["input"]>>
}

export type GenerateDraftExportCertificateInput = {
  requestor?: InputMaybe<Scalars["String"]["input"]>
  requestor_id: Scalars["ID"]["input"]
}

export type GenerateOutputPreviewXmlResult = {
  __typename?: "GenerateOutputPreviewXMLResult"
  templateVersionId: Scalars["ID"]["output"]
}

export type GenerateSubmissionPreviewXmlResponse = {
  __typename?: "GenerateSubmissionPreviewXmlResponse"
  error?: Maybe<Scalars["String"]["output"]>
  presignedUrl?: Maybe<Scalars["String"]["output"]>
  success: Scalars["Boolean"]["output"]
}

export type GeneratedCertificate = {
  __typename?: "GeneratedCertificate"
  createdAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  createdBy?: Maybe<Scalars["String"]["output"]>
  fileExtension?: Maybe<Scalars["String"]["output"]>
  fileName?: Maybe<Scalars["String"]["output"]>
  fileVersion?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
}

export enum GeneratedCertificateType {
  Copy = "COPY",
  Draft = "DRAFT",
  Official = "OFFICIAL",
  Xml = "XML",
}

export type GetDecisionTableRevisionInput = {
  decisionTableId: Scalars["ID"]["input"]
  revisionNumber: Scalars["Int"]["input"]
}

export type GetDecisionTableRevisionResponse = {
  __typename?: "GetDecisionTableRevisionResponse"
  id: Scalars["ID"]["output"]
  inputColumns: Array<DecisionTableColumn>
  responseColumns: Array<DecisionTableColumn>
  revision?: Maybe<DecisionTableRevision>
}

export type GetDfeFormInput = {
  recipeType?: InputMaybe<RecipeType>
  templateId: Scalars["ID"]["input"]
  templateVersionId: Scalars["ID"]["input"]
}

export type GetDraftCertificateGenerationStatusInput = {
  executionArn: Scalars["String"]["input"]
}

export type GetRequestValidationsInput = {
  requestId: Scalars["ID"]["input"]
  requestType: CoreRequestType
  skipFieldValidation?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type GetRequestValidationsResponse = {
  __typename?: "GetRequestValidationsResponse"
  errors: Array<RequestValidation>
  warnings: Array<RequestValidation>
}

export type GetSignedCertificateXmlInput = {
  certificateNumber: Scalars["String"]["input"]
  requestOrigin?: InputMaybe<RequestOrigin>
  systemAccountName?: InputMaybe<Scalars["String"]["input"]>
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
}

export type GetSignedCertificateXmlResponse = {
  __typename?: "GetSignedCertificateXmlResponse"
  s3Path: Scalars["String"]["output"]
}

export type GetSupportingDocumentActionsInput = {
  id: Scalars["ID"]["input"]
}

export type GetSupportingDocumentDetailsInput = {
  id: Scalars["ID"]["input"]
}

export type GetSupportingDocumentHistoryInput = {
  supportingDocumentId: Scalars["ID"]["input"]
}

export type GetTemplateXmlCoreInput = {
  b2gProfileName?: InputMaybe<Scalars["String"]["input"]>
  b2gSystemName?: InputMaybe<Scalars["String"]["input"]>
  templateId: Scalars["String"]["input"]
  templateType: Scalars["String"]["input"]
}

export type GetTemplateXmlCoreResponse = {
  __typename?: "GetTemplateXmlCoreResponse"
  template?: Maybe<Scalars["String"]["output"]>
  templateId?: Maybe<Scalars["String"]["output"]>
}

export type IConfig = {
  fields?: Maybe<Array<Maybe<IConfigField>>>
}

export type IConfigBase = {
  templateId?: Maybe<Scalars["ID"]["output"]>
  templateRevisionId?: Maybe<Scalars["ID"]["output"]>
}

export type IConfigField = {
  fuid?: Maybe<Scalars["ID"]["output"]>
}

export type IDfeValidationRules = {
  largerThan?: Maybe<Scalars["Float"]["output"]>
  length?: Maybe<Scalars["Int"]["output"]>
  lessThan?: Maybe<Scalars["Float"]["output"]>
  maxLength?: Maybe<Scalars["Int"]["output"]>
  minLength?: Maybe<Scalars["Int"]["output"]>
  pattern?: Maybe<Scalars["String"]["output"]>
}

export type IDsTemplate = {
  __typename?: "IDsTemplate"
  as_rows: Array<Scalars["String"]["output"]>
  comma_separated: Scalars["String"]["output"]
  new_line_separated: Scalars["String"]["output"]
}

export type IMeasureTemplate = {
  as_number: Scalars["Float"]["output"]
  mpi_unit?: Maybe<Scalars["String"]["output"]>
  number?: Maybe<Scalars["String"]["output"]>
  three_decimals?: Maybe<Scalars["String"]["output"]>
  unit?: Maybe<Scalars["String"]["output"]>
  value?: Maybe<Scalars["String"]["output"]>
}

export type IppcHubLogEntry = {
  __typename?: "IPPCHubLogEntry"
  /** @deprecated Use certificateNumber */
  certificateId?: Maybe<Scalars["String"]["output"]>
  certificateNumber?: Maybe<Scalars["String"]["output"]>
  date: Scalars["AWSDateTime"]["output"]
  exportCountryCode: Scalars["String"]["output"]
  hubDeliveryNumber: Scalars["String"]["output"]
  hubTrackingInfo: Scalars["String"]["output"]
  id?: Maybe<Scalars["ID"]["output"]>
  message: Scalars["String"]["output"]
}

export type IppcHubLogInput = {
  /** @deprecated Use certificateNumber */
  certificateId?: InputMaybe<Scalars["String"]["input"]>
  certificateNumber?: InputMaybe<Scalars["String"]["input"]>
  exportCountryCode: Scalars["String"]["input"]
  hubDeliveryNumber: Scalars["String"]["input"]
  hubTrackingInfo: Scalars["String"]["input"]
  message: Scalars["String"]["input"]
}

export type ITemplateProcessGroup = {
  id?: Maybe<Scalars["String"]["output"]>
}

export type ImportCertificate = {
  __typename?: "ImportCertificate"
  certificate_id: Scalars["String"]["output"]
  /** @deprecated Use consignment.consignee */
  consignee?: Maybe<SpsParty>
  consignment: SpsConsignment
  /** @deprecated Use consignment.consignor */
  consignor?: Maybe<SpsParty>
  /** @deprecated Use exchanged_document.referenced_documents */
  embeddedDocument: Array<ImportCertificateEmbeddedDocument>
  exchanged_document: SpsExchangedDocument
  export_country: SpsCountry
  id: Scalars["ID"]["output"]
  /** @deprecated Use consignment.import_country */
  import_country: SpsCountry
  /** @deprecated Use exchanged_document.included_notes */
  included_notes: Array<SpsNote>
  ippcLogs: Array<IppcHubLogEntry>
  issued?: Maybe<Scalars["AWSDateTime"]["output"]>
  /** @deprecated Use exchanged_document.issuer */
  issuer?: Maybe<SpsParty>
  items: Array<SpsTradeLineItem>
  /** @deprecated Use consignment.main_carriage_transport_movements */
  last_transport_movement?: Maybe<SpsTransportMovement>
  /** @deprecated Use consignment.loading_base_port_location */
  loading_base_port_location?: Maybe<SpsLocation>
  logs: Array<ImportCertificateLogMessage>
  /** @deprecated Use consignment.main_carriage_transport_movements */
  main_carriage_transport_movements?: Maybe<Array<SpsTransportMovement>>
  pdf_generated: PdfGenerationStatus
  /** @deprecated Use exchanged_document.referenced_documents */
  referenced_documents: Array<SpsReferencedDocument>
  replaced_by?: Maybe<ImportCertificate>
  replacement_reason?: Maybe<Scalars["String"]["output"]>
  replacing?: Maybe<ImportCertificate>
  replacing_certificate_number?: Maybe<Scalars["String"]["output"]>
  /** @deprecated Use exchanged_document.signatories */
  signatories: Array<SpsAuthentication>
  status: ImportCertificateStatus
  status_code: Scalars["Int"]["output"]
  /** @deprecated Use consignment.transit_countries */
  transit_countries?: Maybe<Array<SpsCountry>>
  type_code: Scalars["Int"]["output"]
  type_name?: Maybe<Scalars["String"]["output"]>
  /** @deprecated Use consignment.unloading_base_port_location */
  unloading_base_port_location?: Maybe<SpsLocation>
  /** @deprecated Use consignment.utilized_transport_equipment */
  utilized_transport_equipment: Array<SpsTransportEquipment>
}

export type ImportCertificateEmbeddedDocument = {
  __typename?: "ImportCertificateEmbeddedDocument"
  description?: Maybe<Scalars["String"]["output"]>
  documentID: Scalars["String"]["output"]
  file_name: Scalars["String"]["output"]
  file_size?: Maybe<Scalars["String"]["output"]>
  file_type: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  url?: Maybe<Scalars["String"]["output"]>
}

export type ImportCertificateExtractItem = {
  __typename?: "ImportCertificateExtractItem"
  code: Scalars["String"]["output"]
  items?: Maybe<Array<ImportCertificateExtractItem>>
  label: Scalars["String"]["output"]
  value: Scalars["String"]["output"]
}

export type ImportCertificateExtractMeasurement = {
  __typename?: "ImportCertificateExtractMeasurement"
  code: Scalars["String"]["output"]
  label: Scalars["String"]["output"]
  measures?: Maybe<Array<ImportCertificateExtractItem>>
  value: Scalars["String"]["output"]
}

export type ImportCertificateExtractTemplate = {
  __typename?: "ImportCertificateExtractTemplate"
  as_items?: Maybe<Scalars["String"]["output"]>
}

export type ImportCertificateIntegration = {
  __typename?: "ImportCertificateIntegration"
  countryCode: Scalars["String"]["output"]
  receivingSpsAcknowledgement?: Maybe<ImportCertificateIntegrationResponse>
  response?: Maybe<ImportCertificateIntegrationResponse>
}

export enum ImportCertificateIntegrationResponse {
  Accept = "Accept",
  DeliveredNotReadable = "DeliveredNotReadable",
  Ignore = "Ignore",
}

export type ImportCertificateLogMessage = {
  __typename?: "ImportCertificateLogMessage"
  createdBy: Scalars["String"]["output"]
  date?: Maybe<Scalars["AWSDateTime"]["output"]>
  id: Scalars["ID"]["output"]
  message: Scalars["String"]["output"]
  relatedCertificate?: Maybe<ImportCertificate>
  status: ImportCertificateLogStatus
}

export type ImportCertificateLogMessageInput = {
  id: Scalars["ID"]["input"]
  message: Scalars["String"]["input"]
  relatedCertificateId?: InputMaybe<Scalars["ID"]["input"]>
  relatedCertificateNumber?: InputMaybe<Scalars["String"]["input"]>
  status: ImportCertificateLogStatus
}

export enum ImportCertificateLogStatus {
  Acknowledged = "ACKNOWLEDGED",
  Issued = "ISSUED",
  PdfDownloaded = "PDF_DOWNLOADED",
  Rejected = "REJECTED",
  Replaced = "REPLACED",
  ReplacementRequested = "REPLACEMENT_REQUESTED",
  Withdrawn = "WITHDRAWN",
}

export type ImportCertificateMeasurementTemplate = {
  __typename?: "ImportCertificateMeasurementTemplate"
  as_new_lines?: Maybe<Scalars["String"]["output"]>
}

export type ImportCertificatePackagingTemplate = {
  __typename?: "ImportCertificatePackagingTemplate"
  as_new_lines?: Maybe<Scalars["String"]["output"]>
}

export type ImportCertificatePdf = {
  __typename?: "ImportCertificatePdf"
  id: Scalars["ID"]["output"]
  status: PdfGenerationStatus
  url?: Maybe<Scalars["String"]["output"]>
}

export type ImportCertificatePdfInput = {
  id: Scalars["ID"]["input"]
  reason?: InputMaybe<Scalars["String"]["input"]>
}

export enum ImportCertificateStatus {
  Approved = "APPROVED",
  Issued = "ISSUED",
  Rejected = "REJECTED",
  Replaced = "REPLACED",
  ReplacementRequested = "REPLACEMENT_REQUESTED",
  Unrecognised = "UNRECOGNISED",
  Withdrawn = "WITHDRAWN",
}

export type ImportCertificateStatusChangeInput = {
  id: Scalars["ID"]["input"]
  reason: Scalars["String"]["input"]
}

export enum ImportCertificateType {
  Phytosanitary = "PHYTOSANITARY",
  ReexportPhytosanitary = "REEXPORT_PHYTOSANITARY",
  Sanitary = "SANITARY",
}

export type ImportCertificateXml = {
  __typename?: "ImportCertificateXml"
  documentName: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  url: Scalars["String"]["output"]
}

export type ImportConnectionsInput = {
  connectionType?: InputMaybe<ConnectionType>
  countryCode?: InputMaybe<Scalars["String"]["input"]>
}

export type ImportConnectionsResponse = {
  __typename?: "ImportConnectionsResponse"
  applyDigitalSignature: Scalars["Boolean"]["output"]
  connectionType: ConnectionType
  countryCode: Scalars["String"]["output"]
  receiving?: Maybe<ImportCertificateIntegrationResponse>
  receivingSpsAcknowledgement?: Maybe<ImportCertificateIntegrationResponse>
  sending?: Maybe<Scalars["Boolean"]["output"]>
  spsAcknowledgement: Scalars["Boolean"]["output"]
}

export type ImportConnectionsResponseInput = {
  applyDigitalSignature: Scalars["Boolean"]["input"]
  receiving?: InputMaybe<ImportCertificateIntegrationResponse>
  receivingSpsAcknowledgement?: InputMaybe<ImportCertificateIntegrationResponse>
  sending?: InputMaybe<Scalars["Boolean"]["input"]>
  spsAcknowledgement: Scalars["Boolean"]["input"]
}

export type ImportConnectionsType = DecisionTableBaseInput & {
  __typename?: "ImportConnectionsType"
  connectionType?: Maybe<ConnectionType>
  countryCode?: Maybe<Scalars["String"]["output"]>
  validFrom?: Maybe<Scalars["AWSDateTime"]["output"]>
  validUntil?: Maybe<Scalars["AWSDateTime"]["output"]>
}

export type IndicatorType = {
  __typename?: "IndicatorType"
  content: Scalars["String"]["output"]
  format?: Maybe<Scalars["String"]["output"]>
}

export type InitSupportingDocumentUploadInput = {
  b2gProfileName?: InputMaybe<Scalars["String"]["input"]>
  b2gSystemName?: InputMaybe<Scalars["String"]["input"]>
  fileS3Path: Scalars["String"]["input"]
  intendedOperators?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>
  primaryOperator?: InputMaybe<CoreLookupInput>
  requestOrigin?: InputMaybe<RequestOrigin>
}

export type InitSupportingDocumentUploadResponse = {
  __typename?: "InitSupportingDocumentUploadResponse"
  errors?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  fileId: Scalars["ID"]["output"]
}

export type IntTemplate = {
  __typename?: "IntTemplate"
  in_English: Scalars["String"]["output"]
  value: Scalars["String"]["output"]
}

export type IntegrationsAmendExportFromUriInput = {
  requestOrigin?: InputMaybe<RequestOrigin>
  systemAccountName?: InputMaybe<Scalars["String"]["input"]>
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
  xmlS3Path: Scalars["String"]["input"]
}

export type IntegrationsAmendTransferFromUriInput = {
  requestOrigin?: InputMaybe<RequestOrigin>
  systemAccountName?: InputMaybe<Scalars["String"]["input"]>
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
  xmlS3Path: Scalars["String"]["input"]
}

export type IntegrationsCreateSupportingDocumentInput = {
  documentReferenceNumber: Scalars["String"]["input"]
  documentType: Scalars["String"]["input"]
  fileId: Scalars["String"]["input"]
  foreignManufacturePremises?: InputMaybe<Scalars["String"]["input"]>
  foreignPremisesId?: InputMaybe<Scalars["String"]["input"]>
  identificationMarks?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >
  intendedOperators?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  nzManufacturePremises?: InputMaybe<Scalars["String"]["input"]>
  originCountry?: InputMaybe<Scalars["String"]["input"]>
  primaryOperator: Scalars["String"]["input"]
  productDescription?: InputMaybe<Scalars["String"]["input"]>
  productionDates?: InputMaybe<Array<InputMaybe<ProductionDateRangeInput>>>
  requestOrigin?: InputMaybe<RequestOrigin>
  systemAccountName?: InputMaybe<Scalars["String"]["input"]>
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
}

export type IntegrationsDownloadTransferProcessHistoryXmlInput = {
  certificateId: Scalars["ID"]["input"]
  systemAccountName?: InputMaybe<Scalars["String"]["input"]>
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
}

export type IntegrationsExportRequestApFromUriInput = {
  requestOrigin?: InputMaybe<RequestOrigin>
  systemAccountName?: InputMaybe<Scalars["String"]["input"]>
  userId?: InputMaybe<Scalars["String"]["input"]>
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
  xmlS3Path: Scalars["String"]["input"]
  xmlSequenceNumber?: InputMaybe<Scalars["String"]["input"]>
}

export type IntegrationsExportRequestApInput = {
  requestOrigin?: InputMaybe<RequestOrigin>
  systemAccountName?: InputMaybe<Scalars["String"]["input"]>
  userId?: InputMaybe<Scalars["String"]["input"]>
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
  xml: Scalars["String"]["input"]
  xmlSequenceNumber?: InputMaybe<Scalars["String"]["input"]>
}

export type IntegrationsExportRequestPhytoFromUriInput = {
  requestOrigin?: InputMaybe<RequestOrigin>
  systemAccountName?: InputMaybe<Scalars["String"]["input"]>
  userId?: InputMaybe<Scalars["String"]["input"]>
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
  xmlS3Path: Scalars["String"]["input"]
  xmlSequenceNumber?: InputMaybe<Scalars["String"]["input"]>
}

export type IntegrationsExportRequestPhytoInput = {
  requestOrigin?: InputMaybe<RequestOrigin>
  systemAccountName?: InputMaybe<Scalars["String"]["input"]>
  userId?: InputMaybe<Scalars["String"]["input"]>
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
  xml: Scalars["String"]["input"]
  xmlSequenceNumber?: InputMaybe<Scalars["String"]["input"]>
}

export type IntegrationsGetSignedCertificateXmlInput = {
  certificateNumber: Scalars["String"]["input"]
  systemAccountName: Scalars["String"]["input"]
  userProfileName: Scalars["String"]["input"]
}

export type IntegrationsGetTemplateXmlInput = {
  systemAccountName?: InputMaybe<Scalars["String"]["input"]>
  templateId: Scalars["String"]["input"]
  templateType: Scalars["String"]["input"]
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
}

export type IntegrationsGetTemplateXmlResponse = {
  __typename?: "IntegrationsGetTemplateXmlResponse"
  template?: Maybe<Scalars["String"]["output"]>
  templateId?: Maybe<Scalars["String"]["output"]>
}

export type IntegrationsInitSupportingDocumentUploadInput = {
  fileS3Path: Scalars["String"]["input"]
  intendedOperators?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  primaryOperator: Scalars["String"]["input"]
  requestOrigin?: InputMaybe<RequestOrigin>
  systemAccountName?: InputMaybe<Scalars["String"]["input"]>
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
}

export type IntegrationsRaiseTransferFromUriInput = {
  requestOrigin?: InputMaybe<RequestOrigin>
  systemAccountName?: InputMaybe<Scalars["String"]["input"]>
  userId?: InputMaybe<Scalars["String"]["input"]>
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
  xmlS3Path: Scalars["String"]["input"]
}

export type IntegrationsRaiseTransferInput = {
  requestOrigin?: InputMaybe<RequestOrigin>
  systemAccountName?: InputMaybe<Scalars["String"]["input"]>
  userId?: InputMaybe<Scalars["String"]["input"]>
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
  xml: Scalars["String"]["input"]
}

export type IntegrationsReplaceExportCertificateInput = {
  certificateNumber: Scalars["String"]["input"]
  requestOrigin?: InputMaybe<RequestOrigin>
  systemAccountName?: InputMaybe<Scalars["String"]["input"]>
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
  xmlS3Path: Scalars["String"]["input"]
}

export type IntegrationsRequestAmendmentTransferInput = {
  certificateId: Scalars["String"]["input"]
  reason?: InputMaybe<Scalars["String"]["input"]>
  systemAccountName?: InputMaybe<Scalars["String"]["input"]>
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
}

export type IntegrationsRequestReplacementCertificateInput = {
  certificateNumber: Scalars["String"]["input"]
  overseasAuthoritiesInvolved: Scalars["String"]["input"]
  reason: Scalars["String"]["input"]
  systemAccountName?: InputMaybe<Scalars["String"]["input"]>
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
}

export type Language = {
  __typename?: "Language"
  languageCode: Scalars["String"]["output"]
  languageName: Scalars["String"]["output"]
  rightToLeft?: Maybe<Scalars["Boolean"]["output"]>
}

export type Layout = {
  __typename?: "Layout"
  sections: Array<Section>
}

export type Layouts = {
  __typename?: "Layouts"
  products: Layout
  requests: Layout
}

export type LookupValue = {
  __typename?: "LookupValue"
  code?: Maybe<Scalars["String"]["output"]>
  isActive?: Maybe<Scalars["Boolean"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

export type ManualVolumeAdjustment = {
  __typename?: "ManualVolumeAdjustment"
  changeType?: Maybe<Scalars["String"]["output"]>
  date?: Maybe<Scalars["AWSDateTime"]["output"]>
  litres?: Maybe<Scalars["Float"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  reason?: Maybe<Scalars["String"]["output"]>
}

export type ManualVolumeAdjustmentInput = {
  litres: Scalars["Float"]["input"]
  reason: Scalars["String"]["input"]
}

/**
 * Master Layout configuration for different submission types.
 * Contains field definitions and layout structure for form generation.
 */
export type MasterLayout = {
  __typename?: "MasterLayout"
  /** JSON string containing field definitions and validation rules */
  masterFields: Scalars["String"]["output"]
  /** JSON string containing the layout structure with sections and blocks */
  masterLayout: Scalars["String"]["output"]
}

export type MeasureTemplate = IMeasureTemplate & {
  __typename?: "MeasureTemplate"
  as_number: Scalars["Float"]["output"]
  mpi_unit?: Maybe<Scalars["String"]["output"]>
  number?: Maybe<Scalars["String"]["output"]>
  three_decimals?: Maybe<Scalars["String"]["output"]>
  /** @deprecated Use three_decimals */
  three_digits?: Maybe<Scalars["String"]["output"]>
  unit?: Maybe<Scalars["String"]["output"]>
  value?: Maybe<Scalars["String"]["output"]>
}

export type Measurment = {
  __typename?: "Measurment"
  unit?: Maybe<CoreLookup>
  value?: Maybe<Scalars["Float"]["output"]>
}

export type MeasurmentInput = {
  unit?: InputMaybe<CoreLookupInput>
  value?: InputMaybe<Scalars["Float"]["input"]>
}

export type MonthTemplate = {
  __typename?: "MonthTemplate"
  abbreviation: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  number: IntTemplate
}

export type MultiCollectionApiKeys = {
  __typename?: "MultiCollectionApiKeys"
  agency?: Maybe<Scalars["String"]["output"]>
  expires: Scalars["AWSDateTime"]["output"]
  exportCertificates?: Maybe<Scalars["String"]["output"]>
  exporters?: Maybe<Scalars["String"]["output"]>
  partyApiKey?: Maybe<Scalars["String"]["output"]>
  products?: Maybe<Scalars["String"]["output"]>
  registration?: Maybe<Scalars["String"]["output"]>
  registrationAll?: Maybe<Scalars["String"]["output"]>
  transferRequests?: Maybe<Scalars["String"]["output"]>
}

export type MultiCollectionApiKeysV2 = {
  __typename?: "MultiCollectionApiKeysV2"
  agency?: Maybe<Scalars["String"]["output"]>
  expires: Scalars["AWSDateTime"]["output"]
  exporters?: Maybe<Scalars["String"]["output"]>
  exports?: Maybe<RoleSpecificKeys>
  ocaExports?: Maybe<Scalars["String"]["output"]>
  ocaUsers?: Maybe<Scalars["String"]["output"]>
  partyApiKey?: Maybe<Scalars["String"]["output"]>
  products?: Maybe<Scalars["String"]["output"]>
  supportingDocs?: Maybe<SupportingDocumentKeys>
  templates?: Maybe<Scalars["String"]["output"]>
  transfers?: Maybe<RoleSpecificKeys>
}

export type Mutation = {
  __typename?: "Mutation"
  acceptedTermsAndConditions?: Maybe<Scalars["Boolean"]["output"]>
  addBottlingRuns: BottlingRunResponse
  addCustomsPermitNumbers: Scalars["Int"]["output"]
  addFlexiFillingRuns: FlexiFillingRunResponse
  addProduct: B2GProduct
  addProductAndProcessFromTransfer: Array<SavedProductOutput>
  addRegistrationsToUser: Scalars["ID"]["output"]
  adjustBatchVolume: VolumeAdjustmentResponse
  allocateCustomsPermitNumber: Scalars["String"]["output"]
  appendIPPCHubLog: IppcHubLogEntry
  appendImportCertificateLog: Scalars["Boolean"]["output"]
  approveExportCertificateRequest?: Maybe<ExportCertificateRequest>
  attachTemplateDocument: TemplateUploadUrl
  banWineBatch: Scalars["String"]["output"]
  cancelEstarRequest: EstarCancelRequest
  cancelExportCertificateRequest: B2GExportCertificateRequest
  cancelProcess: CancelledProcessResponse
  cancelSupportingDocument?: Maybe<UpdateSupportingDocumentResult>
  changeExportRequestStatus: ChangeExportRequestStatusResponse
  changeTransferRequestAmendmentStatus: ChangeTransferRequestAmendmentStatusResponse
  changeTransferRequestStatus: ChangeTransferRequestStatusResponse
  completeSensoryProcess: SensoryProcessRequest
  confirmPackaging: ConfirmPackagingResponse
  confirmWinemaking: Scalars["String"]["output"]
  createAnnouncement: Announcement
  createSupportingDocument?: Maybe<CoreSupportingDocument>
  createTemplate: Template
  createTemplateVersion: Template
  createTestRegistration?: Maybe<TestRegistration>
  createTestUser?: Maybe<TestUser>
  createUser: User
  deleteAllCustomsPermitNumbers: Scalars["Boolean"]["output"]
  deleteAnnouncement: Announcement
  deleteCoreReferencedDocument?: Maybe<Scalars["String"]["output"]>
  deleteExportCertificateRequest: Scalars["Boolean"]["output"]
  deleteExportRequest: Scalars["Boolean"]["output"]
  deleteExportRequestById: Scalars["Boolean"]["output"]
  deleteFieldConfiguration: Scalars["String"]["output"]
  deleteProduct: Scalars["Boolean"]["output"]
  deleteReferencedDocument: Scalars["ID"]["output"]
  deleteReplacementExportRequest: DeleteReplacementExportRequestResponse
  deleteTemplate: Scalars["String"]["output"]
  deleteTransferRequestById: Scalars["Boolean"]["output"]
  discardExportCertificateRequest: Scalars["Boolean"]["output"]
  discardG2GAccount: Scalars["Boolean"]["output"]
  downloadExportRequestsAsCsv: ExportCsvResponse
  downloadStatusReport: ExportCsvResponse
  downloadSupportingDocumentsAsCsv: ExportCsvResponse
  downloadTransferProcessHistoryXML?: Maybe<TransferProcessHistoryXmlResponse>
  downloadTransferRequestsAsCsv: ExportCsvResponse
  draftExportCertificateRequest: B2GExportCertificateRequest
  e2eRaiseExportCertificateRequest?: Maybe<B2GExportCertificateRequest>
  executeChemistryTestEvent: Scalars["Boolean"]["output"]
  exhaustTransferProducts: ExhaustTransferProductsResponse
  exhaustTransferRequest: ExhaustTransferRequestResponse
  extendIntendedOperator?: Maybe<UpdateSupportingDocumentResult>
  forceApproveTemplateVersion: TemplateVersion
  generateDraftExportCertificate: DraftExportCertificate
  generateDraftPdf: Scalars["String"]["output"]
  generateOutputPreviewXML: GenerateOutputPreviewXmlResult
  generateSpecimenPdf: StandardPdfPreviewResponse
  generateStandardPdfPreview: StandardPdfPreviewResponse
  generateSubmissionPreviewXml: GenerateSubmissionPreviewXmlResponse
  generateTeoConfigurationJson: Scalars["String"]["output"]
  getNewTemplateVersionUploadUrl: TemplateUploadUrl
  getSignedCertificateXml: GetSignedCertificateXmlResponse
  initSupportingDocumentUpload: InitSupportingDocumentUploadResponse
  integrationsAmendExport?: Maybe<Scalars["AWSJSON"]["output"]>
  integrationsAmendTransfer?: Maybe<Scalars["AWSJSON"]["output"]>
  integrationsCreateSupportingDocument?: Maybe<Scalars["AWSJSON"]["output"]>
  integrationsDownloadTransferProcessHistoryXML?: Maybe<
    Scalars["AWSJSON"]["output"]
  >
  integrationsExhaustTransfer?: Maybe<Scalars["AWSJSON"]["output"]>
  integrationsGetSignedCertificateXml?: Maybe<Scalars["AWSJSON"]["output"]>
  integrationsGetTemplateXml: IntegrationsGetTemplateXmlResponse
  integrationsInitSupportingDocumentUpload?: Maybe<Scalars["AWSJSON"]["output"]>
  integrationsRaiseExportRequestAP?: Maybe<Scalars["AWSJSON"]["output"]>
  integrationsRaiseExportRequestAPV2?: Maybe<Scalars["AWSJSON"]["output"]>
  integrationsRaiseExportRequestPhyto?: Maybe<Scalars["AWSJSON"]["output"]>
  integrationsRaiseExportRequestPhytoV2?: Maybe<Scalars["AWSJSON"]["output"]>
  integrationsRaiseTransfer?: Maybe<Scalars["AWSJSON"]["output"]>
  integrationsRaiseTransferV2?: Maybe<Scalars["AWSJSON"]["output"]>
  integrationsReplaceExportCertificate?: Maybe<Scalars["AWSJSON"]["output"]>
  integrationsRequestAmendmentTransfer?: Maybe<Scalars["AWSJSON"]["output"]>
  integrationsRequestReplacementCertificate?: Maybe<
    Scalars["AWSJSON"]["output"]
  >
  makeProductEligible: Scalars["String"]["output"]
  newCoreReferencedDocument?: Maybe<NewCoreReferencedDocument>
  newMultiCollectionApiKeys?: Maybe<MultiCollectionApiKeys>
  newMultiCollectionApiKeysV2?: Maybe<MultiCollectionApiKeysV2>
  newPartyApiKey?: Maybe<SearchApiKey>
  newReferencedDocument: NewReferencedDocument
  newSearchApiKey?: Maybe<SearchApiKey>
  prepareXmlFileForB2G: PrepareXmlFileForB2GResponse
  printCertificate: PrintCertificateResponse
  processB2GIntegration: ProcessB2GIntegrationResponse
  processCertificateCollection: CertificateCollectionOutput
  processExportCertificateCollection: ExportCertificateCollectionResponse
  processExportOCAWithPermissions: OcaWithPermissionsResponse
  processExportSPSAcknowledgement: ExportSpsAcknowledgementResponse
  processOCAWithPermissions: OcaWithPermissionsResponse
  processSpsAcknowledgement: SpsAcknowledgementOutput
  publishXmlFileProcessed: PrepareXmlFileForB2GResponse
  raiseExportCertificateRequest?: Maybe<B2GExportCertificateRequest>
  raiseExportRequest: RaiseExportRequestResponse
  raiseTransferRequest: RaiseTransferRequestResponse
  regenerateApprovedTemplates: RegenerateApprovedTemplatesResponse
  regenerateCertificate: RegenerateCertificateResponse
  reindexCollection: ReindexResponse
  reindexDatabaseItem: ReindexResponse
  rejectImportCertificate?: Maybe<ImportCertificate>
  removeProductProcesses: RemoveProductProcessesResponse
  removeProductsFromRequest: Array<CoreProduct>
  replacementCertificateRequest: B2GExportCertificateRequest
  requestApprovalToReplaceExportCertificateRequest?: Maybe<
    Scalars["Boolean"]["output"]
  >
  requestChemistryTest: ChemistryTestResponse
  requestConfirmation: RequestConfirmationResponse
  requestReplacementImportCertificate?: Maybe<ImportCertificate>
  requestedToResubmitExportCertificateRequest?: Maybe<ExportCertificateRequest>
  resetConfirmationRequest: Scalars["String"]["output"]
  salesforceErApproval: SalesforceErApprovalResponse
  /** @deprecated Use `sfChangeTransferRequestStatus` mutation */
  salesforceTransferRequestVerification: SalesforceTransferRequestVerificationResponse
  saveChangesToReferenceData: SaveChangesToReferenceDataResponse
  saveExportCertificateRequest: ExportCertificateRequest
  saveExportRequest: CoreExportRequest
  saveFieldConfiguration?: Maybe<TemplateFieldConfiguration>
  saveFieldConfigurationBatch?: Maybe<TemplateFieldConfigurationAcknowledgement>
  saveG2GAccount: G2GAccount
  saveProcessGroupConfig: TemplateProcessGroupsConfigAcknowledgement
  saveTransferRequest: CoreTransferRequest
  setTemplateVersionApproved: TemplateVersion
  setTemplateVersionStatus: TemplateVersion
  sfCancelExportCertificate?: Maybe<Scalars["Boolean"]["output"]>
  sfChangeExportCertificateRequestStatus?: Maybe<ExportCertificateRequest>
  sfChangeExportRequestStatus: SfChangeExportRequestStatusResponse
  sfChangeTransferRequestStatus: SfChangeTransferRequestStatusResponse
  sfDownloadCertificate: SfDownloadCertificateResponse
  sfRequestExportCertificateReplacement?: Maybe<Scalars["Boolean"]["output"]>
  sfUpdateProductExhaustion: SfUpdateProductExhaustionResponse
  sfUpdateStationerySerialNumbers: SfUpdateStationerySerialNumbersResponse
  sfUpdateTransferAuditComment: SfUpdateTransferAuditCommentResponse
  sfVerifyExportCertificateRequestProducts?: Maybe<
    Array<Maybe<SpsTradeLineItem>>
  >
  splitProduct: Array<B2GProduct>
  startPackaging: ProcessResponse
  startWinemaking: ProcessResponse
  transferProduct: B2GProduct
  updateApprovedTransferTransport?: Maybe<Scalars["Boolean"]["output"]>
  updateDecisionTable: DecisionTableRevision
  updateGeneralTabAndStatus: Template
  updateOutputTab?: Maybe<Template>
  updatePrintReason: UpdatePrintReasonResponse
  updateProductExhaustion?: Maybe<ExhaustionResponse>
  updateSupportingDocument?: Maybe<UpdateSupportingDocumentResult>
  updateTemplate: Template
  updateTemplateVersionGeneralSettings: Template
  updateTemplateVersionOutput: TemplateVersionOutput
  uploadReferenceData: UploadReferenceDataResponse
  uploadTemplateDocumentV2: TemplateUploadUrlV2
  upsertTemplateDeclarations: TemplateDeclarationsAcknowledgement
  upsertTemplateSupportingDocuments: Array<TemplateSupportingDocumentAcknowledgement>
  withdrawImportCertificate?: Maybe<ImportCertificate>
}

export type MutationAddBottlingRunsArgs = {
  input: BottlingRunInput
}

export type MutationAddCustomsPermitNumbersArgs = {
  csv: Scalars["String"]["input"]
}

export type MutationAddFlexiFillingRunsArgs = {
  input: FlexiFillingRunInput
}

export type MutationAddProductArgs = {
  ingredients?: InputMaybe<Array<B2GProductInput>>
  product: B2GProductInput
}

export type MutationAddProductAndProcessFromTransferArgs = {
  input: AddProductAndProcessFromTransferInput
}

export type MutationAddRegistrationsToUserArgs = {
  email: Scalars["String"]["input"]
  id: Scalars["ID"]["input"]
  permissions: Array<UserPermissionInput>
}

export type MutationAdjustBatchVolumeArgs = {
  input: VolumeAdjustmentInput
}

export type MutationAllocateCustomsPermitNumberArgs = {
  certificateRequestId: Scalars["String"]["input"]
}

export type MutationAppendIppcHubLogArgs = {
  input: IppcHubLogInput
}

export type MutationAppendImportCertificateLogArgs = {
  input: ImportCertificateLogMessageInput
}

export type MutationApproveExportCertificateRequestArgs = {
  input: ApproveCertificateRequestInput
}

export type MutationAttachTemplateDocumentArgs = {
  templateId: Scalars["ID"]["input"]
}

export type MutationBanWineBatchArgs = {
  input: Array<B2GBanWineBatchInput>
}

export type MutationCancelEstarRequestArgs = {
  reason?: InputMaybe<Scalars["String"]["input"]>
  sampleId: Scalars["ID"]["input"]
}

export type MutationCancelExportCertificateRequestArgs = {
  input: CancelExportCertificateRequestInput
}

export type MutationCancelProcessArgs = {
  input: CancelledProcessInput
}

export type MutationCancelSupportingDocumentArgs = {
  input: CancelSupportingDocumentInput
}

export type MutationChangeExportRequestStatusArgs = {
  input: ChangeExportRequestStatusInput
}

export type MutationChangeTransferRequestAmendmentStatusArgs = {
  input: ChangeTransferRequestAmendmentStatusInput
}

export type MutationChangeTransferRequestStatusArgs = {
  input: ChangeTransferRequestStatusInput
}

export type MutationCompleteSensoryProcessArgs = {
  input: SensoryProcessInput
}

export type MutationConfirmPackagingArgs = {
  input: ConfirmPackagingInput
}

export type MutationConfirmWinemakingArgs = {
  input: ConfirmWinemakingInput
}

export type MutationCreateAnnouncementArgs = {
  input: CreateAnnouncementInput
}

export type MutationCreateSupportingDocumentArgs = {
  input: CoreSupportingDocumentInput
}

export type MutationCreateTemplateArgs = {
  template: CreateTemplateInput
}

export type MutationCreateTemplateVersionArgs = {
  template: CreateTemplateGeneralInput
}

export type MutationCreateTestRegistrationArgs = {
  input: CreateTestRegistrationInput
}

export type MutationCreateTestUserArgs = {
  input: CreateTestUserInput
}

export type MutationCreateUserArgs = {
  userDetails: CreateUserInput
}

export type MutationDeleteAnnouncementArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationDeleteCoreReferencedDocumentArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationDeleteExportCertificateRequestArgs = {
  requestor: Scalars["String"]["input"]
  requestor_id: Scalars["String"]["input"]
}

export type MutationDeleteExportRequestArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationDeleteExportRequestByIdArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationDeleteFieldConfigurationArgs = {
  templateFieldId: Scalars["ID"]["input"]
}

export type MutationDeleteProductArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationDeleteReferencedDocumentArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationDeleteReplacementExportRequestArgs = {
  input: DeleteReplacementExportRequestInput
}

export type MutationDeleteTemplateArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationDeleteTransferRequestByIdArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationDiscardExportCertificateRequestArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationDiscardG2GAccountArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationDownloadExportRequestsAsCsvArgs = {
  input?: InputMaybe<DownloadExportRequestsCsvInput>
}

export type MutationDownloadStatusReportArgs = {
  input: DownloadStatusReportInput
}

export type MutationDownloadSupportingDocumentsAsCsvArgs = {
  input?: InputMaybe<DownloadSupportingDocumentsCsvInput>
}

export type MutationDownloadTransferProcessHistoryXmlArgs = {
  input: DownloadTransferProcessHistoryXmlInput
}

export type MutationDownloadTransferRequestsAsCsvArgs = {
  input: DownloadTransferRequestsCsvInput
}

export type MutationDraftExportCertificateRequestArgs = {
  request: B2GExportCertificateRequestInput
}

export type MutationE2eRaiseExportCertificateRequestArgs = {
  id: Scalars["ID"]["input"]
  partyId: Scalars["String"]["input"]
}

export type MutationExecuteChemistryTestEventArgs = {
  input: ChemistryTestEventDataInput
}

export type MutationExhaustTransferProductsArgs = {
  input: ExhaustTransferProductsInput
}

export type MutationExhaustTransferRequestArgs = {
  input: ExhaustTransferRequestInput
}

export type MutationExtendIntendedOperatorArgs = {
  input: ExtendIntendedOperatorInput
}

export type MutationForceApproveTemplateVersionArgs = {
  templateVersionId: Scalars["ID"]["input"]
}

export type MutationGenerateDraftExportCertificateArgs = {
  input: GenerateDraftExportCertificateInput
}

export type MutationGenerateDraftPdfArgs = {
  isStandardPdfPreviewType?: InputMaybe<Scalars["Boolean"]["input"]>
  templateId: Scalars["ID"]["input"]
}

export type MutationGenerateOutputPreviewXmlArgs = {
  templateVersionId: Scalars["ID"]["input"]
}

export type MutationGenerateSpecimenPdfArgs = {
  languages?: InputMaybe<Array<Scalars["String"]["input"]>>
  templateVersionId: Scalars["ID"]["input"]
}

export type MutationGenerateStandardPdfPreviewArgs = {
  languages?: InputMaybe<Array<Scalars["String"]["input"]>>
  templateVersionId: Scalars["ID"]["input"]
}

export type MutationGenerateSubmissionPreviewXmlArgs = {
  templateVersionId: Scalars["ID"]["input"]
}

export type MutationGenerateTeoConfigurationJsonArgs = {
  templateVersionId: Scalars["ID"]["input"]
}

export type MutationGetNewTemplateVersionUploadUrlArgs = {
  templateId: Scalars["ID"]["input"]
}

export type MutationGetSignedCertificateXmlArgs = {
  input: GetSignedCertificateXmlInput
}

export type MutationInitSupportingDocumentUploadArgs = {
  input: InitSupportingDocumentUploadInput
}

export type MutationIntegrationsAmendExportArgs = {
  input: IntegrationsAmendExportFromUriInput
}

export type MutationIntegrationsAmendTransferArgs = {
  input: IntegrationsAmendTransferFromUriInput
}

export type MutationIntegrationsCreateSupportingDocumentArgs = {
  input: IntegrationsCreateSupportingDocumentInput
}

export type MutationIntegrationsDownloadTransferProcessHistoryXmlArgs = {
  input: IntegrationsDownloadTransferProcessHistoryXmlInput
}

export type MutationIntegrationsExhaustTransferArgs = {
  input: ExhaustTransferRequestInput
}

export type MutationIntegrationsGetSignedCertificateXmlArgs = {
  input: IntegrationsGetSignedCertificateXmlInput
}

export type MutationIntegrationsGetTemplateXmlArgs = {
  input: IntegrationsGetTemplateXmlInput
}

export type MutationIntegrationsInitSupportingDocumentUploadArgs = {
  input: IntegrationsInitSupportingDocumentUploadInput
}

export type MutationIntegrationsRaiseExportRequestApArgs = {
  input: IntegrationsExportRequestApInput
}

export type MutationIntegrationsRaiseExportRequestApv2Args = {
  input: IntegrationsExportRequestApFromUriInput
}

export type MutationIntegrationsRaiseExportRequestPhytoArgs = {
  input: IntegrationsExportRequestPhytoInput
}

export type MutationIntegrationsRaiseExportRequestPhytoV2Args = {
  input: IntegrationsExportRequestPhytoFromUriInput
}

export type MutationIntegrationsRaiseTransferArgs = {
  input: IntegrationsRaiseTransferInput
}

export type MutationIntegrationsRaiseTransferV2Args = {
  input: IntegrationsRaiseTransferFromUriInput
}

export type MutationIntegrationsReplaceExportCertificateArgs = {
  input: IntegrationsReplaceExportCertificateInput
}

export type MutationIntegrationsRequestAmendmentTransferArgs = {
  input: IntegrationsRequestAmendmentTransferInput
}

export type MutationIntegrationsRequestReplacementCertificateArgs = {
  input: IntegrationsRequestReplacementCertificateInput
}

export type MutationMakeProductEligibleArgs = {
  market: DestinationMarket
  productId: Scalars["ID"]["input"]
}

export type MutationNewCoreReferencedDocumentArgs = {
  input: NewCoreReferencedDocumentInput
}

export type MutationNewMultiCollectionApiKeysV2Args = {
  requestOrigin?: InputMaybe<RequestOrigin>
}

export type MutationNewReferencedDocumentArgs = {
  filename?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationPrepareXmlFileForB2GArgs = {
  input: PrepareXmlFileForB2GInput
}

export type MutationPrintCertificateArgs = {
  input: PrintCertificateInput
}

export type MutationProcessB2GIntegrationArgs = {
  input: ProcessB2GIntegrationInput
}

export type MutationProcessCertificateCollectionArgs = {
  input: CertificateCollectionInput
}

export type MutationProcessExportCertificateCollectionArgs = {
  input: ExportCertificateCollectionInput
}

export type MutationProcessExportOcaWithPermissionsArgs = {
  input: OcaWithPermissionsInput
}

export type MutationProcessExportSpsAcknowledgementArgs = {
  input: ExportSpsAcknowledgementInput
}

export type MutationProcessOcaWithPermissionsArgs = {
  input: OcaWithPermissionsInput
}

export type MutationProcessSpsAcknowledgementArgs = {
  input: SpsAcknowledgementInput
}

export type MutationPublishXmlFileProcessedArgs = {
  input: PublishXmlFileProcessedInput
}

export type MutationRaiseExportCertificateRequestArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationRaiseExportRequestArgs = {
  input: RaiseExportRequestInput
}

export type MutationRaiseTransferRequestArgs = {
  input: RaiseTransferRequestInput
}

export type MutationRegenerateApprovedTemplatesArgs = {
  droolsOnly?: InputMaybe<Scalars["Boolean"]["input"]>
  itextOnly?: InputMaybe<Scalars["Boolean"]["input"]>
  recipeOnly?: InputMaybe<Scalars["Boolean"]["input"]>
  submissionLayouts?: InputMaybe<Array<Scalars["String"]["input"]>>
  templateIds?: InputMaybe<Array<Scalars["ID"]["input"]>>
}

export type MutationRegenerateCertificateArgs = {
  input: RegenerateCertificateInput
}

export type MutationReindexCollectionArgs = {
  collectionName: Scalars["String"]["input"]
  options?: InputMaybe<SearchOptions>
}

export type MutationReindexDatabaseItemArgs = {
  collectionName: Scalars["String"]["input"]
  ids: Array<Scalars["ID"]["input"]>
}

export type MutationRejectImportCertificateArgs = {
  input: ImportCertificateStatusChangeInput
}

export type MutationRemoveProductProcessesArgs = {
  input: RemoveProductProcessesInput
}

export type MutationRemoveProductsFromRequestArgs = {
  input: RemoveProductsFromRequestInput
}

export type MutationReplacementCertificateRequestArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationRequestApprovalToReplaceExportCertificateRequestArgs = {
  input: ApprovalToReplaceExportCertificateRequestInput
}

export type MutationRequestChemistryTestArgs = {
  input: ChemistryTestInput
}

export type MutationRequestConfirmationArgs = {
  input: RequestConfirmationInput
}

export type MutationRequestReplacementImportCertificateArgs = {
  input: ImportCertificateStatusChangeInput
}

export type MutationRequestedToResubmitExportCertificateRequestArgs = {
  input: SfRequestedToResubmitExportCertificateInput
}

export type MutationResetConfirmationRequestArgs = {
  input: ResetConfirmationRequestInput
}

export type MutationSalesforceErApprovalArgs = {
  input: SalesforceErApprovalInput
}

export type MutationSalesforceTransferRequestVerificationArgs = {
  input: SalesforceTransferRequestVerificationInput
}

export type MutationSaveChangesToReferenceDataArgs = {
  input: SaveChangesToReferenceDataInput
}

export type MutationSaveExportCertificateRequestArgs = {
  input: ExportCertificateRequestInput
}

export type MutationSaveExportRequestArgs = {
  input: CoreExportRequestInput
}

export type MutationSaveFieldConfigurationArgs = {
  fieldConfig: TemplateFieldConfigurationInput
  templateVersionId: Scalars["ID"]["input"]
}

export type MutationSaveFieldConfigurationBatchArgs = {
  comment?: InputMaybe<Scalars["String"]["input"]>
  deleteItems?: InputMaybe<Array<Scalars["ID"]["input"]>>
  templateVersionId: Scalars["ID"]["input"]
  upsertItems?: InputMaybe<Array<TemplateFieldConfigurationInput>>
}

export type MutationSaveG2GAccountArgs = {
  input: SaveG2GAccountInput
}

export type MutationSaveProcessGroupConfigArgs = {
  deleteItems?: InputMaybe<Array<Scalars["ID"]["input"]>>
  templateVersionId: Scalars["ID"]["input"]
  upsertItems?: InputMaybe<Array<UpsertTemplateProcessGroupConfigInput>>
}

export type MutationSaveTransferRequestArgs = {
  input: CoreTransferRequestInput
}

export type MutationSetTemplateVersionApprovedArgs = {
  isConfigurableTemplate?: InputMaybe<Scalars["Boolean"]["input"]>
  templateVersionId: Scalars["ID"]["input"]
}

export type MutationSetTemplateVersionStatusArgs = {
  isConfigurableTemplate?: InputMaybe<Scalars["Boolean"]["input"]>
  status: TemplateVersionStatus
  templateVersionId: Scalars["ID"]["input"]
}

export type MutationSfCancelExportCertificateArgs = {
  input: SfCancelExportCertificateInput
}

export type MutationSfChangeExportCertificateRequestStatusArgs = {
  input: SfChangeExportCertificateRequestStatusInput
}

export type MutationSfChangeExportRequestStatusArgs = {
  input: SfChangeExportRequestStatusInput
}

export type MutationSfChangeTransferRequestStatusArgs = {
  input: SfChangeTransferRequestStatusInput
}

export type MutationSfDownloadCertificateArgs = {
  input: SfDownloadCertificateInput
}

export type MutationSfRequestExportCertificateReplacementArgs = {
  input: SfRequestExportCertificateReplacementInput
}

export type MutationSfUpdateProductExhaustionArgs = {
  input: SfUpdateProductExhaustionInput
}

export type MutationSfUpdateStationerySerialNumbersArgs = {
  input: SfUpdateStationerySerialNumbersInput
}

export type MutationSfUpdateTransferAuditCommentArgs = {
  input: SfUpdateTransferAuditCommentInput
}

export type MutationSfVerifyExportCertificateRequestProductsArgs = {
  input: SfVerifyExportCertificateRequestProductsInput
}

export type MutationSplitProductArgs = {
  fromProduct: Scalars["ID"]["input"]
  toProducts: Array<B2GProductInput>
}

export type MutationStartPackagingArgs = {
  productId: Scalars["ID"]["input"]
}

export type MutationStartWinemakingArgs = {
  productId: Scalars["ID"]["input"]
}

export type MutationTransferProductArgs = {
  id: Scalars["ID"]["input"]
  toPremise: Scalars["ID"]["input"]
}

export type MutationUpdateApprovedTransferTransportArgs = {
  input: UpdateApprovedTransferTransportInput
}

export type MutationUpdateDecisionTableArgs = {
  input: DecisionTableRevisionInput
}

export type MutationUpdateGeneralTabAndStatusArgs = {
  input: UpdateGeneralTabAndStatusInput
}

export type MutationUpdateOutputTabArgs = {
  input: UpdateOutputTabInput
}

export type MutationUpdatePrintReasonArgs = {
  input: UpdatePrintReasonInput
}

export type MutationUpdateProductExhaustionArgs = {
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>
}

export type MutationUpdateSupportingDocumentArgs = {
  input: UpdateSupportingDocumentInput
}

export type MutationUpdateTemplateArgs = {
  template: UpdateTemplateInput
}

export type MutationUpdateTemplateVersionGeneralSettingsArgs = {
  generalSettings: UpdateTemplateGeneralInput
}

export type MutationUpdateTemplateVersionOutputArgs = {
  templateOutput: TemplateVersionOutputInput
}

export type MutationUploadReferenceDataArgs = {
  input: UploadReferenceDataInput
}

export type MutationUploadTemplateDocumentV2Args = {
  templateVersionId: Scalars["ID"]["input"]
}

export type MutationUpsertTemplateDeclarationsArgs = {
  input: TemplateDeclarationsInput
}

export type MutationUpsertTemplateSupportingDocumentsArgs = {
  input: Array<TemplateSupportingDocumentInput>
}

export type MutationWithdrawImportCertificateArgs = {
  input: ImportCertificateStatusChangeInput
}

export type NamedCode = {
  __typename?: "NamedCode"
  code: Scalars["String"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
}

export type NamedCodeInput = {
  code: Scalars["String"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
}

export type NamedCodeTemplate = {
  __typename?: "NamedCodeTemplate"
  code: Scalars["String"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
}

export type NewCoreReferencedDocument = {
  __typename?: "NewCoreReferencedDocument"
  id: Scalars["ID"]["output"]
  url: Scalars["String"]["output"]
}

export type NewCoreReferencedDocumentInput = {
  contentType?: InputMaybe<Scalars["String"]["input"]>
  filename: Scalars["String"]["input"]
}

export type NewReferencedDocument = {
  __typename?: "NewReferencedDocument"
  id: Scalars["ID"]["output"]
  url: Scalars["String"]["output"]
}

export type NumberConstrain = {
  __typename?: "NumberConstrain"
  max?: Maybe<Scalars["Float"]["output"]>
  min?: Maybe<Scalars["Float"]["output"]>
  step: Scalars["Float"]["output"]
}

export type OcaWithPermissionsInput = {
  certificateNumber: Scalars["String"]["input"]
  correlationId?: InputMaybe<Scalars["String"]["input"]>
  overseasAuthoritiesInvolved?: InputMaybe<Scalars["String"]["input"]>
  reasonInformation?: InputMaybe<Scalars["String"]["input"]>
  status: Scalars["String"]["input"]
  systemAccountName: Scalars["String"]["input"]
  userProfileName?: InputMaybe<Scalars["String"]["input"]>
}

export type OcaWithPermissionsResponse = {
  __typename?: "OCAWithPermissionsResponse"
  messages?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  success: Scalars["Boolean"]["output"]
}

export enum Optionality {
  Disabled = "DISABLED",
  Optional = "OPTIONAL",
  Readonly = "READONLY",
  Required = "REQUIRED",
}

export type OutputTabSupportingDocumentInput = {
  documentType: TemplateSupportingDocumentType
  id?: InputMaybe<Scalars["ID"]["input"]>
  includeInXml: Scalars["Boolean"]["input"]
  printWithPdf: Scalars["Boolean"]["input"]
}

export enum PdfAddendum {
  Catch = "CATCH",
  CatchEu = "CATCH_EU",
  CatchJapan = "CATCH_JAPAN",
  CatchUs = "CATCH_US",
  None = "NONE",
}

export enum PdfBoxWidth {
  Full = "FULL",
  Half = "HALF",
  Quarter = "QUARTER",
  Third = "THIRD",
}

export enum PdfLayout {
  Adobe = "ADOBE",
  ApaRegistration = "APA_REGISTRATION",
  Catch = "CATCH",
  CuAnimalProducts = "CU_ANIMAL_PRODUCTS",
  EuChBeef = "EU_CH_BEEF",
  EuExport = "EU_EXPORT",
  EuExport_2015 = "EU_EXPORT_2015",
  EuExport_2019 = "EU_EXPORT_2019",
  EuExport_2021 = "EU_EXPORT_2021",
  EuTransit = "EU_TRANSIT",
  EuTransit_2021 = "EU_TRANSIT_2021",
  Nz = "NZ",
  Nz_2024 = "NZ_2024",
  NzRtl = "NZ_RTL",
  NzRtlHalal = "NZ_RTL_HALAL",
  RussianDairy = "RUSSIAN_DAIRY",
  RussianSeafood = "RUSSIAN_SEAFOOD",
}

export type PdfSettings = {
  __typename?: "PDFSettings"
  boxWidth?: Maybe<PdfBoxWidth>
  caption?: Maybe<Scalars["String"]["output"]>
  captionId?: Maybe<Scalars["ID"]["output"]>
  defaultOption?: Maybe<PdfDefaultOption>
  order?: Maybe<Scalars["Int"]["output"]>
  pdfColumnsToDisplay?: Maybe<ColumnsToDisplay>
}

export type PdfSettingsInput = {
  boxWidth?: InputMaybe<PdfBoxWidth>
  caption?: InputMaybe<Scalars["ID"]["input"]>
  defaultOption?: InputMaybe<PdfDefaultOption>
  order?: InputMaybe<Scalars["Int"]["input"]>
  pdfColumnsToDisplay?: InputMaybe<ColumnsToDisplay>
}

export type PackageTemplate = {
  __typename?: "PackageTemplate"
  bottle_size?: Maybe<VolumeMeasureTemplate>
  bottles_per_case?: Maybe<IntTemplate>
  cases?: Maybe<IntTemplate>
  extra_bottles?: Maybe<IntTemplate>
  total_bottles: IntTemplate
}

export type Packaging = {
  __typename?: "Packaging"
  availableLitres: Scalars["Float"]["output"]
  confirmation?: Maybe<PackagingConfirmation>
  exportedLitres: Scalars["Float"]["output"]
  runs: Array<PackagingRun>
  status: PackagingStatus
  totalPackagedLitres: Scalars["Float"]["output"]
  volumeAdjustment?: Maybe<Array<Maybe<ManualVolumeAdjustment>>>
  wsmp?: Maybe<Scalars["ID"]["output"]>
}

export type PackagingConfirmation = {
  __typename?: "PackagingConfirmation"
  confirmed: Scalars["Boolean"]["output"]
  disputeReason?: Maybe<Scalars["String"]["output"]>
  disputeResolution?: Maybe<Scalars["String"]["output"]>
}

export type PackagingInput = {
  itemMarksOuter?: InputMaybe<Scalars["String"]["input"]>
  level?: InputMaybe<Scalars["Int"]["input"]>
  nominalGrossVolume?: InputMaybe<MeasurmentInput>
  nominalGrossWeight?: InputMaybe<MeasurmentInput>
  outermostNumberOfPacakges?: InputMaybe<Scalars["Int"]["input"]>
  packageType?: InputMaybe<CoreLookupInput>
  quantity?: InputMaybe<Scalars["Int"]["input"]>
}

export type PackagingRun = BottlingRunData | FlexiFillingRunData

export enum PackagingStatus {
  Confirmed = "CONFIRMED",
  Disputed = "DISPUTED",
  NotRequested = "NOT_REQUESTED",
  Requested = "REQUESTED",
}

export enum PartyRole {
  Consignee = "CONSIGNEE",
  Consignor = "CONSIGNOR",
  ThirdPartyConsignor = "THIRD_PARTY_CONSIGNOR",
}

export enum PdfCertificateType {
  Copy = "COPY",
  Draft = "DRAFT",
  Official = "OFFICIAL",
}

export enum PdfDefaultOption {
  Blank = "BLANK",
  NotApplicable = "NOT_APPLICABLE",
  NotShown = "NOT_SHOWN",
  Xxxxxx = "XXXXXX",
}

export enum PdfGenerationStatus {
  Generated = "GENERATED",
  InProgress = "IN_PROGRESS",
  NotGenerated = "NOT_GENERATED",
}

export enum PermissionConstraintType {
  Agency = "AGENCY",
  CertType = "CERT_TYPE",
  Country = "COUNTRY",
  Port = "PORT",
  Registration = "REGISTRATION",
}

export enum PhytoDocumentType {
  DeclarationOfConformity = "DECLARATION_OF_CONFORMITY",
  ImportPermit = "IMPORT_PERMIT",
  InspectionRecord = "INSPECTION_RECORD",
  Other = "OTHER",
  OverseasMultiplicationAgreement = "OVERSEAS_MULTIPLICATION_AGREEMENT",
  OverseasPhytoCertificate = "OVERSEAS_PHYTO_CERTIFICATE",
  SeedLaboratoryTestResult = "SEED_LABORATORY_TEST_RESULT",
  TreatmentCertificate = "TREATMENT_CERTIFICATE",
}

export type PhytoOcaEmailNotificationsInput = {
  destinationCountry?: InputMaybe<Scalars["String"]["input"]>
}

export type PhytoOcaEmailNotificationsResponse = {
  __typename?: "PhytoOcaEmailNotificationsResponse"
  emailAddress: Scalars["String"]["output"]
}

export type PhytoOcaEmailNotificationsResponseInput = {
  emailAddress: Scalars["String"]["input"]
}

export type PhytoOcaEmailNotificationsType = DecisionTableBaseInput & {
  __typename?: "PhytoOcaEmailNotificationsType"
  destinationCountry?: Maybe<Scalars["String"]["output"]>
  validFrom?: Maybe<Scalars["AWSDateTime"]["output"]>
  validUntil?: Maybe<Scalars["AWSDateTime"]["output"]>
}

export enum PhytoSupportingDocumentType {
  Adh = "ADH",
  Adm = "ADM",
  Doc = "DOC",
  Fic = "FIC",
  Insp = "INSP",
  Ip = "IP",
  Oma = "OMA",
  Opc = "OPC",
  Org = "ORG",
  Other = "OTHER",
  Pac = "PAC",
  Slab = "SLAB",
  Trt = "TRT",
}

export type PortCountryInfo = {
  __typename?: "PortCountryInfo"
  countryCode: Scalars["String"]["output"]
  countryName: Scalars["String"]["output"]
  portCode: Scalars["String"]["output"]
  portName: Scalars["String"]["output"]
}

export enum PremisesAddressFormat {
  Long = "LONG",
  Medium = "MEDIUM",
  Short = "SHORT",
}

export enum PremisesRange {
  All = "ALL",
  LastInEachProduct = "LAST_IN_EACH_PRODUCT",
}

export type PrepareXmlFileForB2GInput = {
  fileName: Scalars["String"]["input"]
  requestType: XmlRequestType
  xmlInputId: Scalars["String"]["input"]
}

export type PrepareXmlFileForB2GResponse = {
  __typename?: "PrepareXmlFileForB2GResponse"
  b2gPayload?: Maybe<Scalars["String"]["output"]>
  errorMessages: Array<Scalars["String"]["output"]>
  fileName: Scalars["String"]["output"]
  requestType: XmlRequestType
  responseId?: Maybe<Scalars["String"]["output"]>
  status: Scalars["String"]["output"]
  xmlInputId: Scalars["String"]["output"]
}

export type PresignedPostField = {
  __typename?: "PresignedPostField"
  key: Scalars["String"]["output"]
  value: Scalars["String"]["output"]
}

export type PresignedUrl = {
  __typename?: "PresignedUrl"
  link: Scalars["String"]["output"]
}

export type PreviewOutputXmlPresignedUrlResult = {
  __typename?: "PreviewOutputXMLPresignedURLResult"
  presignedUrl: Scalars["String"]["output"]
  templateVersionId: Scalars["ID"]["output"]
}

export type PrintCertificateInput = {
  exportRequestId: Scalars["ID"]["input"]
  pdfType: PdfCertificateType
}

export type PrintCertificateResponse = {
  __typename?: "PrintCertificateResponse"
  executionArn?: Maybe<Scalars["String"]["output"]>
  exportRequestId: Scalars["ID"]["output"]
  exportRequestOutputId?: Maybe<Scalars["String"]["output"]>
  pdfCertificateUrl?: Maybe<Scalars["String"]["output"]>
}

export type ProcessAttributesResponse =
  | ChemistryTestResponse
  | Packaging
  | SensoryProcessRequest
  | Winemaking

export type ProcessB2GIntegrationInput = {
  b2gPayload: Scalars["String"]["input"]
  fileName: Scalars["String"]["input"]
  requestType: XmlRequestType
  xmlInputId: Scalars["String"]["input"]
}

export type ProcessB2GIntegrationResponse = {
  __typename?: "ProcessB2GIntegrationResponse"
  errorMessages: Array<Scalars["String"]["output"]>
  fileName: Scalars["String"]["output"]
  requestType: XmlRequestType
  responseId?: Maybe<Scalars["String"]["output"]>
  status: Scalars["String"]["output"]
  xmlInputId: Scalars["String"]["output"]
}

export type ProcessDetail = {
  __typename?: "ProcessDetail"
  active?: Maybe<Scalars["Boolean"]["output"]>
  processCode: Scalars["String"]["output"]
  processName?: Maybe<Scalars["String"]["output"]>
  ranking?: Maybe<Scalars["Int"]["output"]>
  unCode?: Maybe<Scalars["String"]["output"]>
}

export type ProcessGroupCaptionSettings = {
  __typename?: "ProcessGroupCaptionSettings"
  caption?: Maybe<Scalars["String"]["output"]>
  captionId?: Maybe<Scalars["ID"]["output"]>
}

export type ProcessGroupCaptionSettingsInput = {
  caption?: InputMaybe<Scalars["String"]["input"]>
  captionId?: InputMaybe<Scalars["ID"]["input"]>
}

export type ProcessGroupDetail = {
  __typename?: "ProcessGroupDetail"
  active?: Maybe<Scalars["Boolean"]["output"]>
  defaultCharacteristic?: Maybe<Scalars["String"]["output"]>
  groupName?: Maybe<Scalars["String"]["output"]>
  groupType?: Maybe<Scalars["String"]["output"]>
  lowestRank?: Maybe<Scalars["Int"]["output"]>
  lowestRankedProcessUnCode?: Maybe<Scalars["String"]["output"]>
  overrideCharacteristic?: Maybe<Scalars["String"]["output"]>
  overrideUnCode?: Maybe<Scalars["String"]["output"]>
  processGroupId: Scalars["Int"]["output"]
  processes: Array<ProcessDetail>
}

export type ProcessGroupInfo = {
  __typename?: "ProcessGroupInfo"
  groupName: Scalars["String"]["output"]
  groupType: Scalars["String"]["output"]
  processCode: Scalars["String"]["output"]
  processGroupId: Scalars["Int"]["output"]
}

export type ProcessGroupsInput = {
  deleteItems?: InputMaybe<Array<Scalars["ID"]["input"]>>
  upsertItems?: InputMaybe<Array<UpsertTemplateProcessGroupConfigInput>>
}

export type ProcessInfo = {
  __typename?: "ProcessInfo"
  id: Scalars["ID"]["output"]
  processCode: Scalars["String"]["output"]
  processName: Scalars["String"]["output"]
}

export type ProcessResponse = {
  __typename?: "ProcessResponse"
  id: Scalars["ID"]["output"]
  task?: Maybe<ProcessTask>
  type: ProductProcessType
}

export enum ProcessStatus {
  Active = "ACTIVE",
  Completed = "COMPLETED",
}

export type ProcessTask = {
  __typename?: "ProcessTask"
  assignedTo?: Maybe<Scalars["String"]["output"]>
  taskId: Scalars["ID"]["output"]
}

export type ProcessType = {
  __typename?: "ProcessType"
  description: Scalars["String"]["output"]
  id: ProductProcessType
}

export type ProductExhaustionResponse = {
  __typename?: "ProductExhaustionResponse"
  exhaust?: Maybe<Scalars["Boolean"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
}

export type ProductFieldInput = {
  certificateType?: InputMaybe<CertificateType>
  commodity?: InputMaybe<Scalars["String"]["input"]>
  destinationMarket?: InputMaybe<DestinationMarket>
}

export type ProductFieldResponse = {
  __typename?: "ProductFieldResponse"
  certificateType?: Maybe<CertificateType>
  collection?: Maybe<Scalars["String"]["output"]>
  commodity?: Maybe<Scalars["String"]["output"]>
  defaultUnit?: Maybe<Scalars["String"]["output"]>
  defaultValue?: Maybe<Scalars["String"]["output"]>
  destinationMarket?: Maybe<DestinationMarket>
  fieldId: Scalars["ID"]["output"]
  label?: Maybe<Scalars["String"]["output"]>
  listOfValues?: Maybe<Array<Scalars["String"]["output"]>>
  maxStringLength?: Maybe<Scalars["Int"]["output"]>
  required: Optionality
  type?: Maybe<Scalars["String"]["output"]>
}

export type ProductFieldResponseInput = {
  defaultUnit?: InputMaybe<Scalars["String"]["input"]>
  defaultValue?: InputMaybe<Scalars["String"]["input"]>
  fieldId: Scalars["ID"]["input"]
  label?: InputMaybe<Scalars["String"]["input"]>
  listOfValues?: InputMaybe<Array<Scalars["String"]["input"]>>
  maxStringLength?: InputMaybe<Scalars["Int"]["input"]>
  required: Optionality
}

export type ProductFieldType = DecisionTableBaseInput & {
  __typename?: "ProductFieldType"
  certificateType?: Maybe<CertificateType>
  commodity?: Maybe<Scalars["String"]["output"]>
  destinationMarket?: Maybe<DestinationMarket>
  validFrom?: Maybe<Scalars["AWSDateTime"]["output"]>
  validUntil?: Maybe<Scalars["AWSDateTime"]["output"]>
}

export type ProductFieldsInput = {
  certificateType?: InputMaybe<CertificateType>
  commodity?: InputMaybe<Scalars["String"]["input"]>
  country?: InputMaybe<Scalars["String"]["input"]>
  destination?: InputMaybe<DestinationMarket>
}

export type ProductProcessFilterInput = {
  processType?: InputMaybe<ProductProcessType>
  status?: InputMaybe<ProcessStatus>
}

export type ProductProcessResponse = {
  __typename?: "ProductProcessResponse"
  attributes: ProcessAttributesResponse
  confirmationTaskId?: Maybe<Scalars["ID"]["output"]>
  processId: Scalars["ID"]["output"]
  processType: ProductProcessType
  requestTaskId?: Maybe<Scalars["ID"]["output"]>
  /** @deprecated Resetting a request is not a task any longer so this is not required. */
  resetTaskId?: Maybe<Scalars["ID"]["output"]>
  taskId?: Maybe<Scalars["ID"]["output"]>
}

export enum ProductProcessType {
  BottlingRun = "BOTTLING_RUN",
  Chemistry = "CHEMISTRY",
  FlexiFilling = "FLEXI_FILLING",
  Sensory = "SENSORY",
  WineMaking = "WINE_MAKING",
}

export type ProductProcessesInput = {
  filter?: InputMaybe<ProductProcessFilterInput>
  productId: Scalars["ID"]["input"]
}

export type ProductionDateRangeInput = {
  from?: InputMaybe<Scalars["String"]["input"]>
  to?: InputMaybe<Scalars["String"]["input"]>
}

export type PublishXmlFileProcessedInput = {
  b2gPayload?: InputMaybe<Scalars["String"]["input"]>
  errorMessages: Array<Scalars["String"]["input"]>
  fileName: Scalars["String"]["input"]
  requestType: XmlRequestType
  responseId?: InputMaybe<Scalars["String"]["input"]>
  status: Scalars["String"]["input"]
  xmlInputId: Scalars["String"]["input"]
}

export type Query = {
  __typename?: "Query"
  attestations?: Maybe<Array<Scalars["String"]["output"]>>
  availableProcesses: Array<ProcessType>
  availableTemplates?: Maybe<Array<AvailableTemplateFields>>
  certificateTemplateFields?: Maybe<Scalars["AWSJSON"]["output"]>
  certificateTemplateFlatFields: Array<TemplateSection>
  certificateTemplateFlattestFields: Array<TemplateSectionField>
  certificateTemplateFlattestFieldsV2: Array<TemplateSection>
  checkUserAccess: CheckUserAccessResponse
  coreReferencedDocument?: Maybe<CoreReferencedDocument>
  customsPermitNumberUsage: CustomsPermitNumberUsage
  decisionTable?: Maybe<DecisionTable>
  downloadCSVFromReference?: Maybe<PresignedUrl>
  downloadCoreReferencedDocument?: Maybe<CoreReferencedDocumentUrl>
  downloadDocument: TemplateDocumentUrl
  downloadExportCertificates: B2GExportCertificatesDownloadUrl
  downloadOutputXML?: Maybe<XmlDownloadUrl>
  downloadProducts: B2GProductsDownloadUrl
  downloadReferencedDocument: ReferencedDocumentUrl
  downloadSubmissionXML?: Maybe<XmlDownloadUrl>
  e2eCalculateProductEligibilityV2?: Maybe<Array<Maybe<B2GEligibilityStatus>>>
  e2eProductEligibilityCriteriasV2?: Maybe<
    Array<Maybe<B2GProductEligibilityCriteriaV2>>
  >
  estarOrganisations: Array<EStarOrganisation>
  executeRules: Array<RulesResponse>
  exportCertificateAsTemplateValues: SpsCertificateTemplate
  exportCertificateRequest?: Maybe<B2GExportCertificateRequest>
  exportCertificateSupportingDocuments: Array<B2GReferencedDocument>
  fetchFieldsBySubmissionLayout: Array<FieldBySubmissionLayout>
  fetchRequestPartyRole: PartyRole
  fetchRequestPartyRoles: RequestPartyRolesResponse
  findApprovedImportCertificate?: Maybe<TemplateVersion>
  getActiveAnnouncements: Array<Announcement>
  getActiveTemplateBySubmissionLayout?: Maybe<ActiveTemplateResult>
  getAllAvailableLanguages: Array<Language>
  getApprovedProductDetails?: Maybe<ApprovedProductRequest>
  getApprovedTemplateVersion?: Maybe<TemplateVersion>
  getClassificationNameByFieldUniqueId?: Maybe<Scalars["String"]["output"]>
  getConsignorDetails: ConsignorDetails
  getDecisionTableRevision: GetDecisionTableRevisionResponse
  getDeclarationInputs?: Maybe<GetDeclarationInputsResponse>
  getDfeForm: DfeForm
  getDfePermissions: Array<DfePermission>
  getDfeTransferRequestRecipe?: Maybe<DfeConfig>
  getDfeTransferRequestTemplateInfo?: Maybe<DfeTemplateInfo>
  getDraftCertificateGenerationStatus: DraftCertificateGenerationStatusResponse
  getExportCertificateRequest?: Maybe<ExportCertificateRequest>
  getExportReqDetails?: Maybe<CoreExportDetails>
  getExportRequestHistory: Array<ExportRequestHistoryRecord>
  getExtractHtml?: Maybe<Scalars["String"]["output"]>
  getFeatureFlags: Array<Scalars["String"]["output"]>
  getFieldConfiguration?: Maybe<FieldConfiguration>
  getFieldUniqueIdsByClassificationCode?: Maybe<FieldInfo>
  getFieldsV2?: Maybe<Array<Maybe<FieldV2>>>
  getForwardProductTracking?: Maybe<ForwardProductTrackingResponse>
  getG2GAccountDetails?: Maybe<G2GAccount>
  getImportCertificate?: Maybe<ImportCertificate>
  getLatestLookupName?: Maybe<LookupValue>
  getMajorVersionsByCode: Array<Scalars["Int"]["output"]>
  /**
   * Fetches the master layout configuration for a specific submission type.
   * Used by frontend applications to generate dynamic forms.
   *
   * Example:
   * query {
   *   getMasterLayout(submissionType: AP_EXPORT) {
   *     masterFields
   *     masterLayout
   *   }
   * }
   */
  getMasterLayout?: Maybe<MasterLayout>
  getPortCountryInfo?: Maybe<PortCountryInfo>
  /** Return a presigned url to upload a document to the given `key` in the given `fileStore`. */
  getPresignedUrl: Scalars["String"]["output"]
  getPreviewOutputXMLPresignedURL: PreviewOutputXmlPresignedUrlResult
  getProcessGroupDetailsByGroupIds: Array<ProcessGroupDetail>
  getProcessGroupNames?: Maybe<Array<Scalars["String"]["output"]>>
  getProcessGroupReferenceData: TemplateProcessGroupReferenceData
  getProcessGroupsByProcessCodes: Array<ProcessGroupInfo>
  getProductsByTransferReference: TransferReferenceResponse
  getRefTypeAuditEvents: RefTypeAuditEventResponse
  getReferenceData: Array<ReferenceItem>
  getReferenceItemValidationInfo?: Maybe<ReferenceValidationResponse>
  getRegistrationTypes?: Maybe<Array<Maybe<RegistrationType>>>
  getRequestHistoryForSF: Array<RequestHistoryForSf>
  /**
   * Retrieves validations and warnings for a request.
   * Runs field-level validation (for editable statuses) and warning checkers (source modified, doc changed).
   * Returns errors for editable statuses (blocking), warnings for non-editable statuses (informational).
   */
  getRequestValidations: GetRequestValidationsResponse
  getSfForwardProductTracking?: Maybe<ForwardProductTrackingResponse>
  getSnapshotPresignedUrl: SnapshotPresignedUrlResponse
  getSupportingDocumentActions: SupportingDocumentActionsResponse
  getSupportingDocumentDetails: CoreSupportingDocument
  getSupportingDocumentHistory: Array<SupportingDocumentHistoryEntry>
  getSupportingDocumentPresignedUrl: SupportingDocumentPresignedUrlResponse
  getSupportingDocumentUsage: Array<SupportingDocumentUsageRecord>
  getTemplate?: Maybe<Template>
  getTemplateAuditEvents: Array<TemplateAuditEvent>
  getTemplateDetailsByCode?: Maybe<TemplateVersionId>
  getTemplateDocumentDownloadUrlV2: TemplateDocumentUrlV2
  getTemplateFieldReferenceData: TemplateFieldReferenceData
  getTemplateV2?: Maybe<TemplateV2>
  getTemplateVersion?: Maybe<TemplateVersion>
  getTemplateVersionV2?: Maybe<TemplateVersionV2>
  getTemplateWithActiveApproved?: Maybe<Template>
  getTemplateXmlCore: GetTemplateXmlCoreResponse
  getTransferRequestDetails?: Maybe<TransferRequestDetails>
  getTransferRequestHistory: Array<TransferRequestHistoryRecord>
  getTransferRequestHistoryForSF: Array<RequestHistoryForSf>
  getUserDetailsById?: Maybe<UserDetailsById>
  getUserInfo: UserInfo
  importCertificateEmbeddedDocument: ImportCertificateEmbeddedDocument
  importCertificatePdf: ImportCertificatePdf
  importCertificateXml: ImportCertificateXml
  listAnnouncements: AnnouncementList
  listImportCertificateIntegrations: Array<ImportCertificateIntegration>
  listImportCertificates: Array<ImportCertificate>
  numberOfDocuments: Scalars["Int"]["output"]
  product: B2GProduct
  productFields: Array<Maybe<ProductFieldResponse>>
  productForm: Array<Maybe<FormletField>>
  productFormlet: Form
  productProcesses: Array<ProductProcessResponse>
  referenceDocuments?: Maybe<Array<Maybe<B2GReferencedDocument>>>
  referencedDocument?: Maybe<ReferencedDocument>
  salesForceApplicationId?: Maybe<Scalars["ID"]["output"]>
  salesForceProductId?: Maybe<SalesForceProductId>
  searchDecisionTables: Array<DecisionTable>
  searchG2GAccounts: G2GAccountSearchResult
  searchReferenceList: SearchReferenceListResponse
  searchTemplateVersions: SearchTemplateVersionsResponse
  searchTemplates: Array<Template>
  sfDownload?: Maybe<Scalars["String"]["output"]>
  sfDownloadCertificate: Scalars["String"]["output"]
  sfDownloadSupportingDocument: Scalars["String"]["output"]
  sfExporter: SalesForceParty
  sfGetExportRequest: SfRequest
  sfGetExportSnapshot: SfRequest
  sfGetManyExportRequests?: Maybe<Array<Maybe<SfRequest>>>
  sfGetManyTransferRequests?: Maybe<Array<Maybe<SfRequest>>>
  sfGetSnapshot: SfRequest
  sfGetTemplate?: Maybe<Scalars["String"]["output"]>
  sfGetTransferRequest: SfRequest
  sfGetTransferSnapshot: SfRequest
  sfSearchApprovedTemplates: SfSearchApprovedTemplatesResponse
  testDecisionTableRevision: Array<DecisionTableTestResult>
  tradecertUserProfile: UserProfile
  validate?: Maybe<Array<Maybe<B2GValidationErrors>>>
  validateDfeRequest?: Maybe<Array<Maybe<B2GValidationErrors>>>
  validateProduct?: Maybe<Array<Maybe<B2GValidationErrors>>>
  validateSampleDfeRequest?: Maybe<Array<Maybe<B2GValidationErrors>>>
}

export type QueryAttestationsArgs = {
  certificateType: CertificateType
  commodity: Scalars["String"]["input"]
  destination: Scalars["String"]["input"]
}

export type QueryAvailableProcessesArgs = {
  productId: Scalars["ID"]["input"]
}

export type QueryAvailableTemplatesArgs = {
  commodity: Scalars["String"]["input"]
  countryCode: Scalars["String"]["input"]
}

export type QueryCertificateTemplateFieldsArgs = {
  commodity?: InputMaybe<Scalars["String"]["input"]>
  destinationMarket?: InputMaybe<DestinationMarket>
  exportCertificateType?: InputMaybe<CertificateType>
  importCertificateType?: InputMaybe<ImportCertificateType>
  transferCertificateType?: InputMaybe<TransferCertificateType>
}

export type QueryCertificateTemplateFlatFieldsArgs = {
  commodity?: InputMaybe<Scalars["String"]["input"]>
  destinationMarket?: InputMaybe<DestinationMarket>
  exportCertificateType?: InputMaybe<CertificateType>
  importCertificateType?: InputMaybe<ImportCertificateType>
  transferCertificateType?: InputMaybe<TransferCertificateType>
}

export type QueryCertificateTemplateFlattestFieldsArgs = {
  commodity?: InputMaybe<Scalars["String"]["input"]>
  destinationMarket?: InputMaybe<DestinationMarket>
  exportCertificateType?: InputMaybe<CertificateType>
  importCertificateType?: InputMaybe<ImportCertificateType>
  transferCertificateType?: InputMaybe<TransferCertificateType>
}

export type QueryCertificateTemplateFlattestFieldsV2Args = {
  submissionLayout: SubmissionLayoutType
}

export type QueryCheckUserAccessArgs = {
  input: CheckUserAccessInput
}

export type QueryCoreReferencedDocumentArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryDecisionTableArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryDownloadCsvFromReferenceArgs = {
  listCode: Scalars["String"]["input"]
}

export type QueryDownloadCoreReferencedDocumentArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryDownloadDocumentArgs = {
  templateVersionId: Scalars["ID"]["input"]
}

export type QueryDownloadExportCertificatesArgs = {
  endDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  startDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
}

export type QueryDownloadOutputXmlArgs = {
  exportRequestId: Scalars["ID"]["input"]
}

export type QueryDownloadProductsArgs = {
  endDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  startDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
}

export type QueryDownloadReferencedDocumentArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryDownloadSubmissionXmlArgs = {
  requestId: Scalars["ID"]["input"]
  requestType: CoreRequestType
}

export type QueryE2eCalculateProductEligibilityV2Args = {
  productId: Scalars["ID"]["input"]
}

export type QueryE2eProductEligibilityCriteriasV2Args = {
  criterias?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  markets?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  processIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  productId: Scalars["ID"]["input"]
}

export type QueryEstarOrganisationsArgs = {
  filter?: InputMaybe<EStarOrganisationFilter>
}

export type QueryExecuteRulesArgs = {
  input: RulesExecutionInput
}

export type QueryExportCertificateAsTemplateValuesArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryExportCertificateRequestArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryExportCertificateSupportingDocumentsArgs = {
  input: ExportCertificateSupportingDocumentsInput
}

export type QueryFetchFieldsBySubmissionLayoutArgs = {
  fetchNonActive?: InputMaybe<Scalars["Boolean"]["input"]>
  submissionLayout: SubmissionLayoutType
}

export type QueryFetchRequestPartyRoleArgs = {
  input: RequestPartyRoleInput
}

export type QueryFetchRequestPartyRolesArgs = {
  input: RequestPartyRoleInput
}

export type QueryFindApprovedImportCertificateArgs = {
  certificateType: ImportCertificateType
  commodity?: InputMaybe<Scalars["String"]["input"]>
  destinationMarket: DestinationMarket
}

export type QueryGetActiveTemplateBySubmissionLayoutArgs = {
  submissionLayout?: InputMaybe<SubmissionLayoutType>
}

export type QueryGetApprovedProductDetailsArgs = {
  input: ApprovedProductRequestInput
}

export type QueryGetApprovedTemplateVersionArgs = {
  certificateType: CertificateType
  commodity?: InputMaybe<Scalars["String"]["input"]>
  destinationMarket: DestinationMarket
}

export type QueryGetClassificationNameByFieldUniqueIdArgs = {
  fieldUniqueId: Scalars["String"]["input"]
}

export type QueryGetConsignorDetailsArgs = {
  id: Scalars["ID"]["input"]
  requestId?: InputMaybe<Scalars["ID"]["input"]>
}

export type QueryGetDecisionTableRevisionArgs = {
  input: GetDecisionTableRevisionInput
}

export type QueryGetDeclarationInputsArgs = {
  statementCode: Scalars["Int"]["input"]
}

export type QueryGetDfeFormArgs = {
  input: GetDfeFormInput
}

export type QueryGetDfeTransferRequestRecipeArgs = {
  input?: InputMaybe<DfeRequestInput>
}

export type QueryGetDraftCertificateGenerationStatusArgs = {
  input: GetDraftCertificateGenerationStatusInput
}

export type QueryGetExportCertificateRequestArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryGetExportReqDetailsArgs = {
  input: ExportDetailsInput
}

export type QueryGetExportRequestHistoryArgs = {
  input: ExportRequestHistoryInput
}

export type QueryGetExtractHtmlArgs = {
  requestId: Scalars["ID"]["input"]
}

export type QueryGetFieldConfigurationArgs = {
  fieldUniqueId: Scalars["String"]["input"]
}

export type QueryGetFieldUniqueIdsByClassificationCodeArgs = {
  input: FieldFilterInput
}

export type QueryGetFieldsV2Args = {
  templateVersionId: Scalars["ID"]["input"]
}

export type QueryGetForwardProductTrackingArgs = {
  transferRequestId: Scalars["ID"]["input"]
}

export type QueryGetG2GAccountDetailsArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryGetImportCertificateArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryGetLatestLookupNameArgs = {
  code: Scalars["String"]["input"]
  fieldUniqueId: Scalars["String"]["input"]
}

export type QueryGetMajorVersionsByCodeArgs = {
  templateCode: Scalars["String"]["input"]
}

export type QueryGetMasterLayoutArgs = {
  submissionType: SubmissionLayoutType
}

export type QueryGetPortCountryInfoArgs = {
  portCode: Scalars["String"]["input"]
}

export type QueryGetPresignedUrlArgs = {
  fileStore: Scalars["String"]["input"]
  key: Scalars["String"]["input"]
}

export type QueryGetPreviewOutputXmlPresignedUrlArgs = {
  templateVersionId: Scalars["ID"]["input"]
}

export type QueryGetProcessGroupDetailsByGroupIdsArgs = {
  groupIds: Array<Scalars["Int"]["input"]>
  includeDeactivated?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type QueryGetProcessGroupReferenceDataArgs = {
  processGroup: Scalars["String"]["input"]
}

export type QueryGetProcessGroupsByProcessCodesArgs = {
  includeDeactivated?: InputMaybe<Scalars["Boolean"]["input"]>
  processCodes: Array<Scalars["String"]["input"]>
}

export type QueryGetProductsByTransferReferenceArgs = {
  input: TransferReferenceRequestInput
}

export type QueryGetRefTypeAuditEventsArgs = {
  page?: InputMaybe<Scalars["Int"]["input"]>
  perPage?: InputMaybe<Scalars["Int"]["input"]>
  refType: Scalars["String"]["input"]
}

export type QueryGetReferenceDataArgs = {
  input: ReferenceDataInput
}

export type QueryGetReferenceItemValidationInfoArgs = {
  fileName: Scalars["String"]["input"]
  refListCode: Scalars["ID"]["input"]
}

export type QueryGetRegistrationTypesArgs = {
  active?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type QueryGetRequestHistoryForSfArgs = {
  input: RequestHistoryForSfInput
}

export type QueryGetRequestValidationsArgs = {
  input: GetRequestValidationsInput
}

export type QueryGetSfForwardProductTrackingArgs = {
  transferRequestId: Scalars["ID"]["input"]
}

export type QueryGetSnapshotPresignedUrlArgs = {
  historyId: Scalars["ID"]["input"]
}

export type QueryGetSupportingDocumentActionsArgs = {
  input: GetSupportingDocumentActionsInput
}

export type QueryGetSupportingDocumentDetailsArgs = {
  input: GetSupportingDocumentDetailsInput
}

export type QueryGetSupportingDocumentHistoryArgs = {
  input: GetSupportingDocumentHistoryInput
}

export type QueryGetSupportingDocumentPresignedUrlArgs = {
  input: SupportingDocumentInput
}

export type QueryGetSupportingDocumentUsageArgs = {
  input: SupportingDocumentUsageInput
}

export type QueryGetTemplateArgs = {
  templateId: Scalars["ID"]["input"]
}

export type QueryGetTemplateAuditEventsArgs = {
  majorVersion: Scalars["Int"]["input"]
  templateId: Scalars["ID"]["input"]
}

export type QueryGetTemplateDetailsByCodeArgs = {
  majorVersion?: InputMaybe<Scalars["Int"]["input"]>
  minorVersion?: InputMaybe<Scalars["Int"]["input"]>
  templateCode: Scalars["String"]["input"]
}

export type QueryGetTemplateDocumentDownloadUrlV2Args = {
  templateVersionId: Scalars["ID"]["input"]
}

export type QueryGetTemplateFieldReferenceDataArgs = {
  fuid: Scalars["ID"]["input"]
  submissionLayoutType: SubmissionLayoutType
}

export type QueryGetTemplateV2Args = {
  templateId: Scalars["ID"]["input"]
}

export type QueryGetTemplateVersionArgs = {
  templateVersionId: Scalars["ID"]["input"]
}

export type QueryGetTemplateVersionV2Args = {
  includeProcesses?: InputMaybe<Scalars["Boolean"]["input"]>
  templateVersionId: Scalars["ID"]["input"]
}

export type QueryGetTemplateWithActiveApprovedArgs = {
  templateId: Scalars["ID"]["input"]
}

export type QueryGetTemplateXmlCoreArgs = {
  input: GetTemplateXmlCoreInput
}

export type QueryGetTransferRequestDetailsArgs = {
  input: TransferRequestDetailsInput
}

export type QueryGetTransferRequestHistoryArgs = {
  input: TransferRequestHistoryInput
}

export type QueryGetTransferRequestHistoryForSfArgs = {
  input: RequestHistoryForSfInput
}

export type QueryGetUserDetailsByIdArgs = {
  userId: Scalars["ID"]["input"]
}

export type QueryImportCertificateEmbeddedDocumentArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryImportCertificatePdfArgs = {
  input: ImportCertificatePdfInput
}

export type QueryImportCertificateXmlArgs = {
  id: Scalars["ID"]["input"]
  inline?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type QueryListAnnouncementsArgs = {
  input?: InputMaybe<AnnouncementListInput>
}

export type QueryNumberOfDocumentsArgs = {
  collectionName: Scalars["String"]["input"]
}

export type QueryProductArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryProductFieldsArgs = {
  input: ProductFieldsInput
}

export type QueryProductFormArgs = {
  input: ProductFieldsInput
}

export type QueryProductFormletArgs = {
  input: ProductFieldsInput
}

export type QueryProductProcessesArgs = {
  input: ProductProcessesInput
}

export type QueryReferenceDocumentsArgs = {
  exportRequestId: Scalars["ID"]["input"]
}

export type QueryReferencedDocumentArgs = {
  id: Scalars["ID"]["input"]
}

export type QuerySalesForceApplicationIdArgs = {
  requestId: Scalars["ID"]["input"]
}

export type QuerySalesForceProductIdArgs = {
  productId: Scalars["ID"]["input"]
}

export type QuerySearchDecisionTablesArgs = {
  filter?: InputMaybe<DecisionTableFilter>
}

export type QuerySearchG2GAccountsArgs = {
  input?: InputMaybe<SearchG2GAccountsInput>
}

export type QuerySearchReferenceListArgs = {
  filter?: InputMaybe<ReferenceListFilter>
  page?: InputMaybe<Scalars["Int"]["input"]>
  perPage?: InputMaybe<Scalars["Int"]["input"]>
}

export type QuerySearchTemplateVersionsArgs = {
  filter?: InputMaybe<TemplateFilter>
  optionalFilter?: InputMaybe<TemplateOptionalFilter>
  page?: InputMaybe<Scalars["Int"]["input"]>
  perPage?: InputMaybe<Scalars["Int"]["input"]>
}

export type QuerySearchTemplatesArgs = {
  filter?: InputMaybe<TemplateFilter>
  optionalFilter?: InputMaybe<TemplateOptionalFilter>
  page?: InputMaybe<Scalars["Int"]["input"]>
  perPage?: InputMaybe<Scalars["Int"]["input"]>
}

export type QuerySfDownloadArgs = {
  input?: InputMaybe<SfDownloadInput>
}

export type QuerySfDownloadCertificateArgs = {
  input: SfDownloadCertificateInput
}

export type QuerySfDownloadSupportingDocumentArgs = {
  id: Scalars["ID"]["input"]
}

export type QuerySfExporterArgs = {
  certificateType?: InputMaybe<CertificateType>
  id: Scalars["ID"]["input"]
}

export type QuerySfGetExportRequestArgs = {
  id: Scalars["ID"]["input"]
}

export type QuerySfGetExportSnapshotArgs = {
  id: Scalars["ID"]["input"]
}

export type QuerySfGetManyExportRequestsArgs = {
  ids: Array<Scalars["ID"]["input"]>
}

export type QuerySfGetManyTransferRequestsArgs = {
  ids: Array<Scalars["ID"]["input"]>
}

export type QuerySfGetSnapshotArgs = {
  id: Scalars["ID"]["input"]
}

export type QuerySfGetTemplateArgs = {
  id: Scalars["ID"]["input"]
}

export type QuerySfGetTransferRequestArgs = {
  id: Scalars["ID"]["input"]
}

export type QuerySfGetTransferSnapshotArgs = {
  id: Scalars["ID"]["input"]
}

export type QuerySfSearchApprovedTemplatesArgs = {
  input?: InputMaybe<SfSearchApprovedTemplatesInput>
}

export type QueryTestDecisionTableRevisionArgs = {
  input: DecisionTableRevisionInput
}

export type QueryTradecertUserProfileArgs = {
  certificateType?: InputMaybe<CertificateType>
  contactId?: InputMaybe<Scalars["ID"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
}

export type QueryValidateArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryValidateDfeRequestArgs = {
  input?: InputMaybe<DfeRequestInput>
}

export type QueryValidateProductArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>
  product?: InputMaybe<B2GProductInput>
}

export type QueryValidateSampleDfeRequestArgs = {
  input?: InputMaybe<EgRequestInput>
}

export type RaiseExportRequestInput = {
  b2gProfileName?: InputMaybe<Scalars["String"]["input"]>
  b2gSystemName?: InputMaybe<Scalars["String"]["input"]>
  requestID: Scalars["ID"]["input"]
  requestOrigin?: InputMaybe<RequestOrigin>
  userId?: InputMaybe<Scalars["String"]["input"]>
  validationOnly?: InputMaybe<Scalars["Boolean"]["input"]>
  version?: InputMaybe<Scalars["Int"]["input"]>
}

export type RaiseExportRequestResponse = {
  __typename?: "RaiseExportRequestResponse"
  certificateNumber: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  status: CoreStatus
  submittedAt: Scalars["AWSDateTime"]["output"]
  version?: Maybe<Scalars["Int"]["output"]>
  warnings?: Maybe<Array<RequestValidation>>
}

export type RaiseTransferRequestInput = {
  b2gProfileName?: InputMaybe<Scalars["String"]["input"]>
  b2gSystemName?: InputMaybe<Scalars["String"]["input"]>
  requestID: Scalars["ID"]["input"]
  requestOrigin?: InputMaybe<RequestOrigin>
  userId?: InputMaybe<Scalars["String"]["input"]>
  validationOnly?: InputMaybe<Scalars["Boolean"]["input"]>
  version?: InputMaybe<Scalars["Int"]["input"]>
}

export type RaiseTransferRequestResponse = {
  __typename?: "RaiseTransferRequestResponse"
  certificateNumber: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  status: CoreStatus
  submittedAt: Scalars["AWSDateTime"]["output"]
  version?: Maybe<Scalars["Int"]["output"]>
  warnings?: Maybe<Array<RequestValidation>>
}

export enum RecipeType {
  Dfe = "DFE",
  Oca = "OCA",
}

export type RefTypeAuditEvent = {
  __typename?: "RefTypeAuditEvent"
  createdAt: Scalars["AWSDateTime"]["output"]
  createdBy: Scalars["String"]["output"]
  eventType: RefTypeAuditEventType
  id: Scalars["ID"]["output"]
  refItemId: Scalars["String"]["output"]
  refItemName?: Maybe<Scalars["String"]["output"]>
  refType: Scalars["String"]["output"]
}

export type RefTypeAuditEventResponse = {
  __typename?: "RefTypeAuditEventResponse"
  events: Array<RefTypeAuditEvent>
  totalCount: Scalars["Int"]["output"]
}

export enum RefTypeAuditEventType {
  Created = "CREATED",
  Deleted = "DELETED",
  Updated = "UPDATED",
}

export enum RefValidationType {
  Change = "CHANGE",
  Error = "ERROR",
  Override = "OVERRIDE",
}

export type ReferenceCaption = {
  __typename?: "ReferenceCaption"
  caption?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
}

export type ReferenceDataInput = {
  inputs?: InputMaybe<Array<Scalars["String"]["input"]>>
  listCode?: InputMaybe<Scalars["String"]["input"]>
  type: Scalars["String"]["input"]
}

export type ReferenceDataList = {
  __typename?: "ReferenceDataList"
  displayValue?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  tableName?: Maybe<Scalars["String"]["output"]>
}

export type ReferenceItem = {
  __typename?: "ReferenceItem"
  active?: Maybe<Scalars["Boolean"]["output"]>
  code: Scalars["String"]["output"]
  country_id?: Maybe<Scalars["String"]["output"]>
  effective_end_date?: Maybe<Scalars["AWSDate"]["output"]>
  effective_start_date?: Maybe<Scalars["AWSDate"]["output"]>
  name: Scalars["String"]["output"]
  symbol?: Maybe<Scalars["String"]["output"]>
}

export type ReferenceList = {
  __typename?: "ReferenceList"
  description?: Maybe<Scalars["String"]["output"]>
  id: Scalars["ID"]["output"]
  listName?: Maybe<Scalars["String"]["output"]>
  updatedAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  updatedBy?: Maybe<Scalars["String"]["output"]>
}

export type ReferenceListFilter = {
  query?: InputMaybe<Scalars["String"]["input"]>
}

export type ReferenceProcessGroupCaption = {
  __typename?: "ReferenceProcessGroupCaption"
  caption?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  status?: Maybe<Scalars["Boolean"]["output"]>
}

export type ReferenceValidationMode = {
  __typename?: "ReferenceValidationMode"
  count?: Maybe<Scalars["Int"]["output"]>
  rows?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  type: RefValidationType
}

export type ReferenceValidationResponse = {
  __typename?: "ReferenceValidationResponse"
  processedResults: Array<ReferenceValidationMode>
  refListCode: Scalars["ID"]["output"]
}

export type ReferencedDocument = {
  __typename?: "ReferencedDocument"
  filename?: Maybe<Scalars["String"]["output"]>
  id: Scalars["ID"]["output"]
  uploadInProgress: Scalars["Boolean"]["output"]
}

export type ReferencedDocumentUrl = {
  __typename?: "ReferencedDocumentUrl"
  documentName: Scalars["String"]["output"]
  url: Scalars["String"]["output"]
}

export type RegenerateApprovedTemplatesResponse = {
  __typename?: "RegenerateApprovedTemplatesResponse"
  failureCount: Scalars["Int"]["output"]
  results: Array<RegenerateApprovedTemplatesResult>
  successCount: Scalars["Int"]["output"]
  totalProcessed: Scalars["Int"]["output"]
}

export type RegenerateApprovedTemplatesResult = {
  __typename?: "RegenerateApprovedTemplatesResult"
  actions: Array<Scalars["String"]["output"]>
  commodity?: Maybe<Scalars["String"]["output"]>
  destinationCountries?: Maybe<Scalars["AWSJSON"]["output"]>
  error?: Maybe<Scalars["String"]["output"]>
  errors?: Maybe<Array<Scalars["String"]["output"]>>
  majorVersion: Scalars["Int"]["output"]
  success: Scalars["Boolean"]["output"]
  templateCode: Scalars["String"]["output"]
  templateId: Scalars["String"]["output"]
  templateRevisionId: Scalars["String"]["output"]
}

export type RegenerateCertificateInput = {
  certificateNumber: Scalars["String"]["input"]
  systemAccountName: Scalars["String"]["input"]
  userProfileName: Scalars["String"]["input"]
  xmlOutputType: Scalars["String"]["input"]
}

export type RegenerateCertificateResponse = {
  __typename?: "RegenerateCertificateResponse"
  message: Scalars["String"]["output"]
  success: Scalars["Boolean"]["output"]
}

export enum RegistrationSource {
  EcmeAccountId = "ECME_ACCOUNT_ID",
  Legacy = "LEGACY",
  MapsRbm = "MAPS_RBM",
  MapsRm = "MAPS_RM",
}

export type RegistrationType = {
  __typename?: "RegistrationType"
  description?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  typeCode?: Maybe<Scalars["String"]["output"]>
}

export type ReindexResponse = {
  __typename?: "ReindexResponse"
  alias: Scalars["String"]["output"]
  collectionName: Scalars["String"]["output"]
  functionName: Scalars["String"]["output"]
}

export type RemoveProductProcessesInput = {
  processIds: Array<Scalars["ID"]["input"]>
}

export type RemoveProductProcessesResponse = {
  __typename?: "RemoveProductProcessesResponse"
  deletedProcessIds: Array<Scalars["ID"]["output"]>
}

export type RemoveProductsFromRequestInput = {
  productsToRemove: Array<Scalars["String"]["input"]>
  requestId: Scalars["ID"]["input"]
}

export type RemoveSources = {
  prdId?: InputMaybe<Scalars["ID"]["input"]>
  prdSrcId?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>
}

export type RequestConfirmationInput = {
  processId: Scalars["ID"]["input"]
  taskId: Scalars["ID"]["input"]
  wsmp: Scalars["ID"]["input"]
}

export type RequestConfirmationResponse = {
  __typename?: "RequestConfirmationResponse"
  processId: Scalars["ID"]["output"]
  wsmp: Scalars["ID"]["output"]
}

export type RequestHistoryForSf = {
  __typename?: "RequestHistoryForSF"
  action?: Maybe<Scalars["String"]["output"]>
  id: Scalars["ID"]["output"]
  status?: Maybe<Scalars["String"]["output"]>
  statusNote?: Maybe<Scalars["String"]["output"]>
  updatedAt?: Maybe<Scalars["String"]["output"]>
  updatedBy?: Maybe<Scalars["String"]["output"]>
}

export type RequestHistoryForSfInput = {
  id: Scalars["ID"]["input"]
}

export enum RequestOrigin {
  Dfe = "DFE",
  DfeEip = "DFE_EIP",
  Eip = "EIP",
  Teo = "TEO",
}

export type RequestPartyRoleInput = {
  requestId: Scalars["ID"]["input"]
  requestType: CoreRequestType
}

export type RequestPartyRolesResponse = {
  __typename?: "RequestPartyRolesResponse"
  highestPartyRole: PartyRole
  partyRoles: Array<PartyRole>
}

export type RequestValidation = {
  __typename?: "RequestValidation"
  additionalFieldValue?: Maybe<Scalars["AWSJSON"]["output"]>
  additionalFuid?: Maybe<Scalars["String"]["output"]>
  details?: Maybe<Scalars["AWSJSON"]["output"]>
  errorMsg?: Maybe<Scalars["String"]["output"]>
  errorType: ValidationErrorType
  field?: Maybe<Scalars["String"]["output"]>
  fieldFuid?: Maybe<Scalars["String"]["output"]>
  fieldValue?: Maybe<Scalars["AWSJSON"]["output"]>
  id: Scalars["ID"]["output"]
  maxLength?: Maybe<Scalars["Int"]["output"]>
  message: Scalars["String"]["output"]
  path?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
}

export type ResetConfirmationRequestInput = {
  processId: Scalars["ID"]["input"]
  /** @deprecated Resetting a request is not a task any longer so this is not required. */
  taskId?: InputMaybe<Scalars["ID"]["input"]>
}

export enum RoleName {
  ConfirmProduct = "ConfirmProduct",
  ExternalReadOnly = "ExternalReadOnly",
  InternalReadOnly = "InternalReadOnly",
  MpiAgent = "MPIAgent",
  ManageExports = "ManageExports",
  ManageProducts = "ManageProducts",
  ManageTransfers = "ManageTransfers",
}

export type RoleSpecificKeys = {
  __typename?: "RoleSpecificKeys"
  exportCertificates?: Maybe<Scalars["String"]["output"]>
  registration?: Maybe<Scalars["String"]["output"]>
  registrationAll?: Maybe<Scalars["String"]["output"]>
  sourceTransfers?: Maybe<Scalars["String"]["output"]>
  supportingDocuments?: Maybe<Scalars["String"]["output"]>
  transferRequests?: Maybe<Scalars["String"]["output"]>
}

export type Row = {
  __typename?: "Row"
  fields?: Maybe<Array<FieldInput>>
  label?: Maybe<Scalars["String"]["output"]>
  required?: Maybe<Scalars["Boolean"]["output"]>
}

export type RulesExecutionInput = {
  decisionTableId: Scalars["ID"]["input"]
  declarations?: InputMaybe<DeclarationsInput>
  eligibility?: InputMaybe<EligibilityInput>
  exportCertificateWorkflow?: InputMaybe<ExportCertificateWorkflowInput>
  importConnections?: InputMaybe<ImportConnectionsInput>
  phytoOcaEmailNotifications?: InputMaybe<PhytoOcaEmailNotificationsInput>
  productField?: InputMaybe<ProductFieldInput>
  wineAnalytesTolerances?: InputMaybe<WineAnalytesTolerancesResponseInput>
  wineProductField?: InputMaybe<WineProductFieldInput>
}

export type RulesInput =
  | DeclarationsType
  | EligibilityType
  | ExportCertificateWorkflowType
  | ImportConnectionsType
  | PhytoOcaEmailNotificationsType
  | ProductFieldType
  | WineAnalytesTolerancesType
  | WineProductFieldType

export type RulesResponse =
  | DeclarationsResponse
  | EligibilityResponse
  | ExportCertificateWorkflowResponse
  | ImportConnectionsResponse
  | PhytoOcaEmailNotificationsResponse
  | ProductFieldResponse
  | WineAnalytesTolerancesResponse

export type SpsAddress = {
  __typename?: "SPSAddress"
  city?: Maybe<Scalars["String"]["output"]>
  city_id?: Maybe<Scalars["ID"]["output"]>
  country_id?: Maybe<Scalars["ID"]["output"]>
  country_name?: Maybe<Scalars["String"]["output"]>
  country_subdivision_id?: Maybe<Scalars["ID"]["output"]>
  country_subdivision_name?: Maybe<Scalars["String"]["output"]>
  postcode?: Maybe<Scalars["String"]["output"]>
  postcode_code?: Maybe<Scalars["String"]["output"]>
  street?: Maybe<Scalars["String"]["output"]>
  type_code?: Maybe<AddressTypeCode>
}

export type SpsAddressInput = {
  city?: InputMaybe<Scalars["String"]["input"]>
  city_id?: InputMaybe<Scalars["ID"]["input"]>
  country_id?: InputMaybe<Scalars["ID"]["input"]>
  country_name?: InputMaybe<Scalars["String"]["input"]>
  country_subdivision_id?: InputMaybe<Scalars["ID"]["input"]>
  country_subdivision_name?: InputMaybe<Scalars["String"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  postcode_code?: InputMaybe<Scalars["String"]["input"]>
  street?: InputMaybe<Scalars["String"]["input"]>
  type_code?: InputMaybe<AddressTypeCode>
}

export type SpsAuthentication = {
  __typename?: "SPSAuthentication"
  actual?: Maybe<Scalars["AWSDateTime"]["output"]>
  included_clauses: Array<SpsClause>
  issue_location?: Maybe<SpsLocation>
  location_provider_party?: Maybe<SpsParty>
  provider_party?: Maybe<SpsParty>
  type_code?: Maybe<NamedCode>
}

export type SpsAuthenticationInput = {
  actual?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  included_clauses?: InputMaybe<Array<SpsClauseInput>>
  issue_location?: InputMaybe<SpsLocationInput>
  location_provider_party?: InputMaybe<SpsPartyInput>
  provider_party?: InputMaybe<SpsPartyInput>
  type_code?: InputMaybe<NamedCodeInput>
}

export type SpsCertificate = {
  __typename?: "SPSCertificate"
  consignment: SpsConsignment
  exchanged_document: SpsExchangedDocument
}

export type SpsClassification = {
  __typename?: "SPSClassification"
  class_code?: Maybe<Scalars["String"]["output"]>
  class_name: Scalars["String"]["output"]
  system_id?: Maybe<Scalars["String"]["output"]>
  system_name: Scalars["String"]["output"]
}

export type SpsClassificationInput = {
  class_code?: InputMaybe<Scalars["String"]["input"]>
  class_name: Scalars["String"]["input"]
  system_id?: InputMaybe<Scalars["String"]["input"]>
  system_name: Scalars["String"]["input"]
}

export type SpsClause = {
  __typename?: "SPSClause"
  content?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
}

export type SpsClauseInput = {
  content?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
}

export type SpsConsignment = {
  __typename?: "SPSConsignment"
  availability_due_date_time?: Maybe<Scalars["AWSDateTime"]["output"]>
  carrier?: Maybe<SpsParty>
  consignee?: Maybe<SpsParty>
  consignee_receipt_location?: Maybe<SpsLocation>
  consignor?: Maybe<SpsParty>
  customs_transit_agent?: Maybe<SpsParty>
  delivery?: Maybe<SpsParty>
  despatch?: Maybe<SpsParty>
  examination_event?: Maybe<SpsEvent>
  export_country?: Maybe<SpsCountry>
  export_exit_date_time?: Maybe<Scalars["AWSDateTime"]["output"]>
  exporter_reference?: Maybe<Scalars["String"]["output"]>
  gross_weight?: Maybe<Scalars["String"]["output"]>
  import_country?: Maybe<SpsCountry>
  items: Array<SpsConsignmentItem>
  loading_base_port_location?: Maybe<SpsLocation>
  main_carriage_transport_movements: Array<SpsTransportMovement>
  reexport_country?: Maybe<SpsCountry>
  ship_stores_indicator?: Maybe<IndicatorType>
  storage_events: Array<SpsEvent>
  transit_countries: Array<SpsCountry>
  transit_locations: Array<SpsLocation>
  unloading_base_port_location?: Maybe<SpsLocation>
  utilized_transport_equipment: Array<SpsTransportEquipment>
  wine?: Maybe<WineConsignment>
}

export type SpsConsignmentInput = {
  availability_due_date_time?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  carrier?: InputMaybe<SpsPartyInput>
  consignee?: InputMaybe<SpsPartyInput>
  consignee_receipt_location?: InputMaybe<SpsLocationInput>
  consignor?: InputMaybe<SpsPartyInput>
  customs_transit_agent?: InputMaybe<SpsPartyInput>
  delivery?: InputMaybe<SpsPartyInput>
  despatch?: InputMaybe<SpsPartyInput>
  examination_event?: InputMaybe<SpsEventInput>
  export_exit_date_time?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  exporter_reference?: InputMaybe<Scalars["String"]["input"]>
  gross_weight?: InputMaybe<Scalars["String"]["input"]>
  import_country?: InputMaybe<SpsCountryInput>
  items?: InputMaybe<Array<SpsConsignmentItemInput>>
  loading_base_port_location?: InputMaybe<SpsLocationInput>
  main_carriage_transport_movements?: InputMaybe<
    Array<SpsTransportMovementInput>
  >
  storage_events?: InputMaybe<Array<SpsEventInput>>
  transit_countries?: InputMaybe<Array<SpsCountryInput>>
  transit_locations?: InputMaybe<Array<SpsLocationInput>>
  unloading_base_port_location?: InputMaybe<SpsLocationInput>
  utilized_transport_equipment?: InputMaybe<Array<SpsTransportEquipmentInput>>
}

export type SpsConsignmentItem = {
  __typename?: "SPSConsignmentItem"
  gross_weight?: Maybe<Scalars["String"]["output"]>
  items: Array<SpsTradeLineItem>
  nature_identification_cargo: Array<CargoTypeClassificationCode>
}

export type SpsConsignmentItemInput = {
  gross_weight?: InputMaybe<Scalars["String"]["input"]>
  items: Array<SpsTradeLineItemInput>
  nature_identification_cargo?: InputMaybe<Array<CargoTypeClassificationCode>>
}

export type SpsContact = {
  __typename?: "SPSContact"
  person_name?: Maybe<Scalars["String"]["output"]>
}

export type SpsContactInput = {
  person_name?: InputMaybe<Scalars["String"]["input"]>
}

export type SpsCountry = {
  __typename?: "SPSCountry"
  id: Scalars["ID"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  subdivision?: Maybe<SpsCountrySubDivision>
}

export type SpsCountryInput = {
  id: Scalars["ID"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  subdivision?: InputMaybe<SpsCountrySubDivisionInput>
}

export type SpsCountrySubDivision = {
  __typename?: "SPSCountrySubDivision"
  hierarchicalLevelCode?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

export type SpsCountrySubDivisionInput = {
  id?: InputMaybe<Scalars["String"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
}

export type SpsEvent = {
  __typename?: "SPSEvent"
  occurrence_location?: Maybe<SpsLocation>
}

export type SpsEventInput = {
  occurrence_location?: InputMaybe<SpsLocationInput>
}

export type SpsExchangedDocument = {
  __typename?: "SPSExchangedDocument"
  certificate_id: Scalars["String"]["output"]
  certifier?: Maybe<SpsAuthentication>
  customs_permit_number?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  included_notes: Array<SpsNote>
  issue_date_time: Scalars["AWSDateTime"]["output"]
  issuer: SpsParty
  name: Scalars["String"]["output"]
  referenced_documents: Array<SpsReferencedDocument>
  signatories: Array<SpsAuthentication>
  status_code: Scalars["String"]["output"]
  type_code: Scalars["String"]["output"]
  verifiers: Array<SpsAuthentication>
}

export type SpsLocation = {
  __typename?: "SPSLocation"
  country?: Maybe<Scalars["String"]["output"]>
  country_id?: Maybe<Scalars["ID"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

export type SpsLocationInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
}

export type SpsNote = {
  __typename?: "SPSNote"
  content: Scalars["String"]["output"]
  content_code?: Maybe<Scalars["String"]["output"]>
  subject?: Maybe<Scalars["String"]["output"]>
  subject_code?: Maybe<Scalars["String"]["output"]>
}

export type SpsNoteInput = {
  content: Scalars["String"]["input"]
  content_code?: InputMaybe<Scalars["String"]["input"]>
  subject?: InputMaybe<Scalars["String"]["input"]>
  subject_code?: InputMaybe<Scalars["String"]["input"]>
}

export type SpsPackage = {
  __typename?: "SPSPackage"
  level_code?: Maybe<Scalars["String"]["output"]>
  nominal_gross_volume?: Maybe<Scalars["String"]["output"]>
  nominal_gross_weight?: Maybe<Scalars["String"]["output"]>
  physical_shipping_marks: Array<Scalars["String"]["output"]>
  quantity?: Maybe<Scalars["String"]["output"]>
  type_code?: Maybe<NamedCode>
}

export type SpsPackageInput = {
  level_code?: InputMaybe<Scalars["String"]["input"]>
  nominal_gross_volume?: InputMaybe<Scalars["String"]["input"]>
  nominal_gross_weight?: InputMaybe<Scalars["String"]["input"]>
  physical_shipping_marks?: InputMaybe<Array<Scalars["String"]["input"]>>
  quantity?: InputMaybe<Scalars["String"]["input"]>
  type_code?: InputMaybe<NamedCodeInput>
}

export type SpsParty = {
  __typename?: "SPSParty"
  defined_contacts: Array<SpsContact>
  name: Scalars["String"]["output"]
  party_id?: Maybe<Scalars["String"]["output"]>
  role_code?: Maybe<Scalars["String"]["output"]>
  specified_address?: Maybe<SpsAddress>
  specified_person?: Maybe<SpsPerson>
  type_code?: Maybe<Scalars["Int"]["output"]>
}

export type SpsPartyInput = {
  defined_contacts?: InputMaybe<Array<SpsContactInput>>
  name: Scalars["String"]["input"]
  party_id?: InputMaybe<Scalars["String"]["input"]>
  role_code?: InputMaybe<Scalars["String"]["input"]>
  specified_address?: InputMaybe<SpsAddressInput>
  specified_person?: InputMaybe<SpsPersonInput>
  type_code?: InputMaybe<Scalars["Int"]["input"]>
}

export type SpsPeriod = {
  __typename?: "SPSPeriod"
  duration?: Maybe<Scalars["String"]["output"]>
  end?: Maybe<Scalars["AWSDateTime"]["output"]>
  start?: Maybe<Scalars["AWSDateTime"]["output"]>
}

export type SpsPeriodInput = {
  duration?: InputMaybe<Scalars["String"]["input"]>
  end?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  start?: InputMaybe<Scalars["AWSDateTime"]["input"]>
}

export type SpsPerson = {
  __typename?: "SPSPerson"
  attained_qualifications: Array<SpsQualification>
  name?: Maybe<Scalars["String"]["output"]>
}

export type SpsPersonInput = {
  attained_qualifications?: InputMaybe<Array<SpsQualificationInput>>
  name?: InputMaybe<Scalars["String"]["input"]>
}

export type SpsProcess = {
  __typename?: "SPSProcess"
  applicable_process_characteristics: Array<SpsProcessCharacteristic>
  completion_period?: Maybe<SpsPeriod>
  operation_country?: Maybe<SpsCountry>
  operator_party?: Maybe<SpsParty>
  type_code?: Maybe<NamedCode>
}

export type SpsProcessCharacteristic = {
  __typename?: "SPSProcessCharacteristic"
  description?: Maybe<Scalars["String"]["output"]>
  maximum?: Maybe<Scalars["String"]["output"]>
  minimum?: Maybe<Scalars["String"]["output"]>
  type_code?: Maybe<NamedCode>
  value?: Maybe<Scalars["String"]["output"]>
}

export type SpsProcessCharacteristicInput = {
  description?: InputMaybe<Scalars["String"]["input"]>
  maximum?: InputMaybe<Scalars["String"]["input"]>
  minimum?: InputMaybe<Scalars["String"]["input"]>
  type_code?: InputMaybe<NamedCodeInput>
  value?: InputMaybe<Scalars["String"]["input"]>
}

export type SpsProcessInput = {
  applicable_process_characteristics?: InputMaybe<
    Array<SpsProcessCharacteristicInput>
  >
  completion_period?: InputMaybe<SpsPeriodInput>
  operation_country?: InputMaybe<SpsCountryInput>
  operator_party?: InputMaybe<SpsPartyInput>
  type_code?: InputMaybe<NamedCodeInput>
}

export type SpsQualification = {
  __typename?: "SPSQualification"
  abbreviated_name?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

export type SpsQualificationInput = {
  abbreviated_name?: InputMaybe<Scalars["String"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
}

export type SpsReferencedDocument = {
  __typename?: "SPSReferencedDocument"
  checksum?: Maybe<Scalars["String"]["output"]>
  document_id?: Maybe<Scalars["ID"]["output"]>
  filename?: Maybe<Scalars["String"]["output"]>
  filetype?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  information?: Maybe<Scalars["String"]["output"]>
  issued?: Maybe<Scalars["AWSDateTime"]["output"]>
  relationship_type_code: Scalars["String"]["output"]
  type_code?: Maybe<Scalars["String"]["output"]>
}

export type SpsSeal = {
  __typename?: "SPSSeal"
  issuing_party?: Maybe<SpsParty>
  maximum_id?: Maybe<Scalars["String"]["output"]>
  seal_id: Scalars["String"]["output"]
}

export type SpsSealInput = {
  issuing_party?: InputMaybe<SpsPartyInput>
  maximum_id?: InputMaybe<Scalars["String"]["input"]>
  seal_id: Scalars["String"]["input"]
}

export type SpsTemperature = {
  __typename?: "SPSTemperature"
  maximum?: Maybe<Scalars["String"]["output"]>
  minimum?: Maybe<Scalars["String"]["output"]>
  type_code?: Maybe<Scalars["String"]["output"]>
  value?: Maybe<Scalars["String"]["output"]>
}

export type SpsTemperatureInput = {
  maximum?: InputMaybe<Scalars["String"]["input"]>
  minimum?: InputMaybe<Scalars["String"]["input"]>
  type_code?: InputMaybe<Scalars["String"]["input"]>
  value?: InputMaybe<Scalars["String"]["input"]>
}

export type SpsTradeLineItem = {
  __typename?: "SPSTradeLineItem"
  additional_information: Array<SpsNote>
  applied_processes: Array<SpsProcess>
  asserted_authentications: Array<SpsAuthentication>
  associated_transport_equipment: Array<SpsTransportEquipment>
  brand_name?: Maybe<Scalars["String"]["output"]>
  classifications: Array<SpsClassification>
  cn_code?: Maybe<Scalars["String"]["output"]>
  comments?: Maybe<Scalars["String"]["output"]>
  commodity?: Maybe<Scalars["String"]["output"]>
  common_name?: Maybe<Scalars["String"]["output"]>
  description: Scalars["String"]["output"]
  expiry_date_time?: Maybe<Scalars["AWSDateTime"]["output"]>
  gross_volume?: Maybe<Scalars["String"]["output"]>
  gross_weight?: Maybe<Scalars["String"]["output"]>
  hs_code?: Maybe<Scalars["String"]["output"]>
  id: Scalars["String"]["output"]
  import_certificate_extract?: Maybe<Array<ImportCertificateExtractItem>>
  import_certificate_measurement?: Maybe<
    Array<ImportCertificateExtractMeasurement>
  >
  import_permit_number?: Maybe<Scalars["String"]["output"]>
  intended_use?: Maybe<Scalars["String"]["output"]>
  net_volume?: Maybe<Scalars["String"]["output"]>
  net_weight?: Maybe<Scalars["String"]["output"]>
  origin_countries?: Maybe<Array<SpsCountry>>
  origin_country?: Maybe<SpsCountry>
  origin_locations: Array<SpsLocation>
  other_quantity?: Maybe<Scalars["String"]["output"]>
  physical_packages: Array<SpsPackage>
  production_batch_id?: Maybe<Scalars["String"]["output"]>
  referenced_documents: Array<SpsReferencedDocument>
  requestor_id?: Maybe<Scalars["String"]["output"]>
  scientific_name?: Maybe<Scalars["String"]["output"]>
  sequence?: Maybe<Scalars["Int"]["output"]>
  verified: Scalars["Boolean"]["output"]
  wine?: Maybe<B2GWineFields>
}

export type SpsTradeLineItemInput = {
  additional_information?: InputMaybe<Array<SpsNoteInput>>
  applied_processes?: InputMaybe<Array<SpsProcessInput>>
  asserted_authentications?: InputMaybe<Array<SpsAuthenticationInput>>
  associated_transport_equipment?: InputMaybe<Array<SpsTransportEquipmentInput>>
  brand_name?: InputMaybe<Scalars["String"]["input"]>
  classifications?: InputMaybe<Array<SpsClassificationInput>>
  commodity?: InputMaybe<Scalars["String"]["input"]>
  common_name?: InputMaybe<Scalars["String"]["input"]>
  description: Scalars["String"]["input"]
  expiry_date_time?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  gross_volume?: InputMaybe<Scalars["String"]["input"]>
  gross_weight?: InputMaybe<Scalars["String"]["input"]>
  hs_code?: InputMaybe<Scalars["String"]["input"]>
  import_permit_number?: InputMaybe<Scalars["String"]["input"]>
  intended_use?: InputMaybe<Scalars["String"]["input"]>
  net_volume?: InputMaybe<Scalars["String"]["input"]>
  net_weight?: InputMaybe<Scalars["String"]["input"]>
  origin_country?: InputMaybe<SpsCountryInput>
  origin_locations?: InputMaybe<Array<SpsLocationInput>>
  physical_packages?: InputMaybe<Array<SpsPackageInput>>
  production_batch_id?: InputMaybe<Scalars["String"]["input"]>
  requestor_id?: InputMaybe<Scalars["String"]["input"]>
  scientific_name?: InputMaybe<Scalars["String"]["input"]>
  sequence?: InputMaybe<Scalars["Int"]["input"]>
}

export type SpsTransportEquipment = {
  __typename?: "SPSTransportEquipment"
  affixed_seals: Array<SpsSeal>
  temperature_settings: Array<SpsTemperature>
  transport_equipment_id: Scalars["String"]["output"]
}

export type SpsTransportEquipmentInput = {
  affixed_seals?: InputMaybe<Array<SpsSealInput>>
  temperature_settings?: InputMaybe<Array<SpsTemperatureInput>>
  transport_equipment_id: Scalars["String"]["input"]
}

export type SpsTransportMovement = {
  __typename?: "SPSTransportMovement"
  mode: TransportModeCode
  mode_name?: Maybe<Scalars["String"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  used_transport_means?: Maybe<Scalars["String"]["output"]>
}

export type SpsTransportMovementInput = {
  mode: TransportModeCode
  reference?: InputMaybe<Scalars["String"]["input"]>
  used_transport_means?: InputMaybe<Scalars["String"]["input"]>
}

export type SpsTransportMovementTemplate = {
  __typename?: "SPSTransportMovementTemplate"
  id?: Maybe<Scalars["ID"]["output"]>
  mode: TransportMovementCodeTemplate
  used_transport_means?: Maybe<Scalars["String"]["output"]>
}

export type SpsWineExporter = {
  __typename?: "SPSWineExporter"
  name?: Maybe<Scalars["String"]["output"]>
}

export type SalesForceAddress = {
  __typename?: "SalesForceAddress"
  addressType: Scalars["String"]["output"]
  city: Scalars["String"]["output"]
  country: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  isPrimary: Scalars["Boolean"]["output"]
  postalCode?: Maybe<Scalars["String"]["output"]>
  street: Scalars["String"]["output"]
}

export type SalesForceContact = {
  __typename?: "SalesForceContact"
  emails: Array<SalesForceEmail>
  id: Scalars["ID"]["output"]
  name: Scalars["String"]["output"]
  phones: Array<SalesForcePhone>
  role?: Maybe<Scalars["String"]["output"]>
  title?: Maybe<Scalars["String"]["output"]>
}

export type SalesForceEmail = {
  __typename?: "SalesForceEmail"
  emailAddress: Scalars["String"]["output"]
  emailType: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  isPrimary: Scalars["Boolean"]["output"]
}

export type SalesForceIdentifier = {
  __typename?: "SalesForceIdentifier"
  description: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  value: Scalars["String"]["output"]
}

export type SalesForceParty = {
  __typename?: "SalesForceParty"
  addresses: Array<SalesForceAddress>
  contacts: Array<SalesForceContact>
  id: Scalars["String"]["output"]
  identifiers: Array<SalesForceIdentifier>
  name: Scalars["String"]["output"]
  nzbn?: Maybe<Scalars["String"]["output"]>
  primaryAddress?: Maybe<SalesForceAddress>
  registrationIdentifier?: Maybe<Scalars["String"]["output"]>
  registrationNumber?: Maybe<Scalars["String"]["output"]>
  tradingAs?: Maybe<Scalars["String"]["output"]>
}

export type SalesForcePhone = {
  __typename?: "SalesForcePhone"
  id: Scalars["ID"]["output"]
  isPrimary: Scalars["Boolean"]["output"]
  phoneType: Scalars["String"]["output"]
  telephoneNumber: Scalars["String"]["output"]
}

export type SalesForceProductId = {
  __typename?: "SalesForceProductId"
  productId: Scalars["ID"]["output"]
  productRevisionId: Scalars["ID"]["output"]
  sfProductId?: Maybe<Scalars["ID"]["output"]>
}

export type SalesforceErApprovalInput = {
  exportRequestId: Scalars["ID"]["input"]
  reasonForStatusChange?: InputMaybe<Scalars["String"]["input"]>
  status: SalesforceErStatus
}

export type SalesforceErApprovalResponse = {
  __typename?: "SalesforceErApprovalResponse"
  exportRequestId: Scalars["ID"]["output"]
  status: SalesforceErStatus
}

export enum SalesforceErStatus {
  Approved = "APPROVED",
  Rejected = "REJECTED",
}

export enum SalesforceTransferRequestStatus {
  Approved = "APPROVED",
  Rejected = "REJECTED",
  Resubmit = "RESUBMIT",
  ToBeAmended = "TO_BE_AMENDED",
}

export type SalesforceTransferRequestVerificationInput = {
  reasonForStatusChange?: InputMaybe<Scalars["String"]["input"]>
  status: SalesforceTransferRequestStatus
  transferRequestId: Scalars["ID"]["input"]
}

export type SalesforceTransferRequestVerificationResponse = {
  __typename?: "SalesforceTransferRequestVerificationResponse"
  transferRequestId: Scalars["ID"]["output"]
}

export type SaveChangesToReferenceDataInput = {
  description?: InputMaybe<Scalars["String"]["input"]>
  isFileUploaded: Scalars["Boolean"]["input"]
  listCode: Scalars["String"]["input"]
  s3Key?: InputMaybe<Scalars["String"]["input"]>
}

export type SaveChangesToReferenceDataResponse = {
  __typename?: "SaveChangesToReferenceDataResponse"
  isDescUpdated: Scalars["Boolean"]["output"]
  isFileUploaded: Scalars["Boolean"]["output"]
}

export type SaveG2GAccountInput = {
  accountType: G2GAccountType
  comment?: InputMaybe<Scalars["String"]["input"]>
  contactNumber: Scalars["String"]["input"]
  email?: InputMaybe<Scalars["String"]["input"]>
  fullName: Scalars["String"]["input"]
  id?: InputMaybe<Scalars["ID"]["input"]>
  jobTitle?: InputMaybe<Scalars["String"]["input"]>
  permissions: G2GPermissionsInput
  profileName?: InputMaybe<Scalars["String"]["input"]>
  reason?: InputMaybe<SuspensionReason>
  status: G2GAccountStatus
  subId?: InputMaybe<Scalars["String"]["input"]>
  systemUsername?: InputMaybe<Scalars["String"]["input"]>
}

export type SavedClassificationOutput = {
  __typename?: "SavedClassificationOutput"
  id?: Maybe<Scalars["ID"]["output"]>
}

export type SavedProcessOutput = {
  __typename?: "SavedProcessOutput"
  id?: Maybe<Scalars["ID"]["output"]>
}

export type SavedProductOutput = {
  __typename?: "SavedProductOutput"
  classification?: Maybe<Array<Maybe<SavedClassificationOutput>>>
  containerId?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>
  id?: Maybe<Scalars["ID"]["output"]>
  process?: Maybe<Array<Maybe<SavedProcessOutput>>>
  productName?: Maybe<Scalars["String"]["output"]>
}

export type SearchApiKey = {
  __typename?: "SearchApiKey"
  apiKey: Scalars["String"]["output"]
  expires: Scalars["AWSDateTime"]["output"]
}

export type SearchG2GAccountsInput = {
  accountType?: InputMaybe<G2GAccountType>
  certificateType?: InputMaybe<CoreExportCertificateType>
  country?: InputMaybe<Scalars["String"]["input"]>
  page?: InputMaybe<Scalars["Int"]["input"]>
  perPage?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<G2GAccountStatus>
}

export type SearchOptions = {
  fromDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  startWithEmptyCollection: Scalars["Boolean"]["input"]
}

export type SearchReferenceListResponse = {
  __typename?: "SearchReferenceListResponse"
  list?: Maybe<Array<ReferenceList>>
  totalCount: Scalars["Int"]["output"]
}

export type SearchTemplateVersionsResponse = {
  __typename?: "SearchTemplateVersionsResponse"
  results: Array<TemplateVersion>
  totalCount: Scalars["Int"]["output"]
}

export type Section = {
  __typename?: "Section"
  children: Array<Block>
  description?: Maybe<Scalars["String"]["output"]>
  id: Scalars["String"]["output"]
  title?: Maybe<Scalars["String"]["output"]>
}

export type SensoryProcessInput = {
  assessmentDate: Scalars["AWSDateTime"]["input"]
  comment?: InputMaybe<Scalars["String"]["input"]>
  disputed: Scalars["Boolean"]["input"]
  disputedReason?: InputMaybe<WineDisputedReason>
  productId: Scalars["ID"]["input"]
  reference: Scalars["String"]["input"]
  winemaker: B2GContactInput
}

export type SensoryProcessRequest = {
  __typename?: "SensoryProcessRequest"
  assessmentDate: Scalars["AWSDateTime"]["output"]
  comment?: Maybe<Scalars["String"]["output"]>
  disputed: Scalars["Boolean"]["output"]
  disputedReason?: Maybe<WineDisputedReason>
  id: Scalars["ID"]["output"]
  productId: Scalars["ID"]["output"]
  reference: Scalars["String"]["output"]
  winemaker: B2GContact
}

export type SfApplication = {
  __typename?: "SfApplication"
  CNInspection?: Maybe<Scalars["String"]["output"]>
  EUCommodityCode?: Maybe<Scalars["String"]["output"]>
  EUTransit?: Maybe<Scalars["String"]["output"]>
  address?: Maybe<Scalars["String"]["output"]>
  administrativeTerritorialUnit?: Maybe<Scalars["String"]["output"]>
  approvedByName?: Maybe<Scalars["String"]["output"]>
  approvedBySFUserId?: Maybe<Scalars["String"]["output"]>
  approvedCertificateEmailAddresses?: Maybe<
    Array<Maybe<Scalars["String"]["output"]>>
  >
  approvedDateTime?: Maybe<Scalars["AWSDateTime"]["output"]>
  arrivalDateTime?: Maybe<Scalars["String"]["output"]>
  brandName?: Maybe<Scalars["String"]["output"]>
  carrierName?: Maybe<Scalars["String"]["output"]>
  categoryOfGoods?: Maybe<Scalars["String"]["output"]>
  certificateNumber?: Maybe<Scalars["String"]["output"]>
  certificateType?: Maybe<Scalars["String"]["output"]>
  certificates?: Maybe<Array<Maybe<SfGeneratedCertificate>>>
  certifyingAgencyIdentifier?: Maybe<Scalars["String"]["output"]>
  commodityCode?: Maybe<Scalars["String"]["output"]>
  consigneeIdentifier?: Maybe<Scalars["String"]["output"]>
  consignorIdentifier?: Maybe<Scalars["String"]["output"]>
  contractNumber?: Maybe<Scalars["String"]["output"]>
  conveyanceReference?: Maybe<Scalars["String"]["output"]>
  deliveryDetails?: Maybe<Scalars["String"]["output"]>
  deliveryDispatchDetails?: Maybe<Scalars["String"]["output"]>
  departureDateTime?: Maybe<Scalars["String"]["output"]>
  destinationCountry?: Maybe<Scalars["String"]["output"]>
  dischargePort?: Maybe<Scalars["String"]["output"]>
  exporterIdentifier?: Maybe<Scalars["String"]["output"]>
  exportingCountry?: Maybe<Scalars["String"]["output"]>
  finalDestination?: Maybe<Scalars["String"]["output"]>
  forImportOrAdmission?: Maybe<Scalars["String"]["output"]>
  freeTextDeclaration?: Maybe<Scalars["String"]["output"]>
  halalAuditor?: Maybe<Scalars["String"]["output"]>
  halalCertificateNumber?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  importPermitNumbers?: Maybe<Scalars["String"]["output"]>
  inspectionDateTime?: Maybe<Scalars["AWSDateTime"]["output"]>
  inspectionPort?: Maybe<Scalars["String"]["output"]>
  isAutoApproval?: Maybe<Scalars["Boolean"]["output"]>
  isExhausted?: Maybe<Scalars["Boolean"]["output"]>
  isShipStore?: Maybe<Scalars["Boolean"]["output"]>
  lastModifiedByName?: Maybe<Scalars["String"]["output"]>
  lastModifiedBySFUserId?: Maybe<Scalars["String"]["output"]>
  lastModifiedDateTime?: Maybe<Scalars["AWSDateTime"]["output"]>
  letterOfCreditRefCode?: Maybe<Scalars["String"]["output"]>
  loadingPort?: Maybe<Scalars["String"]["output"]>
  localCarrier?: Maybe<Scalars["String"]["output"]>
  localCarrierReference?: Maybe<Scalars["String"]["output"]>
  lot?: Maybe<Scalars["String"]["output"]>
  manufacturerRegistration?: Maybe<Scalars["String"]["output"]>
  manufacturingPremisesName?: Maybe<Scalars["String"]["output"]>
  markingOfSealOnTransportContainer?: Maybe<Scalars["String"]["output"]>
  nameRegistrationAndAddressOfSemenCollection?: Maybe<
    Scalars["String"]["output"]
  >
  netWeightInWords?: Maybe<Scalars["String"]["output"]>
  numberOfDoses?: Maybe<Scalars["Int"]["output"]>
  numberOfEmbryos?: Maybe<Scalars["Int"]["output"]>
  numberOfPackagescontainers?: Maybe<Scalars["Int"]["output"]>
  officialStatement?: Maybe<Scalars["String"]["output"]>
  phytoCertSubType?: Maybe<Scalars["String"]["output"]>
  phytoLotReferenceNumber?: Maybe<Scalars["String"]["output"]>
  phytoPackhouse?: Maybe<Scalars["String"]["output"]>
  phytoSchemeControl?: Maybe<Scalars["String"]["output"]>
  phytoStatementOfRelabelling?: Maybe<Scalars["String"]["output"]>
  placeAndDateOfQuarantine?: Maybe<Scalars["String"]["output"]>
  productDescription?: Maybe<Scalars["String"]["output"]>
  purposeBR?: Maybe<Scalars["String"]["output"]>
  requestorReference?: Maybe<Scalars["String"]["output"]>
  russianDairyExporterReference?: Maybe<Scalars["String"]["output"]>
  sanitaryCertificateNumber?: Maybe<Scalars["String"]["output"]>
  scope?: Maybe<Scalars["String"]["output"]>
  signatory?: Maybe<Scalars["String"]["output"]>
  signingOffice?: Maybe<Scalars["String"]["output"]>
  statementOfRelabelling?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  statusChangeReason?: Maybe<Scalars["String"]["output"]>
  subStatus?: Maybe<Scalars["String"]["output"]>
  submittedByName?: Maybe<Scalars["String"]["output"]>
  submittedBySFUserId?: Maybe<Scalars["String"]["output"]>
  submittedDateTime?: Maybe<Scalars["AWSDateTime"]["output"]>
  summaryOfRecordsFor?: Maybe<Scalars["String"]["output"]>
  totalGrossWeight?: Maybe<Scalars["String"]["output"]>
  totalQuantity?: Maybe<Scalars["String"]["output"]>
  transitCountries?: Maybe<Scalars["String"]["output"]>
  transport?: Maybe<Scalars["String"]["output"]>
  transportMode?: Maybe<Scalars["String"]["output"]>
  uniqueConsignmentReference?: Maybe<Scalars["String"]["output"]>
  unofficialInformation?: Maybe<Scalars["String"]["output"]>
  urgency?: Maybe<Scalars["String"]["output"]>
  verifyingAgencyIdentifier?: Maybe<Scalars["String"]["output"]>
}

export type SfApprovedTemplateVersion = {
  __typename?: "SfApprovedTemplateVersion"
  code: Scalars["String"]["output"]
  commodity?: Maybe<Scalars["String"]["output"]>
  destinationCountries?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  id: Scalars["ID"]["output"]
  majorVersion: Scalars["Int"]["output"]
  minorVersion: Scalars["Int"]["output"]
  title: Scalars["String"]["output"]
}

export type SfCancelExportCertificateInput = {
  reason?: InputMaybe<Scalars["String"]["input"]>
  requestor?: InputMaybe<Scalars["String"]["input"]>
  requestor_id: Scalars["String"]["input"]
}

export type SfChangeExportCertificateRequestStatusInput = {
  reason_for_status_change?: InputMaybe<Scalars["String"]["input"]>
  requestor?: InputMaybe<Scalars["String"]["input"]>
  requestor_id: Scalars["String"]["input"]
  status: ExportCertificateStatus
}

export type SfChangeExportRequestStatusInput = {
  action?: InputMaybe<ChangeExportRequestAction>
  id: Scalars["ID"]["input"]
  reasonCategories?: InputMaybe<Array<InputMaybe<EditReasonCategory>>>
  reasonForStatusChange?: InputMaybe<Scalars["String"]["input"]>
  sfUpdatedAt?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  sfUpdatedBy?: InputMaybe<Scalars["String"]["input"]>
  status: ChangeExportRequestStatus
  substatus?: InputMaybe<CoreSubstatus>
  version?: InputMaybe<Scalars["Int"]["input"]>
}

export type SfChangeExportRequestStatusResponse = {
  __typename?: "SfChangeExportRequestStatusResponse"
  id?: Maybe<Scalars["ID"]["output"]>
  message?: Maybe<Scalars["String"]["output"]>
  success?: Maybe<Scalars["Boolean"]["output"]>
  version?: Maybe<Scalars["Int"]["output"]>
}

export type SfChangeTransferRequestStatusInput = {
  id: Scalars["ID"]["input"]
  reasonCategories?: InputMaybe<Array<InputMaybe<ExportReasonCategory>>>
  reasonForStatusChange?: InputMaybe<Scalars["String"]["input"]>
  sfUpdatedAt?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  sfUpdatedBy?: InputMaybe<Scalars["String"]["input"]>
  status: ChangeTransferRequestStatus
  version?: InputMaybe<Scalars["Int"]["input"]>
}

export type SfChangeTransferRequestStatusResponse = {
  __typename?: "SfChangeTransferRequestStatusResponse"
  id?: Maybe<Scalars["ID"]["output"]>
  message?: Maybe<Scalars["String"]["output"]>
  success?: Maybe<Scalars["Boolean"]["output"]>
  version?: Maybe<Scalars["Int"]["output"]>
}

export type SfDownloadCertificateInput = {
  id: Scalars["ID"]["input"]
  reasonForReprint?: InputMaybe<Scalars["String"]["input"]>
  type: SfGeneratedCertificateType
  updatedAt: Scalars["String"]["input"]
  updatedBy: Scalars["String"]["input"]
}

export type SfDownloadCertificateResponse = {
  __typename?: "SfDownloadCertificateResponse"
  presignedURL?: Maybe<Scalars["String"]["output"]>
}

export type SfDownloadInput = {
  reasonForReprint?: InputMaybe<Scalars["String"]["input"]>
  s3URI?: InputMaybe<Scalars["String"]["input"]>
  updatedAt?: InputMaybe<Scalars["String"]["input"]>
  updatedBy?: InputMaybe<Scalars["String"]["input"]>
}

export type SfGeneratedCertificate = {
  __typename?: "SfGeneratedCertificate"
  createdBy?: Maybe<Scalars["String"]["output"]>
  createdDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  documentType?: Maybe<Scalars["String"]["output"]>
  fileExtension?: Maybe<Scalars["String"]["output"]>
  fileName?: Maybe<Scalars["String"]["output"]>
  fileVersion?: Maybe<Scalars["String"]["output"]>
  s3URI?: Maybe<Scalars["String"]["output"]>
}

export enum SfGeneratedCertificateType {
  CopyPdf = "COPY_PDF",
  DraftPdf = "DRAFT_PDF",
  OfficialPdf = "OFFICIAL_PDF",
  XmlOutput = "XML_OUTPUT",
}

export type SfPrintHistory = {
  __typename?: "SfPrintHistory"
  datePrinted?: Maybe<Scalars["AWSDateTime"]["output"]>
  reasonForReprinting?: Maybe<Scalars["String"]["output"]>
  sfUserId?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<GeneratedCertificateType>
}

export type SfRequest = {
  __typename?: "SfRequest"
  application?: Maybe<Scalars["String"]["output"]>
  applicationHistory?: Maybe<Scalars["String"]["output"]>
  applicationTemplate?: Maybe<Scalars["String"]["output"]>
  applicationWarnings?: Maybe<Scalars["String"]["output"]>
  certificatePrintHistory?: Maybe<Scalars["String"]["output"]>
  certificates?: Maybe<Scalars["String"]["output"]>
  declarations?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  processes?: Maybe<Scalars["String"]["output"]>
  productWarnings?: Maybe<Scalars["String"]["output"]>
  products?: Maybe<Scalars["String"]["output"]>
  sourceProducts?: Maybe<Scalars["String"]["output"]>
  supportingDocuments?: Maybe<Scalars["String"]["output"]>
}

export type SfRequestExportCertificateReplacementInput = {
  reason_for_status_change?: InputMaybe<Scalars["String"]["input"]>
  requestor?: InputMaybe<Scalars["String"]["input"]>
  requestor_id: Scalars["String"]["input"]
}

export type SfRequestedToResubmitExportCertificateInput = {
  products_to_unverify?: InputMaybe<Array<SfUnverifyProductInput>>
  reason_for_status_change?: InputMaybe<Scalars["String"]["input"]>
  requestor?: InputMaybe<Scalars["String"]["input"]>
  requestor_id: Scalars["String"]["input"]
}

export type SfSearchApprovedTemplatesInput = {
  code?: InputMaybe<Scalars["String"]["input"]>
  commodity?: InputMaybe<Scalars["String"]["input"]>
  destinationCountry?: InputMaybe<Scalars["String"]["input"]>
  page?: InputMaybe<Scalars["Int"]["input"]>
  perPage?: InputMaybe<Scalars["Int"]["input"]>
}

export type SfSearchApprovedTemplatesResponse = {
  __typename?: "SfSearchApprovedTemplatesResponse"
  templates: Array<SfApprovedTemplateVersion>
  totalCount: Scalars["Int"]["output"]
}

export type SfSupportingDocumentMetadata = {
  __typename?: "SfSupportingDocumentMetadata"
  comment?: Maybe<Scalars["String"]["output"]>
  createdDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  documentNumber?: Maybe<Scalars["String"]["output"]>
  documentReferenceNumber?: Maybe<Scalars["String"]["output"]>
  documentType?: Maybe<Scalars["String"]["output"]>
  fileExtension?: Maybe<Scalars["String"]["output"]>
  fileName?: Maybe<Scalars["String"]["output"]>
  fileVersion?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  originCountry?: Maybe<Scalars["String"]["output"]>
  printWithPDF?: Maybe<Scalars["Boolean"]["output"]>
  productDescription?: Maybe<Scalars["String"]["output"]>
  productNumber?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<SupportingDocumentStatus>
}

export type SfUnverifyProductInput = {
  comments?: InputMaybe<Scalars["String"]["input"]>
  requestor_product_id: Scalars["String"]["input"]
}

export type SfUpdateProductExhaustionInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>
  exhaust: Scalars["Boolean"]["input"]
  productIds: Array<Scalars["ID"]["input"]>
  updatedBy: Scalars["String"]["input"]
}

export type SfUpdateProductExhaustionResponse = {
  __typename?: "SfUpdateProductExhaustionResponse"
  exhaust?: Maybe<Scalars["Boolean"]["output"]>
  products?: Maybe<Array<Maybe<ProductExhaustionResponse>>>
  transferId?: Maybe<Scalars["String"]["output"]>
}

export type SfUpdateStationerySerialNumbersInput = {
  id: Scalars["ID"]["input"]
  stationerySerialNumbers: Scalars["String"]["input"]
  updatedAt: Scalars["String"]["input"]
  updatedBy: Scalars["String"]["input"]
}

export type SfUpdateStationerySerialNumbersResponse = {
  __typename?: "SfUpdateStationerySerialNumbersResponse"
  success: Scalars["Boolean"]["output"]
  warnings?: Maybe<Scalars["String"]["output"]>
}

export type SfUpdateTransferAuditCommentInput = {
  auditComment: Scalars["String"]["input"]
  id: Scalars["ID"]["input"]
  sfUpdatedAt?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  sfUpdatedBy?: InputMaybe<Scalars["String"]["input"]>
}

export type SfUpdateTransferAuditCommentResponse = {
  __typename?: "SfUpdateTransferAuditCommentResponse"
  id?: Maybe<Scalars["ID"]["output"]>
  message?: Maybe<Scalars["String"]["output"]>
  success?: Maybe<Scalars["Boolean"]["output"]>
}

export type SfVerifyExportCertificateRequestProductsInput = {
  products: Array<SfVerifyProductInput>
  requestor?: InputMaybe<Scalars["String"]["input"]>
}

export type SfVerifyProductInput = {
  comments?: InputMaybe<Scalars["String"]["input"]>
  requestor_product_id: Scalars["String"]["input"]
  verified: Scalars["Boolean"]["input"]
}

export enum Signatory {
  None = "NONE",
  NonVet = "NON_VET",
  ThirdParty = "THIRD_PARTY",
  Vet = "VET",
}

export type SnapshotPresignedUrlResponse = {
  __typename?: "SnapshotPresignedUrlResponse"
  url: Scalars["String"]["output"]
}

export enum SortOrder {
  Code = "CODE",
  Text = "TEXT",
}

export type SourceProductTracking = {
  __typename?: "SourceProductTracking"
  description?: Maybe<Scalars["String"]["output"]>
  destinations: Array<DestinationProductTracking>
  id: Scalars["ID"]["output"]
  outgoingCount: Scalars["Int"]["output"]
  productNumber: Scalars["Int"]["output"]
  quantity?: Maybe<Scalars["String"]["output"]>
  totalPackages: Scalars["Int"]["output"]
}

export type SourceTransfer = {
  __typename?: "SourceTransfer"
  approvalDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  isPaperSource?: Maybe<Scalars["Boolean"]["output"]>
  lineItemNumber?: Maybe<Scalars["Int"]["output"]>
  requestNumber: Scalars["String"]["output"]
  sourceTransferId?: Maybe<Scalars["ID"]["output"]>
}

export type SourcedProduct = {
  __typename?: "SourcedProduct"
  details?: Maybe<SourcedProductDetails>
  id: Scalars["String"]["output"]
  isExhausted?: Maybe<Scalars["Boolean"]["output"]>
  isPaperSourced?: Maybe<Scalars["Boolean"]["output"]>
  sequenceNumber?: Maybe<Scalars["Int"]["output"]>
  transferRequestId?: Maybe<Scalars["String"]["output"]>
  transferRequestNumber?: Maybe<Scalars["String"]["output"]>
}

export type SourcedProductAttributes = {
  __typename?: "SourcedProductAttributes"
  NZHSCode?: Maybe<CoreLookup>
  expiryDateFrom?: Maybe<Scalars["AWSDate"]["output"]>
  expiryDateTo?: Maybe<Scalars["AWSDate"]["output"]>
  grossVolume?: Maybe<Measurment>
  grossWeight?: Maybe<Measurment>
  inspectionType?: Maybe<CoreLookup>
  intendedUse?: Maybe<Array<Maybe<CoreLookup>>>
  netVolume?: Maybe<Measurment>
  netWeight?: Maybe<Measurment>
  origin?: Maybe<CoreLookup>
  productionBatchIds?: Maybe<Array<Scalars["String"]["output"]>>
  scientificName?: Maybe<Array<Maybe<CoreLookup>>>
  speciesCommonName?: Maybe<Array<Maybe<CoreLookup>>>
  temperature?: Maybe<CoreLookup>
}

export type SourcedProductDetails = {
  __typename?: "SourcedProductDetails"
  attributes?: Maybe<SourcedProductAttributes>
  classification?: Maybe<Array<Maybe<CoreProductClassificationResponse>>>
  containers?: Maybe<Array<CoreExportContainer>>
  eligibilityCountries?: Maybe<Array<CoreLookup>>
  itemDescription?: Maybe<CoreLookup>
  packaging?: Maybe<Array<Maybe<CorePackaging>>>
  productReference?: Maybe<Scalars["String"]["output"]>
  productStatement?: Maybe<Scalars["String"]["output"]>
}

export type SpsAcknowledgementInput = {
  certificateNumber: Scalars["String"]["input"]
  reasonInformation?: InputMaybe<Scalars["String"]["input"]>
  source: Scalars["String"]["input"]
  status: CoreStatus
  systemUserName?: InputMaybe<Scalars["String"]["input"]>
}

export type SpsAcknowledgementOutput = {
  __typename?: "SpsAcknowledgementOutput"
  message: Scalars["String"]["output"]
  success: Scalars["Boolean"]["output"]
  updatedStatus?: Maybe<Scalars["String"]["output"]>
}

export type SpsAddressTemplate = {
  __typename?: "SpsAddressTemplate"
  address?: Maybe<Scalars["String"]["output"]>
  city?: Maybe<Scalars["String"]["output"]>
  city_id?: Maybe<Scalars["ID"]["output"]>
  country_id?: Maybe<Scalars["ID"]["output"]>
  country_name?: Maybe<Scalars["String"]["output"]>
  country_subdivision_id?: Maybe<Scalars["ID"]["output"]>
  country_subdivision_name?: Maybe<Scalars["String"]["output"]>
  postcode?: Maybe<Scalars["String"]["output"]>
  postcode_code?: Maybe<Scalars["String"]["output"]>
  street?: Maybe<Scalars["String"]["output"]>
  street_with_commas?: Maybe<Scalars["String"]["output"]>
  street_with_line_breaks?: Maybe<Scalars["String"]["output"]>
  type_code?: Maybe<Scalars["String"]["output"]>
  with_commas?: Maybe<Scalars["String"]["output"]>
  with_line_breaks?: Maybe<Scalars["String"]["output"]>
}

export type SpsAuthenticationTemplate = {
  __typename?: "SpsAuthenticationTemplate"
  actual?: Maybe<DateTimeTemplate>
  ic_label?: Maybe<Scalars["String"]["output"]>
  ic_value?: Maybe<Scalars["String"]["output"]>
  included_clauses?: Maybe<Array<SpsClauseTemplate>>
  issue_location?: Maybe<SpsLocationTemplate>
  location_provider_party?: Maybe<SpsPartyTemplate>
  provider_party?: Maybe<SpsPartyTemplate>
  type_code?: Maybe<NamedCodeTemplate>
}

export type SpsCertificateTemplate = {
  __typename?: "SpsCertificateTemplate"
  consignment: SpsConsignmentTemplate
  exchanged_document: SpsExchangedDocumentTemplate
}

export type SpsClassificationTemplate = {
  __typename?: "SpsClassificationTemplate"
  class_code?: Maybe<Scalars["String"]["output"]>
  class_name: Scalars["String"]["output"]
  system_id?: Maybe<Scalars["String"]["output"]>
  system_name: Scalars["String"]["output"]
}

export type SpsClauseTemplate = {
  __typename?: "SpsClauseTemplate"
  content?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
}

export type SpsConsignmentItemTemplate = {
  __typename?: "SpsConsignmentItemTemplate"
  gross_weight?: Maybe<Scalars["String"]["output"]>
  items: Array<SpsTradeLineItemTemplate>
  nature_identification_cargo?: Maybe<Array<Scalars["String"]["output"]>>
}

export type SpsConsignmentTemplate = {
  __typename?: "SpsConsignmentTemplate"
  authentication_parties?: Maybe<Array<SpsPartyTemplate>>
  availability_due_date_time?: Maybe<DateTimeTemplate>
  carrier?: Maybe<SpsPartyTemplate>
  consignee?: Maybe<SpsPartyTemplate>
  consignee_receipt_location?: Maybe<SpsLocationTemplate>
  consignor?: Maybe<SpsPartyTemplate>
  customs_transit_agent?: Maybe<SpsPartyTemplate>
  delivery?: Maybe<SpsPartyTemplate>
  despatch?: Maybe<SpsPartyTemplate>
  examination_event?: Maybe<SpsEventTemplate>
  export_country?: Maybe<SpsCountryTemplate>
  export_exit_date_time?: Maybe<DateTimeTemplate>
  gross_weight?: Maybe<MeasureTemplate>
  id?: Maybe<Scalars["ID"]["output"]>
  import_country?: Maybe<SpsCountryTemplate>
  items: Array<SpsConsignmentItemTemplate>
  loading_base_port_location?: Maybe<SpsLocationTemplate>
  main_carriage_transport_movements?: Maybe<Array<SpsTransportMovementTemplate>>
  party_table?: Maybe<Array<CombinedPartyTemplate>>
  processor_parties?: Maybe<Array<SpsPartyTemplate>>
  reexport_country?: Maybe<SpsCountryTemplate>
  storage_events?: Maybe<Array<SpsEventTemplate>>
  transit_countries?: Maybe<Array<SpsCountryTemplate>>
  transit_locations?: Maybe<Array<SpsLocationTemplate>>
  unique_production_batch_ids?: Maybe<IDsTemplate>
  unique_seal_number_ids: Scalars["String"]["output"]
  unique_transport_equipment_ids?: Maybe<IDsTemplate>
  unloading_base_port_location?: Maybe<SpsLocationTemplate>
  utilized_transport_equipment?: Maybe<Array<SpsTransportEquipmentTemplate>>
  verifiers?: Maybe<Array<SpsAuthenticationTemplate>>
  wine?: Maybe<WineConsignmentTemplate>
}

export type SpsContactTemplate = {
  __typename?: "SpsContactTemplate"
  person_name?: Maybe<Scalars["String"]["output"]>
}

export type SpsCountrySubDivisionTemplate = {
  __typename?: "SpsCountrySubDivisionTemplate"
  id?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

export type SpsCountryTemplate = {
  __typename?: "SpsCountryTemplate"
  id: Scalars["ID"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  subdivision?: Maybe<SpsCountrySubDivisionTemplate>
}

export type SpsEventTemplate = {
  __typename?: "SpsEventTemplate"
  occurrence_location?: Maybe<SpsLocationTemplate>
}

export type SpsExchangedDocumentTemplate = {
  __typename?: "SpsExchangedDocumentTemplate"
  additional_declarations?: Maybe<Scalars["String"]["output"]>
  additional_information?: Maybe<Scalars["String"]["output"]>
  additional_official_information?: Maybe<Scalars["String"]["output"]>
  certifier?: Maybe<SpsAuthenticationTemplate>
  customs_permit_number?: Maybe<Scalars["String"]["output"]>
  date_of_inspection?: Maybe<DateTimeTemplate>
  description?: Maybe<Scalars["String"]["output"]>
  distinguishing_marks?: Maybe<Scalars["String"]["output"]>
  financial_liability?: Maybe<Scalars["String"]["output"]>
  id: Scalars["ID"]["output"]
  import_permit?: Maybe<Scalars["String"]["output"]>
  issue_date_time?: Maybe<DateTimeTemplate>
  issuer?: Maybe<SpsPartyTemplate>
  name?: Maybe<Scalars["String"]["output"]>
  replacement_certificate?: Maybe<SpsReplacementCertificateTemplate>
  signatories?: Maybe<Array<Maybe<SpsAuthenticationTemplate>>>
  status_code?: Maybe<Scalars["String"]["output"]>
  status_name?: Maybe<Scalars["String"]["output"]>
  type_code?: Maybe<Scalars["String"]["output"]>
  type_name?: Maybe<Scalars["String"]["output"]>
}

export type SpsLocationTemplate = {
  __typename?: "SpsLocationTemplate"
  country?: Maybe<Scalars["String"]["output"]>
  country_id?: Maybe<Scalars["ID"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

export type SpsNoteTemplate = {
  __typename?: "SpsNoteTemplate"
  content?: Maybe<Scalars["String"]["output"]>
  content_code?: Maybe<Scalars["String"]["output"]>
  subject?: Maybe<Scalars["String"]["output"]>
  subject_code?: Maybe<Scalars["String"]["output"]>
}

export type SpsPackageTemplate = {
  __typename?: "SpsPackageTemplate"
  level_code?: Maybe<Scalars["String"]["output"]>
  nominal_gross_volume?: Maybe<MeasureTemplate>
  nominal_gross_weight?: Maybe<MeasureTemplate>
  physical_shipping_marks?: Maybe<Array<Scalars["String"]["output"]>>
  quantity?: Maybe<DecimalTemplate>
  type_code?: Maybe<NamedCodeTemplate>
}

export type SpsPartyTemplate = {
  __typename?: "SpsPartyTemplate"
  defined_contacts?: Maybe<Array<SpsContactTemplate>>
  id?: Maybe<Scalars["ID"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  role_code?: Maybe<Scalars["String"]["output"]>
  specified_address?: Maybe<SpsAddressTemplate>
  specified_person?: Maybe<SpsPersonTemplate>
  type_code?: Maybe<Scalars["String"]["output"]>
}

export type SpsPeriodTemplate = {
  __typename?: "SpsPeriodTemplate"
  duration?: Maybe<MeasureTemplate>
  end?: Maybe<DateTimeTemplate>
  start?: Maybe<DateTimeTemplate>
}

export type SpsPersonTemplate = {
  __typename?: "SpsPersonTemplate"
  attained_qualifications?: Maybe<Array<SpsQualificationTemplate>>
  name?: Maybe<Scalars["String"]["output"]>
  signature?: Maybe<Scalars["String"]["output"]>
}

export type SpsProcessCharacteristicTemplate = {
  __typename?: "SpsProcessCharacteristicTemplate"
  description?: Maybe<Scalars["String"]["output"]>
  maximum?: Maybe<MeasureTemplate>
  minimum?: Maybe<MeasureTemplate>
  type_code?: Maybe<NamedCodeTemplate>
  value?: Maybe<MeasureTemplate>
}

export type SpsProcessTemplate = {
  __typename?: "SpsProcessTemplate"
  applicable_process_characteristics?: Maybe<
    Array<SpsProcessCharacteristicTemplate>
  >
  completion_period?: Maybe<SpsPeriodTemplate>
  operation_country?: Maybe<SpsCountryTemplate>
  operator_party?: Maybe<SpsPartyTemplate>
  type_code?: Maybe<NamedCodeTemplate>
}

export type SpsQualificationTemplate = {
  __typename?: "SpsQualificationTemplate"
  abbreviated_name?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

export type SpsReplacementCertificateTemplate = {
  __typename?: "SpsReplacementCertificateTemplate"
  additional_declaration?: Maybe<Scalars["String"]["output"]>
  replaced_certificate_issue_date?: Maybe<DateTimeTemplate>
  replaced_certificate_number?: Maybe<Scalars["String"]["output"]>
  replacement_reason?: Maybe<Scalars["String"]["output"]>
}

export type SpsSealTemplate = {
  __typename?: "SpsSealTemplate"
  id: Scalars["String"]["output"]
  issuing_party?: Maybe<SpsPartyTemplate>
  maximum_id?: Maybe<Scalars["String"]["output"]>
}

export type SpsTemperatureTemplate = {
  __typename?: "SpsTemperatureTemplate"
  maximum?: Maybe<MeasureTemplate>
  minimum?: Maybe<MeasureTemplate>
  type_code?: Maybe<Scalars["String"]["output"]>
  value?: Maybe<MeasureTemplate>
}

export type SpsTradeLineItemTemplate = {
  __typename?: "SpsTradeLineItemTemplate"
  additional_information?: Maybe<Array<SpsNoteTemplate>>
  applied_processes?: Maybe<Array<SpsProcessTemplate>>
  asserted_authentications?: Maybe<Array<SpsAuthenticationTemplate>>
  associated_transport_equipment?: Maybe<Array<SpsTransportEquipmentTemplate>>
  brand_name?: Maybe<Scalars["String"]["output"]>
  classifications?: Maybe<Array<SpsClassificationTemplate>>
  cn_code?: Maybe<Scalars["String"]["output"]>
  commodity?: Maybe<Scalars["String"]["output"]>
  common_name?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  expiry_date_time?: Maybe<DateTimeTemplate>
  gross_volume?: Maybe<MeasureTemplate>
  gross_weight?: Maybe<MeasureTemplate>
  hs_code?: Maybe<Scalars["String"]["output"]>
  import_certificate_extract?: Maybe<ImportCertificateExtractTemplate>
  import_certificate_measurement?: Maybe<ImportCertificateMeasurementTemplate>
  import_permit_number?: Maybe<Scalars["String"]["output"]>
  intended_use?: Maybe<Scalars["String"]["output"]>
  net_volume?: Maybe<MeasureTemplate>
  net_weight?: Maybe<MeasureTemplate>
  origin_country?: Maybe<SpsCountryTemplate>
  origin_locations?: Maybe<Array<SpsLocationTemplate>>
  packaging?: Maybe<ImportCertificatePackagingTemplate>
  physical_packages?: Maybe<Array<SpsPackageTemplate>>
  production_batch_id?: Maybe<Scalars["String"]["output"]>
  scientific_name?: Maybe<Scalars["String"]["output"]>
  sequence?: Maybe<Scalars["String"]["output"]>
  treatments?: Maybe<TreatmentTemplate>
  wine?: Maybe<WineFieldsTemplate>
}

export type SpsTransportEquipmentTemplate = {
  __typename?: "SpsTransportEquipmentTemplate"
  affixed_seals?: Maybe<Array<SpsSealTemplate>>
  id: Scalars["String"]["output"]
  temperature_settings?: Maybe<Array<SpsTemperatureTemplate>>
}

export type StandardPdfPreviewResponse = {
  __typename?: "StandardPdfPreviewResponse"
  error?: Maybe<Scalars["String"]["output"]>
  presignedUrl?: Maybe<Scalars["String"]["output"]>
  status: StandardPdfPreviewStatus
}

export enum StandardPdfPreviewStatus {
  Failed = "FAILED",
  NotFound = "NOT_FOUND",
  Ready = "READY",
}

export enum StatusReportType {
  ExportResubmission = "EXPORT_RESUBMISSION",
  TransferAmendment = "TRANSFER_AMENDMENT",
  TransferResubmission = "TRANSFER_RESUBMISSION",
}

export enum SubmissionLayoutType {
  ApExport = "AP_EXPORT",
  ApTransfer = "AP_TRANSFER",
  Custom = "CUSTOM",
  PhytoExport = "PHYTO_EXPORT",
}

export type SubmissionSettings = {
  __typename?: "SubmissionSettings"
  caption?: Maybe<Scalars["String"]["output"]>
  customLookup?: Maybe<CustomLookupType>
  displayType?: Maybe<DisplayType>
  displayTypeSettings?: Maybe<DisplayTypeSettings>
  mandatory?: Maybe<Scalars["Boolean"]["output"]>
  order?: Maybe<Scalars["Int"]["output"]>
}

export type SubmissionSettingsInput = {
  caption?: InputMaybe<Scalars["String"]["input"]>
  customLookup?: InputMaybe<CustomLookupType>
  displayType?: InputMaybe<DisplayType>
  displayTypeSettings?: InputMaybe<DisplayTypeSettingsInput>
  mandatory?: InputMaybe<Scalars["Boolean"]["input"]>
  order?: InputMaybe<Scalars["Int"]["input"]>
}

export type Subscription = {
  __typename?: "Subscription"
  onXmlFileProcessed: PrepareXmlFileForB2GResponse
}

export type SubscriptionOnXmlFileProcessedArgs = {
  xmlInputId: Scalars["String"]["input"]
}

export type SupportingDocumentActionsResponse = {
  __typename?: "SupportingDocumentActionsResponse"
  allowedActions: Array<Scalars["String"]["output"]>
  role: Scalars["String"]["output"]
}

export type SupportingDocumentHistoryEntry = {
  __typename?: "SupportingDocumentHistoryEntry"
  action?: Maybe<Scalars["String"]["output"]>
  comment?: Maybe<Scalars["String"]["output"]>
  dateTime?: Maybe<Scalars["AWSDateTime"]["output"]>
  id: Scalars["ID"]["output"]
  status?: Maybe<Scalars["String"]["output"]>
  supportingDocumentId: Scalars["ID"]["output"]
  updatedByFullName?: Maybe<Scalars["String"]["output"]>
  updatedByProfile?: Maybe<Scalars["String"]["output"]>
  updatedByProfileFullName?: Maybe<Scalars["String"]["output"]>
  userName?: Maybe<Scalars["String"]["output"]>
}

export type SupportingDocumentInput = {
  file_id: Scalars["String"]["input"]
}

export type SupportingDocumentKeys = {
  __typename?: "SupportingDocumentKeys"
  registration?: Maybe<Scalars["String"]["output"]>
  registrationAll?: Maybe<Scalars["String"]["output"]>
  supportingDocuments?: Maybe<Scalars["String"]["output"]>
}

export type SupportingDocumentPresignedUrlResponse = {
  __typename?: "SupportingDocumentPresignedUrlResponse"
  expiresIn: Scalars["Int"]["output"]
  presignedUrl: Scalars["String"]["output"]
}

export enum SupportingDocumentStatus {
  Active = "ACTIVE",
  Cancelled = "CANCELLED",
  Replaced = "REPLACED",
}

export type SupportingDocumentUsageInput = {
  supportingDocumentId: Scalars["ID"]["input"]
}

export type SupportingDocumentUsageRecord = {
  __typename?: "SupportingDocumentUsageRecord"
  certificateNumber: Scalars["String"]["output"]
  consigneeRegistration?: Maybe<Scalars["String"]["output"]>
  consignorRegistration?: Maybe<Scalars["String"]["output"]>
  departureDate?: Maybe<Scalars["AWSDateTime"]["output"]>
  id: Scalars["ID"]["output"]
  requestId: Scalars["ID"]["output"]
  requestType: CoreRequestType
  status?: Maybe<Scalars["String"]["output"]>
  submittedAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  unofficialInfo?: Maybe<Scalars["String"]["output"]>
}

export enum SuspensionReason {
  AccessNoLongerRequired = "ACCESS_NO_LONGER_REQUIRED",
  BreachOfUserAgreement = "BREACH_OF_USER_AGREEMENT",
  NonPayment = "NON_PAYMENT",
  PersonSuspended = "PERSON_SUSPENDED",
}

export type Template = {
  __typename?: "Template"
  approvedVersion?: Maybe<TemplateVersion>
  id: Scalars["ID"]["output"]
  importantVersions?: Maybe<Array<Maybe<TemplateVersion>>>
  lastVersion: TemplateVersion
  versions?: Maybe<Array<Maybe<TemplateVersion>>>
}

export type TemplateAuditEvent = {
  __typename?: "TemplateAuditEvent"
  changeCategory: TemplateChangeCategory
  comment?: Maybe<Scalars["String"]["output"]>
  createdAt: Scalars["AWSDateTime"]["output"]
  createdBy: Scalars["String"]["output"]
  detail: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  majorVersion: Scalars["Int"]["output"]
  minorVersion: Scalars["Int"]["output"]
  status: TemplateVersionStatus
  templateCode: Scalars["String"]["output"]
  templateId: Scalars["ID"]["output"]
  templateVersionId: Scalars["ID"]["output"]
}

export enum TemplateChangeCategory {
  CopiedFrom = "CopiedFrom",
  CopiedTo = "CopiedTo",
  Created = "Created",
  GeneralOnly = "GeneralOnly",
  ScheduleAndGeneral = "ScheduleAndGeneral",
  ScheduleAndStatus = "ScheduleAndStatus",
  ScheduleOnly = "ScheduleOnly",
  ScheduleStatusAndGeneral = "ScheduleStatusAndGeneral",
  StatusAndGeneral = "StatusAndGeneral",
  StatusOnly = "StatusOnly",
  TabSpecific = "TabSpecific",
}

export type TemplateDeclarationGroup = {
  __typename?: "TemplateDeclarationGroup"
  id: Scalars["ID"]["output"]
  indent: Scalars["Int"]["output"]
  numbering: DeclarationGroupNumbering
  sequenceNumber: Scalars["Int"]["output"]
  startAt: Scalars["Int"]["output"]
  statements?: Maybe<Array<DeclarationStatement>>
  type: DeclarationGroupType
}

export type TemplateDeclarationsAcknowledgement = {
  __typename?: "TemplateDeclarationsAcknowledgement"
  delete?: Maybe<TemplateDeclarationsDeleteAcknowledgement>
  group?: Maybe<Array<TemplateDeclarationsGroupAcknowledgement>>
  statement?: Maybe<Array<TemplateDeclarationsStatementAcknowledgement>>
  traces?: Maybe<Array<TemplateDeclarationsTraceAcknowledgement>>
}

export type TemplateDeclarationsDeleteAcknowledgement = {
  __typename?: "TemplateDeclarationsDeleteAcknowledgement"
  groupId?: Maybe<Array<Scalars["ID"]["output"]>>
  statementId?: Maybe<Array<Scalars["ID"]["output"]>>
  tracesId?: Maybe<Array<Scalars["ID"]["output"]>>
}

export type TemplateDeclarationsDeleteInput = {
  groupId?: InputMaybe<Array<Scalars["ID"]["input"]>>
  statementId?: InputMaybe<Array<Scalars["ID"]["input"]>>
  tracesId?: InputMaybe<Array<Scalars["ID"]["input"]>>
}

export type TemplateDeclarationsGroupAcknowledgement = {
  __typename?: "TemplateDeclarationsGroupAcknowledgement"
  groupId: Scalars["ID"]["output"]
}

export type TemplateDeclarationsGroupInput = {
  groupSequenceNumber?: InputMaybe<Scalars["Int"]["input"]>
  groupType?: InputMaybe<DeclarationGroupType>
  id?: InputMaybe<Scalars["ID"]["input"]>
  indent?: InputMaybe<Scalars["Int"]["input"]>
  numbering?: InputMaybe<DeclarationGroupNumbering>
  startAt?: InputMaybe<Scalars["Int"]["input"]>
  statement?: InputMaybe<Array<TemplateDeclarationsStatementInput>>
}

export type TemplateDeclarationsInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>
  delete?: InputMaybe<TemplateDeclarationsDeleteInput>
  group?: InputMaybe<Array<TemplateDeclarationsGroupInput>>
  templateVersionId: Scalars["ID"]["input"]
}

export type TemplateDeclarationsStatementAcknowledgement = {
  __typename?: "TemplateDeclarationsStatementAcknowledgement"
  groupId: Scalars["ID"]["output"]
  statementId: Scalars["ID"]["output"]
}

export type TemplateDeclarationsStatementInput = {
  customNumber?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
  statementCode?: InputMaybe<Scalars["Int"]["input"]>
  statementSequenceNumber?: InputMaybe<Scalars["Int"]["input"]>
  statementText?: InputMaybe<Scalars["String"]["input"]>
  statementTextTranslations?: InputMaybe<Scalars["AWSJSON"]["input"]>
  traces?: InputMaybe<Array<TemplateDeclarationsTracesInput>>
}

export type TemplateDeclarationsTraceAcknowledgement = {
  __typename?: "TemplateDeclarationsTraceAcknowledgement"
  statementId: Scalars["ID"]["output"]
  traceId: Scalars["ID"]["output"]
}

export type TemplateDeclarationsTracesInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>
  tracesContent?: InputMaybe<Scalars["String"]["input"]>
  tracesId?: InputMaybe<Scalars["String"]["input"]>
}

export type TemplateDocumentUrl = {
  __typename?: "TemplateDocumentUrl"
  documentName: Scalars["String"]["output"]
  url: Scalars["String"]["output"]
}

export type TemplateDocumentUrlV2 = {
  __typename?: "TemplateDocumentUrlV2"
  documentName: Scalars["String"]["output"]
  templateVersionId: Scalars["ID"]["output"]
  uploadedAt: Scalars["String"]["output"]
  uploadedBy: Scalars["String"]["output"]
  url: Scalars["String"]["output"]
}

export type TemplateFieldConfiguration = {
  __typename?: "TemplateFieldConfiguration"
  fieldCategory?: Maybe<Scalars["String"]["output"]>
  fuid: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  pdfSettings?: Maybe<PdfSettings>
  sectionName?: Maybe<Scalars["String"]["output"]>
  submissionSettings?: Maybe<SubmissionSettings>
  viewInPdf?: Maybe<Scalars["Boolean"]["output"]>
  viewInSubmission?: Maybe<Scalars["Boolean"]["output"]>
  viewInXML?: Maybe<Scalars["Boolean"]["output"]>
  xmlSettings?: Maybe<XmlSettings>
}

export type TemplateFieldConfigurationAcknowledgement = {
  __typename?: "TemplateFieldConfigurationAcknowledgement"
  delete?: Maybe<Array<Scalars["ID"]["output"]>>
  upsert?: Maybe<Array<Scalars["ID"]["output"]>>
}

export type TemplateFieldConfigurationInput = {
  fuid: Scalars["String"]["input"]
  id?: InputMaybe<Scalars["ID"]["input"]>
  pdfSettings?: InputMaybe<PdfSettingsInput>
  submissionLayoutType: SubmissionLayoutType
  submissionSettings?: InputMaybe<SubmissionSettingsInput>
  viewInPdf?: InputMaybe<Scalars["Boolean"]["input"]>
  viewInSubmission?: InputMaybe<Scalars["Boolean"]["input"]>
  viewInXML?: InputMaybe<Scalars["Boolean"]["input"]>
  xmlSettings?: InputMaybe<XmlSettingsInput>
}

export type TemplateFieldConfigurationV2 = {
  __typename?: "TemplateFieldConfigurationV2"
  classificationCode?: Maybe<Scalars["String"]["output"]>
  fieldCategory?: Maybe<Scalars["String"]["output"]>
  fieldName: Scalars["String"]["output"]
  fuid: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  pdfSettings?: Maybe<PdfSettings>
  sectionName: Scalars["String"]["output"]
  sequenceNumber?: Maybe<Scalars["Int"]["output"]>
  subCategory?: Maybe<Scalars["String"]["output"]>
  submissionSettings?: Maybe<SubmissionSettings>
  viewInPdf?: Maybe<Scalars["Boolean"]["output"]>
  viewInSubmission?: Maybe<Scalars["Boolean"]["output"]>
  viewInXML?: Maybe<Scalars["Boolean"]["output"]>
  xmlSettings?: Maybe<XmlSettings>
}

export type TemplateFieldReferenceData = {
  __typename?: "TemplateFieldReferenceData"
  captionList?: Maybe<Array<Maybe<ReferenceCaption>>>
  defaultDisplayType?: Maybe<Scalars["String"]["output"]>
  fieldCategory?: Maybe<Scalars["String"]["output"]>
  referenceDataList?: Maybe<Array<Maybe<ReferenceDataList>>>
  sectionName?: Maybe<Scalars["String"]["output"]>
}

export type TemplateFilter = {
  q?: InputMaybe<Scalars["String"]["input"]>
}

export type TemplateGeneralSettingsV2 = {
  __typename?: "TemplateGeneralSettingsV2"
  agencies?: Maybe<Array<Maybe<Agency>>>
  allowForeignPremises?: Maybe<Scalars["Boolean"]["output"]>
  allowPackageLevels?: Maybe<Scalars["Boolean"]["output"]>
  assignedTo?: Maybe<Scalars["String"]["output"]>
  businessArea?: Maybe<BusinessArea>
  code: Scalars["String"]["output"]
  commodities?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  commodity: Scalars["String"]["output"]
  createdAt: Scalars["AWSDateTime"]["output"]
  description?: Maybe<Scalars["String"]["output"]>
  destinationCountries?: Maybe<Array<Scalars["String"]["output"]>>
  destinationCountryNames?: Maybe<Array<Scalars["String"]["output"]>>
  displayedDescription?: Maybe<Scalars["String"]["output"]>
  documentId?: Maybe<Scalars["String"]["output"]>
  effective?: Maybe<Scalars["AWSDateTime"]["output"]>
  expire?: Maybe<Scalars["AWSDateTime"]["output"]>
  exportCertificateType?: Maybe<CertificateType>
  exportingCountry?: Maybe<Scalars["String"]["output"]>
  exportingCountryName?: Maybe<Scalars["String"]["output"]>
  importCertificateType?: Maybe<ImportCertificateType>
  industryAccess?: Maybe<Scalars["Boolean"]["output"]>
  majorVersion?: Maybe<Scalars["Int"]["output"]>
  minorVersion?: Maybe<Scalars["Int"]["output"]>
  ocaAccess?: Maybe<Scalars["Boolean"]["output"]>
  officialVersion?: Maybe<Scalars["Int"]["output"]>
  outputSubtitle?: Maybe<Scalars["String"]["output"]>
  outputSubtitleTranslation?: Maybe<Array<Maybe<Translation>>>
  outputTitle?: Maybe<Scalars["String"]["output"]>
  outputTitleTranslation?: Maybe<Array<Maybe<Translation>>>
  reasonForUpdate?: Maybe<Scalars["String"]["output"]>
  release?: Maybe<Scalars["AWSDateTime"]["output"]>
  signatory?: Maybe<Scalars["String"]["output"]>
  status: TemplateVersionStatus
  submissionLayout: SubmissionLayoutType
  templateId: Scalars["ID"]["output"]
  templateType?: Maybe<TemplateType>
  title: Scalars["String"]["output"]
  transferCertificateType?: Maybe<TransferCertificateType>
  updatedAt: Scalars["AWSDateTime"]["output"]
  updatedBy: Scalars["String"]["output"]
}

export type TemplateHistory = {
  __typename?: "TemplateHistory"
  fieldName: Scalars["String"]["output"]
  from: Scalars["String"]["output"]
  to: Scalars["String"]["output"]
  updatedAt: Scalars["AWSDateTime"]["output"]
  updatedBy: Scalars["String"]["output"]
  version: Scalars["String"]["output"]
}

export type TemplateOptionalFilter = {
  commodity?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  destinationMarket?: InputMaybe<Array<InputMaybe<DestinationMarket>>>
  effectiveDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  effectiveDateEnd?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  effectiveDateStart?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  expiryDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  expiryDateEnd?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  expiryDateStart?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  lastEditedDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  lastEditedDateEnd?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  lastEditedDateStart?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  status?: InputMaybe<Array<InputMaybe<TemplateVersionStatus>>>
}

export type TemplateOutputV2 = {
  __typename?: "TemplateOutputV2"
  competentAuthority?: Maybe<CompetentAuthorityType>
  competentAuthorityOther?: Maybe<Scalars["String"]["output"]>
  declarationHeading?: Maybe<DeclarationHeadingType>
  declarationHeadingOther?: Maybe<Scalars["String"]["output"]>
  destinationSystem?: Maybe<DestinationSystem>
  forceNzCountryOrigin: Scalars["Boolean"]["output"]
  languages: Array<Scalars["String"]["output"]>
  pdfAddendum: PdfAddendum
  pdfLayout: PdfLayout
  processGroups?: Maybe<Array<Maybe<TemplateProcessGroups>>>
  producePdf: Scalars["Boolean"]["output"]
  sendToTraces: Scalars["Boolean"]["output"]
  templateSupportingDocuments?: Maybe<Array<TemplateSupportingDocument>>
  useAllLanguages: Scalars["Boolean"]["output"]
  usePortOfCountryLanguages: Scalars["Boolean"]["output"]
  usePortOfDischargeLanguages: Scalars["Boolean"]["output"]
  usePortOfInspectionLanguages: Scalars["Boolean"]["output"]
  useTheseLanguages: Scalars["Boolean"]["output"]
  xmlLayout: XmlLayout
}

export type TemplateProcessGroupReferenceData = {
  __typename?: "TemplateProcessGroupReferenceData"
  captions?: Maybe<Array<Maybe<ReferenceProcessGroupCaption>>>
  groupId: Scalars["Int"]["output"]
  groupName: Scalars["String"]["output"]
  groupType: Scalars["String"]["output"]
}

export type TemplateProcessGroups = {
  __typename?: "TemplateProcessGroups"
  dateFormat?: Maybe<Scalars["String"]["output"]>
  dateRange?: Maybe<Scalars["String"]["output"]>
  defaultAction?: Maybe<Scalars["String"]["output"]>
  id: Scalars["ID"]["output"]
  includeOverseasProcesses?: Maybe<Scalars["Boolean"]["output"]>
  isPDF?: Maybe<Scalars["Boolean"]["output"]>
  isXML?: Maybe<Scalars["Boolean"]["output"]>
  operatorActivityType?: Maybe<Scalars["String"]["output"]>
  operatorActivityTypeLabel?: Maybe<Scalars["String"]["output"]>
  pdfSettings?: Maybe<ProcessGroupCaptionSettings>
  premisesAddressFormat?: Maybe<Scalars["String"]["output"]>
  premisesRange?: Maybe<Scalars["String"]["output"]>
  processGroupId?: Maybe<Scalars["Int"]["output"]>
  processGroupName: Scalars["String"]["output"]
  processGroupType: Scalars["String"]["output"]
  processes?: Maybe<Array<Maybe<ProcessInfo>>>
  sortOrder: Scalars["Int"]["output"]
  width?: Maybe<Scalars["String"]["output"]>
  xmlSettings?: Maybe<ProcessGroupCaptionSettings>
}

export type TemplateProcessGroupsConfigAcknowledgement = {
  __typename?: "TemplateProcessGroupsConfigAcknowledgement"
  delete?: Maybe<Array<Scalars["ID"]["output"]>>
  upsert?: Maybe<Array<Scalars["ID"]["output"]>>
}

export type TemplateSection = {
  __typename?: "TemplateSection"
  fields: Array<TemplateSectionField>
  name: Scalars["String"]["output"]
}

export type TemplateSectionField = {
  __typename?: "TemplateSectionField"
  field: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
}

export enum TemplateSectionType {
  Declarations = "DECLARATIONS",
  Fields = "FIELDS",
  ProcessGroups = "PROCESS_GROUPS",
  SupportingDocuments = "SUPPORTING_DOCUMENTS",
}

export type TemplateSupportingDocument = {
  __typename?: "TemplateSupportingDocument"
  documentType: TemplateSupportingDocumentType
  id: Scalars["ID"]["output"]
  includeInXml: Scalars["Boolean"]["output"]
  printWithPdf: Scalars["Boolean"]["output"]
  templateVersionId: Scalars["ID"]["output"]
}

export type TemplateSupportingDocumentAcknowledgement = {
  __typename?: "TemplateSupportingDocumentAcknowledgement"
  id: Scalars["ID"]["output"]
  templateVersionId: Scalars["ID"]["output"]
}

export type TemplateSupportingDocumentInput = {
  documentType: TemplateSupportingDocumentType
  id?: InputMaybe<Scalars["ID"]["input"]>
  includeInXml: Scalars["Boolean"]["input"]
  printWithPdf: Scalars["Boolean"]["input"]
  templateVersionId: Scalars["ID"]["input"]
}

export enum TemplateSupportingDocumentType {
  Adh = "ADH",
  Adm = "ADM",
  Doc = "DOC",
  Fic = "FIC",
  Insp = "INSP",
  Ip = "IP",
  Oma = "OMA",
  Opc = "OPC",
  Org = "ORG",
  Other = "OTHER",
  Pac = "PAC",
  Slab = "SLAB",
  Trt = "TRT",
}

export enum TemplateType {
  Export = "EXPORT",
  Import = "IMPORT",
  Transfer = "TRANSFER",
}

export type TemplateUploadUrl = {
  __typename?: "TemplateUploadUrl"
  lastVersion: TemplateVersion
  url: Scalars["String"]["output"]
}

export type TemplateUploadUrlV2 = {
  __typename?: "TemplateUploadUrlV2"
  lastTemplateVersionId: Scalars["ID"]["output"]
  s3Url: AwsS3PostUploadUrl
  templateVersionId: Scalars["ID"]["output"]
  version: Scalars["String"]["output"]
}

export type TemplateV2 = {
  __typename?: "TemplateV2"
  approvedVersion?: Maybe<TemplateVersion>
  id: Scalars["ID"]["output"]
  lastVersion: TemplateVersion
  versionsV2?: Maybe<Array<Maybe<TemplateVersion>>>
}

export type TemplateVersion = {
  __typename?: "TemplateVersion"
  agencies?: Maybe<Array<Maybe<Agency>>>
  allowForeignPremises?: Maybe<Scalars["Boolean"]["output"]>
  allowPackageLevels?: Maybe<Scalars["Boolean"]["output"]>
  assignedTo?: Maybe<Scalars["String"]["output"]>
  businessArea?: Maybe<BusinessArea>
  certificateType?: Maybe<Scalars["String"]["output"]>
  code: Scalars["String"]["output"]
  commodities?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  commodity?: Maybe<Scalars["String"]["output"]>
  createdAt: Scalars["AWSDateTime"]["output"]
  description?: Maybe<Scalars["String"]["output"]>
  destinationCountries?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  destinationMarket: DestinationMarket
  displayedDescription?: Maybe<Scalars["String"]["output"]>
  documentId?: Maybe<Scalars["String"]["output"]>
  documentRevision?: Maybe<TemplateVersion>
  editable?: Maybe<Scalars["Boolean"]["output"]>
  effective?: Maybe<Scalars["AWSDateTime"]["output"]>
  expire?: Maybe<Scalars["AWSDateTime"]["output"]>
  exportCertificateType?: Maybe<CertificateType>
  exportingCountry?: Maybe<Scalars["String"]["output"]>
  fields?: Maybe<Array<Maybe<Field>>>
  history?: Maybe<Array<TemplateHistory>>
  id: Scalars["ID"]["output"]
  importCertificateType?: Maybe<ImportCertificateType>
  industryAccess?: Maybe<Scalars["Boolean"]["output"]>
  isEditable?: Maybe<Scalars["Boolean"]["output"]>
  majorVersion: Scalars["Int"]["output"]
  minorVersion: Scalars["Int"]["output"]
  newFileUpload: Scalars["Boolean"]["output"]
  ocaAccess?: Maybe<Scalars["Boolean"]["output"]>
  officialVersion?: Maybe<Scalars["Int"]["output"]>
  outputSubtitle?: Maybe<Scalars["String"]["output"]>
  outputSubtitleTranslation?: Maybe<Array<Maybe<Translation>>>
  outputTitle?: Maybe<Scalars["String"]["output"]>
  outputTitleTranslation?: Maybe<Array<Maybe<Translation>>>
  pdfLayout?: Maybe<Scalars["String"]["output"]>
  reasonForUpdate?: Maybe<Scalars["String"]["output"]>
  release?: Maybe<Scalars["AWSDateTime"]["output"]>
  s3key?: Maybe<Scalars["String"]["output"]>
  s3uri?: Maybe<Scalars["String"]["output"]>
  signatory?: Maybe<Scalars["String"]["output"]>
  status: TemplateVersionStatus
  submissionLayout?: Maybe<SubmissionLayoutType>
  templateId: Scalars["String"]["output"]
  templateType?: Maybe<TemplateType>
  title: Scalars["String"]["output"]
  transferCertificateType?: Maybe<TransferCertificateType>
  updatedAt: Scalars["AWSDateTime"]["output"]
  updatedBy: Scalars["String"]["output"]
  uploadInProgress: Scalars["Boolean"]["output"]
}

export type TemplateVersionId = {
  __typename?: "TemplateVersionId"
  certificateType?: Maybe<Scalars["String"]["output"]>
  commodity?: Maybe<Scalars["String"]["output"]>
  effectiveDate?: Maybe<Scalars["String"]["output"]>
  expiryDate?: Maybe<Scalars["String"]["output"]>
  id: Scalars["ID"]["output"]
  majorVersion?: Maybe<Scalars["Int"]["output"]>
  submissionLayout?: Maybe<SubmissionLayoutType>
  templateId?: Maybe<Scalars["ID"]["output"]>
}

export type TemplateVersionOutput = {
  __typename?: "TemplateVersionOutput"
  id: Scalars["ID"]["output"]
}

export type TemplateVersionOutputInput = {
  competentAuthority?: InputMaybe<CompetentAuthorityType>
  competentAuthorityOther?: InputMaybe<Scalars["String"]["input"]>
  declarationHeading?: InputMaybe<DeclarationHeadingType>
  declarationHeadingOther?: InputMaybe<Scalars["String"]["input"]>
  destinationSystem?: InputMaybe<DestinationSystem>
  forceNzCountryOrigin?: InputMaybe<Scalars["Boolean"]["input"]>
  id: Scalars["ID"]["input"]
  languages: Array<Scalars["String"]["input"]>
  pdfAddendum: PdfAddendum
  pdfLayout: PdfLayout
  producePdf: Scalars["Boolean"]["input"]
  sendToTraces?: InputMaybe<Scalars["Boolean"]["input"]>
  useAllLanguages?: InputMaybe<Scalars["Boolean"]["input"]>
  usePortOfCountryLanguages?: InputMaybe<Scalars["Boolean"]["input"]>
  usePortOfDischargeLanguages?: InputMaybe<Scalars["Boolean"]["input"]>
  usePortOfInspectionLanguages?: InputMaybe<Scalars["Boolean"]["input"]>
  useTheseLanguages?: InputMaybe<Scalars["Boolean"]["input"]>
  xmlLayout: XmlLayout
}

export enum TemplateVersionStatus {
  Approved = "APPROVED",
  Cancelled = "CANCELLED",
  Draft = "DRAFT",
  Expired = "EXPIRED",
  Review = "REVIEW",
  Suspended = "SUSPENDED",
}

export type TemplateVersionV2 = {
  __typename?: "TemplateVersionV2"
  declarations?: Maybe<Array<TemplateDeclarationGroup>>
  fields?: Maybe<Array<TemplateFieldConfigurationV2>>
  general: TemplateGeneralSettingsV2
  output?: Maybe<TemplateOutputV2>
  templateVersionId: Scalars["ID"]["output"]
}

export type TestRegistration = {
  __typename?: "TestRegistration"
  accountName?: Maybe<Scalars["String"]["output"]>
  businessName?: Maybe<Scalars["String"]["output"]>
  id: Scalars["ID"]["output"]
  nzbn?: Maybe<Scalars["String"]["output"]>
  operatorDisplayName?: Maybe<Scalars["String"]["output"]>
  registrationDescription?: Maybe<Scalars["String"]["output"]>
  registrationType?: Maybe<Scalars["String"]["output"]>
  registrationTypeId?: Maybe<Scalars["Int"]["output"]>
  source?: Maybe<RegistrationSource>
}

export type TestUser = {
  __typename?: "TestUser"
  email?: Maybe<Scalars["String"]["output"]>
  g2gUser?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["ID"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  permissions: Array<UserPermission>
  profileName?: Maybe<Scalars["String"]["output"]>
  systemUser?: Maybe<Scalars["Boolean"]["output"]>
  systemUsername?: Maybe<Scalars["String"]["output"]>
}

export type TimeTemplate = {
  __typename?: "TimeTemplate"
  hour: IntTemplate
  minute: IntTemplate
  second: Scalars["String"]["output"]
}

export enum TransferCertificateType {
  AnimalProductTransfer = "ANIMAL_PRODUCT_TRANSFER",
}

export type TransferProcessHistoryXmlResponse = {
  __typename?: "TransferProcessHistoryXmlResponse"
  certificateNumber: Scalars["String"]["output"]
  presignedUrl: Scalars["String"]["output"]
  transferRequestId: Scalars["ID"]["output"]
}

export type TransferProductDetails = {
  __typename?: "TransferProductDetails"
  aggregatedProcessHistory?: Maybe<Array<Maybe<CoreProcessHistory>>>
  attributes?: Maybe<CoreProductAttributes>
  classification?: Maybe<Array<Maybe<CoreProductClassificationResponse>>>
  commodity?: Maybe<Scalars["String"]["output"]>
  containers: Array<CoreExportContainer>
  createdAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  createdBy?: Maybe<Scalars["String"]["output"]>
  eligibilityCountries?: Maybe<Array<CoreLookup>>
  exhausted?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["ID"]["output"]
  isSourceOf?: Maybe<Scalars["ID"]["output"]>
  itemDescription?: Maybe<CoreLookup>
  packaging?: Maybe<Array<Maybe<CorePackaging>>>
  processHistory?: Maybe<Array<Maybe<AggregatedProcessHistory>>>
  processes: Array<CoreProductProcess>
  productDeclaration?: Maybe<Scalars["String"]["output"]>
  productGroupId?: Maybe<Scalars["ID"]["output"]>
  productItemRelation?: Maybe<Array<Maybe<CoreProductItemRelation>>>
  productNumber?: Maybe<Scalars["String"]["output"]>
  productReference?: Maybe<Scalars["String"]["output"]>
  productStatement?: Maybe<Scalars["String"]["output"]>
  quantity?: Maybe<Measurment>
  registrationId?: Maybe<Scalars["String"]["output"]>
  sequenceNumber?: Maybe<Scalars["Int"]["output"]>
  sourceProcessCount?: Maybe<Scalars["Int"]["output"]>
  sources?: Maybe<Array<SourcedProduct>>
  standaloneProductNumber?: Maybe<Scalars["String"]["output"]>
  supportingDocuments?: Maybe<Array<CoreTransferProductSupportingDocument>>
  tradeLineGroupNumber?: Maybe<Scalars["Int"]["output"]>
  /** @deprecated No longer supported as this was created for nested Source Products retrieval */
  transferRequestId?: Maybe<Scalars["ID"]["output"]>
  /** @deprecated No longer supported as this was created for nested Source Products retrieval */
  transferRequestNumber?: Maybe<Scalars["String"]["output"]>
  updatedAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  updatedBy?: Maybe<Scalars["String"]["output"]>
}

export type TransferReferenceError = {
  __typename?: "TransferReferenceError"
  errorCode: TransferReferenceErrorCode
  errorMessage: Scalars["String"]["output"]
  lineItem: Scalars["Int"]["output"]
  transferNumber: Scalars["String"]["output"]
}

export enum TransferReferenceErrorCode {
  Exhausted = "EXHAUSTED",
  LineNotFound = "LINE_NOT_FOUND",
  NotApproved = "NOT_APPROVED",
  NotFound = "NOT_FOUND",
  NoAccess = "NO_ACCESS",
  TooManyReferences = "TOO_MANY_REFERENCES",
}

export type TransferReferenceInput = {
  lineItem: Scalars["Int"]["input"]
  transferNumber: Scalars["String"]["input"]
}

export type TransferReferenceRequestInput = {
  references: Array<TransferReferenceInput>
}

export type TransferReferenceResponse = {
  __typename?: "TransferReferenceResponse"
  errors: Array<TransferReferenceError>
  products: Array<TransferProductDetails>
}

export type TransferRequestDetails = {
  __typename?: "TransferRequestDetails"
  action?: Maybe<CoreHistoryTransferActions>
  approvedAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  approvedBy?: Maybe<Scalars["String"]["output"]>
  attributes?: Maybe<CoreExportRequestAttributes>
  auditComment?: Maybe<Scalars["String"]["output"]>
  auditedAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  auditedBy?: Maybe<Scalars["String"]["output"]>
  certificateNumber: Scalars["String"]["output"]
  commodity: CoreCommodity
  consignee?: Maybe<CoreRegistration>
  consigneeRegId?: Maybe<Scalars["String"]["output"]>
  consignor?: Maybe<CoreRegistration>
  consignorRegId?: Maybe<Scalars["String"]["output"]>
  createdAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  createdBy?: Maybe<Scalars["String"]["output"]>
  destinationCountry: CoreCountry
  eligibility_declaration?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["ID"]["output"]
  isExhausted?: Maybe<Scalars["Boolean"]["output"]>
  products: Array<TransferProductDetails>
  reasonForStateChangeCategories?: Maybe<Array<Maybe<CoreLookup>>>
  reasonForStatusChange?: Maybe<Scalars["String"]["output"]>
  requiresAttention?: Maybe<Scalars["Boolean"]["output"]>
  status: CoreRequestStatus
  submittedAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  submittedBy?: Maybe<Scalars["String"]["output"]>
  substatus?: Maybe<Scalars["String"]["output"]>
  supportingDocuments?: Maybe<Array<Maybe<CoreSupportingDocument>>>
  template?: Maybe<CoreTemplate>
  templateCode?: Maybe<Scalars["String"]["output"]>
  templateId?: Maybe<Scalars["ID"]["output"]>
  thirdPartyConsignor?: Maybe<Array<Maybe<CoreLookup>>>
  transport?: Maybe<CoreTransport>
  uniqueConsignmentReference?: Maybe<Scalars["String"]["output"]>
  unofficialInformation?: Maybe<Scalars["String"]["output"]>
  updatedAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  updatedBy?: Maybe<Scalars["String"]["output"]>
  updatedByFullName?: Maybe<Scalars["String"]["output"]>
  updatedBySystem?: Maybe<Scalars["String"]["output"]>
  urgency?: Maybe<CoreLookup>
  version?: Maybe<Scalars["Int"]["output"]>
}

export type TransferRequestDetailsInput = {
  transferId: Scalars["ID"]["input"]
}

export type TransferRequestHistoryInput = {
  transferRequestId: Scalars["ID"]["input"]
}

export type TransferRequestHistoryRecord = {
  __typename?: "TransferRequestHistoryRecord"
  action?: Maybe<Scalars["String"]["output"]>
  autoApproved?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["ID"]["output"]
  nzxmlURI?: Maybe<Scalars["String"]["output"]>
  reasonCategories?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  reasonForStatusChange?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  substatus?: Maybe<Scalars["String"]["output"]>
  templateVersionId?: Maybe<Scalars["ID"]["output"]>
  transferRequestId: Scalars["ID"]["output"]
  updatedAt?: Maybe<Scalars["AWSDateTime"]["output"]>
  updatedBy?: Maybe<Scalars["String"]["output"]>
  updatedByFullName?: Maybe<Scalars["String"]["output"]>
  updatedByProfileFullName?: Maybe<Scalars["String"]["output"]>
  updatedByProfileName?: Maybe<Scalars["String"]["output"]>
  updatedBySystem?: Maybe<Scalars["String"]["output"]>
}

export type Translation = {
  __typename?: "Translation"
  lang: Scalars["String"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  text: Scalars["String"]["output"]
}

export type TranslationInput = {
  lang: Scalars["String"]["input"]
  text: Scalars["String"]["input"]
}

export enum TransportModeCode {
  AirTransport = "AIR_TRANSPORT",
  FixedTransportInstallation = "FIXED_TRANSPORT_INSTALLATION",
  InlandWaterTransport = "INLAND_WATER_TRANSPORT",
  Mail = "MAIL",
  MaritimeTransport = "MARITIME_TRANSPORT",
  MultimodalTransport = "MULTIMODAL_TRANSPORT",
  NotApplicable = "NOT_APPLICABLE",
  NotSpecified = "NOT_SPECIFIED",
  RailTransport = "RAIL_TRANSPORT",
  RoadTransport = "ROAD_TRANSPORT",
}

export type TransportMovementCodeTemplate = {
  __typename?: "TransportMovementCodeTemplate"
  code: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
}

export type TreatmentTemplate = {
  __typename?: "TreatmentTemplate"
  full_information?: Maybe<Scalars["String"]["output"]>
}

export type UpdateApprovedTransferTransportInput = {
  thirdPartyAccess?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>
  transferId: Scalars["ID"]["input"]
  transport?: InputMaybe<CoreTransportInput>
}

export type UpdateApprovedTransferTransportResponse = {
  __typename?: "UpdateApprovedTransferTransportResponse"
  success: Scalars["Boolean"]["output"]
}

export type UpdateGeneralTabAndStatusInput = {
  agencies?: InputMaybe<Array<InputMaybe<AgencyInput>>>
  allowForeignPremises?: InputMaybe<Scalars["Boolean"]["input"]>
  allowPackageLevels?: InputMaybe<Scalars["Boolean"]["input"]>
  assignedTo?: InputMaybe<Scalars["String"]["input"]>
  businessArea?: InputMaybe<BusinessArea>
  code: Scalars["String"]["input"]
  comment?: InputMaybe<Scalars["String"]["input"]>
  commodities?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  commodity: Scalars["String"]["input"]
  description?: InputMaybe<Scalars["String"]["input"]>
  destinationCountries?: InputMaybe<Array<Scalars["String"]["input"]>>
  displayedDescription: Scalars["String"]["input"]
  effective?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  expire?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  exportCertificateType?: InputMaybe<CertificateType>
  exportingCountry?: InputMaybe<Scalars["String"]["input"]>
  id: Scalars["ID"]["input"]
  importCertificateType?: InputMaybe<ImportCertificateType>
  industryAccess?: InputMaybe<Scalars["Boolean"]["input"]>
  isConfigurableTemplate?: InputMaybe<Scalars["Boolean"]["input"]>
  majorVersion: Scalars["Int"]["input"]
  minorVersion: Scalars["Int"]["input"]
  ocaAccess?: InputMaybe<Scalars["Boolean"]["input"]>
  officialVersion?: InputMaybe<Scalars["Int"]["input"]>
  outputSubtitle?: InputMaybe<Scalars["String"]["input"]>
  outputSubtitleTranslations?: InputMaybe<Array<InputMaybe<TranslationInput>>>
  outputTitle?: InputMaybe<Scalars["String"]["input"]>
  outputTitleTranslations?: InputMaybe<Array<InputMaybe<TranslationInput>>>
  reasonForUpdate?: InputMaybe<Scalars["String"]["input"]>
  release?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  signatory?: InputMaybe<Scalars["String"]["input"]>
  skipCopyFor?: InputMaybe<Array<InputMaybe<TemplateSectionType>>>
  status: TemplateVersionStatus
  submissionLayout: SubmissionLayoutType
  templateType?: InputMaybe<TemplateType>
  title: Scalars["String"]["input"]
  transferCertificateType?: InputMaybe<TransferCertificateType>
}

export type UpdateOutputTabInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>
  generalSettings: UpdateTemplateGeneralInput
  generateXml?: InputMaybe<Scalars["Boolean"]["input"]>
  outputSettings: TemplateVersionOutputInput
  processGroups?: InputMaybe<ProcessGroupsInput>
  supportingDocuments?: InputMaybe<Array<OutputTabSupportingDocumentInput>>
}

export type UpdatePrintReasonInput = {
  exportRequestId: Scalars["ID"]["input"]
  exportRequestOutputId: Scalars["ID"]["input"]
  printReason: Scalars["String"]["input"]
  updatedAt?: InputMaybe<Scalars["String"]["input"]>
  updatedBy?: InputMaybe<Scalars["String"]["input"]>
}

export type UpdatePrintReasonResponse = {
  __typename?: "UpdatePrintReasonResponse"
  createdAt: Scalars["AWSDateTime"]["output"]
  exportRequestOutputId: Scalars["ID"]["output"]
  outputEventId: Scalars["ID"]["output"]
  reasonForReprinting: Scalars["String"]["output"]
}

export type UpdateSupportingDocumentInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>
  documentReferenceNumber?: InputMaybe<Scalars["String"]["input"]>
  fileId?: InputMaybe<Scalars["String"]["input"]>
  foreignManufacturePremises?: InputMaybe<Scalars["String"]["input"]>
  foreignPremisesId?: InputMaybe<Scalars["String"]["input"]>
  id: Scalars["ID"]["input"]
  identificationMarks?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >
  intendedOperators?: InputMaybe<Array<InputMaybe<CoreLookupInput>>>
  nzManufacturePremises?: InputMaybe<Scalars["String"]["input"]>
  originCountry?: InputMaybe<CoreLookupInput>
  primaryOperator?: InputMaybe<CoreLookupInput>
  productDescription?: InputMaybe<Scalars["String"]["input"]>
  productionDates?: InputMaybe<Array<InputMaybe<CoreDateRangeInput>>>
  reason: Scalars["String"]["input"]
}

export type UpdateSupportingDocumentResult = {
  __typename?: "UpdateSupportingDocumentResult"
  message: Scalars["String"]["output"]
  success: Scalars["Boolean"]["output"]
  supportingDocument?: Maybe<CoreSupportingDocument>
}

export type UpdateTemplateGeneralInput = {
  agencies?: InputMaybe<Array<InputMaybe<AgencyInput>>>
  allowForeignPremises?: InputMaybe<Scalars["Boolean"]["input"]>
  allowPackageLevels?: InputMaybe<Scalars["Boolean"]["input"]>
  assignedTo?: InputMaybe<Scalars["String"]["input"]>
  businessArea?: InputMaybe<BusinessArea>
  code: Scalars["String"]["input"]
  commodities?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  commodity: Scalars["String"]["input"]
  description?: InputMaybe<Scalars["String"]["input"]>
  destinationCountries?: InputMaybe<Array<Scalars["String"]["input"]>>
  displayedDescription: Scalars["String"]["input"]
  effective?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  expire?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  exportCertificateType?: InputMaybe<CertificateType>
  exportingCountry?: InputMaybe<Scalars["String"]["input"]>
  id: Scalars["ID"]["input"]
  importCertificateType?: InputMaybe<ImportCertificateType>
  industryAccess?: InputMaybe<Scalars["Boolean"]["input"]>
  majorVersion: Scalars["Int"]["input"]
  minorVersion: Scalars["Int"]["input"]
  ocaAccess?: InputMaybe<Scalars["Boolean"]["input"]>
  officialVersion?: InputMaybe<Scalars["Int"]["input"]>
  outputSubtitle?: InputMaybe<Scalars["String"]["input"]>
  outputSubtitleTranslations?: InputMaybe<Array<InputMaybe<TranslationInput>>>
  outputTitle?: InputMaybe<Scalars["String"]["input"]>
  outputTitleTranslations?: InputMaybe<Array<InputMaybe<TranslationInput>>>
  reasonForUpdate?: InputMaybe<Scalars["String"]["input"]>
  release?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  signatory?: InputMaybe<Scalars["String"]["input"]>
  skipCopyFor?: InputMaybe<Array<InputMaybe<TemplateSectionType>>>
  status?: InputMaybe<TemplateVersionStatus>
  submissionLayout: SubmissionLayoutType
  templateType?: InputMaybe<TemplateType>
  title: Scalars["String"]["input"]
  transferCertificateType?: InputMaybe<TransferCertificateType>
}

export type UpdateTemplateInput = {
  assignedTo?: InputMaybe<Scalars["String"]["input"]>
  businessArea?: InputMaybe<BusinessArea>
  code: Scalars["String"]["input"]
  commodities?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  commodity?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  destinationMarket: DestinationMarket
  displayedDescription?: InputMaybe<Scalars["String"]["input"]>
  effective?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  expire?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  exportCertificateType?: InputMaybe<CertificateType>
  id: Scalars["ID"]["input"]
  importCertificateType?: InputMaybe<ImportCertificateType>
  majorVersion: Scalars["Int"]["input"]
  minorVersion: Scalars["Int"]["input"]
  reasonForUpdate?: InputMaybe<Scalars["String"]["input"]>
  templateType?: InputMaybe<TemplateType>
  title: Scalars["String"]["input"]
  transferCertificateType?: InputMaybe<TransferCertificateType>
}

export type UploadReferenceDataInput = {
  listCode: Scalars["String"]["input"]
}

export type UploadReferenceDataResponse = {
  __typename?: "UploadReferenceDataResponse"
  fields: Array<PresignedPostField>
  presignedUrl: Scalars["String"]["output"]
  s3Location: Scalars["String"]["output"]
}

export type UpsertTemplateProcessGroupConfigInput = {
  dateFormat?: InputMaybe<DateFormat>
  dateRange?: InputMaybe<DateRange>
  defaultAction?: InputMaybe<DefaultAction>
  id?: InputMaybe<Scalars["ID"]["input"]>
  includeOverseasProcesses?: InputMaybe<Scalars["Boolean"]["input"]>
  isPDF?: InputMaybe<Scalars["Boolean"]["input"]>
  isXML?: InputMaybe<Scalars["Boolean"]["input"]>
  operatorActivityType?: InputMaybe<Scalars["String"]["input"]>
  pdfSettings?: InputMaybe<ProcessGroupCaptionSettingsInput>
  premisesAddressFormat?: InputMaybe<PremisesAddressFormat>
  premisesRange?: InputMaybe<PremisesRange>
  processGroupId: Scalars["Int"]["input"]
  sortOrder: Scalars["Int"]["input"]
  width?: InputMaybe<DisplayedBoxWidth>
  xmlSettings?: InputMaybe<ProcessGroupCaptionSettingsInput>
}

export type User = {
  __typename?: "User"
  email?: Maybe<Scalars["String"]["output"]>
  id: Scalars["String"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
}

export type UserDetailsById = {
  __typename?: "UserDetailsById"
  email?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

export type UserInfo = {
  __typename?: "UserInfo"
  registrations: Array<Scalars["String"]["output"]>
}

export type UserPermission = {
  __typename?: "UserPermission"
  agencyId?: Maybe<Scalars["ID"]["output"]>
  constraintType?: Maybe<PermissionConstraintType>
  constraintValue?: Maybe<Scalars["String"]["output"]>
  registrationId?: Maybe<Scalars["ID"]["output"]>
  role?: Maybe<RoleName>
}

export type UserPermissionInput = {
  agencyId?: InputMaybe<Scalars["ID"]["input"]>
  constraintType: PermissionConstraintType
  constraintValue: Scalars["String"]["input"]
  registrationId?: InputMaybe<Scalars["ID"]["input"]>
  role: RoleName
}

export type UserProfile = {
  __typename?: "UserProfile"
  organisationName?: Maybe<Scalars["String"]["output"]>
  organisationPartyId: Scalars["ID"]["output"]
  organisationPrimaryAddress?: Maybe<B2GAddress>
  /** @deprecated Use registrationIdentifier */
  registartionNumberId?: Maybe<Scalars["String"]["output"]>
  registrationIdentifier?: Maybe<Scalars["String"]["output"]>
  registrationNumber?: Maybe<Scalars["String"]["output"]>
  /** @deprecated Use registrationNumber */
  registrationNumberValue?: Maybe<Scalars["String"]["output"]>
  userContactId?: Maybe<Scalars["ID"]["output"]>
  userEmail?: Maybe<Scalars["String"]["output"]>
  userName?: Maybe<Scalars["String"]["output"]>
  userPrimaryPhone?: Maybe<Scalars["String"]["output"]>
}

export type Validation = {
  __typename?: "Validation"
  errorType: ValidationErrorType
  id: Scalars["ID"]["output"]
  message: Scalars["String"]["output"]
}

export enum ValidationErrorType {
  Error = "ERROR",
  Warning = "WARNING",
}

export type VolumeAdjustmentInput = {
  productId: Scalars["ID"]["input"]
  volumeAdjustment: ManualVolumeAdjustmentInput
}

export type VolumeAdjustmentResponse = {
  __typename?: "VolumeAdjustmentResponse"
  productId: Scalars["ID"]["output"]
  volumeAdjustment: ManualVolumeAdjustment
}

export type VolumeMeasureTemplate = IMeasureTemplate & {
  __typename?: "VolumeMeasureTemplate"
  as_number: Scalars["Float"]["output"]
  in_litres?: Maybe<MeasureTemplate>
  mpi_unit?: Maybe<Scalars["String"]["output"]>
  number?: Maybe<Scalars["String"]["output"]>
  three_decimals?: Maybe<Scalars["String"]["output"]>
  unit?: Maybe<Scalars["String"]["output"]>
  value?: Maybe<Scalars["String"]["output"]>
}

export type WineAnalytesTolerancesInput = {
  chemistryTest?: InputMaybe<Scalars["String"]["input"]>
  dealcoholisedWine?: InputMaybe<Scalars["String"]["input"]>
  max?: InputMaybe<Scalars["Float"]["input"]>
  min?: InputMaybe<Scalars["Float"]["input"]>
  red?: InputMaybe<Scalars["Boolean"]["input"]>
  shippingFormat?: InputMaybe<WinePackaging>
  wineCategory?: InputMaybe<Scalars["String"]["input"]>
}

export type WineAnalytesTolerancesResponse = {
  __typename?: "WineAnalytesTolerancesResponse"
  destinationMarket?: Maybe<DestinationMarket>
  eligible?: Maybe<Scalars["Boolean"]["output"]>
}

export type WineAnalytesTolerancesResponseInput = {
  dealcoholisedWine?: InputMaybe<Scalars["String"]["input"]>
  red: Scalars["Boolean"]["input"]
  shippingFormat: WinePackaging
  testResults: Array<ChemistryTest>
  wineCategory?: InputMaybe<Scalars["String"]["input"]>
}

export type WineAnalytesTolerancesResponseRowInput = {
  destinationMarket?: InputMaybe<DestinationMarket>
}

export type WineAnalytesTolerancesType = DecisionTableBaseInput & {
  __typename?: "WineAnalytesTolerancesType"
  chemistryTest?: Maybe<Scalars["String"]["output"]>
  dealcoholisedWine?: Maybe<Scalars["String"]["output"]>
  max?: Maybe<Scalars["Float"]["output"]>
  min?: Maybe<Scalars["Float"]["output"]>
  red?: Maybe<Scalars["Boolean"]["output"]>
  shippingFormat?: Maybe<WinePackaging>
  validFrom?: Maybe<Scalars["AWSDateTime"]["output"]>
  validUntil?: Maybe<Scalars["AWSDateTime"]["output"]>
  wineCategory?: Maybe<Scalars["String"]["output"]>
}

export type WineChemistryTemplate = {
  __typename?: "WineChemistryTemplate"
  actual_alcohol_content?: Maybe<MeasureTemplate>
  citric_acidity?: Maybe<MeasureTemplate>
  laboratory?: Maybe<SpsPartyTemplate>
  laboratory_reference?: Maybe<Scalars["String"]["output"]>
  methyl_alcohol?: Maybe<MeasureTemplate>
  reduced_dry_extract?: Maybe<MeasureTemplate>
  sugar_content?: Maybe<MeasureTemplate>
  sugar_content_qualifier?: Maybe<Scalars["String"]["output"]>
  total_acidity_7_0?: Maybe<MeasureTemplate>
  total_acidity_8_2_meql?: Maybe<MeasureTemplate>
  total_alcoholic_strength?: Maybe<MeasureTemplate>
  total_dry_extract?: Maybe<MeasureTemplate>
  total_sulphates?: Maybe<MeasureTemplate>
  total_sulphur_dioxide?: Maybe<MeasureTemplate>
  volatile_acidity?: Maybe<MeasureTemplate>
  volatile_acidity_meql?: Maybe<MeasureTemplate>
}

export type WineConsignment = {
  __typename?: "WineConsignment"
  cases?: Maybe<Scalars["Int"]["output"]>
  /** @deprecated Use producer */
  exporter?: Maybe<SpsWineExporter>
  is_bulk?: Maybe<Scalars["String"]["output"]>
  net_volume?: Maybe<Scalars["String"]["output"]>
  producer?: Maybe<SpsWineExporter>
}

export type WineConsignmentTemplate = {
  __typename?: "WineConsignmentTemplate"
  cases?: Maybe<IntTemplate>
  /** @deprecated Use producer */
  exporter?: Maybe<SpsPartyTemplate>
  is_bulk?: Maybe<Scalars["String"]["output"]>
  net_volume?: Maybe<MeasureTemplate>
  producer?: Maybe<SpsPartyTemplate>
}

export enum WineDisputedReason {
  Malodorous = "MALODOROUS",
  Oxidised = "OXIDISED",
  Tainted = "TAINTED",
}

export type WineFieldsTemplate = {
  __typename?: "WineFieldsTemplate"
  batch_number?: Maybe<Scalars["String"]["output"]>
  bottler_reference?: Maybe<Scalars["String"]["output"]>
  br_brand_name?: Maybe<Scalars["String"]["output"]>
  br_classification?: Maybe<BrClassificationTemplate>
  chemistry?: Maybe<WineChemistryTemplate>
  colour?: Maybe<Scalars["String"]["output"]>
  eu_category?: Maybe<Scalars["String"]["output"]>
  eu_ingredients?: Maybe<EuIngredientsTemplate>
  geographic_indication?: Maybe<Scalars["String"]["output"]>
  grape_variety?: Maybe<Scalars["String"]["output"]>
  is_dealcoholised?: Maybe<Scalars["String"]["output"]>
  is_eu_eligible?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  package?: Maybe<PackageTemplate>
  special_process?: Maybe<Scalars["String"]["output"]>
  style?: Maybe<Scalars["String"]["output"]>
  vintage?: Maybe<Scalars["String"]["output"]>
  wine_description?: Maybe<Scalars["String"]["output"]>
}

export enum WinePackaging {
  Cs = "CS",
  Ft = "FT",
}

export type WineProductFieldInput = {
  certificateType?: InputMaybe<CertificateType>
  destinationMarket?: InputMaybe<DestinationMarket>
}

export type WineProductFieldType = DecisionTableBaseInput & {
  __typename?: "WineProductFieldType"
  certificateType?: Maybe<CertificateType>
  destinationMarket?: Maybe<DestinationMarket>
  validFrom?: Maybe<Scalars["AWSDateTime"]["output"]>
  validUntil?: Maybe<Scalars["AWSDateTime"]["output"]>
}

export type Winemaking = {
  __typename?: "Winemaking"
  confirmations?: Maybe<Array<Maybe<WinemakingConfirmation>>>
  status?: Maybe<ProcessStatus>
  wsmp?: Maybe<Scalars["ID"]["output"]>
}

export type WinemakingConfirmation = {
  __typename?: "WinemakingConfirmation"
  confirmed?: Maybe<Scalars["Boolean"]["output"]>
  disputedReason?: Maybe<Scalars["String"]["output"]>
  disputedResolution?: Maybe<Scalars["String"]["output"]>
  market: DestinationMarket
  status: WinemakingStatus
}

export type WinemakingConfirmationInput = {
  confirmed?: InputMaybe<Scalars["Boolean"]["input"]>
  disputedReason?: InputMaybe<Scalars["String"]["input"]>
  disputedResolution?: InputMaybe<Scalars["String"]["input"]>
  market: DestinationMarket
}

export enum WinemakingStatus {
  Confirmed = "CONFIRMED",
  Disputed = "DISPUTED",
  NotApplicable = "NOT_APPLICABLE",
  Requested = "REQUESTED",
}

export enum XmlLayout {
  EuCatchXml = "EU_CATCH_XML",
  EuImportXml = "EU_IMPORT_XML",
  EuProcStatementXml = "EU_PROC_STATEMENT_XML",
  EuTransitXml = "EU_TRANSIT_XML",
  IppcPhytoXml = "IPPC_PHYTO_XML",
  None = "NONE",
  Official_2_9_1 = "OFFICIAL_2_9_1",
  Uncefact = "UNCEFACT",
}

export type XmlSettings = {
  __typename?: "XMLSettings"
  caption?: Maybe<Scalars["String"]["output"]>
  captionId?: Maybe<Scalars["ID"]["output"]>
  defaultOption?: Maybe<XmlDefaultOption>
  order?: Maybe<Scalars["Int"]["output"]>
  xmlColumnsToDisplay?: Maybe<ColumnsToDisplay>
}

export type XmlSettingsInput = {
  caption?: InputMaybe<Scalars["ID"]["input"]>
  defaultOption?: InputMaybe<XmlDefaultOption>
  order?: InputMaybe<Scalars["Int"]["input"]>
  xmlColumnsToDisplay?: InputMaybe<ColumnsToDisplay>
}

export enum XmlDefaultOption {
  NotApplicable = "NOT_APPLICABLE",
  TagNotIncluded = "TAG_NOT_INCLUDED",
  Xxxxxx = "XXXXXX",
}

export type XmlDownloadUrl = {
  __typename?: "XmlDownloadUrl"
  fileName?: Maybe<Scalars["String"]["output"]>
  url?: Maybe<Scalars["String"]["output"]>
}

export enum XmlRequestType {
  ApExport = "AP_EXPORT",
  PhytoExport = "PHYTO_EXPORT",
  Transfer = "TRANSFER",
}

export type AddProductAndProcessFromTransferInput = {
  products: Array<Scalars["String"]["input"]>
  transferId: Scalars["ID"]["input"]
}

export type AwsS3PostUploadUrl = {
  __typename?: "awsS3PostUploadUrl"
  fields: Array<AwsS3Fields>
  url?: Maybe<Scalars["String"]["output"]>
}

export type GetDeclarationInputsResponse = {
  __typename?: "getDeclarationInputsResponse"
  statementInputs: Scalars["Int"]["output"]
}

export type SaveTransferRequestMutationMutationVariables = Exact<{
  input: CoreTransferRequestInput
}>

export type SaveTransferRequestMutationMutation = {
  __typename?: "Mutation"
  saveTransferRequest: {
    __typename?: "CoreTransferRequest"
    id: string
    version?: number | null
    certificateNumber: string
    status: {
      __typename?: "CoreRequestStatus"
      code?: CoreStatus | null
      label: string
    }
    products?: Array<{
      __typename?: "SavedProductOutput"
      id?: string | null
    } | null> | null
  }
}

export type RaiseTransferRequestMutationVariables = Exact<{
  id: Scalars["ID"]["input"]
  version?: InputMaybe<Scalars["Int"]["input"]>
  validation?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type RaiseTransferRequestMutation = {
  __typename?: "Mutation"
  raiseTransferRequest: {
    __typename?: "RaiseTransferRequestResponse"
    certificateNumber: string
    id: string
    status: CoreStatus
    submittedAt: any
    warnings?: Array<{
      __typename?: "RequestValidation"
      id: string
      errorType: ValidationErrorType
      errorMsg?: string | null
      message: string
      field?: string | null
      fieldFuid?: string | null
      additionalFuid?: string | null
      maxLength?: number | null
      fieldValue?: any | null
      additionalFieldValue?: any | null
      type?: string | null
      details?: any | null
    }> | null
  }
}

export type ChangeTransferRequestStatusMutationMutationVariables = Exact<{
  input: ChangeTransferRequestStatusInput
}>

export type ChangeTransferRequestStatusMutationMutation = {
  __typename?: "Mutation"
  changeTransferRequestStatus: {
    __typename?: "ChangeTransferRequestStatusResponse"
    transferRequestId: string
    status: string
    version?: number | null
  }
}

export type DeleteTransferRequestByIdMutationVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type DeleteTransferRequestByIdMutation = {
  __typename?: "Mutation"
  deleteTransferRequestById: boolean
}

export type UpdateApprovedTransferTransportMutationVariables = Exact<{
  input: UpdateApprovedTransferTransportInput
}>

export type UpdateApprovedTransferTransportMutation = {
  __typename?: "Mutation"
  updateApprovedTransferTransport?: boolean | null
}

export type DownloadTransferRequestsAsCsvMutationVariables = Exact<{
  input: DownloadTransferRequestsCsvInput
}>

export type DownloadTransferRequestsAsCsvMutation = {
  __typename?: "Mutation"
  downloadTransferRequestsAsCsv: {
    __typename?: "ExportCsvResponse"
    filename: string
    presignedUrl: string
  }
}

export type DownloadStatusReportMutationVariables = Exact<{
  input: DownloadStatusReportInput
}>

export type DownloadStatusReportMutation = {
  __typename?: "Mutation"
  downloadStatusReport: {
    __typename?: "ExportCsvResponse"
    filename: string
    presignedUrl: string
  }
}

export type SaveExportRequestMutationMutationVariables = Exact<{
  input: CoreExportRequestInput
}>

export type SaveExportRequestMutationMutation = {
  __typename?: "Mutation"
  saveExportRequest: {
    __typename?: "CoreExportRequest"
    id: string
    version?: number | null
    status: { __typename?: "CoreRequestStatus"; label: string }
  }
}

export type RaiseExportRequestMutationVariables = Exact<{
  id: Scalars["ID"]["input"]
  version?: InputMaybe<Scalars["Int"]["input"]>
  validation?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type RaiseExportRequestMutation = {
  __typename?: "Mutation"
  raiseExportRequest: {
    __typename?: "RaiseExportRequestResponse"
    certificateNumber: string
    id: string
    status: CoreStatus
    submittedAt: any
    warnings?: Array<{
      __typename?: "RequestValidation"
      id: string
      errorType: ValidationErrorType
      errorMsg?: string | null
      message: string
      field?: string | null
      fieldFuid?: string | null
      additionalFuid?: string | null
      maxLength?: number | null
      fieldValue?: any | null
      additionalFieldValue?: any | null
      type?: string | null
      details?: any | null
    }> | null
  }
}

export type ChangeExportRequestStatusMutationMutationVariables = Exact<{
  input: ChangeExportRequestStatusInput
}>

export type ChangeExportRequestStatusMutationMutation = {
  __typename?: "Mutation"
  changeExportRequestStatus: {
    __typename?: "ChangeExportRequestStatusResponse"
    exportRequestId: string
    status: string
    version?: number | null
  }
}

export type DeleteExportRequestByIdMutationVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type DeleteExportRequestByIdMutation = {
  __typename?: "Mutation"
  deleteExportRequestById: boolean
}

export type DeleteReplacementExportRequestMutationVariables = Exact<{
  input: DeleteReplacementExportRequestInput
}>

export type DeleteReplacementExportRequestMutation = {
  __typename?: "Mutation"
  deleteReplacementExportRequest: {
    __typename?: "DeleteReplacementExportRequestResponse"
    parentId?: string | null
  }
}

export type GenerateExportPdfMutationVariables = Exact<{
  input: PrintCertificateInput
}>

export type GenerateExportPdfMutation = {
  __typename?: "Mutation"
  printCertificate: {
    __typename?: "PrintCertificateResponse"
    executionArn?: string | null
    exportRequestId: string
    pdfCertificateUrl?: string | null
    exportRequestOutputId?: string | null
  }
}

export type UpdatePrintReasonMutationVariables = Exact<{
  input: UpdatePrintReasonInput
}>

export type UpdatePrintReasonMutation = {
  __typename?: "Mutation"
  updatePrintReason: {
    __typename?: "UpdatePrintReasonResponse"
    outputEventId: string
    exportRequestOutputId: string
    reasonForReprinting: string
    createdAt: any
  }
}

export type NewCoreReferencedDocumentMutationVariables = Exact<{
  input: NewCoreReferencedDocumentInput
}>

export type NewCoreReferencedDocumentMutation = {
  __typename?: "Mutation"
  newCoreReferencedDocument?: {
    __typename?: "NewCoreReferencedDocument"
    id: string
    url: string
  } | null
}

export type DeleteCoreReferencedDocumentMutationVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type DeleteCoreReferencedDocumentMutation = {
  __typename?: "Mutation"
  deleteCoreReferencedDocument?: string | null
}

export type CreateSupportingDocumentMutationVariables = Exact<{
  input: CoreSupportingDocumentInput
}>

export type CreateSupportingDocumentMutation = {
  __typename?: "Mutation"
  createSupportingDocument?: {
    __typename?: "CoreSupportingDocument"
    id?: string | null
    comment?: string | null
    documentNumber?: string | null
    documentReferenceNumber?: string | null
    productDescription?: string | null
    identificationMarks?: Array<string | null> | null
    foreignManufacturePremises?: string | null
    foreignPremisesId?: string | null
    nzManufacturePremises?: string | null
    primaryOperator?: {
      __typename?: "CoreLookup"
      id?: string | null
      name?: string | null
    } | null
    intendedOperators?: Array<{
      __typename?: "CoreLookup"
      id?: string | null
      name?: string | null
    } | null> | null
    originCountry?: {
      __typename?: "CoreLookup"
      id?: string | null
      name?: string | null
    } | null
    productionDates?: Array<{
      __typename?: "CoreDateRange"
      from?: any | null
      to?: any | null
    } | null> | null
  } | null
}

export type CancelSupportingDocumentMutationVariables = Exact<{
  input: CancelSupportingDocumentInput
}>

export type CancelSupportingDocumentMutation = {
  __typename?: "Mutation"
  cancelSupportingDocument?: {
    __typename?: "UpdateSupportingDocumentResult"
    success: boolean
    message: string
    supportingDocument?: {
      __typename?: "CoreSupportingDocument"
      id?: string | null
      status?: string | null
    } | null
  } | null
}

export type UpdateSupportingDocumentMutationVariables = Exact<{
  input: UpdateSupportingDocumentInput
}>

export type UpdateSupportingDocumentMutation = {
  __typename?: "Mutation"
  updateSupportingDocument?: {
    __typename?: "UpdateSupportingDocumentResult"
    success: boolean
    message: string
    supportingDocument?: {
      __typename?: "CoreSupportingDocument"
      id?: string | null
      status?: string | null
      documentNumber?: string | null
      documentReferenceNumber?: string | null
      productDescription?: string | null
      identificationMarks?: Array<string | null> | null
      foreignManufacturePremises?: string | null
      foreignPremisesId?: string | null
      nzManufacturePremises?: string | null
      primaryOperator?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      intendedOperators?: Array<{
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null> | null
      productionDates?: Array<{
        __typename?: "CoreDateRange"
        from?: any | null
        to?: any | null
      } | null> | null
      originCountry?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
    } | null
  } | null
}

export type ExtendIntendedOperatorMutationVariables = Exact<{
  input: ExtendIntendedOperatorInput
}>

export type ExtendIntendedOperatorMutation = {
  __typename?: "Mutation"
  extendIntendedOperator?: {
    __typename?: "UpdateSupportingDocumentResult"
    success: boolean
    message: string
    supportingDocument?: {
      __typename?: "CoreSupportingDocument"
      id?: string | null
      status?: string | null
      intendedOperators?: Array<{
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null> | null
    } | null
  } | null
}

export type DownloadSupportingDocumentsAsCsvMutationVariables = Exact<{
  input: DownloadSupportingDocumentsCsvInput
}>

export type DownloadSupportingDocumentsAsCsvMutation = {
  __typename?: "Mutation"
  downloadSupportingDocumentsAsCsv: {
    __typename?: "ExportCsvResponse"
    filename: string
    presignedUrl: string
  }
}

export type ExhaustTransferProductsMutationVariables = Exact<{
  input: ExhaustTransferProductsInput
}>

export type ExhaustTransferProductsMutation = {
  __typename?: "Mutation"
  exhaustTransferProducts: {
    __typename?: "ExhaustTransferProductsResponse"
    results: Array<{
      __typename?: "ExhaustTransferProductResult"
      transferRequestId: string
      isFullyExhausted: boolean
      products: Array<{
        __typename?: "TransferProductDetails"
        id: string
        exhausted?: boolean | null
      }>
    }>
  }
}

export type PrepareXmlFileForB2GMutationVariables = Exact<{
  input: PrepareXmlFileForB2GInput
}>

export type PrepareXmlFileForB2GMutation = {
  __typename?: "Mutation"
  prepareXmlFileForB2G: {
    __typename?: "PrepareXmlFileForB2GResponse"
    b2gPayload?: string | null
    errorMessages: Array<string>
    fileName: string
    requestType: XmlRequestType
    responseId?: string | null
    status: string
    xmlInputId: string
  }
}

export type ProcessB2GIntegrationMutationVariables = Exact<{
  input: ProcessB2GIntegrationInput
}>

export type ProcessB2GIntegrationMutation = {
  __typename?: "Mutation"
  processB2GIntegration: {
    __typename?: "ProcessB2GIntegrationResponse"
    errorMessages: Array<string>
    fileName: string
    requestType: XmlRequestType
    responseId?: string | null
    status: string
    xmlInputId: string
  }
}

export type AddOrUpdateWineProductMutationVariables = Exact<{
  product: B2GProductInput
}>

export type AddOrUpdateWineProductMutation = {
  __typename?: "Mutation"
  addProduct: {
    __typename?: "B2GProduct"
    id: string
    commodity: string
    modifiable: boolean
    description: string
    premise: { __typename?: "B2GPremise"; id: string }
  }
}

export type NewReferencedDocumentMutationVariables = Exact<{
  filename?: InputMaybe<Scalars["String"]["input"]>
}>

export type NewReferencedDocumentMutation = {
  __typename?: "Mutation"
  newReferencedDocument: {
    __typename?: "NewReferencedDocument"
    id: string
    url: string
  }
}

export type DeleteSupportingDocumentMutationVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type DeleteSupportingDocumentMutation = {
  __typename?: "Mutation"
  deleteReferencedDocument: string
}

export type NewApiKeyMutationVariables = Exact<{ [key: string]: never }>

export type NewApiKeyMutation = {
  __typename?: "Mutation"
  newSearchApiKey?: {
    __typename?: "SearchApiKey"
    apiKey: string
    expires: any
  } | null
}

export type AcceptedTermsAndConditionsMutationVariables = Exact<{
  [key: string]: never
}>

export type AcceptedTermsAndConditionsMutation = {
  __typename?: "Mutation"
  acceptedTermsAndConditions?: boolean | null
}

export type NewPartyApiKeyMutationVariables = Exact<{ [key: string]: never }>

export type NewPartyApiKeyMutation = {
  __typename?: "Mutation"
  newPartyApiKey?: {
    __typename?: "SearchApiKey"
    apiKey: string
    expires: any
  } | null
}

export type NewMultiCollectionApiKeysMutationVariables = Exact<{
  [key: string]: never
}>

export type NewMultiCollectionApiKeysMutation = {
  __typename?: "Mutation"
  newMultiCollectionApiKeys?: {
    __typename?: "MultiCollectionApiKeys"
    products?: string | null
    exportCertificates?: string | null
    exporters?: string | null
    transferRequests?: string | null
    agency?: string | null
    registration?: string | null
    registrationAll?: string | null
    expires: any
    partyApiKey?: string | null
  } | null
}

export type GetApiKeysV2MutationVariables = Exact<{ [key: string]: never }>

export type GetApiKeysV2Mutation = {
  __typename?: "Mutation"
  newMultiCollectionApiKeysV2?: {
    __typename?: "MultiCollectionApiKeysV2"
    products?: string | null
    partyApiKey?: string | null
    agency?: string | null
    templates?: string | null
    expires: any
    exporters?: string | null
    ocaExports?: string | null
    exports?: {
      __typename?: "RoleSpecificKeys"
      supportingDocuments?: string | null
      exportCertificates?: string | null
      registration?: string | null
      registrationAll?: string | null
      transferRequests?: string | null
      sourceTransfers?: string | null
    } | null
    transfers?: {
      __typename?: "RoleSpecificKeys"
      supportingDocuments?: string | null
      exportCertificates?: string | null
      registration?: string | null
      registrationAll?: string | null
      transferRequests?: string | null
      sourceTransfers?: string | null
    } | null
    supportingDocs?: {
      __typename?: "SupportingDocumentKeys"
      registration?: string | null
      registrationAll?: string | null
      supportingDocuments?: string | null
    } | null
  } | null
}

export type MutateDraftExportCertificateRequestMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>
  referencedDocuments?: InputMaybe<
    Array<B2GReferencedDocumentInput> | B2GReferencedDocumentInput
  >
  exporterDeclaration?: InputMaybe<B2GExporterDeclarationInput>
  destination?: InputMaybe<B2GCountryInput>
  consignment?: InputMaybe<B2GConsignmentInput>
  commodity?: InputMaybe<Scalars["String"]["input"]>
  certificateType?: InputMaybe<CertificateType>
  certificateDelivery?: InputMaybe<B2GCertificateDeliveryInput>
  requestName?: InputMaybe<Scalars["String"]["input"]>
  requestedOnBehalfOfConsignor?: InputMaybe<Scalars["Boolean"]["input"]>
  copyFromId?: InputMaybe<Scalars["String"]["input"]>
}>

export type MutateDraftExportCertificateRequestMutation = {
  __typename?: "Mutation"
  draftExportCertificateRequest: {
    __typename?: "B2GExportCertificateRequest"
    id: string
    commodity?: string | null
    certificateType?: CertificateType | null
    market: DestinationMarket
    destination?: { __typename?: "B2GCountry"; id: string } | null
  }
}

export type MutateRaiseExportCertificateRequestMutationVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type MutateRaiseExportCertificateRequestMutation = {
  __typename?: "Mutation"
  raiseExportCertificateRequest?: {
    __typename?: "B2GExportCertificateRequest"
    id: string
    status: ExportCertificateStatus
    statusLabel: string
  } | null
}

export type DiscardExportCertificateRequestMutationVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type DiscardExportCertificateRequestMutation = {
  __typename?: "Mutation"
  discardExportCertificateRequest: boolean
}

export type CancelExportCertificateRequestMutationVariables = Exact<{
  input: CancelExportCertificateRequestInput
}>

export type CancelExportCertificateRequestMutation = {
  __typename?: "Mutation"
  cancelExportCertificateRequest: {
    __typename?: "B2GExportCertificateRequest"
    id: string
  }
}

export type CreateSensoryProcessMutationVariables = Exact<{
  productId: Scalars["ID"]["input"]
  reference: Scalars["String"]["input"]
  disputed: Scalars["Boolean"]["input"]
  disputedReason?: InputMaybe<WineDisputedReason>
  comment?: InputMaybe<Scalars["String"]["input"]>
  winemaker: Scalars["String"]["input"]
  assessmentDate: Scalars["AWSDateTime"]["input"]
}>

export type CreateSensoryProcessMutation = {
  __typename?: "Mutation"
  completeSensoryProcess: {
    __typename?: "SensoryProcessRequest"
    id: string
    productId: string
    reference: string
    disputed: boolean
    disputedReason?: WineDisputedReason | null
    comment?: string | null
    assessmentDate: any
    winemaker: { __typename?: "B2GContact"; personName?: string | null }
  }
}

export type RequestChemistryTestMutationVariables = Exact<{
  productId: Scalars["ID"]["input"]
  expectedAlcoholContent?: InputMaybe<Scalars["Float"]["input"]>
  laboratory: Scalars["String"]["input"]
  packagingReference?: InputMaybe<Scalars["String"]["input"]>
  packagingDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  sampleCollectionDate: Scalars["AWSDateTime"]["input"]
  testRequired: Scalars["ID"]["input"]
}>

export type RequestChemistryTestMutation = {
  __typename?: "Mutation"
  requestChemistryTest: {
    __typename?: "ChemistryTestResponse"
    status?: string | null
    cancelledReason?: string | null
    firstResultReportedDate?: string | null
    receipt: {
      __typename?: "ChemistryTestReceipt"
      laboratoryReference?: string | null
      receiptDate?: any | null
      sampleSuitable?: boolean | null
      unsuitableReason?: string | null
    }
    request: {
      __typename?: "ChemistryTestRequest"
      expectedAlcoholContent?: number | null
      laboratory: string
      packagingDate?: any | null
      packagingReference?: string | null
      sampleCollectionDate: any
      testRequired: string
      sampleReference: string
      wineTestReference: string
    }
  }
}

export type AddBottlingRunsMutationVariables = Exact<{
  input: BottlingRunInput
}>

export type AddBottlingRunsMutation = {
  __typename?: "Mutation"
  addBottlingRuns: {
    __typename?: "BottlingRunResponse"
    processId: string
    runs: Array<{
      __typename?: "BottlingRunData"
      id: string
      bottleVolume: string
      bottlesPerCase: number
      cases: number
      date: any
      extraBottles?: number | null
      reference: string
    }>
  }
}

export type AddFlexiFillingRunsMutationVariables = Exact<{
  input: FlexiFillingRunInput
}>

export type AddFlexiFillingRunsMutation = {
  __typename?: "Mutation"
  addFlexiFillingRuns: {
    __typename?: "FlexiFillingRunResponse"
    processId: string
    runs: Array<{
      __typename?: "FlexiFillingRunData"
      date: any
      litres: number
      id: string
      reference: string
    }>
  }
}

export type StartPackagingMutationVariables = Exact<{
  productId: Scalars["ID"]["input"]
}>

export type StartPackagingMutation = {
  __typename?: "Mutation"
  startPackaging: {
    __typename?: "ProcessResponse"
    id: string
    type: ProductProcessType
    task?: {
      __typename?: "ProcessTask"
      taskId: string
      assignedTo?: string | null
    } | null
  }
}

export type RequestConfirmationMutationVariables = Exact<{
  input: RequestConfirmationInput
}>

export type RequestConfirmationMutation = {
  __typename?: "Mutation"
  requestConfirmation: {
    __typename?: "RequestConfirmationResponse"
    wsmp: string
    processId: string
  }
}

export type ConfirmPackagingMutationVariables = Exact<{
  input: ConfirmPackagingInput
}>

export type ConfirmPackagingMutation = {
  __typename?: "Mutation"
  confirmPackaging: {
    __typename?: "ConfirmPackagingResponse"
    confirmed: boolean
    disputeReason?: string | null
    disputeResolution?: string | null
    processId: string
  }
}

export type CancelProcessMutationVariables = Exact<{
  processId: Scalars["ID"]["input"]
  cancelledReason?: InputMaybe<Scalars["String"]["input"]>
}>

export type CancelProcessMutation = {
  __typename?: "Mutation"
  cancelProcess: {
    __typename?: "CancelledProcessResponse"
    status?: string | null
    cancelledReason?: string | null
    firstResultReportedDate?: string | null
    receipt: {
      __typename?: "ChemistryTestReceipt"
      laboratoryReference?: string | null
      receiptDate?: any | null
      sampleSuitable?: boolean | null
      unsuitableReason?: string | null
    }
    request: {
      __typename?: "ChemistryTestRequest"
      expectedAlcoholContent?: number | null
      laboratory: string
      packagingDate?: any | null
      packagingReference?: string | null
      sampleCollectionDate: any
      testRequired: string
      sampleReference: string
      wineTestReference: string
    }
  }
}

export type StartWinemakingMutationVariables = Exact<{
  productId: Scalars["ID"]["input"]
}>

export type StartWinemakingMutation = {
  __typename?: "Mutation"
  startWinemaking: {
    __typename?: "ProcessResponse"
    type: ProductProcessType
    id: string
    task?: {
      __typename?: "ProcessTask"
      assignedTo?: string | null
      taskId: string
    } | null
  }
}

export type ConfirmWinemakingMutationVariables = Exact<{
  input: ConfirmWinemakingInput
}>

export type ConfirmWinemakingMutation = {
  __typename?: "Mutation"
  confirmWinemaking: string
}

export type ResetConfirmationRequestMutationVariables = Exact<{
  input: ResetConfirmationRequestInput
}>

export type ResetConfirmationRequestMutation = {
  __typename?: "Mutation"
  resetConfirmationRequest: string
}

export type ReplacingCertificateMutationVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type ReplacingCertificateMutation = {
  __typename?: "Mutation"
  replacementCertificateRequest: {
    __typename?: "B2GExportCertificateRequest"
    id: string
    status: ExportCertificateStatus
    certificateType?: CertificateType | null
    commodity?: string | null
    destination?: { __typename?: "B2GCountry"; id: string } | null
    replacedBy?: {
      __typename?: "B2GExportCertificateRequest"
      id: string
      requestName?: string | null
      status: ExportCertificateStatus
    } | null
  }
}

export type RequestApprovalToReplaceExportCertificateRequestMutationVariables =
  Exact<{
    input: ApprovalToReplaceExportCertificateRequestInput
  }>

export type RequestApprovalToReplaceExportCertificateRequestMutation = {
  __typename?: "Mutation"
  requestApprovalToReplaceExportCertificateRequest?: boolean | null
}

export type AdjustBatchVolumeMutationVariables = Exact<{
  productId: Scalars["ID"]["input"]
  litres: Scalars["Float"]["input"]
  reason: Scalars["String"]["input"]
}>

export type AdjustBatchVolumeMutation = {
  __typename?: "Mutation"
  adjustBatchVolume: {
    __typename?: "VolumeAdjustmentResponse"
    volumeAdjustment: {
      __typename?: "ManualVolumeAdjustment"
      date?: any | null
      changeType?: string | null
      litres?: number | null
      reason?: string | null
    }
  }
}

export type DownloadExportRequestsAsCsvMutationVariables = Exact<{
  input: DownloadExportRequestsCsvInput
}>

export type DownloadExportRequestsAsCsvMutation = {
  __typename?: "Mutation"
  downloadExportRequestsAsCsv: {
    __typename?: "ExportCsvResponse"
    filename: string
    presignedUrl: string
  }
}

export type GetActiveAnnouncementsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetActiveAnnouncementsQuery = {
  __typename?: "Query"
  getActiveAnnouncements: Array<{
    __typename?: "Announcement"
    id: string
    title: string
    message: string
    publishDate: any
    endDate: any
    status: AnnouncementStatus
  }>
}

export type GetPresignedUrlForXmlQueryVariables = Exact<{
  fileStore: Scalars["String"]["input"]
  key: Scalars["String"]["input"]
}>

export type GetPresignedUrlForXmlQuery = {
  __typename?: "Query"
  getPresignedUrl: string
}

export type ListFeatureFlagsQueryVariables = Exact<{ [key: string]: never }>

export type ListFeatureFlagsQuery = {
  __typename?: "Query"
  getFeatureFlags: Array<string>
}

export type GetDfeFormConfigQueryVariables = Exact<{
  templateId: Scalars["ID"]["input"]
  templateVersionId: Scalars["ID"]["input"]
  recipeType?: InputMaybe<RecipeType>
}>

export type GetDfeFormConfigQuery = {
  __typename?: "Query"
  getDfeForm: { __typename?: "DFEForm"; config?: any | null }
}

export type GetActiveTemplateBySubmissionLayoutQueryVariables = Exact<{
  submissionLayout: SubmissionLayoutType
}>

export type GetActiveTemplateBySubmissionLayoutQuery = {
  __typename?: "Query"
  getActiveTemplateBySubmissionLayout?: {
    __typename?: "ActiveTemplateResult"
    templateId?: string | null
    templateVersionId?: string | null
  } | null
}

export type FetchRequestPartyRolesQueryVariables = Exact<{
  requestId: Scalars["ID"]["input"]
  requestType: CoreRequestType
}>

export type FetchRequestPartyRolesQuery = {
  __typename?: "Query"
  fetchRequestPartyRoles: {
    __typename?: "RequestPartyRolesResponse"
    highestPartyRole: PartyRole
    partyRoles: Array<PartyRole>
  }
}

export type GetTemplateWithApprovedVersionQueryVariables = Exact<{
  templateId: Scalars["ID"]["input"]
}>

export type GetTemplateWithApprovedVersionQuery = {
  __typename?: "Query"
  getTemplateWithActiveApproved?: {
    __typename?: "Template"
    id: string
    approvedVersion?: { __typename?: "TemplateVersion"; id: string } | null
  } | null
}

export type QueryValidateQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type QueryValidateQuery = {
  __typename?: "Query"
  validate?: Array<{
    __typename?: "B2GValidationErrors"
    error?: string | null
    path?: string | null
    type?: B2GError | null
  } | null> | null
}

export type GetRequestValidationsQueryVariables = Exact<{
  input: GetRequestValidationsInput
}>

export type GetRequestValidationsQuery = {
  __typename?: "Query"
  getRequestValidations: {
    __typename?: "GetRequestValidationsResponse"
    errors: Array<{
      __typename?: "RequestValidation"
      errorType: ValidationErrorType
      field?: string | null
      fieldFuid?: string | null
      id: string
      message: string
      errorMsg?: string | null
      maxLength?: number | null
      fieldValue?: any | null
      additionalFieldValue?: any | null
      additionalFuid?: string | null
      type?: string | null
      details?: any | null
    }>
    warnings: Array<{
      __typename?: "RequestValidation"
      errorType: ValidationErrorType
      field?: string | null
      fieldFuid?: string | null
      id: string
      message: string
      errorMsg?: string | null
      maxLength?: number | null
      fieldValue?: any | null
      additionalFieldValue?: any | null
      additionalFuid?: string | null
      type?: string | null
      details?: any | null
    }>
  }
}

export type DownloadSubmissionXmlQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
  requestType: CoreRequestType
}>

export type DownloadSubmissionXmlQuery = {
  __typename?: "Query"
  downloadSubmissionXML?: {
    __typename?: "XmlDownloadUrl"
    fileName?: string | null
    url?: string | null
  } | null
}

export type DownloadOutputXmlQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type DownloadOutputXmlQuery = {
  __typename?: "Query"
  downloadOutputXML?: {
    __typename?: "XmlDownloadUrl"
    fileName?: string | null
    url?: string | null
  } | null
}

export type CheckUserAccessQueryVariables = Exact<{
  input: CheckUserAccessInput
}>

export type CheckUserAccessQuery = {
  __typename?: "Query"
  checkUserAccess: {
    __typename?: "CheckUserAccessResponse"
    allowed: boolean
    message?: string | null
  }
}

export type GetConsignorDetailsQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
  requestId?: InputMaybe<Scalars["ID"]["input"]>
}>

export type GetConsignorDetailsQuery = {
  __typename?: "Query"
  getConsignorDetails: {
    __typename?: "ConsignorDetails"
    physicalAddress?: string | null
    name: string
    identifiers: Array<{
      __typename?: "ConsignorIdentifier"
      id: string
      status: string
      type: string
    }>
  }
}

export type QuerySfExporterQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
  certificateType?: InputMaybe<CertificateType>
}>

export type QuerySfExporterQuery = {
  __typename?: "Query"
  sfExporter: {
    __typename?: "SalesForceParty"
    nzbn?: string | null
    name: string
    id: string
    registrationNumber?: string | null
    addresses: Array<{
      __typename?: "SalesForceAddress"
      addressType: string
      city: string
      country: string
      street: string
      postalCode?: string | null
      isPrimary: boolean
    }>
    contacts: Array<{
      __typename?: "SalesForceContact"
      name: string
      role?: string | null
      emails: Array<{
        __typename?: "SalesForceEmail"
        emailAddress: string
        isPrimary: boolean
      }>
      phones: Array<{
        __typename?: "SalesForcePhone"
        telephoneNumber: string
        isPrimary: boolean
      }>
    }>
    identifiers: Array<{
      __typename?: "SalesForceIdentifier"
      value: string
      id: string
      description: string
    }>
  }
}

export type GetSnapshotPresignedUrlQueryVariables = Exact<{
  historyId: Scalars["ID"]["input"]
}>

export type GetSnapshotPresignedUrlQuery = {
  __typename?: "Query"
  getSnapshotPresignedUrl: {
    __typename?: "SnapshotPresignedUrlResponse"
    url: string
  }
}

export type FindAvailableTemplatesQueryVariables = Exact<{
  commodity: Scalars["String"]["input"]
  countryCode: Scalars["String"]["input"]
}>

export type FindAvailableTemplatesQuery = {
  __typename?: "Query"
  availableTemplates?: Array<{
    __typename?: "AvailableTemplateFields"
    id: string
    code: string
    title: string
    exportCertificateType?: CertificateType | null
    commodity?: string | null
    destinationMarket: DestinationMarket
    displayedDescription?: string | null
    minorVersion: number
    majorVersion: number
  }> | null
}

export type ReferencedDocumentQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type ReferencedDocumentQuery = {
  __typename?: "Query"
  referencedDocument?: {
    __typename?: "ReferencedDocument"
    uploadInProgress: boolean
    id: string
    filename?: string | null
  } | null
}

export type DownloadSupportingDocumentQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type DownloadSupportingDocumentQuery = {
  __typename?: "Query"
  downloadReferencedDocument: {
    __typename?: "ReferencedDocumentUrl"
    documentName: string
    url: string
  }
}

export type CoreReferencedDocumentQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type CoreReferencedDocumentQuery = {
  __typename?: "Query"
  coreReferencedDocument?: {
    __typename?: "CoreReferencedDocument"
    uploadInProgress: boolean
    id: string
    filename: string
  } | null
}

export type DownloadCoreReferencedDocumentQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type DownloadCoreReferencedDocumentQuery = {
  __typename?: "Query"
  downloadCoreReferencedDocument?: {
    __typename?: "CoreReferencedDocumentUrl"
    documentName: string
    url: string
  } | null
}

export type GetSupportingDocumentDetailsQueryVariables = Exact<{
  input: GetSupportingDocumentDetailsInput
}>

export type GetSupportingDocumentDetailsQuery = {
  __typename?: "Query"
  getSupportingDocumentDetails: {
    __typename?: "CoreSupportingDocument"
    id?: string | null
    status?: string | null
    documentType?: string | null
    documentNumber?: string | null
    documentReferenceNumber?: string | null
    fileId?: string | null
    filename?: string | null
    createdBy?: string | null
    createdAt?: any | null
    updatedBy?: string | null
    updatedAt?: any | null
    comment?: string | null
    productDescription?: string | null
    identificationMarks?: Array<string | null> | null
    foreignManufacturePremises?: string | null
    foreignPremisesId?: string | null
    nzManufacturePremises?: string | null
    isLinked?: boolean | null
    reason?: string | null
    replacesId?: string | null
    replacesDocumentNumber?: string | null
    replacedById?: string | null
    replacedByDocumentNumber?: string | null
    lastAction?: string | null
    primaryOperator?: {
      __typename?: "CoreLookup"
      id?: string | null
      name?: string | null
    } | null
    intendedOperators?: Array<{
      __typename?: "CoreLookup"
      id?: string | null
      name?: string | null
    } | null> | null
    originCountry?: {
      __typename?: "CoreLookup"
      id?: string | null
      name?: string | null
    } | null
    productionDates?: Array<{
      __typename?: "CoreDateRange"
      from?: any | null
      to?: any | null
    } | null> | null
  }
}

export type GetSupportingDocumentPresignedUrlQueryVariables = Exact<{
  input: SupportingDocumentInput
}>

export type GetSupportingDocumentPresignedUrlQuery = {
  __typename?: "Query"
  getSupportingDocumentPresignedUrl: {
    __typename?: "SupportingDocumentPresignedUrlResponse"
    presignedUrl: string
    expiresIn: number
  }
}

export type GetSupportingDocumentHistoryQueryVariables = Exact<{
  input: GetSupportingDocumentHistoryInput
}>

export type GetSupportingDocumentHistoryQuery = {
  __typename?: "Query"
  getSupportingDocumentHistory: Array<{
    __typename?: "SupportingDocumentHistoryEntry"
    id: string
    dateTime?: any | null
    status?: string | null
    userName?: string | null
    comment?: string | null
    updatedByProfileFullName?: string | null
    updatedByProfile?: string | null
    updatedByFullName?: string | null
  }>
}

export type GetSupportingDocumentUsageQueryVariables = Exact<{
  input: SupportingDocumentUsageInput
}>

export type GetSupportingDocumentUsageQuery = {
  __typename?: "Query"
  getSupportingDocumentUsage: Array<{
    __typename?: "SupportingDocumentUsageRecord"
    id: string
    requestId: string
    requestType: CoreRequestType
    certificateNumber: string
    unofficialInfo?: string | null
    status?: string | null
    consignorRegistration?: string | null
    consigneeRegistration?: string | null
    departureDate?: any | null
    submittedAt?: any | null
  }>
}

export type GetSupportingDocumentActionsQueryVariables = Exact<{
  input: GetSupportingDocumentActionsInput
}>

export type GetSupportingDocumentActionsQuery = {
  __typename?: "Query"
  getSupportingDocumentActions: {
    __typename?: "SupportingDocumentActionsResponse"
    role: string
    allowedActions: Array<string>
  }
}

export type QueryExportCertificateBaseQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type QueryExportCertificateBaseQuery = {
  __typename?: "Query"
  exportCertificateRequest?: {
    __typename?: "B2GExportCertificateRequest"
    id: string
    commodity?: string | null
    status: ExportCertificateStatus
    certificateType?: CertificateType | null
    destination?: { __typename?: "B2GCountry"; id: string } | null
  } | null
}

export type QueryExportCertificateDetailsQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type QueryExportCertificateDetailsQuery = {
  __typename?: "Query"
  exportCertificateRequest?: {
    __typename?: "B2GExportCertificateRequest"
    id: string
    status: ExportCertificateStatus
    statusLabel: string
    certificateNumber?: string | null
    statusNotes?: string | null
    replacing?: {
      __typename?: "B2GExportCertificateRequest"
      id: string
      certificateNumber?: string | null
    } | null
    replacedBy?: {
      __typename?: "B2GExportCertificateRequest"
      id: string
      status: ExportCertificateStatus
      certificateNumber?: string | null
    } | null
  } | null
}

export type DownloadExportCertificatesQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  endDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
}>

export type DownloadExportCertificatesQuery = {
  __typename?: "Query"
  downloadExportCertificates: {
    __typename?: "B2GExportCertificatesDownloadUrl"
    url: string
    filename: string
  }
}

export type GetExportRequestDetailsQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type GetExportRequestDetailsQuery = {
  __typename?: "Query"
  getExportReqDetails?: {
    __typename?: "CoreExportDetails"
    templateId?: string | null
    templateCode?: string | null
    version?: number | null
    certificateNumber: string
    requiresAttention?: boolean | null
    id: string
    replacedById?: string | null
    replacesId?: string | null
    certificateNumberReplacedById?: string | null
    certificateNumberReplacesId?: string | null
    overseasAuthorityInvolved?: boolean | null
    requestName?: string | null
    status?: ExportStatus | null
    substatus?: string | null
    outputTranslationLanguages?: Array<string | null> | null
    reasonForStatusChange?: string | null
    reasonCategories?: Array<string | null> | null
    verifyingAgencyId?: string | null
    officialStatement?: string | null
    additionalDeclaration?: string | null
    thirdPartyConsignor?: Array<string | null> | null
    unofficialInformation?: string | null
    uniqueConsignmentReference?: string | null
    approvedCertificateEmailAddresses?: Array<string | null> | null
    template?: {
      __typename?: "CoreTemplate"
      id?: string | null
      code?: string | null
      majorVersion?: number | null
    } | null
    attributes?: {
      __typename?: "CoreExportRequestAttributes"
      phytoStatementOfRelabelling?: string | null
      inspectionDate?: any | null
      phytoPackhouse?: string | null
      phytoLotRefNumber?: string | null
      importPermitNumbers?: Array<string | null> | null
      orgCertRefCode?: string | null
      placeandDateofQuarantine?: string | null
      shipStores?: boolean | null
      address?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      phytoSchemeControl?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      phytoCertSubType?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      letterOfCreditRefCode?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      issuingAuthority?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      halalAuditor?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      brandName?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      numberOfPackagesContainers?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      contractNo?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      halalCertificateNumber?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      sanitoryCertificateNumber?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      cnInspection?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      administrativeTerritorialUnit?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      scope?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      manufacturerRegistration?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      manifacturingpremisesname?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      productDescription?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      purposeBR?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      netWeightInWords?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      euTransit?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      exporterRef?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      expRef?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      markingofsealontransportcontai?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      nameRegistrationandAddressofse?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      numberOfDoses?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      numberOfEmbryos?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      transport?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      forImportorAdmission?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      categoryOfGoods?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      euCommodityCode?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      summaryofRecordsfor?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      issuingAuthority1?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      lot?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      edReference?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      exporterSignature?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
    } | null
    printDetails?: {
      __typename?: "CorePrintDetails"
      officialPrinted: boolean
      reasonForReprinting?: string | null
    } | null
    consignor?: {
      __typename?: "CoreRegistration"
      id?: string | null
      name?: string | null
      registrationId?: string | null
      addresses?: {
        __typename?: "CoreAddress"
        city?: string | null
        country?: string | null
        countryCode?: string | null
        lines?: string | null
        postCode?: string | null
        state?: string | null
      } | null
    } | null
    urgency?: {
      __typename?: "CoreLookup"
      id?: string | null
      name?: string | null
    } | null
    commodity: { __typename?: "CoreCommodity"; id: string }
    destinationCountry: { __typename?: "CoreCountry"; id: string; name: string }
    certifyingAgencyId?: {
      __typename?: "CoreLookup"
      id?: string | null
      name?: string | null
    } | null
    externalConsignor?: {
      __typename?: "CoreExportRequestPartyType"
      id?: string | null
      name?: string | null
      address?: {
        __typename?: "CoreExportRequestAddressType"
        city?: string | null
        lines?: Array<string | null> | null
        postCode?: string | null
        countryCode?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
      } | null
    } | null
    importer?: {
      __typename?: "CoreExportRequestImporterType"
      name?: string | null
      id?: string | null
      representative?: string | null
      address?: {
        __typename?: "CoreExportRequestAddressType"
        city?: string | null
        postCode?: string | null
        lines?: Array<string | null> | null
        state?: string | null
        countryCode?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
      } | null
    } | null
    transitCountries?: Array<{
      __typename?: "CoreLookup"
      id?: string | null
      name?: string | null
    } | null> | null
    destinationParty?: {
      __typename?: "CoreExportRequestPartyType"
      name?: string | null
      id?: string | null
      address?: {
        __typename?: "CoreExportRequestAddressType"
        city?: string | null
        state?: string | null
        postCode?: string | null
        lines?: Array<string | null> | null
        country?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        countryCode?: {
          __typename?: "CoreLookup"
          name?: string | null
          id?: string | null
        } | null
      } | null
    } | null
    transport?: {
      __typename?: "CoreExportTransport"
      departureDate?: any | null
      conveyanceReference?: string | null
      carrierName?: string | null
      expectedArrivalDate?: any | null
      transportMode?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      loadingPort?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      inspectionPort?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      finalDestination?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      dischargePort?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
    } | null
    customsTransitAgent?: {
      __typename?: "CoreExportRequestPartyType"
      id?: string | null
      name?: string | null
      address?: {
        __typename?: "CoreExportRequestAddressType"
        lines?: Array<string | null> | null
        city?: string | null
        postCode?: string | null
        state?: string | null
        countryCode?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
      } | null
    } | null
    supportingDocuments?: Array<{
      __typename?: "CoreSupportingDocument"
      id?: string | null
      comment?: string | null
      documentReferenceNumber?: string | null
      b2gFile?: {
        __typename?: "CoreB2GFile"
        extensionType?: PhytoSupportingDocumentType | null
        name?: string | null
      } | null
    } | null> | null
    thirdParty?: Array<{
      __typename?: "CoreLookup"
      id?: string | null
      name?: string | null
      registrationId?: string | null
    } | null> | null
    deliveryDispatchDetails?: {
      __typename?: "CoreLookup"
      id?: string | null
      name?: string | null
    } | null
    deliveryDetails?: {
      __typename?: "CoreLookup"
      id?: string | null
      name?: string | null
    } | null
    signingOffice?: {
      __typename?: "CoreLookup"
      id?: string | null
      name?: string | null
    } | null
    productItemGroupDetails?: {
      __typename?: "CoreProductItemGroup"
      products?: Array<{
        __typename?: "TransferProductDetails"
        id: string
        productDeclaration?: string | null
        exhausted?: boolean | null
        sequenceNumber?: number | null
        productStatement?: string | null
        productReference?: string | null
        tradeLineGroupNumber?: number | null
        sourceProcessCount?: number | null
        itemDescription?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        classification?: Array<{
          __typename?: "CoreProductClassificationResponse"
          classificationCode?: string | null
          classificationName?: string | null
          createdAt?: string | null
          fieldUniqueId?: string | null
          id?: string | null
          itemCode?: string | null
          updatedAt?: string | null
          value?: string | null
        } | null> | null
        eligibilityCountries?: Array<{
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        }> | null
        attributes?: {
          __typename?: "CoreProductAttributes"
          overseasCertIDs?: Array<string> | null
          phytoIsInspectionOnOriginal?: string | null
          phytoIsOriginalCert?: string | null
          phytoIsOriginalContainer?: string | null
          phytoIsRepacked?: string | null
          phytoPackhouse?: string | null
          expiryDateFrom?: any | null
          expiryDateTo?: any | null
          productionBatchIds?: Array<string> | null
          phytoGrowers?: string | null
          phytoEndPointInspectionRef?: string | null
          phytoSupplier?: string | null
          phytoInspectionLocation?: string | null
          phytoObservation?: string | null
          phytoVariety?: string | null
          phytoPercentageByWeight?: number | null
          phytoSeedLotReference?: string | null
          originCountries?: Array<{
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null> | null
          scientificName?: Array<{
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null> | null
          inspectionType?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
          speciesCommonName?: Array<{
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null> | null
          temperature?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
          NZHSCode?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
          intendedUse?: Array<{
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null> | null
          grossVolume?: {
            __typename?: "Measurment"
            value?: number | null
            unit?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
          } | null
          grossWeight?: {
            __typename?: "Measurment"
            value?: number | null
            unit?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
          } | null
          netVolume?: {
            __typename?: "Measurment"
            value?: number | null
            unit?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
          } | null
          netWeight?: {
            __typename?: "Measurment"
            value?: number | null
            unit?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
          } | null
          origin?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
          phytoBotanicalName?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
          phytoCommonName?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
          phytoClass?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
          phytoSubClass?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
          phytoApprovedSeedCategory?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
          phytoLableDescription?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
          phytoQuantityMeasure?: {
            __typename?: "Measurment"
            value?: number | null
            unit?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
          } | null
          phytoQuantityType?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
        quantity?: {
          __typename?: "Measurment"
          value?: number | null
          unit?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
        containers: Array<{
          __typename?: "CoreExportContainer"
          number?: string | null
          seals?: Array<string | null> | null
          id?: string | null
        }>
        packaging?: Array<{
          __typename?: "CorePackaging"
          quantity?: number | null
          level?: number | null
          itemMarksOuter?: string | null
          packageType?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
          nominalGrossWeight?: {
            __typename?: "Measurment"
            value?: number | null
            unit?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
          } | null
          nominalGrossVolume?: {
            __typename?: "Measurment"
            value?: number | null
            unit?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
          } | null
        } | null> | null
        processes: Array<{
          __typename?: "CoreProductProcess"
          id: string
          sequenceNumber?: string | null
          isSourceProcess?: boolean | null
          foreignPremises?: string | null
          foreignPremisesIdentifier?: string | null
          endDate?: any | null
          startDate?: any | null
          overrideProcessDate?: boolean | null
          nameOverride?: boolean | null
          updatedAt?: any | null
          processGroup?: string | null
          processType?: {
            __typename?: "CoreProcessTypeLookup"
            id?: string | null
            name?: string | null
          } | null
          premises?: {
            __typename?: "CoreRegistration"
            id?: string | null
            name?: string | null
            registrationId?: string | null
          } | null
          foreignPremisesCountryID?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
          attributes?: {
            __typename?: "CoreProcessAttributes"
            additionalTreatment?: string | null
            chemicalDetail?: string | null
            concentration?: string | null
            duration?: {
              __typename?: "Measurment"
              value?: number | null
              unit?: {
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null
            } | null
            temperature?: {
              __typename?: "Measurment"
              value?: number | null
              unit?: {
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null
            } | null
          } | null
        }>
        processHistory?: Array<{
          __typename?: "AggregatedProcessHistory"
          createdAt: any
          dateOverride?: boolean | null
          earliestStartDate?: any | null
          id: string
          latestEndDate?: any | null
          owned: boolean
          premisesIdentifier: string
          premisesName?: string | null
          processCategory: string
          processCode: string
          processName?: string | null
          lastProcessStartDate?: any | null
          lastProcessEndDate?: any | null
          concatenated: boolean
          latestSubmissionDate?: any | null
          processSequenceNumber?: number | null
        } | null> | null
        sources?: Array<{
          __typename?: "SourcedProduct"
          id: string
          sequenceNumber?: number | null
          isExhausted?: boolean | null
          transferRequestId?: string | null
          transferRequestNumber?: string | null
          isPaperSourced?: boolean | null
          details?: {
            __typename?: "SourcedProductDetails"
            productReference?: string | null
            productStatement?: string | null
            itemDescription?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
            eligibilityCountries?: Array<{
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            }> | null
            classification?: Array<{
              __typename?: "CoreProductClassificationResponse"
              classificationCode?: string | null
              classificationName?: string | null
              createdAt?: string | null
              fieldUniqueId?: string | null
              id?: string | null
              itemCode?: string | null
              updatedAt?: string | null
              value?: string | null
            } | null> | null
            attributes?: {
              __typename?: "SourcedProductAttributes"
              expiryDateFrom?: any | null
              expiryDateTo?: any | null
              productionBatchIds?: Array<string> | null
              inspectionType?: {
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null
              intendedUse?: Array<{
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null> | null
              netVolume?: {
                __typename?: "Measurment"
                value?: number | null
                unit?: {
                  __typename?: "CoreLookup"
                  id?: string | null
                  name?: string | null
                } | null
              } | null
              netWeight?: {
                __typename?: "Measurment"
                value?: number | null
                unit?: {
                  __typename?: "CoreLookup"
                  id?: string | null
                  name?: string | null
                } | null
              } | null
              NZHSCode?: {
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null
              origin?: {
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null
              scientificName?: Array<{
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null> | null
              speciesCommonName?: Array<{
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null> | null
              temperature?: {
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null
            } | null
            packaging?: Array<{
              __typename?: "CorePackaging"
              quantity?: number | null
              itemMarksOuter?: string | null
              outermostNumberOfPacakges?: number | null
              level?: number | null
              packageType?: {
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null
              nominalGrossVolume?: {
                __typename?: "Measurment"
                value?: number | null
                unit?: {
                  __typename?: "CoreLookup"
                  id?: string | null
                  name?: string | null
                } | null
              } | null
              nominalGrossWeight?: {
                __typename?: "Measurment"
                value?: number | null
                unit?: {
                  __typename?: "CoreLookup"
                  id?: string | null
                  name?: string | null
                } | null
              } | null
            } | null> | null
            containers?: Array<{
              __typename?: "CoreExportContainer"
              id?: string | null
              number?: string | null
              seals?: Array<string | null> | null
            }> | null
          } | null
        }> | null
        supportingDocuments?: Array<{
          __typename?: "CoreTransferProductSupportingDocument"
          id?: string | null
          status?: string | null
          documentNumber?: string | null
          documentReferenceNumber?: string | null
          comment?: string | null
          isInherited?: boolean | null
          fileId?: string | null
          primaryOperator?: {
            __typename?: "CoreLookup"
            id?: string | null
          } | null
          intendedOperators?: Array<{
            __typename?: "CoreLookup"
            id?: string | null
          } | null> | null
        }> | null
      } | null> | null
    } | null
    declarations?: Array<{
      __typename?: "CoreDeclarationOutput"
      id?: string | null
      selected?: boolean | null
      statementCode?: number | null
      inputs?: Array<{
        __typename?: "CoreDeclarationInputValueOutput"
        id?: string | null
        inputValue?: string | null
        sequenceNumber?: number | null
      }> | null
    } | null> | null
    sourceTransfer?: Array<{
      __typename?: "SourceTransfer"
      sourceTransferId?: string | null
      requestNumber: string
      approvalDate?: any | null
    }> | null
  } | null
}

export type GetExportRequestHistoryQueryVariables = Exact<{
  input: ExportRequestHistoryInput
}>

export type GetExportRequestHistoryQuery = {
  __typename?: "Query"
  getExportRequestHistory: Array<{
    __typename?: "ExportRequestHistoryRecord"
    id: string
    exportRequestId: string
    action?: string | null
    nzxmlURI?: string | null
    overseasAuthorityInvolved?: boolean | null
    reasonCategories?: Array<string | null> | null
    reasonForStatusChange?: string | null
    reasonForReprinting?: string | null
    replacesId?: string | null
    status?: string | null
    substatus?: string | null
    updatedAt?: any | null
    templateVersionId?: string | null
    updatedBy?: string | null
    updatedBySystem?: string | null
    updatedByProfileName?: string | null
    updatedByProfileFullName?: string | null
    updatedByFullName?: string | null
  }>
}

export type GetDraftCertificateGenerationStatusQueryVariables = Exact<{
  input: GetDraftCertificateGenerationStatusInput
}>

export type GetDraftCertificateGenerationStatusQuery = {
  __typename?: "Query"
  getDraftCertificateGenerationStatus: {
    __typename?: "DraftCertificateGenerationStatusResponse"
    error?: string | null
    isCompleted: boolean
    pdfCertificateUrl?: string | null
    status: DraftCertificateExecutionStatus
  }
}

export type ProductFormQueryVariables = Exact<{
  certificateType?: InputMaybe<CertificateType>
  country?: InputMaybe<Scalars["String"]["input"]>
  commodity?: InputMaybe<Scalars["String"]["input"]>
}>

export type ProductFormQuery = {
  __typename?: "Query"
  productForm: Array<{
    __typename?: "FormletField"
    type?: FormletFieldType | null
    required?: boolean | null
    readonly?: boolean | null
    numberOfLines?: number | null
    label?: string | null
    id: string
    description?: string | null
    collection?: string | null
    charLength?: number | null
    nested?: Array<{
      __typename?: "FormletNestedFields"
      type: FormletFieldType
      id: string
      collection?: string | null
    } | null> | null
    options?: Array<{
      __typename?: "FormletOption"
      value: string
      label: string
    } | null> | null
    numberConstrain?: {
      __typename?: "NumberConstrain"
      step: number
      min?: number | null
      max?: number | null
    } | null
    filter?: {
      __typename?: "FormletCollectionFilter"
      attribute: string
      value: string
    } | null
  } | null>
}

export type GetProductQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type GetProductQuery = {
  __typename?: "Query"
  product: {
    __typename?: "B2GProduct"
    id: string
    productNumber?: string | null
    modifiable: boolean
    description: string
    exporterReference?: string | null
    premise: { __typename?: "B2GPremise"; id: string; name?: string | null }
    wine?: {
      __typename?: "B2GWineFields"
      totalPackagedLitres?: number | null
      availableLitres?: number | null
      exportedLitres?: number | null
      shippingFormat?: WinePackaging | null
      EUCategory?: string | null
    } | null
    eligibilityStatus?: Array<{
      __typename?: "B2GEligibilityStatus"
      market: DestinationMarket
      status: B2GEligibilityStatusType
      expiryDate?: any | null
    }> | null
  }
}

export type GetSimpleProductQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type GetSimpleProductQuery = {
  __typename?: "Query"
  product: {
    __typename?: "B2GProduct"
    id: string
    wine?: {
      __typename?: "B2GWineFields"
      vintage?: string | null
      alternateWineNames?: Array<string> | null
    } | null
  }
}

export type QueryValidateProductQueryVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>
  product: B2GProductInput
}>

export type QueryValidateProductQuery = {
  __typename?: "Query"
  validateProduct?: Array<{
    __typename?: "B2GValidationErrors"
    error?: string | null
    path?: string | null
    type?: B2GError | null
  } | null> | null
}

export type GetAvailableProcessesQueryVariables = Exact<{
  productId: Scalars["ID"]["input"]
}>

export type GetAvailableProcessesQuery = {
  __typename?: "Query"
  availableProcesses: Array<{
    __typename?: "ProcessType"
    description: string
    id: ProductProcessType
  }>
}

export type QueryProductProcessesSensoryEvaluationQueryVariables = Exact<{
  productId: Scalars["ID"]["input"]
}>

export type QueryProductProcessesSensoryEvaluationQuery = {
  __typename?: "Query"
  productProcesses: Array<{
    __typename?: "ProductProcessResponse"
    processId: string
    processType: ProductProcessType
    taskId?: string | null
    attributes:
      | { __typename?: "ChemistryTestResponse" }
      | { __typename?: "Packaging" }
      | {
          __typename?: "SensoryProcessRequest"
          assessmentDate: any
          reference: string
          disputed: boolean
          disputedReason?: WineDisputedReason | null
          id: string
          productId: string
          comment?: string | null
          winemaker: { __typename?: "B2GContact"; personName?: string | null }
        }
      | { __typename?: "Winemaking" }
  }>
}

export type QueryProductProcessesChemistryTestQueryVariables = Exact<{
  productId: Scalars["ID"]["input"]
}>

export type QueryProductProcessesChemistryTestQuery = {
  __typename?: "Query"
  productProcesses: Array<{
    __typename?: "ProductProcessResponse"
    processId: string
    processType: ProductProcessType
    taskId?: string | null
    attributes:
      | {
          __typename?: "ChemistryTestResponse"
          requestedDate?: any | null
          status?: string | null
          cancelledReason?: string | null
          firstResultReportedDate?: string | null
          receipt: {
            __typename?: "ChemistryTestReceipt"
            laboratoryReference?: string | null
            receiptDate?: any | null
            sampleSuitable?: boolean | null
            unsuitableReason?: string | null
          }
          request: {
            __typename?: "ChemistryTestRequest"
            expectedAlcoholContent?: number | null
            laboratory: string
            packagingDate?: any | null
            packagingReference?: string | null
            sampleCollectionDate: any
            sampleReference: string
            testRequired: string
            wineTestReference: string
          }
        }
      | { __typename?: "Packaging" }
      | { __typename?: "SensoryProcessRequest" }
      | { __typename?: "Winemaking" }
  }>
}

export type QueryProductProcessBottlingRunsQueryVariables = Exact<{
  productId: Scalars["ID"]["input"]
}>

export type QueryProductProcessBottlingRunsQuery = {
  __typename?: "Query"
  productProcesses: Array<{
    __typename?: "ProductProcessResponse"
    confirmationTaskId?: string | null
    requestTaskId?: string | null
    taskId?: string | null
    processType: ProductProcessType
    processId: string
    attributes:
      | { __typename?: "ChemistryTestResponse" }
      | {
          __typename?: "Packaging"
          wsmp?: string | null
          exportedLitres: number
          availableLitres: number
          status: PackagingStatus
          totalPackagedLitres: number
          confirmation?: {
            __typename?: "PackagingConfirmation"
            confirmed: boolean
            disputeReason?: string | null
            disputeResolution?: string | null
          } | null
          runs: Array<
            | {
                __typename?: "BottlingRunData"
                id: string
                bottleVolume: string
                bottlesPerCase: number
                cases: number
                date: any
                extraBottles?: number | null
                litres: number
                reference: string
              }
            | { __typename?: "FlexiFillingRunData" }
          >
        }
      | { __typename?: "SensoryProcessRequest" }
      | { __typename?: "Winemaking" }
  }>
}

export type QueryProductProcessFillingRunsQueryVariables = Exact<{
  productId: Scalars["ID"]["input"]
}>

export type QueryProductProcessFillingRunsQuery = {
  __typename?: "Query"
  productProcesses: Array<{
    __typename?: "ProductProcessResponse"
    confirmationTaskId?: string | null
    requestTaskId?: string | null
    taskId?: string | null
    processType: ProductProcessType
    processId: string
    attributes:
      | { __typename?: "ChemistryTestResponse" }
      | {
          __typename?: "Packaging"
          wsmp?: string | null
          exportedLitres: number
          availableLitres: number
          status: PackagingStatus
          totalPackagedLitres: number
          confirmation?: {
            __typename?: "PackagingConfirmation"
            confirmed: boolean
            disputeReason?: string | null
            disputeResolution?: string | null
          } | null
          runs: Array<
            | { __typename?: "BottlingRunData" }
            | {
                __typename?: "FlexiFillingRunData"
                date: any
                id: string
                litres: number
                reference: string
              }
          >
        }
      | { __typename?: "SensoryProcessRequest" }
      | { __typename?: "Winemaking" }
  }>
}

export type QueryProductDeclarationQueryVariables = Exact<{
  commodity: Scalars["String"]["input"]
}>

export type QueryProductDeclarationQuery = {
  __typename?: "Query"
  productFormlet: {
    __typename?: "Form"
    declarations: Array<{
      __typename?: "DeclarationFormletSection"
      id: string
      type: FormletFieldType
      fields: {
        __typename?: "DeclarationFormletFields"
        market: {
          __typename?: "FormletField"
          id: string
          value?: string | null
          label?: string | null
        }
        text: {
          __typename?: "FormletField"
          id: string
          type?: FormletFieldType | null
          label?: string | null
        }
        eligibilityCriteria: {
          __typename?: "FormletField"
          id: string
          value?: string | null
        }
      }
    }>
  }
}

export type QueryProductProcessWinemakingQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type QueryProductProcessWinemakingQuery = {
  __typename?: "Query"
  productProcesses: Array<{
    __typename?: "ProductProcessResponse"
    confirmationTaskId?: string | null
    requestTaskId?: string | null
    taskId?: string | null
    processType: ProductProcessType
    processId: string
    attributes:
      | { __typename?: "ChemistryTestResponse" }
      | { __typename?: "Packaging" }
      | { __typename?: "SensoryProcessRequest" }
      | {
          __typename?: "Winemaking"
          wsmp?: string | null
          confirmations?: Array<{
            __typename?: "WinemakingConfirmation"
            status: WinemakingStatus
            market: DestinationMarket
            disputedResolution?: string | null
            disputedReason?: string | null
            confirmed?: boolean | null
          } | null> | null
        }
  }>
}

export type DownloadProductsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
  endDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>
}>

export type DownloadProductsQuery = {
  __typename?: "Query"
  downloadProducts: {
    __typename?: "B2GProductsDownloadUrl"
    url: string
    filename: string
  }
}

export type GetApprovedProductDetailsQueryVariables = Exact<{
  productIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
}>

export type GetApprovedProductDetailsQuery = {
  __typename?: "Query"
  getApprovedProductDetails?: {
    __typename?: "ApprovedProductRequest"
    products: Array<{
      __typename?: "TransferProductDetails"
      id: string
      transferRequestId?: string | null
      transferRequestNumber?: string | null
      sequenceNumber?: number | null
      exhausted?: boolean | null
      productStatement?: string | null
      productReference?: string | null
      itemDescription?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      attributes?: {
        __typename?: "CoreProductAttributes"
        expiryDateTo?: any | null
        expiryDateFrom?: any | null
        productionBatchIds?: Array<string> | null
        origin?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        netWeight?: {
          __typename?: "Measurment"
          value?: number | null
          unit?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
        netVolume?: {
          __typename?: "Measurment"
          value?: number | null
          unit?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
        intendedUse?: Array<{
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null> | null
        inspectionType?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        NZHSCode?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        speciesCommonName?: Array<{
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null> | null
        scientificName?: Array<{
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null> | null
        commonName?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        temperature?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        grossWeight?: {
          __typename?: "Measurment"
          value?: number | null
          unit?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
        grossVolume?: {
          __typename?: "Measurment"
          value?: number | null
          unit?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
      } | null
      eligibilityCountries?: Array<{
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      }> | null
      processes: Array<{
        __typename?: "CoreProductProcess"
        id: string
        startDate?: any | null
        endDate?: any | null
        foreignPremises?: string | null
        foreignPremisesIdentifier?: string | null
        overrideProcessDate?: boolean | null
        premises?: {
          __typename?: "CoreRegistration"
          id?: string | null
          name?: string | null
          registrationId?: string | null
        } | null
        processType?: {
          __typename?: "CoreProcessTypeLookup"
          id?: string | null
          name?: string | null
        } | null
      }>
      sources?: Array<{
        __typename?: "SourcedProduct"
        id: string
        sequenceNumber?: number | null
        transferRequestId?: string | null
        transferRequestNumber?: string | null
        isPaperSourced?: boolean | null
        details?: {
          __typename?: "SourcedProductDetails"
          productReference?: string | null
          productStatement?: string | null
          itemDescription?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
          eligibilityCountries?: Array<{
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          }> | null
          attributes?: {
            __typename?: "SourcedProductAttributes"
            expiryDateFrom?: any | null
            expiryDateTo?: any | null
            productionBatchIds?: Array<string> | null
            inspectionType?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
            intendedUse?: Array<{
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null> | null
            netVolume?: {
              __typename?: "Measurment"
              value?: number | null
              unit?: {
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null
            } | null
            netWeight?: {
              __typename?: "Measurment"
              value?: number | null
              unit?: {
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null
            } | null
            NZHSCode?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
            origin?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
            scientificName?: Array<{
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null> | null
            speciesCommonName?: Array<{
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null> | null
            grossWeight?: {
              __typename?: "Measurment"
              value?: number | null
              unit?: {
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null
            } | null
            grossVolume?: {
              __typename?: "Measurment"
              value?: number | null
              unit?: {
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null
            } | null
            temperature?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
          } | null
        } | null
      }> | null
      classification?: Array<{
        __typename?: "CoreProductClassificationResponse"
        classificationCode?: string | null
        classificationName?: string | null
        createdAt?: string | null
        fieldUniqueId?: string | null
        id?: string | null
        itemCode?: string | null
        updatedAt?: string | null
        value?: string | null
      } | null> | null
      packaging?: Array<{
        __typename?: "CorePackaging"
        outermostNumberOfPacakges?: number | null
        itemMarksOuter?: string | null
        itemMarksOuterCaption?: string | null
        quantity?: number | null
        level?: number | null
        packageType?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        nominalGrossWeight?: {
          __typename?: "Measurment"
          value?: number | null
          unit?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
        nominalGrossVolume?: {
          __typename?: "Measurment"
          value?: number | null
          unit?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
      } | null> | null
      supportingDocuments?: Array<{
        __typename?: "CoreTransferProductSupportingDocument"
        id?: string | null
        documentNumber?: string | null
        comment?: string | null
        isInherited?: boolean | null
        isLinked?: boolean | null
      }> | null
      containers: Array<{
        __typename?: "CoreExportContainer"
        id?: string | null
        number?: string | null
        seals?: Array<string | null> | null
      }>
    }>
  } | null
}

export type GetTemplateVersionGeneralQueryVariables = Exact<{
  templateVersionId: Scalars["ID"]["input"]
}>

export type GetTemplateVersionGeneralQuery = {
  __typename?: "Query"
  getTemplateVersionV2?: {
    __typename?: "TemplateVersionV2"
    templateVersionId: string
    general: {
      __typename?: "TemplateGeneralSettingsV2"
      allowForeignPremises?: boolean | null
      allowPackageLevels?: boolean | null
      assignedTo?: string | null
      businessArea?: BusinessArea | null
      code: string
      commodity: string
      commodities?: Array<string | null> | null
      description?: string | null
      destinationCountries?: Array<string> | null
      destinationCountryNames?: Array<string> | null
      displayedDescription?: string | null
      effective?: any | null
      status: TemplateVersionStatus
      templateId: string
      title: string
      templateType?: TemplateType | null
      submissionLayout: SubmissionLayoutType
      expire?: any | null
      exportCertificateType?: CertificateType | null
      exportingCountry?: string | null
      exportingCountryName?: string | null
      importCertificateType?: ImportCertificateType | null
      transferCertificateType?: TransferCertificateType | null
      industryAccess?: boolean | null
      majorVersion?: number | null
      minorVersion?: number | null
      ocaAccess?: boolean | null
      reasonForUpdate?: string | null
      release?: any | null
      signatory?: string | null
      outputTitle?: string | null
      outputSubtitle?: string | null
      updatedAt: any
      updatedBy: string
      createdAt: any
      agencies?: Array<{
        __typename?: "Agency"
        id: string
        name: string
      } | null> | null
      outputSubtitleTranslation?: Array<{
        __typename?: "Translation"
        lang: string
        name?: string | null
        text: string
      } | null> | null
      outputTitleTranslation?: Array<{
        __typename?: "Translation"
        lang: string
        name?: string | null
        text: string
      } | null> | null
    }
  } | null
}

export type GetTemplateVersionFieldsQueryVariables = Exact<{
  templateVersionId: Scalars["ID"]["input"]
}>

export type GetTemplateVersionFieldsQuery = {
  __typename?: "Query"
  getTemplateVersionV2?: {
    __typename?: "TemplateVersionV2"
    fields?: Array<{
      __typename?: "TemplateFieldConfigurationV2"
      id: string
      fuid: string
      fieldName: string
      sectionName: string
      fieldCategory?: string | null
      viewInSubmission?: boolean | null
      viewInPdf?: boolean | null
      viewInXML?: boolean | null
      submissionSettings?: {
        __typename?: "SubmissionSettings"
        caption?: string | null
        mandatory?: boolean | null
        displayType?: DisplayType | null
        order?: number | null
        displayTypeSettings?: {
          __typename?: "DisplayTypeSettings"
          maxFieldLength?: number | null
          columnsToDisplay?: ColumnsToDisplay | null
          sortOrder?: SortOrder | null
          referenceDataList?: {
            __typename?: "ReferenceDataList"
            id?: string | null
          } | null
        } | null
      } | null
      pdfSettings?: {
        __typename?: "PDFSettings"
        caption?: string | null
        captionId?: string | null
        defaultOption?: PdfDefaultOption | null
        boxWidth?: PdfBoxWidth | null
        pdfColumnsToDisplay?: ColumnsToDisplay | null
        order?: number | null
      } | null
      xmlSettings?: {
        __typename?: "XMLSettings"
        caption?: string | null
        captionId?: string | null
        defaultOption?: XmlDefaultOption | null
        xmlColumnsToDisplay?: ColumnsToDisplay | null
        order?: number | null
      } | null
    }> | null
  } | null
}

export type GetTemplateVersionDeclarationsQueryVariables = Exact<{
  templateVersionId: Scalars["ID"]["input"]
}>

export type GetTemplateVersionDeclarationsQuery = {
  __typename?: "Query"
  getTemplateVersionV2?: {
    __typename?: "TemplateVersionV2"
    declarations?: Array<{
      __typename?: "TemplateDeclarationGroup"
      id: string
      indent: number
      numbering: DeclarationGroupNumbering
      sequenceNumber: number
      startAt: number
      type: DeclarationGroupType
      statements?: Array<{
        __typename?: "DeclarationStatement"
        code: number
        customNumber?: string | null
        id: string
        statementDisplayCode?: string | null
        sequenceNumber: number
        text: string
        translations?: any | null
        traces?: Array<{
          __typename?: "DeclarationStatementTrace"
          id: string
          tracesContent?: string | null
          tracesId?: string | null
        }> | null
      }> | null
    }> | null
  } | null
}

export type GetTemplateVersionOutputQueryVariables = Exact<{
  templateVersionId: Scalars["ID"]["input"]
}>

export type GetTemplateVersionOutputQuery = {
  __typename?: "Query"
  getTemplateVersionV2?: {
    __typename?: "TemplateVersionV2"
    output?: {
      __typename?: "TemplateOutputV2"
      competentAuthority?: CompetentAuthorityType | null
      competentAuthorityOther?: string | null
      declarationHeading?: DeclarationHeadingType | null
      declarationHeadingOther?: string | null
      forceNzCountryOrigin: boolean
      languages: Array<string>
      pdfAddendum: PdfAddendum
      pdfLayout: PdfLayout
      producePdf: boolean
      xmlLayout: XmlLayout
      destinationSystem?: DestinationSystem | null
      useTheseLanguages: boolean
      usePortOfInspectionLanguages: boolean
      usePortOfDischargeLanguages: boolean
      usePortOfCountryLanguages: boolean
      useAllLanguages: boolean
      sendToTraces: boolean
      processGroups?: Array<{
        __typename?: "TemplateProcessGroups"
        id: string
        processGroupId?: number | null
        processGroupName: string
        processGroupType: string
        sortOrder: number
        dateFormat?: string | null
        dateRange?: string | null
        premisesAddressFormat?: string | null
        premisesRange?: string | null
        defaultAction?: string | null
        width?: string | null
        includeOverseasProcesses?: boolean | null
        operatorActivityType?: string | null
        operatorActivityTypeLabel?: string | null
        isPDF?: boolean | null
        isXML?: boolean | null
        pdfSettings?: {
          __typename?: "ProcessGroupCaptionSettings"
          captionId?: string | null
          caption?: string | null
        } | null
        xmlSettings?: {
          __typename?: "ProcessGroupCaptionSettings"
          captionId?: string | null
          caption?: string | null
        } | null
        processes?: Array<{
          __typename?: "ProcessInfo"
          id: string
          processCode: string
          processName: string
        } | null> | null
      } | null> | null
      templateSupportingDocuments?: Array<{
        __typename?: "TemplateSupportingDocument"
        id: string
        templateVersionId: string
        documentType: TemplateSupportingDocumentType
        includeInXml: boolean
        printWithPdf: boolean
      }> | null
    } | null
  } | null
}

export type GetTransferRequestTemplateInfoQueryVariables = Exact<{
  [key: string]: never
}>

export type GetTransferRequestTemplateInfoQuery = {
  __typename?: "Query"
  getDfeTransferRequestTemplateInfo?: {
    __typename?: "DfeTemplateInfo"
    templateId?: string | null
    templateRevisionId?: string | null
  } | null
}

export type GetTransferRequestDetailsQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type GetTransferRequestDetailsQuery = {
  __typename?: "Query"
  getTransferRequestDetails?: {
    __typename?: "TransferRequestDetails"
    certificateNumber: string
    requiresAttention?: boolean | null
    id: string
    version?: number | null
    isExhausted?: boolean | null
    templateId?: string | null
    templateCode?: string | null
    reasonForStatusChange?: string | null
    eligibility_declaration?: boolean | null
    auditComment?: string | null
    auditedAt?: any | null
    auditedBy?: string | null
    unofficialInformation?: string | null
    uniqueConsignmentReference?: string | null
    commodity: { __typename?: "CoreCommodity"; id: string }
    consignor?: {
      __typename?: "CoreRegistration"
      id?: string | null
      name?: string | null
      registrationId?: string | null
      registrationTypeCode?: string | null
    } | null
    consignee?: {
      __typename?: "CoreRegistration"
      id?: string | null
      name?: string | null
      registrationId?: string | null
      registrationTypeCode?: string | null
    } | null
    template?: {
      __typename?: "CoreTemplate"
      id?: string | null
      code?: string | null
      majorVersion?: number | null
    } | null
    destinationCountry: { __typename?: "CoreCountry"; id: string }
    status: {
      __typename?: "CoreRequestStatus"
      code?: CoreStatus | null
      label: string
    }
    attributes?: {
      __typename?: "CoreExportRequestAttributes"
      phytoStatementOfRelabelling?: string | null
      inspectionDate?: any | null
      phytoPackhouse?: string | null
      phytoLotRefNumber?: string | null
      importPermitNumbers?: Array<string | null> | null
      orgCertRefCode?: string | null
      placeandDateofQuarantine?: string | null
      shipStores?: boolean | null
      inspectionDateCaption?: string | null
      importPermitNumbersCaption?: string | null
      phytoCertificateNumber?: string | null
      address?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      phytoSchemeControl?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      phytoCertSubType?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      letterOfCreditRefCode?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      numberOfPackagesContainers?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      issuingAuthority?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      issuingAuthority1?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      halalAuditor?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      brandName?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      summaryofRecordsfor?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      categoryOfGoods?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      euCommodityCode?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      forImportorAdmission?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      contractNo?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      halalCertificateNumber?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      sanitoryCertificateNumber?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      cnInspection?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      administrativeTerritorialUnit?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      scope?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      manufacturerRegistration?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      manifacturingpremisesname?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      productDescription?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      purposeBR?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      netWeightInWords?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      euTransit?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      exporterRef?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      expRef?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      markingofsealontransportcontai?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      nameRegistrationandAddressofse?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      numberOfDoses?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      numberOfEmbryos?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      transport?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      edReference?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      exporterSignature?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      lot?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      exportingCountryId?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      totalQuantity?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      totalGrossWeight?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
    } | null
    reasonForStateChangeCategories?: Array<{
      __typename?: "CoreLookup"
      id?: string | null
      name?: string | null
    } | null> | null
    urgency?: {
      __typename?: "CoreLookup"
      id?: string | null
      name?: string | null
    } | null
    thirdPartyConsignor?: Array<{
      __typename?: "CoreLookup"
      id?: string | null
      name?: string | null
      registrationId?: string | null
    } | null> | null
    transport?: {
      __typename?: "CoreTransport"
      carrierName?: string | null
      departureDate?: any | null
      expectedArrivalDate?: any | null
      localCarrier?: string | null
      localCarrierReference?: string | null
      conveyanceReference?: string | null
      transportMode?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      finalDestination?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      loadingPort?: {
        __typename?: "CoreLocation"
        id: string
        name: string
      } | null
      dischargePort?: {
        __typename?: "CoreLocation"
        id: string
        name: string
      } | null
      inspectionPort?: {
        __typename?: "CoreLocation"
        id: string
        name: string
      } | null
    } | null
    products: Array<{
      __typename?: "TransferProductDetails"
      id: string
      exhausted?: boolean | null
      sequenceNumber?: number | null
      sourceProcessCount?: number | null
      productStatement?: string | null
      productReference?: string | null
      productDeclaration?: string | null
      tradeLineGroupNumber?: number | null
      itemDescription?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      processes: Array<{
        __typename?: "CoreProductProcess"
        endDate?: any | null
        foreignPremises?: string | null
        foreignPremisesIdentifier?: string | null
        id: string
        overrideProcessDate?: boolean | null
        startDate?: any | null
        isSourceProcess?: boolean | null
        updatedAt?: any | null
        processGroup?: string | null
        sequenceNumber?: string | null
        nameOverride?: boolean | null
        premises?: {
          __typename?: "CoreRegistration"
          id?: string | null
          name?: string | null
          registrationId?: string | null
        } | null
        processType?: {
          __typename?: "CoreProcessTypeLookup"
          id?: string | null
          name?: string | null
        } | null
        foreignPremisesCountryID?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        attributes?: {
          __typename?: "CoreProcessAttributes"
          additionalTreatment?: string | null
          chemicalDetail?: string | null
          concentration?: string | null
          duration?: {
            __typename?: "Measurment"
            value?: number | null
            unit?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
          } | null
          temperature?: {
            __typename?: "Measurment"
            value?: number | null
            unit?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
          } | null
        } | null
      }>
      processHistory?: Array<{
        __typename?: "AggregatedProcessHistory"
        createdAt: any
        dateOverride?: boolean | null
        earliestStartDate?: any | null
        id: string
        latestEndDate?: any | null
        owned: boolean
        premisesIdentifier: string
        premisesName?: string | null
        processCategory: string
        processCode: string
        processName?: string | null
        lastProcessStartDate?: any | null
        lastProcessEndDate?: any | null
        concatenated: boolean
        latestSubmissionDate?: any | null
        processSequenceNumber?: number | null
      } | null> | null
      classification?: Array<{
        __typename?: "CoreProductClassificationResponse"
        classificationCode?: string | null
        classificationName?: string | null
        createdAt?: string | null
        fieldUniqueId?: string | null
        id?: string | null
        itemCode?: string | null
        updatedAt?: string | null
        value?: string | null
      } | null> | null
      containers: Array<{
        __typename?: "CoreExportContainer"
        number?: string | null
        seals?: Array<string | null> | null
        id?: string | null
      }>
      sources?: Array<{
        __typename?: "SourcedProduct"
        id: string
        sequenceNumber?: number | null
        isExhausted?: boolean | null
        transferRequestId?: string | null
        transferRequestNumber?: string | null
        isPaperSourced?: boolean | null
        details?: {
          __typename?: "SourcedProductDetails"
          productReference?: string | null
          productStatement?: string | null
          itemDescription?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
          eligibilityCountries?: Array<{
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          }> | null
          classification?: Array<{
            __typename?: "CoreProductClassificationResponse"
            classificationCode?: string | null
            classificationName?: string | null
            createdAt?: string | null
            fieldUniqueId?: string | null
            id?: string | null
            itemCode?: string | null
            updatedAt?: string | null
            value?: string | null
          } | null> | null
          attributes?: {
            __typename?: "SourcedProductAttributes"
            expiryDateFrom?: any | null
            expiryDateTo?: any | null
            productionBatchIds?: Array<string> | null
            inspectionType?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
            intendedUse?: Array<{
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null> | null
            netVolume?: {
              __typename?: "Measurment"
              value?: number | null
              unit?: {
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null
            } | null
            netWeight?: {
              __typename?: "Measurment"
              value?: number | null
              unit?: {
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null
            } | null
            NZHSCode?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
            origin?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
            scientificName?: Array<{
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null> | null
            speciesCommonName?: Array<{
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null> | null
            grossWeight?: {
              __typename?: "Measurment"
              value?: number | null
              unit?: {
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null
            } | null
            grossVolume?: {
              __typename?: "Measurment"
              value?: number | null
              unit?: {
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null
            } | null
            temperature?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
          } | null
          packaging?: Array<{
            __typename?: "CorePackaging"
            quantity?: number | null
            itemMarksOuter?: string | null
            outermostNumberOfPacakges?: number | null
            level?: number | null
            packageType?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
            nominalGrossVolume?: {
              __typename?: "Measurment"
              value?: number | null
              unit?: {
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null
            } | null
            nominalGrossWeight?: {
              __typename?: "Measurment"
              value?: number | null
              unit?: {
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null
            } | null
          } | null> | null
        } | null
      }> | null
      eligibilityCountries?: Array<{
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      }> | null
      attributes?: {
        __typename?: "CoreProductAttributes"
        productionBatchIds?: Array<string> | null
        expiryDateFrom?: any | null
        expiryDateTo?: any | null
        temperature?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        netVolume?: {
          __typename?: "Measurment"
          value?: number | null
          unit?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
        netWeight?: {
          __typename?: "Measurment"
          value?: number | null
          unit?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
        grossVolume?: {
          __typename?: "Measurment"
          value?: number | null
          unit?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
        grossWeight?: {
          __typename?: "Measurment"
          value?: number | null
          unit?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
        inspectionType?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        intendedUse?: Array<{
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null> | null
        origin?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        speciesCommonName?: Array<{
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null> | null
        scientificName?: Array<{
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null> | null
        NZHSCode?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        originCountries?: Array<{
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null> | null
        commonName?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
      } | null
      packaging?: Array<{
        __typename?: "CorePackaging"
        quantity?: number | null
        itemMarksOuter?: string | null
        outermostNumberOfPacakges?: number | null
        level?: number | null
        packageType?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        nominalGrossVolume?: {
          __typename?: "Measurment"
          value?: number | null
          unit?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
        nominalGrossWeight?: {
          __typename?: "Measurment"
          value?: number | null
          unit?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
      } | null> | null
      supportingDocuments?: Array<{
        __typename?: "CoreTransferProductSupportingDocument"
        id?: string | null
        documentNumber?: string | null
        documentReferenceNumber?: string | null
        comment?: string | null
        isInherited?: boolean | null
        fileId?: string | null
        status?: string | null
        primaryOperator?: {
          __typename?: "CoreLookup"
          id?: string | null
        } | null
        intendedOperators?: Array<{
          __typename?: "CoreLookup"
          id?: string | null
        } | null> | null
      }> | null
    }>
  } | null
}

export type GetTransferRequestHistoryQueryVariables = Exact<{
  input: TransferRequestHistoryInput
}>

export type GetTransferRequestHistoryQuery = {
  __typename?: "Query"
  getTransferRequestHistory: Array<{
    __typename?: "TransferRequestHistoryRecord"
    id: string
    transferRequestId: string
    action?: string | null
    status?: string | null
    substatus?: string | null
    reasonForStatusChange?: string | null
    reasonCategories?: Array<string | null> | null
    autoApproved?: boolean | null
    updatedAt?: any | null
    updatedBy?: string | null
    updatedByFullName?: string | null
    updatedByProfileName?: string | null
    updatedByProfileFullName?: string | null
    updatedBySystem?: string | null
  }>
}

export type GetProductsByTransferReferenceQueryVariables = Exact<{
  input: TransferReferenceRequestInput
}>

export type GetProductsByTransferReferenceQuery = {
  __typename?: "Query"
  getProductsByTransferReference: {
    __typename?: "TransferReferenceResponse"
    products: Array<{
      __typename?: "TransferProductDetails"
      id: string
      sequenceNumber?: number | null
      transferRequestId?: string | null
      transferRequestNumber?: string | null
      exhausted?: boolean | null
      productStatement?: string | null
      productReference?: string | null
      itemDescription?: {
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      } | null
      attributes?: {
        __typename?: "CoreProductAttributes"
        expiryDateTo?: any | null
        expiryDateFrom?: any | null
        productionBatchIds?: Array<string> | null
        origin?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        netWeight?: {
          __typename?: "Measurment"
          value?: number | null
          unit?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
        netVolume?: {
          __typename?: "Measurment"
          value?: number | null
          unit?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
        intendedUse?: Array<{
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null> | null
        inspectionType?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        NZHSCode?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        speciesCommonName?: Array<{
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null> | null
        scientificName?: Array<{
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null> | null
        commonName?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        temperature?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        grossWeight?: {
          __typename?: "Measurment"
          value?: number | null
          unit?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
        grossVolume?: {
          __typename?: "Measurment"
          value?: number | null
          unit?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
      } | null
      classification?: Array<{
        __typename?: "CoreProductClassificationResponse"
        classificationCode?: string | null
        classificationName?: string | null
        createdAt?: string | null
        fieldUniqueId?: string | null
        id?: string | null
        itemCode?: string | null
        updatedAt?: string | null
        value?: string | null
      } | null> | null
      packaging?: Array<{
        __typename?: "CorePackaging"
        outermostNumberOfPacakges?: number | null
        itemMarksOuter?: string | null
        itemMarksOuterCaption?: string | null
        quantity?: number | null
        level?: number | null
        packageType?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
        nominalGrossWeight?: {
          __typename?: "Measurment"
          value?: number | null
          unit?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
        nominalGrossVolume?: {
          __typename?: "Measurment"
          value?: number | null
          unit?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
        } | null
      } | null> | null
      eligibilityCountries?: Array<{
        __typename?: "CoreLookup"
        id?: string | null
        name?: string | null
      }> | null
      processes: Array<{
        __typename?: "CoreProductProcess"
        id: string
        startDate?: any | null
        endDate?: any | null
        foreignPremises?: string | null
        foreignPremisesIdentifier?: string | null
        overrideProcessDate?: boolean | null
        premises?: {
          __typename?: "CoreRegistration"
          id?: string | null
          name?: string | null
          registrationId?: string | null
        } | null
        processType?: {
          __typename?: "CoreProcessTypeLookup"
          id?: string | null
          name?: string | null
        } | null
      }>
      sources?: Array<{
        __typename?: "SourcedProduct"
        id: string
        sequenceNumber?: number | null
        transferRequestId?: string | null
        transferRequestNumber?: string | null
        isPaperSourced?: boolean | null
        details?: {
          __typename?: "SourcedProductDetails"
          itemDescription?: {
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          } | null
          eligibilityCountries?: Array<{
            __typename?: "CoreLookup"
            id?: string | null
            name?: string | null
          }> | null
          attributes?: {
            __typename?: "SourcedProductAttributes"
            expiryDateFrom?: any | null
            expiryDateTo?: any | null
            inspectionType?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
            intendedUse?: Array<{
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null> | null
            netVolume?: {
              __typename?: "Measurment"
              value?: number | null
              unit?: {
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null
            } | null
            netWeight?: {
              __typename?: "Measurment"
              value?: number | null
              unit?: {
                __typename?: "CoreLookup"
                id?: string | null
                name?: string | null
              } | null
            } | null
            NZHSCode?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
            origin?: {
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null
            scientificName?: Array<{
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null> | null
            speciesCommonName?: Array<{
              __typename?: "CoreLookup"
              id?: string | null
              name?: string | null
            } | null> | null
          } | null
        } | null
      }> | null
      supportingDocuments?: Array<{
        __typename?: "CoreTransferProductSupportingDocument"
        id?: string | null
        documentNumber?: string | null
        comment?: string | null
        isInherited?: boolean | null
        isLinked?: boolean | null
      }> | null
      containers: Array<{
        __typename?: "CoreExportContainer"
        id?: string | null
        number?: string | null
        seals?: Array<string | null> | null
      }>
      quantity?: {
        __typename?: "Measurment"
        value?: number | null
        unit?: {
          __typename?: "CoreLookup"
          id?: string | null
          name?: string | null
        } | null
      } | null
    }>
    errors: Array<{
      __typename?: "TransferReferenceError"
      transferNumber: string
      lineItem: number
      errorCode: TransferReferenceErrorCode
      errorMessage: string
    }>
  }
}

export type GetForwardProductTrackingQueryVariables = Exact<{
  transferRequestId: Scalars["ID"]["input"]
}>

export type GetForwardProductTrackingQuery = {
  __typename?: "Query"
  getForwardProductTracking?: {
    __typename?: "ForwardProductTrackingResponse"
    sourceProducts: Array<{
      __typename?: "SourceProductTracking"
      id: string
      productNumber: number
      description?: string | null
      quantity?: string | null
      outgoingCount: number
      totalPackages: number
      destinations: Array<{
        __typename?: "DestinationProductTracking"
        id: string
        sourceNumber: string
        sourceStatus: string
        requestId: string
        requestNumber: string
        requestType: string
        productItem: number
        status: string
        templateVersion?: string | null
        isExhausted: boolean
        productDescription?: string | null
        quantity?: string | null
        packagingType?: string | null
      }>
    }>
  } | null
}

export type QueryTradecertUserProfileQueryVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>
  certificateType?: InputMaybe<CertificateType>
}>

export type QueryTradecertUserProfileQuery = {
  __typename?: "Query"
  tradecertUserProfile: {
    __typename?: "UserProfile"
    userPrimaryPhone?: string | null
    registrationNumber?: string | null
    registrationIdentifier?: string | null
    organisationName?: string | null
    organisationPartyId: string
    userEmail?: string | null
    userName?: string | null
    organisationPrimaryAddress?: {
      __typename?: "B2GAddress"
      street?: string | null
      postcode?: string | null
      countryId?: string | null
      city?: string | null
      countryName?: string | null
      typeCode?: AddressTypeCode | null
    } | null
  }
}

export type GetUserInfoQueryVariables = Exact<{ [key: string]: never }>

export type GetUserInfoQuery = {
  __typename?: "Query"
  getUserInfo: { __typename?: "UserInfo"; registrations: Array<string> }
}

export type GetUserDetailsByIdQueryVariables = Exact<{
  userId: Scalars["ID"]["input"]
}>

export type GetUserDetailsByIdQuery = {
  __typename?: "Query"
  getUserDetailsById?: {
    __typename?: "UserDetailsById"
    name?: string | null
    email?: string | null
  } | null
}

export type XmlProcessingStatusSubscriptionVariables = Exact<{
  xmlInputId: Scalars["String"]["input"]
}>

export type XmlProcessingStatusSubscription = {
  __typename?: "Subscription"
  onXmlFileProcessed: {
    __typename?: "PrepareXmlFileForB2GResponse"
    errorMessages: Array<string>
    fileName: string
    requestType: XmlRequestType
    status: string
    b2gPayload?: string | null
    responseId?: string | null
    xmlInputId: string
  }
}

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: DocumentTypeDecoration<TResult, TVariables>["__apiType"]
  private value: string
  public __meta__?: Record<string, any> | undefined

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value)
    this.value = value
    this.__meta__ = __meta__
  }

  toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value
  }
}

export const SaveTransferRequestMutationDocument = new TypedDocumentString(`
    mutation saveTransferRequestMutation($input: CoreTransferRequestInput!) {
  saveTransferRequest(input: $input) {
    id
    version
    status {
      code
      label
    }
    certificateNumber
    products {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  SaveTransferRequestMutationMutation,
  SaveTransferRequestMutationMutationVariables
>
export const RaiseTransferRequestDocument = new TypedDocumentString(`
    mutation RaiseTransferRequest($id: ID!, $version: Int, $validation: Boolean) {
  raiseTransferRequest(
    input: {requestID: $id, version: $version, validationOnly: $validation}
  ) {
    certificateNumber
    id
    status
    submittedAt
    warnings {
      id
      errorType
      errorMsg
      message
      field
      fieldFuid
      additionalFuid
      maxLength
      fieldValue
      additionalFieldValue
      type
      details
    }
  }
}
    `) as unknown as TypedDocumentString<
  RaiseTransferRequestMutation,
  RaiseTransferRequestMutationVariables
>
export const ChangeTransferRequestStatusMutationDocument =
  new TypedDocumentString(`
    mutation changeTransferRequestStatusMutation($input: ChangeTransferRequestStatusInput!) {
  changeTransferRequestStatus(input: $input) {
    transferRequestId
    status
    version
  }
}
    `) as unknown as TypedDocumentString<
    ChangeTransferRequestStatusMutationMutation,
    ChangeTransferRequestStatusMutationMutationVariables
  >
export const DeleteTransferRequestByIdDocument = new TypedDocumentString(`
    mutation deleteTransferRequestById($id: ID!) {
  deleteTransferRequestById(id: $id)
}
    `) as unknown as TypedDocumentString<
  DeleteTransferRequestByIdMutation,
  DeleteTransferRequestByIdMutationVariables
>
export const UpdateApprovedTransferTransportDocument = new TypedDocumentString(`
    mutation updateApprovedTransferTransport($input: UpdateApprovedTransferTransportInput!) {
  updateApprovedTransferTransport(input: $input)
}
    `) as unknown as TypedDocumentString<
  UpdateApprovedTransferTransportMutation,
  UpdateApprovedTransferTransportMutationVariables
>
export const DownloadTransferRequestsAsCsvDocument = new TypedDocumentString(`
    mutation downloadTransferRequestsAsCsv($input: DownloadTransferRequestsCsvInput!) {
  downloadTransferRequestsAsCsv(input: $input) {
    filename
    presignedUrl
  }
}
    `) as unknown as TypedDocumentString<
  DownloadTransferRequestsAsCsvMutation,
  DownloadTransferRequestsAsCsvMutationVariables
>
export const DownloadStatusReportDocument = new TypedDocumentString(`
    mutation downloadStatusReport($input: DownloadStatusReportInput!) {
  downloadStatusReport(input: $input) {
    filename
    presignedUrl
  }
}
    `) as unknown as TypedDocumentString<
  DownloadStatusReportMutation,
  DownloadStatusReportMutationVariables
>
export const SaveExportRequestMutationDocument = new TypedDocumentString(`
    mutation saveExportRequestMutation($input: CoreExportRequestInput!) {
  saveExportRequest(input: $input) {
    id
    version
    status {
      label
    }
  }
}
    `) as unknown as TypedDocumentString<
  SaveExportRequestMutationMutation,
  SaveExportRequestMutationMutationVariables
>
export const RaiseExportRequestDocument = new TypedDocumentString(`
    mutation RaiseExportRequest($id: ID!, $version: Int, $validation: Boolean) {
  raiseExportRequest(
    input: {requestID: $id, version: $version, validationOnly: $validation}
  ) {
    certificateNumber
    id
    status
    submittedAt
    warnings {
      id
      errorType
      errorMsg
      message
      field
      fieldFuid
      additionalFuid
      maxLength
      fieldValue
      additionalFieldValue
      type
      details
    }
  }
}
    `) as unknown as TypedDocumentString<
  RaiseExportRequestMutation,
  RaiseExportRequestMutationVariables
>
export const ChangeExportRequestStatusMutationDocument =
  new TypedDocumentString(`
    mutation changeExportRequestStatusMutation($input: ChangeExportRequestStatusInput!) {
  changeExportRequestStatus(input: $input) {
    exportRequestId
    status
    version
  }
}
    `) as unknown as TypedDocumentString<
    ChangeExportRequestStatusMutationMutation,
    ChangeExportRequestStatusMutationMutationVariables
  >
export const DeleteExportRequestByIdDocument = new TypedDocumentString(`
    mutation deleteExportRequestById($id: ID!) {
  deleteExportRequestById(id: $id)
}
    `) as unknown as TypedDocumentString<
  DeleteExportRequestByIdMutation,
  DeleteExportRequestByIdMutationVariables
>
export const DeleteReplacementExportRequestDocument = new TypedDocumentString(`
    mutation deleteReplacementExportRequest($input: DeleteReplacementExportRequestInput!) {
  deleteReplacementExportRequest(input: $input) {
    parentId
  }
}
    `) as unknown as TypedDocumentString<
  DeleteReplacementExportRequestMutation,
  DeleteReplacementExportRequestMutationVariables
>
export const GenerateExportPdfDocument = new TypedDocumentString(`
    mutation generateExportPdf($input: PrintCertificateInput!) {
  printCertificate(input: $input) {
    executionArn
    exportRequestId
    pdfCertificateUrl
    exportRequestOutputId
  }
}
    `) as unknown as TypedDocumentString<
  GenerateExportPdfMutation,
  GenerateExportPdfMutationVariables
>
export const UpdatePrintReasonDocument = new TypedDocumentString(`
    mutation updatePrintReason($input: UpdatePrintReasonInput!) {
  updatePrintReason(input: $input) {
    outputEventId
    exportRequestOutputId
    reasonForReprinting
    createdAt
  }
}
    `) as unknown as TypedDocumentString<
  UpdatePrintReasonMutation,
  UpdatePrintReasonMutationVariables
>
export const NewCoreReferencedDocumentDocument = new TypedDocumentString(`
    mutation newCoreReferencedDocument($input: NewCoreReferencedDocumentInput!) {
  newCoreReferencedDocument(input: $input) {
    id
    url
  }
}
    `) as unknown as TypedDocumentString<
  NewCoreReferencedDocumentMutation,
  NewCoreReferencedDocumentMutationVariables
>
export const DeleteCoreReferencedDocumentDocument = new TypedDocumentString(`
    mutation deleteCoreReferencedDocument($id: ID!) {
  deleteCoreReferencedDocument(id: $id)
}
    `) as unknown as TypedDocumentString<
  DeleteCoreReferencedDocumentMutation,
  DeleteCoreReferencedDocumentMutationVariables
>
export const CreateSupportingDocumentDocument = new TypedDocumentString(`
    mutation createSupportingDocument($input: CoreSupportingDocumentInput!) {
  createSupportingDocument(input: $input) {
    id
    comment
    documentNumber
    documentReferenceNumber
    primaryOperator {
      id
      name
    }
    intendedOperators {
      id
      name
    }
    originCountry {
      id
      name
    }
    productDescription
    identificationMarks
    foreignManufacturePremises
    foreignPremisesId
    nzManufacturePremises
    productionDates {
      from
      to
    }
  }
}
    `) as unknown as TypedDocumentString<
  CreateSupportingDocumentMutation,
  CreateSupportingDocumentMutationVariables
>
export const CancelSupportingDocumentDocument = new TypedDocumentString(`
    mutation CancelSupportingDocument($input: CancelSupportingDocumentInput!) {
  cancelSupportingDocument(input: $input) {
    success
    message
    supportingDocument {
      id
      status
    }
  }
}
    `) as unknown as TypedDocumentString<
  CancelSupportingDocumentMutation,
  CancelSupportingDocumentMutationVariables
>
export const UpdateSupportingDocumentDocument = new TypedDocumentString(`
    mutation UpdateSupportingDocument($input: UpdateSupportingDocumentInput!) {
  updateSupportingDocument(input: $input) {
    success
    message
    supportingDocument {
      id
      status
      documentNumber
      documentReferenceNumber
      primaryOperator {
        id
        name
      }
      intendedOperators {
        id
        name
      }
      productDescription
      identificationMarks
      foreignManufacturePremises
      foreignPremisesId
      nzManufacturePremises
      productionDates {
        from
        to
      }
      originCountry {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  UpdateSupportingDocumentMutation,
  UpdateSupportingDocumentMutationVariables
>
export const ExtendIntendedOperatorDocument = new TypedDocumentString(`
    mutation ExtendIntendedOperator($input: ExtendIntendedOperatorInput!) {
  extendIntendedOperator(input: $input) {
    success
    message
    supportingDocument {
      id
      status
      intendedOperators {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  ExtendIntendedOperatorMutation,
  ExtendIntendedOperatorMutationVariables
>
export const DownloadSupportingDocumentsAsCsvDocument =
  new TypedDocumentString(`
    mutation downloadSupportingDocumentsAsCsv($input: DownloadSupportingDocumentsCsvInput!) {
  downloadSupportingDocumentsAsCsv(input: $input) {
    filename
    presignedUrl
  }
}
    `) as unknown as TypedDocumentString<
    DownloadSupportingDocumentsAsCsvMutation,
    DownloadSupportingDocumentsAsCsvMutationVariables
  >
export const ExhaustTransferProductsDocument = new TypedDocumentString(`
    mutation exhaustTransferProducts($input: ExhaustTransferProductsInput!) {
  exhaustTransferProducts(input: $input) {
    results {
      transferRequestId
      products {
        id
        exhausted
      }
      isFullyExhausted
    }
  }
}
    `) as unknown as TypedDocumentString<
  ExhaustTransferProductsMutation,
  ExhaustTransferProductsMutationVariables
>
export const PrepareXmlFileForB2GDocument = new TypedDocumentString(`
    mutation PrepareXmlFileForB2G($input: PrepareXmlFileForB2GInput!) {
  prepareXmlFileForB2G(input: $input) {
    b2gPayload
    errorMessages
    fileName
    requestType
    responseId
    status
    xmlInputId
  }
}
    `) as unknown as TypedDocumentString<
  PrepareXmlFileForB2GMutation,
  PrepareXmlFileForB2GMutationVariables
>
export const ProcessB2GIntegrationDocument = new TypedDocumentString(`
    mutation ProcessB2GIntegration($input: ProcessB2GIntegrationInput!) {
  processB2GIntegration(input: $input) {
    errorMessages
    fileName
    requestType
    responseId
    status
    xmlInputId
  }
}
    `) as unknown as TypedDocumentString<
  ProcessB2GIntegrationMutation,
  ProcessB2GIntegrationMutationVariables
>
export const AddOrUpdateWineProductDocument = new TypedDocumentString(`
    mutation addOrUpdateWineProduct($product: B2GProductInput!) {
  addProduct(product: $product, ingredients: []) {
    id
    commodity
    modifiable
    description
    premise {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  AddOrUpdateWineProductMutation,
  AddOrUpdateWineProductMutationVariables
>
export const NewReferencedDocumentDocument = new TypedDocumentString(`
    mutation newReferencedDocument($filename: String = "") {
  newReferencedDocument(filename: $filename) {
    id
    url
  }
}
    `) as unknown as TypedDocumentString<
  NewReferencedDocumentMutation,
  NewReferencedDocumentMutationVariables
>
export const DeleteSupportingDocumentDocument = new TypedDocumentString(`
    mutation deleteSupportingDocument($id: ID!) {
  deleteReferencedDocument(id: $id)
}
    `) as unknown as TypedDocumentString<
  DeleteSupportingDocumentMutation,
  DeleteSupportingDocumentMutationVariables
>
export const NewApiKeyDocument = new TypedDocumentString(`
    mutation newApiKey {
  newSearchApiKey {
    apiKey
    expires
  }
}
    `) as unknown as TypedDocumentString<
  NewApiKeyMutation,
  NewApiKeyMutationVariables
>
export const AcceptedTermsAndConditionsDocument = new TypedDocumentString(`
    mutation acceptedTermsAndConditions {
  acceptedTermsAndConditions
}
    `) as unknown as TypedDocumentString<
  AcceptedTermsAndConditionsMutation,
  AcceptedTermsAndConditionsMutationVariables
>
export const NewPartyApiKeyDocument = new TypedDocumentString(`
    mutation newPartyApiKey {
  newPartyApiKey {
    apiKey
    expires
  }
}
    `) as unknown as TypedDocumentString<
  NewPartyApiKeyMutation,
  NewPartyApiKeyMutationVariables
>
export const NewMultiCollectionApiKeysDocument = new TypedDocumentString(`
    mutation newMultiCollectionApiKeys {
  newMultiCollectionApiKeys {
    products
    exportCertificates
    exporters
    transferRequests
    agency
    registration
    registrationAll
    expires
    partyApiKey
  }
}
    `) as unknown as TypedDocumentString<
  NewMultiCollectionApiKeysMutation,
  NewMultiCollectionApiKeysMutationVariables
>
export const GetApiKeysV2Document = new TypedDocumentString(`
    mutation GetApiKeysV2 {
  newMultiCollectionApiKeysV2 {
    exports {
      supportingDocuments
      exportCertificates
      registration
      registrationAll
      transferRequests
      sourceTransfers
    }
    transfers {
      supportingDocuments
      exportCertificates
      registration
      registrationAll
      transferRequests
      sourceTransfers
    }
    supportingDocs {
      registration
      registrationAll
      supportingDocuments
    }
    products
    partyApiKey
    agency
    templates
    expires
    exporters
    ocaExports
  }
}
    `) as unknown as TypedDocumentString<
  GetApiKeysV2Mutation,
  GetApiKeysV2MutationVariables
>
export const MutateDraftExportCertificateRequestDocument =
  new TypedDocumentString(`
    mutation mutateDraftExportCertificateRequest($id: ID, $referencedDocuments: [B2GReferencedDocumentInput!], $exporterDeclaration: B2GExporterDeclarationInput, $destination: B2GCountryInput, $consignment: B2GConsignmentInput, $commodity: String = "", $certificateType: CertificateType, $certificateDelivery: B2GCertificateDeliveryInput, $requestName: String = "", $requestedOnBehalfOfConsignor: Boolean, $copyFromId: String) {
  draftExportCertificateRequest(
    request: {id: $id, referencedDocuments: $referencedDocuments, exporterDeclaration: $exporterDeclaration, destination: $destination, consignment: $consignment, commodity: $commodity, certificateType: $certificateType, certificateDelivery: $certificateDelivery, requestName: $requestName, requestedOnBehalfOfConsignor: $requestedOnBehalfOfConsignor, copyFromId: $copyFromId}
  ) {
    id
    destination {
      id
    }
    commodity
    certificateType
    market
  }
}
    `) as unknown as TypedDocumentString<
    MutateDraftExportCertificateRequestMutation,
    MutateDraftExportCertificateRequestMutationVariables
  >
export const MutateRaiseExportCertificateRequestDocument =
  new TypedDocumentString(`
    mutation mutateRaiseExportCertificateRequest($id: ID!) {
  raiseExportCertificateRequest(id: $id) {
    id
    status
    statusLabel
  }
}
    `) as unknown as TypedDocumentString<
    MutateRaiseExportCertificateRequestMutation,
    MutateRaiseExportCertificateRequestMutationVariables
  >
export const DiscardExportCertificateRequestDocument = new TypedDocumentString(`
    mutation discardExportCertificateRequest($id: ID!) {
  discardExportCertificateRequest(id: $id)
}
    `) as unknown as TypedDocumentString<
  DiscardExportCertificateRequestMutation,
  DiscardExportCertificateRequestMutationVariables
>
export const CancelExportCertificateRequestDocument = new TypedDocumentString(`
    mutation cancelExportCertificateRequest($input: CancelExportCertificateRequestInput!) {
  cancelExportCertificateRequest(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  CancelExportCertificateRequestMutation,
  CancelExportCertificateRequestMutationVariables
>
export const CreateSensoryProcessDocument = new TypedDocumentString(`
    mutation CreateSensoryProcess($productId: ID!, $reference: String!, $disputed: Boolean!, $disputedReason: WineDisputedReason, $comment: String, $winemaker: String!, $assessmentDate: AWSDateTime!) {
  completeSensoryProcess(
    input: {productId: $productId, reference: $reference, disputed: $disputed, disputedReason: $disputedReason, comment: $comment, winemaker: {personName: $winemaker}, assessmentDate: $assessmentDate}
  ) {
    id
    productId
    reference
    disputed
    disputedReason
    comment
    winemaker {
      personName
    }
    assessmentDate
  }
}
    `) as unknown as TypedDocumentString<
  CreateSensoryProcessMutation,
  CreateSensoryProcessMutationVariables
>
export const RequestChemistryTestDocument = new TypedDocumentString(`
    mutation RequestChemistryTest($productId: ID!, $expectedAlcoholContent: Float, $laboratory: String!, $packagingReference: String, $packagingDate: AWSDateTime, $sampleCollectionDate: AWSDateTime!, $testRequired: ID!) {
  requestChemistryTest(
    input: {productId: $productId, attributes: {expectedAlcoholContent: $expectedAlcoholContent, laboratory: $laboratory, packagingReference: $packagingReference, packagingDate: $packagingDate, sampleCollectionDate: $sampleCollectionDate, testRequired: $testRequired}}
  ) {
    status
    cancelledReason
    firstResultReportedDate
    receipt {
      laboratoryReference
      receiptDate
      sampleSuitable
      unsuitableReason
    }
    request {
      expectedAlcoholContent
      laboratory
      packagingDate
      packagingReference
      sampleCollectionDate
      testRequired
      sampleReference
      wineTestReference
    }
  }
}
    `) as unknown as TypedDocumentString<
  RequestChemistryTestMutation,
  RequestChemistryTestMutationVariables
>
export const AddBottlingRunsDocument = new TypedDocumentString(`
    mutation AddBottlingRuns($input: BottlingRunInput!) {
  addBottlingRuns(input: $input) {
    processId
    runs {
      id
      bottleVolume
      bottlesPerCase
      cases
      date
      extraBottles
      reference
    }
  }
}
    `) as unknown as TypedDocumentString<
  AddBottlingRunsMutation,
  AddBottlingRunsMutationVariables
>
export const AddFlexiFillingRunsDocument = new TypedDocumentString(`
    mutation AddFlexiFillingRuns($input: FlexiFillingRunInput!) {
  addFlexiFillingRuns(input: $input) {
    processId
    runs {
      date
      litres
      id
      reference
    }
  }
}
    `) as unknown as TypedDocumentString<
  AddFlexiFillingRunsMutation,
  AddFlexiFillingRunsMutationVariables
>
export const StartPackagingDocument = new TypedDocumentString(`
    mutation StartPackaging($productId: ID!) {
  startPackaging(productId: $productId) {
    id
    type
    task {
      taskId
      assignedTo
    }
  }
}
    `) as unknown as TypedDocumentString<
  StartPackagingMutation,
  StartPackagingMutationVariables
>
export const RequestConfirmationDocument = new TypedDocumentString(`
    mutation RequestConfirmation($input: RequestConfirmationInput!) {
  requestConfirmation(input: $input) {
    wsmp
    processId
  }
}
    `) as unknown as TypedDocumentString<
  RequestConfirmationMutation,
  RequestConfirmationMutationVariables
>
export const ConfirmPackagingDocument = new TypedDocumentString(`
    mutation ConfirmPackaging($input: ConfirmPackagingInput!) {
  confirmPackaging(input: $input) {
    confirmed
    disputeReason
    disputeResolution
    processId
  }
}
    `) as unknown as TypedDocumentString<
  ConfirmPackagingMutation,
  ConfirmPackagingMutationVariables
>
export const CancelProcessDocument = new TypedDocumentString(`
    mutation CancelProcess($processId: ID!, $cancelledReason: String) {
  cancelProcess(input: {processId: $processId, cancelledReason: $cancelledReason}) {
    status
    cancelledReason
    firstResultReportedDate
    receipt {
      laboratoryReference
      receiptDate
      sampleSuitable
      unsuitableReason
    }
    request {
      expectedAlcoholContent
      laboratory
      packagingDate
      packagingReference
      sampleCollectionDate
      testRequired
      sampleReference
      wineTestReference
    }
  }
}
    `) as unknown as TypedDocumentString<
  CancelProcessMutation,
  CancelProcessMutationVariables
>
export const StartWinemakingDocument = new TypedDocumentString(`
    mutation StartWinemaking($productId: ID!) {
  startWinemaking(productId: $productId) {
    type
    task {
      assignedTo
      taskId
    }
    id
  }
}
    `) as unknown as TypedDocumentString<
  StartWinemakingMutation,
  StartWinemakingMutationVariables
>
export const ConfirmWinemakingDocument = new TypedDocumentString(`
    mutation ConfirmWinemaking($input: ConfirmWinemakingInput!) {
  confirmWinemaking(input: $input)
}
    `) as unknown as TypedDocumentString<
  ConfirmWinemakingMutation,
  ConfirmWinemakingMutationVariables
>
export const ResetConfirmationRequestDocument = new TypedDocumentString(`
    mutation ResetConfirmationRequest($input: ResetConfirmationRequestInput!) {
  resetConfirmationRequest(input: $input)
}
    `) as unknown as TypedDocumentString<
  ResetConfirmationRequestMutation,
  ResetConfirmationRequestMutationVariables
>
export const ReplacingCertificateDocument = new TypedDocumentString(`
    mutation ReplacingCertificate($id: ID!) {
  replacementCertificateRequest(id: $id) {
    id
    status
    certificateType
    commodity
    destination {
      id
    }
    replacedBy {
      id
      requestName
      status
    }
  }
}
    `) as unknown as TypedDocumentString<
  ReplacingCertificateMutation,
  ReplacingCertificateMutationVariables
>
export const RequestApprovalToReplaceExportCertificateRequestDocument =
  new TypedDocumentString(`
    mutation requestApprovalToReplaceExportCertificateRequest($input: ApprovalToReplaceExportCertificateRequestInput!) {
  requestApprovalToReplaceExportCertificateRequest(input: $input)
}
    `) as unknown as TypedDocumentString<
    RequestApprovalToReplaceExportCertificateRequestMutation,
    RequestApprovalToReplaceExportCertificateRequestMutationVariables
  >
export const AdjustBatchVolumeDocument = new TypedDocumentString(`
    mutation adjustBatchVolume($productId: ID!, $litres: Float!, $reason: String!) {
  adjustBatchVolume(
    input: {productId: $productId, volumeAdjustment: {litres: $litres, reason: $reason}}
  ) {
    volumeAdjustment {
      date
      changeType
      litres
      reason
    }
  }
}
    `) as unknown as TypedDocumentString<
  AdjustBatchVolumeMutation,
  AdjustBatchVolumeMutationVariables
>
export const DownloadExportRequestsAsCsvDocument = new TypedDocumentString(`
    mutation downloadExportRequestsAsCsv($input: DownloadExportRequestsCsvInput!) {
  downloadExportRequestsAsCsv(input: $input) {
    filename
    presignedUrl
  }
}
    `) as unknown as TypedDocumentString<
  DownloadExportRequestsAsCsvMutation,
  DownloadExportRequestsAsCsvMutationVariables
>
export const GetActiveAnnouncementsDocument = new TypedDocumentString(`
    query GetActiveAnnouncements {
  getActiveAnnouncements {
    id
    title
    message
    publishDate
    endDate
    status
  }
}
    `) as unknown as TypedDocumentString<
  GetActiveAnnouncementsQuery,
  GetActiveAnnouncementsQueryVariables
>
export const GetPresignedUrlForXmlDocument = new TypedDocumentString(`
    query GetPresignedUrlForXml($fileStore: String!, $key: String!) {
  getPresignedUrl(fileStore: $fileStore, key: $key)
}
    `) as unknown as TypedDocumentString<
  GetPresignedUrlForXmlQuery,
  GetPresignedUrlForXmlQueryVariables
>
export const ListFeatureFlagsDocument = new TypedDocumentString(`
    query listFeatureFlags {
  getFeatureFlags
}
    `) as unknown as TypedDocumentString<
  ListFeatureFlagsQuery,
  ListFeatureFlagsQueryVariables
>
export const GetDfeFormConfigDocument = new TypedDocumentString(`
    query GetDfeFormConfig($templateId: ID!, $templateVersionId: ID!, $recipeType: RecipeType) {
  getDfeForm(
    input: {templateId: $templateId, templateVersionId: $templateVersionId, recipeType: $recipeType}
  ) {
    config
  }
}
    `) as unknown as TypedDocumentString<
  GetDfeFormConfigQuery,
  GetDfeFormConfigQueryVariables
>
export const GetActiveTemplateBySubmissionLayoutDocument =
  new TypedDocumentString(`
    query getActiveTemplateBySubmissionLayout($submissionLayout: SubmissionLayoutType!) {
  getActiveTemplateBySubmissionLayout(submissionLayout: $submissionLayout) {
    templateId
    templateVersionId
  }
}
    `) as unknown as TypedDocumentString<
    GetActiveTemplateBySubmissionLayoutQuery,
    GetActiveTemplateBySubmissionLayoutQueryVariables
  >
export const FetchRequestPartyRolesDocument = new TypedDocumentString(`
    query FetchRequestPartyRoles($requestId: ID!, $requestType: CoreRequestType!) {
  fetchRequestPartyRoles(
    input: {requestId: $requestId, requestType: $requestType}
  ) {
    highestPartyRole
    partyRoles
  }
}
    `) as unknown as TypedDocumentString<
  FetchRequestPartyRolesQuery,
  FetchRequestPartyRolesQueryVariables
>
export const GetTemplateWithApprovedVersionDocument = new TypedDocumentString(`
    query GetTemplateWithApprovedVersion($templateId: ID!) {
  getTemplateWithActiveApproved(templateId: $templateId) {
    id
    approvedVersion {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetTemplateWithApprovedVersionQuery,
  GetTemplateWithApprovedVersionQueryVariables
>
export const QueryValidateDocument = new TypedDocumentString(`
    query queryValidate($id: ID!) {
  validate(id: $id) {
    error
    path
    type
  }
}
    `) as unknown as TypedDocumentString<
  QueryValidateQuery,
  QueryValidateQueryVariables
>
export const GetRequestValidationsDocument = new TypedDocumentString(`
    query GetRequestValidations($input: GetRequestValidationsInput!) {
  getRequestValidations(input: $input) {
    errors {
      errorType
      field
      fieldFuid
      id
      message
      errorMsg
      maxLength
      fieldValue
      additionalFieldValue
      additionalFuid
      type
      details
    }
    warnings {
      errorType
      field
      fieldFuid
      id
      message
      errorMsg
      maxLength
      fieldValue
      additionalFieldValue
      additionalFuid
      type
      details
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetRequestValidationsQuery,
  GetRequestValidationsQueryVariables
>
export const DownloadSubmissionXmlDocument = new TypedDocumentString(`
    query downloadSubmissionXML($id: ID!, $requestType: CoreRequestType!) {
  downloadSubmissionXML(requestId: $id, requestType: $requestType) {
    fileName
    url
  }
}
    `) as unknown as TypedDocumentString<
  DownloadSubmissionXmlQuery,
  DownloadSubmissionXmlQueryVariables
>
export const DownloadOutputXmlDocument = new TypedDocumentString(`
    query downloadOutputXML($id: ID!) {
  downloadOutputXML(exportRequestId: $id) {
    fileName
    url
  }
}
    `) as unknown as TypedDocumentString<
  DownloadOutputXmlQuery,
  DownloadOutputXmlQueryVariables
>
export const CheckUserAccessDocument = new TypedDocumentString(`
    query checkUserAccess($input: CheckUserAccessInput!) {
  checkUserAccess(input: $input) {
    allowed
    message
  }
}
    `) as unknown as TypedDocumentString<
  CheckUserAccessQuery,
  CheckUserAccessQueryVariables
>
export const GetConsignorDetailsDocument = new TypedDocumentString(`
    query getConsignorDetails($id: ID!, $requestId: ID) {
  getConsignorDetails(id: $id, requestId: $requestId) {
    physicalAddress
    name
    identifiers {
      id
      status
      type
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetConsignorDetailsQuery,
  GetConsignorDetailsQueryVariables
>
export const QuerySfExporterDocument = new TypedDocumentString(`
    query querySfExporter($id: ID!, $certificateType: CertificateType) {
  sfExporter(id: $id, certificateType: $certificateType) {
    addresses {
      addressType
      city
      country
      street
      postalCode
      isPrimary
    }
    nzbn
    name
    id
    registrationNumber
    contacts {
      emails {
        emailAddress
        isPrimary
      }
      name
      phones {
        telephoneNumber
        isPrimary
      }
      role
    }
    identifiers {
      value
      id
      description
    }
  }
}
    `) as unknown as TypedDocumentString<
  QuerySfExporterQuery,
  QuerySfExporterQueryVariables
>
export const GetSnapshotPresignedUrlDocument = new TypedDocumentString(`
    query GetSnapshotPresignedUrl($historyId: ID!) {
  getSnapshotPresignedUrl(historyId: $historyId) {
    url
  }
}
    `) as unknown as TypedDocumentString<
  GetSnapshotPresignedUrlQuery,
  GetSnapshotPresignedUrlQueryVariables
>
export const FindAvailableTemplatesDocument = new TypedDocumentString(`
    query FindAvailableTemplates($commodity: String!, $countryCode: String!) {
  availableTemplates(commodity: $commodity, countryCode: $countryCode) {
    id
    code
    title
    exportCertificateType
    commodity
    destinationMarket
    displayedDescription
    minorVersion
    majorVersion
  }
}
    `) as unknown as TypedDocumentString<
  FindAvailableTemplatesQuery,
  FindAvailableTemplatesQueryVariables
>
export const ReferencedDocumentDocument = new TypedDocumentString(`
    query referencedDocument($id: ID!) {
  referencedDocument(id: $id) {
    uploadInProgress
    id
    filename
  }
}
    `) as unknown as TypedDocumentString<
  ReferencedDocumentQuery,
  ReferencedDocumentQueryVariables
>
export const DownloadSupportingDocumentDocument = new TypedDocumentString(`
    query downloadSupportingDocument($id: ID!) {
  downloadReferencedDocument(id: $id) {
    documentName
    url
  }
}
    `) as unknown as TypedDocumentString<
  DownloadSupportingDocumentQuery,
  DownloadSupportingDocumentQueryVariables
>
export const CoreReferencedDocumentDocument = new TypedDocumentString(`
    query coreReferencedDocument($id: ID!) {
  coreReferencedDocument(id: $id) {
    uploadInProgress
    id
    filename
  }
}
    `) as unknown as TypedDocumentString<
  CoreReferencedDocumentQuery,
  CoreReferencedDocumentQueryVariables
>
export const DownloadCoreReferencedDocumentDocument = new TypedDocumentString(`
    query downloadCoreReferencedDocument($id: ID!) {
  downloadCoreReferencedDocument(id: $id) {
    documentName
    url
  }
}
    `) as unknown as TypedDocumentString<
  DownloadCoreReferencedDocumentQuery,
  DownloadCoreReferencedDocumentQueryVariables
>
export const GetSupportingDocumentDetailsDocument = new TypedDocumentString(`
    query GetSupportingDocumentDetails($input: GetSupportingDocumentDetailsInput!) {
  getSupportingDocumentDetails(input: $input) {
    id
    status
    documentType
    documentNumber
    documentReferenceNumber
    fileId
    filename
    createdBy
    createdAt
    updatedBy
    updatedAt
    comment
    primaryOperator {
      id
      name
    }
    intendedOperators {
      id
      name
    }
    originCountry {
      id
      name
    }
    productDescription
    identificationMarks
    foreignManufacturePremises
    foreignPremisesId
    nzManufacturePremises
    productionDates {
      from
      to
    }
    isLinked
    reason
    replacesId
    replacesDocumentNumber
    replacedById
    replacedByDocumentNumber
    lastAction
  }
}
    `) as unknown as TypedDocumentString<
  GetSupportingDocumentDetailsQuery,
  GetSupportingDocumentDetailsQueryVariables
>
export const GetSupportingDocumentPresignedUrlDocument =
  new TypedDocumentString(`
    query GetSupportingDocumentPresignedUrl($input: SupportingDocumentInput!) {
  getSupportingDocumentPresignedUrl(input: $input) {
    presignedUrl
    expiresIn
  }
}
    `) as unknown as TypedDocumentString<
    GetSupportingDocumentPresignedUrlQuery,
    GetSupportingDocumentPresignedUrlQueryVariables
  >
export const GetSupportingDocumentHistoryDocument = new TypedDocumentString(`
    query GetSupportingDocumentHistory($input: GetSupportingDocumentHistoryInput!) {
  getSupportingDocumentHistory(input: $input) {
    id
    dateTime
    status
    userName
    comment
    updatedByProfileFullName
    updatedByProfile
    updatedByFullName
  }
}
    `) as unknown as TypedDocumentString<
  GetSupportingDocumentHistoryQuery,
  GetSupportingDocumentHistoryQueryVariables
>
export const GetSupportingDocumentUsageDocument = new TypedDocumentString(`
    query GetSupportingDocumentUsage($input: SupportingDocumentUsageInput!) {
  getSupportingDocumentUsage(input: $input) {
    id
    requestId
    requestType
    certificateNumber
    unofficialInfo
    status
    consignorRegistration
    consigneeRegistration
    departureDate
    submittedAt
  }
}
    `) as unknown as TypedDocumentString<
  GetSupportingDocumentUsageQuery,
  GetSupportingDocumentUsageQueryVariables
>
export const GetSupportingDocumentActionsDocument = new TypedDocumentString(`
    query GetSupportingDocumentActions($input: GetSupportingDocumentActionsInput!) {
  getSupportingDocumentActions(input: $input) {
    role
    allowedActions
  }
}
    `) as unknown as TypedDocumentString<
  GetSupportingDocumentActionsQuery,
  GetSupportingDocumentActionsQueryVariables
>
export const QueryExportCertificateBaseDocument = new TypedDocumentString(`
    query queryExportCertificateBase($id: ID!) {
  exportCertificateRequest(id: $id) {
    id
    commodity
    status
    certificateType
    destination {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  QueryExportCertificateBaseQuery,
  QueryExportCertificateBaseQueryVariables
>
export const QueryExportCertificateDetailsDocument = new TypedDocumentString(`
    query queryExportCertificateDetails($id: ID!) {
  exportCertificateRequest(id: $id) {
    id
    status
    statusLabel
    certificateNumber
    statusNotes
    replacing {
      id
      certificateNumber
    }
    replacedBy {
      id
      status
      certificateNumber
    }
  }
}
    `) as unknown as TypedDocumentString<
  QueryExportCertificateDetailsQuery,
  QueryExportCertificateDetailsQueryVariables
>
export const DownloadExportCertificatesDocument = new TypedDocumentString(`
    query downloadExportCertificates($startDate: AWSDateTime, $endDate: AWSDateTime) {
  downloadExportCertificates(startDate: $startDate, endDate: $endDate) {
    url
    filename
  }
}
    `) as unknown as TypedDocumentString<
  DownloadExportCertificatesQuery,
  DownloadExportCertificatesQueryVariables
>
export const GetExportRequestDetailsDocument = new TypedDocumentString(`
    query GetExportRequestDetails($id: ID!) {
  getExportReqDetails(input: {id: $id}) {
    templateId
    templateCode
    template {
      id
      code
      majorVersion
    }
    version
    attributes {
      address {
        id
        name
      }
      phytoSchemeControl {
        id
        name
      }
      phytoCertSubType {
        id
        name
      }
      phytoStatementOfRelabelling
      inspectionDate
      letterOfCreditRefCode {
        id
        name
      }
      phytoPackhouse
      phytoLotRefNumber
      importPermitNumbers
      orgCertRefCode
      issuingAuthority {
        id
        name
      }
      halalAuditor {
        id
        name
      }
      brandName {
        id
        name
      }
      numberOfPackagesContainers {
        id
        name
      }
      contractNo {
        id
        name
      }
      halalCertificateNumber {
        id
        name
      }
      sanitoryCertificateNumber {
        id
        name
      }
      cnInspection {
        id
        name
      }
      administrativeTerritorialUnit {
        id
        name
      }
      scope {
        id
        name
      }
      manufacturerRegistration {
        id
        name
      }
      manifacturingpremisesname {
        id
        name
      }
      productDescription {
        id
        name
      }
      purposeBR {
        id
        name
      }
      netWeightInWords {
        id
        name
      }
      euTransit {
        id
        name
      }
      exporterRef {
        id
        name
      }
      expRef {
        id
        name
      }
      markingofsealontransportcontai {
        id
        name
      }
      nameRegistrationandAddressofse {
        id
        name
      }
      numberOfDoses {
        id
        name
      }
      numberOfEmbryos {
        id
        name
      }
      placeandDateofQuarantine
      transport {
        id
        name
      }
      forImportorAdmission {
        id
        name
      }
      categoryOfGoods {
        id
        name
      }
      euCommodityCode {
        id
        name
      }
      summaryofRecordsfor {
        id
        name
      }
      issuingAuthority1 {
        id
        name
      }
      shipStores
      lot {
        id
        name
      }
      edReference {
        id
        name
      }
      exporterSignature {
        id
        name
      }
    }
    printDetails {
      officialPrinted
      reasonForReprinting
    }
    certificateNumber
    requiresAttention
    id
    replacedById
    replacesId
    certificateNumberReplacedById
    certificateNumberReplacesId
    overseasAuthorityInvolved
    consignor {
      id
      name
      addresses {
        city
        country
        countryCode
        lines
        postCode
        state
      }
      registrationId
    }
    requestName
    status
    substatus
    outputTranslationLanguages
    reasonForStatusChange
    reasonCategories
    replacedById
    overseasAuthorityInvolved
    urgency {
      id
      name
    }
    commodity {
      id
    }
    destinationCountry {
      id
      name
    }
    verifyingAgencyId
    certifyingAgencyId {
      id
      name
    }
    officialStatement
    additionalDeclaration
    externalConsignor {
      address {
        city
        lines
        postCode
        countryCode {
          id
          name
        }
      }
      id
      name
    }
    importer {
      name
      address {
        city
        postCode
        countryCode {
          id
          name
        }
        lines
        state
      }
      id
      representative
    }
    transitCountries {
      id
      name
    }
    destinationParty {
      name
      id
      address {
        city
        country {
          id
          name
        }
        state
        postCode
        lines
        countryCode {
          name
          id
        }
      }
    }
    transport {
      transportMode {
        id
        name
      }
      loadingPort {
        id
        name
      }
      inspectionPort {
        id
        name
      }
      finalDestination {
        id
        name
      }
      dischargePort {
        id
        name
      }
      departureDate
      conveyanceReference
      carrierName
      expectedArrivalDate
    }
    customsTransitAgent {
      id
      name
      address {
        lines
        city
        countryCode {
          id
          name
        }
        postCode
        state
      }
    }
    supportingDocuments {
      id
      b2gFile {
        extensionType
        name
      }
      comment
      documentReferenceNumber
    }
    printDetails {
      officialPrinted
      reasonForReprinting
    }
    thirdPartyConsignor
    thirdParty {
      id
      name
      registrationId
    }
    unofficialInformation
    uniqueConsignmentReference
    officialStatement
    deliveryDispatchDetails {
      id
      name
    }
    deliveryDetails {
      id
      name
    }
    signingOffice {
      id
      name
    }
    approvedCertificateEmailAddresses
    productItemGroupDetails {
      products {
        id
        productDeclaration
        itemDescription {
          id
          name
        }
        exhausted
        classification {
          classificationCode
          classificationName
          createdAt
          fieldUniqueId
          id
          itemCode
          updatedAt
          value
        }
        sequenceNumber
        eligibilityCountries {
          id
          name
        }
        attributes {
          originCountries {
            id
            name
          }
          scientificName {
            id
            name
          }
          inspectionType {
            id
            name
          }
          overseasCertIDs
          phytoIsInspectionOnOriginal
          phytoIsOriginalCert
          phytoIsOriginalContainer
          phytoIsRepacked
          phytoPackhouse
          speciesCommonName {
            id
            name
          }
          expiryDateFrom
          expiryDateTo
          productionBatchIds
          temperature {
            id
            name
          }
          NZHSCode {
            id
            name
          }
          intendedUse {
            id
            name
          }
          grossVolume {
            unit {
              id
              name
            }
            value
          }
          grossWeight {
            unit {
              id
              name
            }
            value
          }
          netVolume {
            unit {
              id
              name
            }
            value
          }
          netWeight {
            unit {
              id
              name
            }
            value
          }
          origin {
            id
            name
          }
          phytoGrowers
          phytoBotanicalName {
            id
            name
          }
          phytoCommonName {
            id
            name
          }
          phytoClass {
            id
            name
          }
          phytoSubClass {
            id
            name
          }
          phytoEndPointInspectionRef
          phytoSupplier
          phytoInspectionLocation
          phytoObservation
          phytoVariety
          phytoApprovedSeedCategory {
            id
            name
          }
          phytoLableDescription {
            id
            name
          }
          phytoPercentageByWeight
          phytoQuantityMeasure {
            unit {
              id
              name
            }
            value
          }
          phytoQuantityType {
            id
            name
          }
          phytoSeedLotReference
        }
        productStatement
        productReference
        tradeLineGroupNumber
        quantity {
          value
          unit {
            id
            name
          }
        }
        containers {
          number
          seals
          id
        }
        packaging {
          quantity
          level
          itemMarksOuter
          packageType {
            id
            name
          }
          nominalGrossWeight {
            unit {
              id
              name
            }
            value
          }
          nominalGrossVolume {
            unit {
              id
              name
            }
            value
          }
        }
        sourceProcessCount
        processes {
          id
          sequenceNumber
          isSourceProcess
          processType {
            id
            name
          }
          premises {
            id
            name
            registrationId
          }
          foreignPremises
          foreignPremisesIdentifier
          endDate
          startDate
          overrideProcessDate
          nameOverride
          foreignPremisesCountryID {
            id
            name
          }
          updatedAt
          processGroup
          attributes {
            additionalTreatment
            chemicalDetail
            concentration
            duration {
              unit {
                id
                name
              }
              value
            }
            temperature {
              value
              unit {
                id
                name
              }
            }
          }
        }
        processHistory {
          createdAt
          dateOverride
          earliestStartDate
          id
          latestEndDate
          owned
          premisesIdentifier
          premisesName
          processCategory
          processCode
          processName
          lastProcessStartDate
          lastProcessEndDate
          concatenated
          latestSubmissionDate
          processSequenceNumber
        }
        sources {
          id
          sequenceNumber
          isExhausted
          transferRequestId
          transferRequestNumber
          isPaperSourced
          details {
            itemDescription {
              id
              name
            }
            eligibilityCountries {
              id
              name
            }
            classification {
              classificationCode
              classificationName
              createdAt
              fieldUniqueId
              id
              itemCode
              updatedAt
              value
            }
            attributes {
              expiryDateFrom
              expiryDateTo
              inspectionType {
                id
                name
              }
              intendedUse {
                id
                name
              }
              netVolume {
                unit {
                  id
                  name
                }
                value
              }
              netWeight {
                unit {
                  id
                  name
                }
                value
              }
              NZHSCode {
                id
                name
              }
              origin {
                id
                name
              }
              scientificName {
                id
                name
              }
              speciesCommonName {
                id
                name
              }
              temperature {
                id
                name
              }
              productionBatchIds
            }
            packaging {
              quantity
              itemMarksOuter
              outermostNumberOfPacakges
              packageType {
                id
                name
              }
              level
              nominalGrossVolume {
                unit {
                  id
                  name
                }
                value
              }
              nominalGrossWeight {
                unit {
                  id
                  name
                }
                value
              }
            }
            containers {
              id
              number
              seals
            }
            productReference
            productStatement
          }
        }
        supportingDocuments {
          id
          status
          documentNumber
          documentReferenceNumber
          comment
          isInherited
          fileId
          primaryOperator {
            id
          }
          intendedOperators {
            id
          }
        }
      }
    }
    declarations {
      id
      selected
      statementCode
      inputs {
        id
        inputValue
        sequenceNumber
      }
    }
    sourceTransfer {
      sourceTransferId
      requestNumber
      approvalDate
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetExportRequestDetailsQuery,
  GetExportRequestDetailsQueryVariables
>
export const GetExportRequestHistoryDocument = new TypedDocumentString(`
    query GetExportRequestHistory($input: ExportRequestHistoryInput!) {
  getExportRequestHistory(input: $input) {
    id
    exportRequestId
    action
    nzxmlURI
    overseasAuthorityInvolved
    reasonCategories
    reasonForStatusChange
    reasonForReprinting
    replacesId
    status
    substatus
    updatedAt
    templateVersionId
    updatedBy
    updatedBySystem
    updatedByProfileName
    updatedByProfileFullName
    updatedByFullName
  }
}
    `) as unknown as TypedDocumentString<
  GetExportRequestHistoryQuery,
  GetExportRequestHistoryQueryVariables
>
export const GetDraftCertificateGenerationStatusDocument =
  new TypedDocumentString(`
    query getDraftCertificateGenerationStatus($input: GetDraftCertificateGenerationStatusInput!) {
  getDraftCertificateGenerationStatus(input: $input) {
    error
    isCompleted
    pdfCertificateUrl
    status
  }
}
    `) as unknown as TypedDocumentString<
    GetDraftCertificateGenerationStatusQuery,
    GetDraftCertificateGenerationStatusQueryVariables
  >
export const ProductFormDocument = new TypedDocumentString(`
    query productForm($certificateType: CertificateType, $country: String, $commodity: String) {
  productForm(
    input: {certificateType: $certificateType, commodity: $commodity, country: $country}
  ) {
    type
    required
    readonly
    numberOfLines
    nested {
      type
      id
      collection
    }
    label
    id
    options {
      value
      label
    }
    description
    collection
    numberConstrain {
      step
      min
      max
    }
    filter {
      attribute
      value
    }
    charLength
  }
}
    `) as unknown as TypedDocumentString<
  ProductFormQuery,
  ProductFormQueryVariables
>
export const GetProductDocument = new TypedDocumentString(`
    query GetProduct($id: ID!) {
  product(id: $id) {
    id
    premise {
      id
      name
    }
    productNumber
    modifiable
    description
    exporterReference
    wine {
      totalPackagedLitres
      availableLitres
      exportedLitres
      shippingFormat
      EUCategory
    }
    eligibilityStatus {
      market
      status
      expiryDate
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetProductQuery,
  GetProductQueryVariables
>
export const GetSimpleProductDocument = new TypedDocumentString(`
    query GetSimpleProduct($id: ID!) {
  product(id: $id) {
    id
    wine {
      vintage
      alternateWineNames
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetSimpleProductQuery,
  GetSimpleProductQueryVariables
>
export const QueryValidateProductDocument = new TypedDocumentString(`
    query queryValidateProduct($id: ID, $product: B2GProductInput!) {
  validateProduct(id: $id, product: $product) {
    error
    path
    type
  }
}
    `) as unknown as TypedDocumentString<
  QueryValidateProductQuery,
  QueryValidateProductQueryVariables
>
export const GetAvailableProcessesDocument = new TypedDocumentString(`
    query getAvailableProcesses($productId: ID!) {
  availableProcesses(productId: $productId) {
    description
    id
  }
}
    `) as unknown as TypedDocumentString<
  GetAvailableProcessesQuery,
  GetAvailableProcessesQueryVariables
>
export const QueryProductProcessesSensoryEvaluationDocument =
  new TypedDocumentString(`
    query queryProductProcessesSensoryEvaluation($productId: ID!) {
  productProcesses(input: {productId: $productId, filter: {processType: SENSORY}}) {
    processId
    processType
    taskId
    attributes {
      ... on SensoryProcessRequest {
        assessmentDate
        reference
        disputed
        disputedReason
        id
        productId
        winemaker {
          personName
        }
        comment
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
    QueryProductProcessesSensoryEvaluationQuery,
    QueryProductProcessesSensoryEvaluationQueryVariables
  >
export const QueryProductProcessesChemistryTestDocument =
  new TypedDocumentString(`
    query queryProductProcessesChemistryTest($productId: ID!) {
  productProcesses(
    input: {productId: $productId, filter: {processType: CHEMISTRY}}
  ) {
    processId
    processType
    taskId
    attributes {
      ... on ChemistryTestResponse {
        requestedDate
        status
        cancelledReason
        firstResultReportedDate
        receipt {
          laboratoryReference
          receiptDate
          sampleSuitable
          unsuitableReason
        }
        request {
          expectedAlcoholContent
          laboratory
          packagingDate
          packagingReference
          sampleCollectionDate
          sampleReference
          testRequired
          wineTestReference
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
    QueryProductProcessesChemistryTestQuery,
    QueryProductProcessesChemistryTestQueryVariables
  >
export const QueryProductProcessBottlingRunsDocument = new TypedDocumentString(`
    query QueryProductProcessBottlingRuns($productId: ID!) {
  productProcesses(
    input: {productId: $productId, filter: {processType: BOTTLING_RUN}}
  ) {
    attributes {
      ... on Packaging {
        wsmp
        exportedLitres
        confirmation {
          confirmed
          disputeReason
          disputeResolution
        }
        availableLitres
        runs {
          ... on BottlingRunData {
            id
            bottleVolume
            bottlesPerCase
            cases
            date
            extraBottles
            litres
            reference
          }
        }
        status
        totalPackagedLitres
      }
    }
    confirmationTaskId
    requestTaskId
    taskId
    processType
    processId
  }
}
    `) as unknown as TypedDocumentString<
  QueryProductProcessBottlingRunsQuery,
  QueryProductProcessBottlingRunsQueryVariables
>
export const QueryProductProcessFillingRunsDocument = new TypedDocumentString(`
    query QueryProductProcessFillingRuns($productId: ID!) {
  productProcesses(
    input: {productId: $productId, filter: {processType: FLEXI_FILLING}}
  ) {
    attributes {
      ... on Packaging {
        wsmp
        exportedLitres
        confirmation {
          confirmed
          disputeReason
          disputeResolution
        }
        availableLitres
        runs {
          ... on FlexiFillingRunData {
            date
            id
            litres
            reference
          }
        }
        status
        totalPackagedLitres
      }
    }
    confirmationTaskId
    requestTaskId
    taskId
    processType
    processId
  }
}
    `) as unknown as TypedDocumentString<
  QueryProductProcessFillingRunsQuery,
  QueryProductProcessFillingRunsQueryVariables
>
export const QueryProductDeclarationDocument = new TypedDocumentString(`
    query queryProductDeclaration($commodity: String!) {
  productFormlet(input: {commodity: $commodity}) {
    declarations {
      id
      type
      fields {
        market {
          id
          value
          label
        }
        text {
          id
          type
          label
        }
        eligibilityCriteria {
          id
          value
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  QueryProductDeclarationQuery,
  QueryProductDeclarationQueryVariables
>
export const QueryProductProcessWinemakingDocument = new TypedDocumentString(`
    query queryProductProcessWinemaking($id: ID!) {
  productProcesses(input: {filter: {processType: WINE_MAKING}, productId: $id}) {
    attributes {
      ... on Winemaking {
        wsmp
        confirmations {
          status
          market
          disputedResolution
          disputedReason
          confirmed
        }
      }
    }
    confirmationTaskId
    requestTaskId
    taskId
    processType
    processId
  }
}
    `) as unknown as TypedDocumentString<
  QueryProductProcessWinemakingQuery,
  QueryProductProcessWinemakingQueryVariables
>
export const DownloadProductsDocument = new TypedDocumentString(`
    query downloadProducts($startDate: AWSDateTime, $endDate: AWSDateTime) {
  downloadProducts(startDate: $startDate, endDate: $endDate) {
    url
    filename
  }
}
    `) as unknown as TypedDocumentString<
  DownloadProductsQuery,
  DownloadProductsQueryVariables
>
export const GetApprovedProductDetailsDocument = new TypedDocumentString(`
    query GetApprovedProductDetails($productIds: [String!]!) {
  getApprovedProductDetails(input: {productIds: $productIds}) {
    products {
      id
      itemDescription {
        id
        name
      }
      attributes {
        origin {
          id
          name
        }
        netWeight {
          value
          unit {
            id
            name
          }
        }
        netVolume {
          value
          unit {
            id
            name
          }
        }
        intendedUse {
          id
          name
        }
        inspectionType {
          id
          name
        }
        NZHSCode {
          id
          name
        }
        speciesCommonName {
          id
          name
        }
        scientificName {
          id
          name
        }
        commonName {
          id
          name
        }
        expiryDateTo
        expiryDateFrom
        temperature {
          id
          name
        }
        grossWeight {
          value
          unit {
            id
            name
          }
        }
        grossVolume {
          value
          unit {
            id
            name
          }
        }
        productionBatchIds
      }
      eligibilityCountries {
        id
        name
      }
      processes {
        id
        premises {
          id
          name
          registrationId
        }
        processType {
          id
          name
        }
        startDate
        endDate
        foreignPremises
        foreignPremisesIdentifier
        overrideProcessDate
      }
      sources {
        id
        sequenceNumber
        transferRequestId
        transferRequestNumber
        isPaperSourced
        details {
          itemDescription {
            id
            name
          }
          eligibilityCountries {
            id
            name
          }
          attributes {
            expiryDateFrom
            expiryDateTo
            inspectionType {
              id
              name
            }
            intendedUse {
              id
              name
            }
            netVolume {
              unit {
                id
                name
              }
              value
            }
            netWeight {
              unit {
                id
                name
              }
              value
            }
            NZHSCode {
              id
              name
            }
            origin {
              id
              name
            }
            scientificName {
              id
              name
            }
            speciesCommonName {
              id
              name
            }
            grossWeight {
              unit {
                id
                name
              }
              value
            }
            grossVolume {
              unit {
                id
                name
              }
              value
            }
            temperature {
              id
              name
            }
            productionBatchIds
          }
          productReference
          productStatement
        }
      }
      classification {
        classificationCode
        classificationName
        createdAt
        fieldUniqueId
        id
        itemCode
        updatedAt
        value
      }
      packaging {
        outermostNumberOfPacakges
        itemMarksOuter
        itemMarksOuterCaption
        quantity
        level
        packageType {
          id
          name
        }
        nominalGrossWeight {
          value
          unit {
            id
            name
          }
        }
        nominalGrossVolume {
          value
          unit {
            id
            name
          }
        }
      }
      supportingDocuments {
        id
        documentNumber
        comment
        isInherited
        isLinked
      }
      transferRequestId
      transferRequestNumber
      sequenceNumber
      exhausted
      productStatement
      productReference
      containers {
        id
        number
        seals
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetApprovedProductDetailsQuery,
  GetApprovedProductDetailsQueryVariables
>
export const GetTemplateVersionGeneralDocument = new TypedDocumentString(`
    query getTemplateVersionGeneral($templateVersionId: ID!) {
  getTemplateVersionV2(templateVersionId: $templateVersionId) {
    templateVersionId
    general {
      allowForeignPremises
      allowPackageLevels
      assignedTo
      businessArea
      code
      commodity
      commodities
      description
      destinationCountries
      destinationCountryNames
      displayedDescription
      effective
      status
      templateId
      title
      templateType
      submissionLayout
      expire
      exportCertificateType
      exportingCountry
      exportingCountryName
      importCertificateType
      transferCertificateType
      industryAccess
      majorVersion
      minorVersion
      ocaAccess
      reasonForUpdate
      release
      signatory
      outputTitle
      outputSubtitle
      updatedAt
      updatedBy
      createdAt
      agencies {
        id
        name
      }
      outputSubtitleTranslation {
        lang
        name
        text
      }
      outputTitleTranslation {
        lang
        name
        text
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetTemplateVersionGeneralQuery,
  GetTemplateVersionGeneralQueryVariables
>
export const GetTemplateVersionFieldsDocument = new TypedDocumentString(`
    query getTemplateVersionFields($templateVersionId: ID!) {
  getTemplateVersionV2(templateVersionId: $templateVersionId) {
    fields {
      id
      fuid
      fieldName
      sectionName
      fieldCategory
      viewInSubmission
      viewInPdf
      viewInXML
      submissionSettings {
        caption
        mandatory
        displayType
        order
        displayTypeSettings {
          maxFieldLength
          referenceDataList {
            id
          }
          columnsToDisplay
          sortOrder
        }
      }
      pdfSettings {
        caption
        captionId
        defaultOption
        boxWidth
        pdfColumnsToDisplay
        order
      }
      xmlSettings {
        caption
        captionId
        defaultOption
        xmlColumnsToDisplay
        order
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetTemplateVersionFieldsQuery,
  GetTemplateVersionFieldsQueryVariables
>
export const GetTemplateVersionDeclarationsDocument = new TypedDocumentString(`
    query getTemplateVersionDeclarations($templateVersionId: ID!) {
  getTemplateVersionV2(templateVersionId: $templateVersionId) {
    declarations {
      id
      indent
      numbering
      sequenceNumber
      startAt
      type
      statements {
        code
        customNumber
        id
        statementDisplayCode
        sequenceNumber
        text
        translations
        traces {
          id
          tracesContent
          tracesId
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetTemplateVersionDeclarationsQuery,
  GetTemplateVersionDeclarationsQueryVariables
>
export const GetTemplateVersionOutputDocument = new TypedDocumentString(`
    query getTemplateVersionOutput($templateVersionId: ID!) {
  getTemplateVersionV2(templateVersionId: $templateVersionId) {
    output {
      competentAuthority
      competentAuthorityOther
      declarationHeading
      declarationHeadingOther
      forceNzCountryOrigin
      languages
      pdfAddendum
      pdfLayout
      producePdf
      xmlLayout
      destinationSystem
      useTheseLanguages
      usePortOfInspectionLanguages
      usePortOfDischargeLanguages
      usePortOfCountryLanguages
      useAllLanguages
      sendToTraces
      processGroups {
        id
        processGroupId
        processGroupName
        processGroupType
        sortOrder
        dateFormat
        dateRange
        premisesAddressFormat
        premisesRange
        defaultAction
        width
        includeOverseasProcesses
        operatorActivityType
        operatorActivityTypeLabel
        isPDF
        pdfSettings {
          captionId
          caption
        }
        isXML
        xmlSettings {
          captionId
          caption
        }
        processes {
          id
          processCode
          processName
        }
      }
      templateSupportingDocuments {
        id
        templateVersionId
        documentType
        includeInXml
        printWithPdf
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetTemplateVersionOutputQuery,
  GetTemplateVersionOutputQueryVariables
>
export const GetTransferRequestTemplateInfoDocument = new TypedDocumentString(`
    query GetTransferRequestTemplateInfo {
  getDfeTransferRequestTemplateInfo {
    templateId
    templateRevisionId
  }
}
    `) as unknown as TypedDocumentString<
  GetTransferRequestTemplateInfoQuery,
  GetTransferRequestTemplateInfoQueryVariables
>
export const GetTransferRequestDetailsDocument = new TypedDocumentString(`
    query GetTransferRequestDetails($id: ID!) {
  getTransferRequestDetails(input: {transferId: $id}) {
    certificateNumber
    requiresAttention
    id
    version
    isExhausted
    commodity {
      id
    }
    consignor {
      id
      name
      registrationId
      registrationTypeCode
    }
    consignee {
      id
      name
      registrationId
      registrationTypeCode
    }
    template {
      id
      code
      majorVersion
    }
    templateId
    templateCode
    destinationCountry {
      id
    }
    status {
      code
      label
    }
    attributes {
      address {
        id
        name
      }
      phytoSchemeControl {
        id
        name
      }
      phytoCertSubType {
        id
        name
      }
      phytoStatementOfRelabelling
      inspectionDate
      letterOfCreditRefCode {
        id
        name
      }
      numberOfPackagesContainers {
        id
        name
      }
      phytoPackhouse
      phytoLotRefNumber
      importPermitNumbers
      orgCertRefCode
      issuingAuthority {
        id
        name
      }
      issuingAuthority1 {
        id
        name
      }
      halalAuditor {
        id
        name
      }
      brandName {
        id
        name
      }
      summaryofRecordsfor {
        id
        name
      }
      categoryOfGoods {
        id
        name
      }
      euCommodityCode {
        id
        name
      }
      forImportorAdmission {
        id
        name
      }
      contractNo {
        id
        name
      }
      halalCertificateNumber {
        id
        name
      }
      sanitoryCertificateNumber {
        id
        name
      }
      cnInspection {
        id
        name
      }
      administrativeTerritorialUnit {
        id
        name
      }
      scope {
        id
        name
      }
      manufacturerRegistration {
        id
        name
      }
      manifacturingpremisesname {
        id
        name
      }
      productDescription {
        id
        name
      }
      purposeBR {
        id
        name
      }
      netWeightInWords {
        id
        name
      }
      euTransit {
        id
        name
      }
      exporterRef {
        id
        name
      }
      expRef {
        id
        name
      }
      markingofsealontransportcontai {
        id
        name
      }
      nameRegistrationandAddressofse {
        id
        name
      }
      numberOfDoses {
        id
        name
      }
      numberOfEmbryos {
        id
        name
      }
      placeandDateofQuarantine
      transport {
        id
        name
      }
      shipStores
      edReference {
        id
        name
      }
      exporterSignature {
        id
        name
      }
      lot {
        id
        name
      }
      exportingCountryId {
        id
        name
      }
      totalQuantity {
        id
        name
      }
      totalGrossWeight {
        id
        name
      }
      inspectionDateCaption
      importPermitNumbersCaption
      phytoCertificateNumber
    }
    reasonForStatusChange
    reasonForStateChangeCategories {
      id
      name
    }
    eligibility_declaration
    auditComment
    auditedAt
    auditedBy
    urgency {
      id
      name
    }
    unofficialInformation
    thirdPartyConsignor {
      id
      name
      registrationId
    }
    uniqueConsignmentReference
    transport {
      carrierName
      transportMode {
        id
        name
      }
      finalDestination {
        id
        name
      }
      departureDate
      expectedArrivalDate
      loadingPort {
        id
        name
      }
      dischargePort {
        id
        name
      }
      inspectionPort {
        id
        name
      }
      localCarrier
      localCarrierReference
      conveyanceReference
    }
    products {
      itemDescription {
        id
        name
      }
      id
      exhausted
      sequenceNumber
      sourceProcessCount
      processes {
        endDate
        foreignPremises
        foreignPremisesIdentifier
        id
        overrideProcessDate
        premises {
          id
          name
          registrationId
        }
        processType {
          id
          name
        }
        startDate
        isSourceProcess
        foreignPremisesCountryID {
          id
          name
        }
        updatedAt
        processGroup
        sequenceNumber
        nameOverride
        attributes {
          additionalTreatment
          chemicalDetail
          concentration
          duration {
            value
            unit {
              id
              name
            }
          }
          temperature {
            value
            unit {
              id
              name
            }
          }
        }
      }
      processHistory {
        createdAt
        dateOverride
        earliestStartDate
        id
        latestEndDate
        owned
        premisesIdentifier
        premisesName
        processCategory
        processCode
        processName
        lastProcessStartDate
        lastProcessEndDate
        concatenated
        latestSubmissionDate
        processSequenceNumber
      }
      classification {
        classificationCode
        classificationName
        createdAt
        fieldUniqueId
        id
        itemCode
        updatedAt
        value
      }
      containers {
        number
        seals
        id
      }
      productStatement
      productReference
      productDeclaration
      tradeLineGroupNumber
      sources {
        id
        sequenceNumber
        isExhausted
        transferRequestId
        transferRequestNumber
        isPaperSourced
        details {
          itemDescription {
            id
            name
          }
          eligibilityCountries {
            id
            name
          }
          classification {
            classificationCode
            classificationName
            createdAt
            fieldUniqueId
            id
            itemCode
            updatedAt
            value
          }
          attributes {
            expiryDateFrom
            expiryDateTo
            inspectionType {
              id
              name
            }
            intendedUse {
              id
              name
            }
            netVolume {
              unit {
                id
                name
              }
              value
            }
            netWeight {
              unit {
                id
                name
              }
              value
            }
            NZHSCode {
              id
              name
            }
            origin {
              id
              name
            }
            scientificName {
              id
              name
            }
            speciesCommonName {
              id
              name
            }
            grossWeight {
              unit {
                id
                name
              }
              value
            }
            grossVolume {
              unit {
                id
                name
              }
              value
            }
            temperature {
              id
              name
            }
            productionBatchIds
          }
          packaging {
            quantity
            itemMarksOuter
            outermostNumberOfPacakges
            packageType {
              id
              name
            }
            level
            nominalGrossVolume {
              unit {
                id
                name
              }
              value
            }
            nominalGrossWeight {
              unit {
                id
                name
              }
              value
            }
          }
          productReference
          productStatement
        }
      }
      eligibilityCountries {
        id
        name
      }
      attributes {
        productionBatchIds
        temperature {
          id
          name
        }
        netVolume {
          unit {
            id
            name
          }
          value
        }
        netWeight {
          unit {
            id
            name
          }
          value
        }
        grossVolume {
          unit {
            id
            name
          }
          value
        }
        grossWeight {
          unit {
            id
            name
          }
          value
        }
        inspectionType {
          id
          name
        }
        intendedUse {
          id
          name
        }
        origin {
          id
          name
        }
        speciesCommonName {
          id
          name
        }
        scientificName {
          id
          name
        }
        NZHSCode {
          id
          name
        }
        originCountries {
          id
          name
        }
        commonName {
          id
          name
        }
        expiryDateFrom
        expiryDateTo
      }
      packaging {
        quantity
        itemMarksOuter
        outermostNumberOfPacakges
        packageType {
          id
          name
        }
        level
        nominalGrossVolume {
          unit {
            id
            name
          }
          value
        }
        nominalGrossWeight {
          unit {
            id
            name
          }
          value
        }
      }
      supportingDocuments {
        id
        documentNumber
        documentReferenceNumber
        comment
        isInherited
        fileId
        primaryOperator {
          id
        }
        intendedOperators {
          id
        }
        status
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetTransferRequestDetailsQuery,
  GetTransferRequestDetailsQueryVariables
>
export const GetTransferRequestHistoryDocument = new TypedDocumentString(`
    query GetTransferRequestHistory($input: TransferRequestHistoryInput!) {
  getTransferRequestHistory(input: $input) {
    id
    transferRequestId
    action
    status
    substatus
    reasonForStatusChange
    reasonCategories
    autoApproved
    updatedAt
    updatedBy
    updatedByFullName
    updatedByProfileName
    updatedByProfileFullName
    updatedBySystem
  }
}
    `) as unknown as TypedDocumentString<
  GetTransferRequestHistoryQuery,
  GetTransferRequestHistoryQueryVariables
>
export const GetProductsByTransferReferenceDocument = new TypedDocumentString(`
    query GetProductsByTransferReference($input: TransferReferenceRequestInput!) {
  getProductsByTransferReference(input: $input) {
    products {
      id
      sequenceNumber
      itemDescription {
        id
        name
      }
      attributes {
        origin {
          id
          name
        }
        netWeight {
          value
          unit {
            id
            name
          }
        }
        netVolume {
          value
          unit {
            id
            name
          }
        }
        intendedUse {
          id
          name
        }
        inspectionType {
          id
          name
        }
        NZHSCode {
          id
          name
        }
        speciesCommonName {
          id
          name
        }
        scientificName {
          id
          name
        }
        commonName {
          id
          name
        }
        expiryDateTo
        expiryDateFrom
        temperature {
          id
          name
        }
        grossWeight {
          value
          unit {
            id
            name
          }
        }
        grossVolume {
          value
          unit {
            id
            name
          }
        }
        productionBatchIds
      }
      classification {
        classificationCode
        classificationName
        createdAt
        fieldUniqueId
        id
        itemCode
        updatedAt
        value
      }
      packaging {
        outermostNumberOfPacakges
        itemMarksOuter
        itemMarksOuterCaption
        quantity
        level
        packageType {
          id
          name
        }
        nominalGrossWeight {
          value
          unit {
            id
            name
          }
        }
        nominalGrossVolume {
          value
          unit {
            id
            name
          }
        }
      }
      eligibilityCountries {
        id
        name
      }
      processes {
        id
        premises {
          id
          name
          registrationId
        }
        processType {
          id
          name
        }
        startDate
        endDate
        foreignPremises
        foreignPremisesIdentifier
        overrideProcessDate
      }
      sources {
        id
        sequenceNumber
        transferRequestId
        transferRequestNumber
        isPaperSourced
        details {
          itemDescription {
            id
            name
          }
          eligibilityCountries {
            id
            name
          }
          attributes {
            expiryDateFrom
            expiryDateTo
            inspectionType {
              id
              name
            }
            intendedUse {
              id
              name
            }
            netVolume {
              unit {
                id
                name
              }
              value
            }
            netWeight {
              unit {
                id
                name
              }
              value
            }
            NZHSCode {
              id
              name
            }
            origin {
              id
              name
            }
            scientificName {
              id
              name
            }
            speciesCommonName {
              id
              name
            }
          }
        }
      }
      supportingDocuments {
        id
        documentNumber
        comment
        isInherited
        isLinked
      }
      containers {
        id
        number
        seals
      }
      transferRequestId
      transferRequestNumber
      quantity {
        value
        unit {
          id
          name
        }
      }
      exhausted
      productStatement
      productReference
    }
    errors {
      transferNumber
      lineItem
      errorCode
      errorMessage
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetProductsByTransferReferenceQuery,
  GetProductsByTransferReferenceQueryVariables
>
export const GetForwardProductTrackingDocument = new TypedDocumentString(`
    query GetForwardProductTracking($transferRequestId: ID!) {
  getForwardProductTracking(transferRequestId: $transferRequestId) {
    sourceProducts {
      id
      productNumber
      description
      quantity
      outgoingCount
      totalPackages
      destinations {
        id
        sourceNumber
        sourceStatus
        requestId
        requestNumber
        requestType
        productItem
        status
        templateVersion
        isExhausted
        productDescription
        quantity
        packagingType
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetForwardProductTrackingQuery,
  GetForwardProductTrackingQueryVariables
>
export const QueryTradecertUserProfileDocument = new TypedDocumentString(`
    query queryTradecertUserProfile($id: ID, $certificateType: CertificateType) {
  tradecertUserProfile(id: $id, certificateType: $certificateType) {
    userPrimaryPhone
    registrationNumber
    registrationIdentifier
    organisationPrimaryAddress {
      street
      postcode
      countryId
      city
      countryName
      typeCode
    }
    organisationName
    organisationPartyId
    userEmail
    userName
  }
}
    `) as unknown as TypedDocumentString<
  QueryTradecertUserProfileQuery,
  QueryTradecertUserProfileQueryVariables
>
export const GetUserInfoDocument = new TypedDocumentString(`
    query getUserInfo {
  getUserInfo {
    registrations
  }
}
    `) as unknown as TypedDocumentString<
  GetUserInfoQuery,
  GetUserInfoQueryVariables
>
export const GetUserDetailsByIdDocument = new TypedDocumentString(`
    query getUserDetailsById($userId: ID!) {
  getUserDetailsById(userId: $userId) {
    name
    email
  }
}
    `) as unknown as TypedDocumentString<
  GetUserDetailsByIdQuery,
  GetUserDetailsByIdQueryVariables
>
export const XmlProcessingStatusDocument = new TypedDocumentString(`
    subscription XmlProcessingStatus($xmlInputId: String!) {
  onXmlFileProcessed(xmlInputId: $xmlInputId) {
    errorMessages
    fileName
    requestType
    status
    b2gPayload
    responseId
    xmlInputId
  }
}
    `) as unknown as TypedDocumentString<
  XmlProcessingStatusSubscription,
  XmlProcessingStatusSubscriptionVariables
>
